/**
 * The panel's Turkish: English as it appears in the code → Turkish. Keys are the words exactly as written (the template
 * transform passes them without the whitespace around them). A missing key shows the English.
 * build/panel-i18n-extract.cjs lists the words the panel shows, so missing ones can be found (--missing).
 * Made 2026-11-03 from the template words of pg_dev, lr_dev and mb_dev, the menu, and the notifications in the code;
 * 2026-11-04 the text built in JavaScript (tr / trf calls, labels kept in scripts) was added.
 */
export default {
  "#{0} · by {1}": "#{0} · oluşturan: {1}",
  "$ off the order": "$ sipariş indirimi",
  "$5 off orders over $30": "$30 üzeri siparişlerde $5 indirim",
  "% OF TOTAL": "% TOPLAMDAKİ PAY",
  "% off (100 = free), up to": "% indirimle (100 = ücretsiz), en fazla",
  "% off items": "% ürün indirimi",
  "% off these items:": "% indirim, şu ürünlerde:",
  "% off.": "% indirimle.",
  "(ADDITIONAL AREA)": "(EK BÖLGE)",
  "(BRAND)": "(MARKA)",
  "(custom pizza)": "(özel pizza)",
  "(customer #{0})": "(müşteri #{0})",
  "(empty)": "(boş)",
  "(leave empty = another of what they bought)": "(boş bırakın = aldığı üründen bir tane daha)",
  "(leave empty = any item on the menu)": "(boş bırakın = menüdeki herhangi bir ürün)",
  "(leave empty = any item)": "(boş bırakın = herhangi bir ürün)",
  "(leave empty = every item on the menu)": "(boş bırakın = menüdeki tüm ürünler)",
  "(MAIN AREA)": "(ANA BÖLGE)",
  "(nothing selected = any size)": "(hiçbiri seçilmezse = her boy)",
  "(optional)": "(isteğe bağlı)",
  "(participant #{0})": "(katılımcı #{0})",
  "(sent {0}): {1} The form shows it on top of the website's version; saving again replaces it.": "(gönderim: {0}): {1} Form, değişikliğinizi web sitesindeki sürümün üzerinde gösterir; yeniden kaydederseniz yeni hâli bunun yerine geçer.",
  "(STORE)": "(MAĞAZA)",
  "(unknown product)": "(bilinmeyen ürün)",
  "(unnamed)": "(adsız)",
  "(up to {0} sends in total, then set it again)": "(toplam en fazla {0} gönderim; sonra yeniden ayarlayın)",
  "({0} from scans)": "({0} taramadan)",
  "({0} in this window)": "(bu aralıkta {0})",
  "({0} only)": "(yalnızca {0})",
  "+ 3P {0}": "+ 3. taraf {0}",
  "+ Add a choice": "+ Seçim ekle",
  "+ Add a reward": "+ Ödül ekle",
  "+ Add another deal": "+ Başka bir kampanya ekle",
  "+ New Banner": "+ Yeni banner",
  "+ New Notification": "+ Yeni bildirim",
  "+ {0} third-party": "+ {0} üçüncü taraf",
  "+50 or -50": "+50 veya -50",
  "+{0} guest": "+{0} misafir",
  "+{0} more": "+{0} daha",
  ", against": ", buna karşılık",
  ", created": ", oluşturulma tarihi",
  ", or sooner when the customer stays silent for": ", müşteri sessiz kalırsa daha erken biter; sessizlik sınırı",
  ", order number": ", sipariş numarası",
  ", so this is the whole store, not app performance.": ", yani bu rakamlar uygulama performansını değil, mağazanın tamamını gösterir.",
  ", unit {0}": ", daire {0}",
  ", worth about {0}": ", toplam değeri yaklaşık {0}",
  ", worth {0}": ", toplam değeri {0}",
  ". New messages open at once, and the older ones come back as soon as a colleague's panel is open.": ". Yeni mesajlar hemen açılır; eskileri de bir iş arkadaşınızın paneli açıldığı anda geri gelir.",
  ". New messages open at once; older ones come back as soon as a colleague's panel is open. Nothing is lost while one person on the team still has their key.": ". Yeni mesajlar hemen açılır; eskileri bir iş arkadaşınızın paneli açıldığı anda geri gelir. Ekipte anahtarı olan bir kişi kaldığı sürece hiçbir şey kaybolmaz.",
  ". Someone marked": ". Şöyle işaretlenmiş biri:",
  ". Tips ({0}) and sales tax ({1}) are not sales.": ". Bahşiş ({0}) ve satış vergisi ({1}) satış sayılmaz.",
  ". Two things are deliberately kept out, and putting either back is what produces a number roughly three times higher.": ". İki şey bilerek dışarıda bırakılır; bunlardan birini geri eklemek, yaklaşık üç kat yüksek bir sayı ortaya çıkarır.",
  ". {0} items you left empty stay untouched.": ". Boş bıraktığınız {0} kalem olduğu gibi kalır.",
  "/promotions/campaign or https://…": "/promotions/campaign veya https://…",
  "0 = all matching items in the cart.": "0 = sepetteki tüm uygun ürünler.",
  "0 = no limit. Any limit hides the deal from customers who are not signed in, because there is no account to count against.": "0 = sınır yok. Herhangi bir sınır, kampanyayı giriş yapmamış müşterilerden gizler; çünkü sayımın yapılacağı bir hesap yoktur.",
  "0 = toppings are charged as usual.": "0 = malzemeler her zamanki gibi ücretlendirilir.",
  "1 = the discount starts with the first item.": "1 = indirim ilk üründen başlar.",
  "1 banner": "1 banner",
  "1 change": "1 değişiklik",
  "1 change waiting": "1 değişiklik bekliyor",
  "1 day": "1 gün",
  "1 day up to today": "Bugüne kadarki 1 gün",
  "1 day up to yesterday": "Düne kadarki 1 gün",
  "1 location": "1 mağaza",
  "1 notification": "1 bildirim",
  "1 qualifying product": "1 geçerli ürün",
  "1 reward product": "1 ödül ürünü",
  "1 segment": "1 segment",
  "1 specific product": "1 belirli ürün",
  "1 store": "1 mağaza",
  "1 tier": "1 seviye",
  "1 use": "1 kullanım",
  "1. List": "1. Liste",
  "1.000 is clean; above 1.02 means orders are being sent twice": "1.000 temizdir; 1.02'nin üstü siparişlerin iki kez gönderildiği anlamına gelir",
  "100% off = free. 50 = half price. “0” in the first box means every extra item is rewarded, with no cap.": "%100 indirim = ücretsiz. 50 = yarı fiyat. İlk kutudaki “0”, her ek ürünün üst sınır olmadan ödüllendirileceği anlamına gelir.",
  "20% off all pastas": "Tüm makarnalarda %20 indirim",
  "30 Days": "30 gün",
  "7 days": "7 gün",
  "7 Days": "7 gün",
  "7-Day Rolling": "7 günlük hareketli ortalama",
  "7-DAY ROLLING": "7 GÜNLÜK HAREKETLİ ORT.",
  "7×24 Heatmap ({0})": "7×24 ısı haritası ({0})",
  "8-4-4-4-12 letters and digits, from the Simli dashboard": "8-4-4-4-12 harf ve rakam, Simli panosundan",
  ": recent enough to remember you.": ": sizi hatırlayacak kadar yakın zamanda gelmişler.",
  "; the story has no page of its own.": "; hikayenin kendine ait bir sayfası yoktur.",
  "<product>": "<ürün>",
  "= target − on hand + used by then. That middle column is why an item can be above its target and still need ordering: the stock has to last until the delivery actually turns up. Cases are rounded up, so slightly more arrives than the gap — Sysco does not split a case.": "= hedef − eldeki + o zamana kadar kullanılacak. Bir ürünün hedefinin üstünde olup yine de sipariş gerektirebilmesinin nedeni bu ortadaki sütundur: stok, teslimat gerçekten gelene kadar yetmelidir. Koliler yukarı yuvarlanır, bu yüzden açıktan biraz fazlası gelir — Sysco koli bölmez.",
  "? This cannot be undone.": "? Bu işlem geri alınamaz.",
  "[product]": "[ürün]",
  "a case, from invoice {0} ({1}, {2}).": "koli başına, {0} numaralı faturadan ({1}, {2}).",
  "a choice from anything": "tüm menüden bir seçim",
  "a choice from {0}": "{0} arasından bir seçim",
  "A combo needs at least one choice.": "Kombo en az bir seçim içermelidir.",
  "A count belongs to one store. Choose which one from the selector at the top left, then come back — otherwise the numbers would land somewhere you did not mean.": "Sayım tek bir mağazaya aittir. Sol üstteki seçiciden hangi mağaza olduğunu seçin, sonra geri gelin — aksi halde sayılar istemediğiniz bir yere kaydedilir.",
  "A coupon code has only letters, digits, - and _.": "Kupon kodunda yalnızca harf, rakam, - ve _ olabilir.",
  "A customer belongs to the brand, and the store on their record is only filled in once they actually order — so filtering signups by store would quietly keep only the people who ordered and report an activation rate of 100%. This table is that field read honestly: the store each activated signup first ordered from, with the ones who have not ordered on the last row.": "Müşteri markaya aittir ve kaydındaki mağaza ancak gerçekten sipariş verdiğinde doldurulur — bu yüzden kayıtları mağazaya göre filtrelemek sessizce yalnızca sipariş verenleri bırakır ve %100 aktivasyon oranı gösterirdi. Bu tablo o alanı dürüstçe okur: aktive olan her kaydın ilk sipariş verdiği mağaza; henüz sipariş vermeyenler son satırdadır.",
  "a customer is offered the deal if they match": "müşteri şuna uyarsa kampanya ona sunulur:",
  "A customer who orders every week builds a streak. At the weeks set here they can claim the reward in the app; each tier has its own list.": "Her hafta sipariş veren müşteri bir seri oluşturur. Burada belirlenen haftalara ulaştığında ödülü uygulamada alabilir; her seviyenin kendi listesi vardır.",
  "A date range overrides the time window below.": "Tarih aralığı, aşağıdaki saat aralığının yerine geçer.",
  "A delivery arrives at one store. Choose which one from the selector at the top left.": "Teslimat tek bir mağazaya gelir. Sol üstteki seçiciden hangi mağaza olduğunu seçin.",
  "A flat amount off the bill once it passes a minimum.": "Hesap belirli bir tutarı geçtiğinde sabit bir tutar düşülür.",
  "a free item": "bir ürün",
  "A map of the addresses orders were sent to": "Siparişlerin gönderildiği adreslerin haritası",
  "A member started checkout": "Bir üye ödemeyi başlattı",
  "A percentage off specific items, or the whole menu.": "Belirli ürünlerde ya da tüm menüde yüzde indirim.",
  "A phrase you make up now, like a second password for the chat only. You type it once here; it is asked again only when you open the chat on another browser or phone.": "Şimdi belirlediğiniz, yalnızca sohbete özel ikinci bir şifre gibi bir ifade. Burada bir kez yazarsınız; yalnızca sohbeti başka bir tarayıcıda veya telefonda açtığınızda yeniden sorulur.",
  "A rate is only meaningful when the top and bottom describe the same people. This one counts": "Bir oran ancak pay ile payda aynı kişileri anlattığında anlamlıdır. Bu oran şunu ölçer:",
  "A role is a set of permissions you choose. Give it to a person on the Users page. Built-in roles are locked: copy one to start from it.": "Rol, seçtiğiniz yetkilerden oluşan bir kümedir. Rolü Kullanıcılar sayfasında bir kişiye verin. Yerleşik roller kilitlidir: başlangıç için birini kopyalayın.",
  "A role says": "Rol, kişinin",
  "A short reason helps the engine avoid proposing the same thing again.": "Kısa bir gerekçe, motorun aynı şeyi yeniden önermesini önler.",
  "A shortcut when naming every item one by one is too much. Exact items above still work.": "Her ürünü tek tek seçmek zahmetli olduğunda bir kısayol. Yukarıda seçilen ürünler de geçerli olmaya devam eder.",
  "A Simli face ID; empty means the order server's own default face.": "Bir Simli yüz kimliği; boş bırakılırsa sipariş sunucusunun kendi varsayılan yüzü kullanılır.",
  "A till record is a phone or counter customer keyed in by staff. They rarely leave an e-mail address, so an e-mail campaign cannot reach most of them however large the number looks — check the reachable figure above before planning one.": "Kasa kaydı, personelin sisteme girdiği telefon veya kasa müşterisidir. Bu kişiler nadiren e-posta adresi bırakır; bu yüzden sayı ne kadar büyük görünse de bir e-posta kampanyası çoğuna ulaşamaz — planlamadan önce yukarıdaki ulaşılabilir sayıyı kontrol edin.",
  "A voice session ends after": "Sesli oturumun azami süresi",
  "A web page starts with https://": "Web sayfası adresi https:// ile başlar",
  "A-Z": "A-Z",
  "A/B Tests": "A/B testleri",
  "above, then add the order to that day's shift on the store POS with this order ID.": "düğmesini (yukarıda) kullanın, ardından siparişi bu sipariş kimliğiyle mağaza POS'undaki o günün vardiyasına ekleyin.",
  "Accept all {0} suggestions": "{0} önerinin tümünü kabul et",
  "Access request": "Erişim isteği",
  "Access requests": "Erişim istekleri",
  "Accessing Permissions": "Erişim yetkileri",
  "Accordion Body": "Akordeon içeriği",
  "accounts on the brand": "markaya kayıtlı hesap",
  "across every channel": "tüm kanallarda",
  "across every cohort shown": "gösterilen tüm kohortlarda",
  "across the top of the page": "sayfanın üstünde, boydan boya",
  "across this page": "bu sayfa genelinde",
  "Actions": "İşlemler",
  "Activate": "Etkinleştir",
  "Activation": "Aktivasyon",
  "Activation rate": "Aktivasyon oranı",
  "Active": "Aktif",
  "Active orders": "Aktif siparişler",
  "Active right now": "Şu anda aktif",
  "Active Stores": "Aktif mağazalar",
  "Activity, last 50": "Etkinlik, son 50",
  "ad set, audience…": "reklam seti, hedef kitle…",
  "Add": "Ekle",
  "Add a product": "Ürün ekle",
  "Add an item…": "Ürün ekle…",
  "Add at least one choice to the combo": "Komboya en az bir seçim ekleyin",
  "Add Code": "Kod ekle",
  "Add Common Products": "Ortak ürünleri ekle",
  "Add Date": "Tarih ekle",
  "Add item": "Kalem ekle",
  "Add Line": "Satır ekle",
  "Add link": "Bağlantı ekle",
  "Add more": "Daha fazla ekle",
  "Add New Stock": "Yeni stok ekle",
  "Add New Vendor": "Yeni tedarikçi ekle",
  "Add or remove: {0}": "Ekle veya kaldır: {0}",
  "Add Pattern": "Tekrar düzeni ekle",
  "Add pictures": "Görsel ekle",
  "Add Recurring Patterns": "Tekrar düzenleri ekle",
  "Add the other page": "Diğer sayfayı ekle",
  "Add to": "Şuraya ekle:",
  "Add {0}": "Ekle",
  "Added between": "Eklenme aralığı",
  "Added item(s)": "Eklenen ürün(ler)",
  "Added Reports": "Ekleme raporları",
  "Added Reports (old)": "Ekleme raporları (eski)",
  "added to stock on {0}.": "{0} tarihinde stoğa eklendi.",
  "Added {0} points.": "{0} puan eklendi.",
  "ADDITIONAL": "EK",
  "Address": "Adres",
  "address": "adres",
  "Address cannot be empty!": "Adres boş olamaz!",
  "Address of the story's page": "Hikaye sayfasının adresi",
  "Admin Notes": "Yönetici notları",
  "After": "Sonra",
  "after discount; no tax, tips, delivery fees or deposits": "indirim sonrası; vergi, bahşiş, teslimat ücretleri ve depozitolar hariç",
  "again to {0} at the time you pick, and at every repeat. The original stays as it is.": "bildirimini seçtiğiniz saatte ve her tekrarda yeniden şu kitleye gönderir: {0}. Orijinali olduğu gibi kalır.",
  "against": "bölü",
  "AI conversations": "AI sohbetleri",
  "AI image prompt": "AI görsel istemi",
  "AI Panel": "AI paneli",
  "All": "Tümü",
  "ALL": "TÜMÜ",
  "All categories": "Tüm kategoriler",
  "all clear": "her şey yolunda",
  "All Customers": "Tüm müşteriler",
  "All deals": "Tüm kampanyalar",
  "All locations": "Tüm mağazalar",
  "all locations": "tüm mağazalar",
  "ALL OPTIONS": "TÜM SEÇENEKLER",
  "All Products": "Tüm ürünler",
  "ALL PRODUCTS": "TÜM ÜRÜNLER",
  "All segments": "Tüm segmentler",
  "All Services": "Tüm hizmetler",
  "All stores": "Tüm mağazalar",
  "All Stores": "Tüm mağazalar",
  "All stores ranked side-by-side — heat-colored by performance": "Tüm mağazalar yan yana sıralı — performansa göre renklendirilmiş",
  "All stores: {0} of {1} stores added together.": "Tüm mağazalar: {1} mağazadan {0} tanesinin toplamı.",
  "All stores: {0} stores added together.": "Tüm mağazalar: {0} mağazanın toplamı.",
  "All time": "Tüm zamanlar",
  "All {0} stores": "Tüm {0} mağazaları",
  "all-time spend across the base": "tüm müşteri tabanının bugüne kadarki harcaması",
  "Allow the microphone for this site to talk with Connect.": "Connect ile konuşmak için bu siteye mikrofon izni verin.",
  "Allowed sizes": "İzin verilen boylar",
  "Already paid": "Zaten ödendi",
  "Also show it in the app's Special Offers carousel on the home screen": "Uygulamanın ana ekranındaki Special Offers (Özel Teklifler) karuselinde de göster",
  "Also waiting for this story:": "Bu hikaye için bekleyen diğer istekler:",
  "Amount": "Tutar",
  "AMOUNT": "TUTAR",
  "amount content": "tutar içeriği",
  "an administrator": "bir yönetici",
  "An animated orb as one more look in the AI host's mode picker.": "AI asistanının mod seçicisinde ek bir görünüm olarak hareketli bir küre.",
  "An error occurred": "Bir hata oluştu",
  "An error occurred while copying menus.": "Menüler kopyalanırken bir hata oluştu.",
  "an item": "bir ürün",
  "Analytics counts an order the moment it is paid for; we count it after cancellations, so it running a shade above 100% is expected rather than alarming. This row is also the only thing that would catch the Analytics property being switched to another timezone, which nothing else on this page could detect.": "Analytics bir siparişi ödendiği anda sayar; biz ise iptallerden sonra sayarız, bu yüzden oranın %100'ün biraz üzerinde çıkması endişe verici değil, beklenen bir durumdur. Bu satır, Analytics mülkünün başka bir saat dilimine geçirilmesini yakalayabilecek tek şeydir; bu sayfadaki başka hiçbir şey bunu fark edemez.",
  "and": "ve",
  "another of the same": "aynı ürün",
  "Another Pattern": "Bir düzen daha",
  "Answer five short questions. The deal is created switched OFF, so nothing reaches customers until you turn it on from the Dashboard.": "Beş kısa soruyu yanıtlayın. Kampanya KAPALI olarak oluşturulur; siz Pano'dan açana kadar müşterilere hiçbir şey ulaşmaz.",
  "any": "herhangi bir",
  "Any": "Herhangi biri",
  "Any 14\" pizza + 1 dessert + 2 pops for $35.99": "Herhangi bir 14\" pizza + 1 tatlı + 2 gazlı içecek, $35.99 fiyatına",
  "Any dates, compared with the days before them and with the same days last year": "İstediğiniz tarihler; önceki günlerle ve geçen yılın aynı günleriyle karşılaştırmalı",
  "Any day": "Herhangi bir gün",
  "Any deal can also go in the app's home-screen carousel — you tick that in step 4. The picture banners on the website's Deals page are managed under Marketing → Banners, not here.": "Her kampanya uygulamanın ana ekran karuselinde de yer alabilir — bunu 4. adımda işaretlersiniz. Web sitesinin Kampanyalar sayfasındaki görselli banner'lar burada değil, Pazarlama → Banner'lar altında yönetilir.",
  "any item": "herhangi bir ürün",
  "Any two dates you choose": "Seçtiğiniz herhangi iki tarih arası",
  "anything named “{0}”": "adında “{0}” geçen ürün",
  "anything on the menu": "menüdeki herhangi bir ürün",
  "APP": "UYGULAMA",
  "App": "Uygulama",
  "App AI": "Uygulama AI",
  "App AI · publish": "Uygulama AI · yayımla",
  "App Banner Image": "Uygulama banner görseli",
  "APP ORDERS": "UYGULAMA SİPARİŞLERİ",
  "App orders stay out of the top": "Uygulama siparişleri payın dışında kalır",
  "Appears as “This deal adds: …” in the cart.": "Sepette “This deal adds: …” (Bu kampanya şunu ekler: …) olarak görünür.",
  "Applied at checkout": "Ödeme adımında uygulanır",
  "Apply": "Uygula",
  "Apply it at the store selected in the panel (or the first one), check it, then apply the rest": "Önce panelde seçili mağazada (ya da ilkinde) uygulayın, kontrol edin, sonra kalanlara uygulayın",
  "Apply the rest: {0}": "Kalanlara uygula: {0}",
  "Approval": "Onay",
  "Approvals": "Onaylar",
  "Approve": "Onayla",
  "Approve creation #{0}?": "Kreasyon #{0} onaylansın mı?",
  "Approve it and put it on the website now?": "Onaylanıp hemen web sitesinde yayımlansın mı?",
  "Approve it and run it now?": "Onaylanıp hemen çalıştırılsın mı?",
  "Approve it and take the story off the website now?": "Onaylanıp yazı hemen web sitesinden kaldırılsın mı?",
  "Approve photo": "Fotoğrafı onayla",
  "Approve the customer photo on #{0}?": "Kreasyon #{0} için müşteri fotoğrafı onaylansın mı?",
  "Approve “{0}”?": "“{0}” bildirimi onaylansın mı?",
  "Approved": "Onaylandı",
  "approved": "onaylandı",
  "Approved — it goes out to customers at its scheduled time.": "Onaylandı — planlanan zamanda müşterilere gönderilecek.",
  "Approved — the role is assigned.": "Onaylandı — rol atandı.",
  "Approved.": "Onaylandı.",
  "Approve…": "Onayla…",
  "approx weight": "yaklaşık ağırlık",
  "Are you sure you want to delete this coupon?": "Bu kuponu silmek istediğinizden emin misiniz?",
  "Are you sure you want to delete this delivery area?": "Bu teslimat bölgesini silmek istediğinizden emin misiniz?",
  "Are you sure you want to delete this group?": "Bu grubu silmek istediğinizden emin misiniz?",
  "Are you sure you want to delete this invoice?": "Bu faturayı silmek istediğinizden emin misiniz?",
  "Are you sure you want to delete this menu?": "Bu menüyü silmek istediğinizden emin misiniz?",
  "Are you sure you want to delete this option item?": "Bu seçeneği silmek istediğinizden emin misiniz?",
  "Are you sure you want to delete this product?": "Bu ürünü silmek istediğinizden emin misiniz?",
  "Are you sure you want to delete this stock audit?": "Bu stok denetimini silmek istediğinizden emin misiniz?",
  "Are you sure you want to delete this stock?": "Bu stoğu silmek istediğinizden emin misiniz?",
  "Are you sure you want to delete this this vendor?": "Bu tedarikçiyi silmek istediğinizden emin misiniz?",
  "Are you sure you want to delete this user?": "Bu kullanıcıyı silmek istediğinizden emin misiniz?",
  "Are you sure you want to send this SMS to all brand customers?": "Bu SMS'i markanın tüm müşterilerine göndermek istediğinizden emin misiniz?",
  "Are you sure you want to send this SMS to all selected store customers?": "Bu SMS'i seçili mağazaların tüm müşterilerine göndermek istediğinizden emin misiniz?",
  "ARRIVED": "GELEN",
  "As a check, the same rate computed entirely inside Google Analytics for {0} days from {1} is": "Kontrol olarak, {1} tarihinden itibaren {0} gün boyunca tamamen Google Analytics içinde hesaplanan aynı oran",
  "As soon as it is on": "Açılır açılmaz",
  "Ask before changes: Off": "Değişikliklerden önce sor: Kapalı",
  "Ask before changes: On": "Değişikliklerden önce sor: Açık",
  "Ask Connect… Enter to send": "Connect'e sorun… Enter ile gönderin",
  "Ask for a role": "Rol iste",
  "Ask out loud in any language. It answers by voice.": "Herhangi bir dilde sesli sorun. Sesli yanıt verir.",
  "Ask out loud in any language; it answers by voice.": "Herhangi bir dilde sesli sorun; sesli yanıt verir.",
  "Ask to delete “{0}”?": "“{0}” için silme isteği gönderilsin mi?",
  "Ask to delete…": "Silinmesini iste…",
  "Asked for": "İstenen",
  "assistant": "asistan",
  "Assistant": "Asistan",
  "At every store.": "Tüm mağazalarda.",
  "At least this many in the cart": "Sepette en az bu kadar",
  "At Risk": "Risk altında",
  "At risk": "Risk altında",
  "at Stock list prices": "Stok listesi fiyatlarıyla",
  "At the time this goes out the deal is not running (its dates, days or hours), so checkout will not apply it.": "Bu gönderildiği anda kampanya geçerli değil (tarihleri, günleri veya saatleri nedeniyle); bu yüzden ödeme adımında uygulanmaz.",
  "at {0}": "· {0}",
  "ATLAS": "ATLAS",
  "Atlas could not be opened.": "Atlas açılamadı.",
  "Atlas's AI Studio and archive, signed in as you": "Atlas'ın AI Studio'su ve arşivi; sizin hesabınızla giriş yapılmış olarak",
  "Atlas's SMS panel, signed in as you": "Atlas'ın SMS paneli; sizin hesabınızla giriş yapılmış olarak",
  "Attach an image (JPEG or PNG)": "Görsel ekle (JPEG veya PNG)",
  "Attached to the items you pick. Customers see the badge on those items in the menu, a nudge in the cart, and the deal on the Deals page.": "Seçtiğiniz ürünlere bağlıdır. Müşteriler menüde bu ürünlerin üzerinde rozeti, sepette teşvik edici bir mesajı ve Kampanyalar sayfasında kampanyayı görür.",
  "Attempts": "Denemeler",
  "ATTEMPTS": "DENEMELER",
  "Audits": "Denetimler",
  "Audits (old)": "Denetimler (eski)",
  "Automation": "Otomasyon",
  "Availability Settings": "Uygunluk ayarları",
  "Available groups ({0}) were left empty.": "Seçilebilir gruplar ({0}) boş bırakıldı.",
  "AVERAGE": "ORTALAMA",
  "average across the window": "dönem ortalaması",
  "Average Hourly Sales — {0}": "Saatlik ortalama satış — {0}",
  "Average order value": "Ortalama sipariş tutarı",
  "Average order, 7 days": "Ortalama sipariş, 7 gün",
  "AVERAGE TICKET": "ORTALAMA SEPET",
  "AVG (PERIOD)": "ORT. (DÖNEM)",
  "AVG DAILY SALES": "ORT. GÜNLÜK SATIŞ",
  "AVG ITEM PRICE": "ORT. ÜRÜN FİYATI",
  "Avg order": "Ort. sipariş",
  "AVG ORDER": "ORT. SİPARİŞ",
  "AVG PRICE": "ORT. FİYAT",
  "avg ticket": "ortalama sepet",
  "Avg ticket": "Ortalama sepet",
  "AVG TICKET": "ORTALAMA SEPET",
  "Avg Ticket Trend": "Ortalama sepet trendi",
  "Avg Ticket Trend Error": "Ortalama sepet trendi hatası",
  "AVG TICKET {0}": "ORTALAMA SEPET {0}",
  "Avg wait": "Ort. bekleme",
  "avg {0}": "ort. {0}",
  "avg. {0}": "ort. {0}",
  "B": "B",
  "Back": "Geri",
  "Back to deals": "Kampanyalara dön",
  "Badge on the free item": "Ücretsiz üründe rozet",
  "Badge on the items": "Ürünlerde rozet",
  "Bag Product": "Poşet ürünü",
  "banner": "banner",
  "Banner": "Banner",
  "Banner created successfully.": "Banner oluşturuldu.",
  "Banner Type": "Banner türü",
  "Banner updated successfully.": "Banner güncellendi.",
  "Banners": "Banner'lar",
  "Barcode": "Barkod",
  "Barcode cannot be empty!": "Barkod boş olamaz!",
  "Base": "Taban",
  "Base price": "Taban fiyat",
  "BASE UNIT": "TEMEL BİRİM",
  "Based on the order total, not on an item. No badge in the menu — customers see a progress nudge in the cart (“Add $12 more…”) and the deal on the Deals page.": "Bir ürüne değil, sipariş toplamına bağlıdır. Menüde rozet yoktur — müşteriler sepette bir ilerleme mesajı (“Add $12 more…”) ve Kampanyalar sayfasında kampanyayı görür.",
  "Basic Information": "Temel bilgiler",
  "BASIS": "MATRAH",
  "Beer": "Bira",
  "Before": "Önceki hali",
  "before tax": "vergi öncesi",
  "before tax, the customer gets this for free:": "vergi hariç olduğunda müşteri şunu ücretsiz alır:",
  "before tax.": "vergi hariç.",
  "Before this can be saved:": "Kaydedebilmek için önce:",
  "being prepared": "hazırlanıyor",
  "Below target": "Hedefin altında",
  "BELOW TARGET": "HEDEFİN ALTINDA",
  "between open and {0}": "açılış ile {0} arası",
  "Between the last two counts, with everything that arrived in between added in. No recipes are involved — this is simply what went missing from the shelf, which is the number that says how much to order.": "Son iki sayım arası, aradaki tüm gelenler de eklenerek. Tarifler işin içinde değildir — bu yalnızca raftan eksilen miktardır; ne kadar sipariş verileceğini söyleyen sayı da budur.",
  "between {0} and close": "{0} ile kapanış arası",
  "between {0} and {1}": "{0} ile {1} arası",
  "Big text on the deal card.": "Kampanya kartındaki büyük yazı.",
  "Billing Address cannot be empty": "Fatura adresi boş olamaz",
  "Bills and invoices": "Fiş ve faturalar",
  "blank": "boş",
  "block is normal for a brand with a long tail of one-time guests — those people were never really retained. The rows worth spending money on are": "bloğu, tek seferlik misafirlerden oluşan uzun bir kuyruğu olan markalar için normaldir — bu kişiler hiçbir zaman gerçekten elde tutulmamıştı. Para harcamaya değer satırlar",
  "Body": "Metin",
  "Bold": "Kalın",
  "Both empty = all day. Example: 17:00 to 21:00 for an evening-only deal. A window that passes midnight (22:00 to 02:00) works too.": "İkisi de boş = tüm gün. Örnek: yalnızca akşam geçerli bir kampanya için 17:00 ile 21:00 arası. Gece yarısını geçen bir aralık (22:00 ile 02:00 arası) da çalışır.",
  "Bottom picture": "Alt görsel",
  "bottom picture": "alt görsel",
  "Boxing Status": "Kutulama durumu",
  "Branch Settings": "Mağaza ayarları",
  "BRAND": "MARKA",
  "Brand": "Marka",
  "Brand Menu": "Marka menüsü",
  "BRAND'S MENU": "MARKA MENÜSÜ",
  "Brand-wide, whatever the location picker says. The seven-day figures cover the seven complete days ending yesterday, so today is never counted twice or plotted half-finished. Sales are net, as the POS reports them: after discounts, without tax, tips, delivery fees or bottle deposits, on the day the order was closed out. Uber, DoorDash and Skip are not included.": "Mağaza seçicide ne seçili olursa olsun marka geneli. Yedi günlük rakamlar dünle biten son yedi tam günü kapsar; böylece bugün asla iki kez sayılmaz ya da yarım çizilmez. Satışlar POS'un bildirdiği gibi nettir: indirimler düşülmüş; vergi, bahşiş, teslimat ücretleri ve şişe depozitoları hariç; siparişin kapatıldığı güne göre. Uber, DoorDash ve Skip dahil değildir.",
  "Breadcrumb": "Sayfa yolu",
  "Bring it back": "Geri getir",
  "Bronze": "Bronz",
  "Bronze is where everyone starts. Each tier needs at least what the tier before it needs; only the measure chosen here decides the tier.": "Herkes Bronz seviyeden başlar. Her seviye en az bir önceki seviye kadar şart ister; seviyeyi yalnızca burada seçilen ölçüt belirler.",
  "Build": "Oluştur",
  "Build a deal, switch it on, see what it gave away": "Kampanya kurun, açın, ne kadar indirim verdiğini görün",
  "Build a set of permissions and give it a name": "Bir yetki kümesi oluşturun ve ona bir ad verin",
  "Build a trackable link for a post or an email": "Bir gönderi ya da e-posta için izlenebilir bağlantı oluşturun",
  "Build campaign URLs, and see what the campaign actually did": "Kampanya URL'leri oluşturun ve kampanyanın gerçekte ne getirdiğini görün",
  "Build links": "Bağlantı oluştur",
  "Building…": "Oluşturuluyor…",
  "Built-in role. It cannot be edited, only copied.": "Yerleşik rol. Düzenlenemez, yalnızca kopyalanabilir.",
  "Bulleted list": "Madde işaretli liste",
  "Bundle": "Birlikte al",
  "Busiest hours": "En yoğun saatler",
  "BUSIEST SLOT": "EN YOĞUN DİLİM",
  "busy": "yoğun",
  "Button text": "Düğme metni",
  "button text": "düğme metni",
  "Button text on the card": "Karttaki düğme metni",
  "Buy 2 pizzas, get the 2nd free": "2 pizza al, ikincisi ücretsiz",
  "Buy a large pizza, add a pop free": "Büyük boy pizza al, yanına gazlı içecek ücretsiz",
  "Buy some, get one": "Birkaç al, bir tane kazan",
  "BUYERS": "ALICILAR",
  "Buying certain items adds another item free or discounted.": "Belirli ürünler alındığında başka bir ürün ücretsiz ya da indirimli olarak eklenir.",
  "Buying {0} of {1} adds {2} at no charge (up to {3}).": "{0} adet {1} alındığında {2} ücretsiz eklenir (en fazla {3} adet).",
  "Buying {0} of {1} adds {2} at no charge.": "{0} adet {1} alındığında {2} ücretsiz eklenir.",
  "Buying {0} of {1} adds {2} at {3}% off (up to {4}).": "{0} adet {1} alındığında {2} %{3} indirimle eklenir (en fazla {4} adet).",
  "Buying {0} of {1} adds {2} at {3}% off.": "{0} adet {1} alındığında {2} %{3} indirimle eklenir.",
  "by": "yapan",
  "by default, the way Sysco delivers them — the case size on each line comes from the order guide, so there is no need to work anything out in kilos. Switch a line to its own unit if a case was split.": "cinsindendir (varsayılan olarak), tıpkı Sysco'nun teslim ettiği gibi — her satırdaki koli büyüklüğü sipariş kılavuzundan gelir, bu yüzden kilo hesabı yapmanız gerekmez. Bir koli bölündüyse o satırı kendi birimine çevirin.",
  "By e-mail, phone, name or customer number. Open one to see their points history or to give some back.": "E-posta, telefon, ad veya müşteri numarasıyla. Puan geçmişini görmek ya da puan iade etmek için birini açın.",
  "By Order Source": "Sipariş kaynağına göre",
  "By send time, newest first": "Gönderim saatine göre, en yeni önce",
  "By send time, oldest first": "Gönderim saatine göre, en eski önce",
  "By store": "Mağazaya göre",
  "By store — {0}": "Mağazaya göre — {0}",
  "by {0}": "({0} tarafından)",
  "by {0} · {1}": "isteyen: {0} · {1}",
  "by {0} · {1} — goes out to customers at {2}": "{0} tarafından · {1} — müşterilere {2} tarihinde gönderilir",
  "by {0} · {1} — goes out to customers on the sender’s next run": "{0} tarafından · {1} — müşterilere gönderim görevinin bir sonraki çalışmasında gönderilir",
  "By {0}; the bar is each one's share of the leader's.": "Ölçüt: {0}; çubuk, her birinin liderinkine oranını gösterir.",
  "Calendar": "Takvim",
  "Calories": "Kalori",
  "Came back after a gap.": "Bir aradan sonra geri döndü.",
  "came back the month after joining": "katıldıktan sonraki ay geri geldi",
  "Campaign": "Kampanya",
  "CAMPAIGN": "KAMPANYA",
  "Campaign links": "Kampanya bağlantıları",
  "Campaign outcomes": "Kampanya sonuçları",
  "Campaign Performance Error": "Kampanya performansı hatası",
  "Campaign Title": "Kampanya başlığı",
  "Campaign title is required": "Kampanya başlığı gerekli",
  "CAMPAIGNS SEEN": "GÖRÜLEN KAMPANYALAR",
  "can tell one offer from another.": "sütunu ayırt edebilir.",
  "Canadian": "Kanada ürünü",
  "Cancel": "İptal",
  "Cancel this session for everyone?": "Bu oturum herkes için iptal edilsin mi?",
  "Cancelled": "İptal edildi",
  "Cannot change once the deal exists — orders reference it.": "Kampanya oluşturulduktan sonra değiştirilemez — siparişler bu anahtara bağlı.",
  "Cannot get coupon product list.": "Kupon ürün listesi alınamadı.",
  "Card colour": "Kart rengi",
  "Card picture": "Kart görseli",
  "card picture": "kart görseli",
  "Card, cash and the rest": "Kart, nakit ve diğerleri",
  "Carousel icon name": "Karusel simge adı",
  "CARRYOUT": "GEL-AL",
  "Cart nudge": "Sepet mesajı",
  "Cart progress nudge": "Sepet ilerleme mesajı",
  "Cart was updated": "Sepet güncellendi",
  "case": "koli",
  "CASE": "CASE",
  "CASE PRICE": "CASE FİYATI",
  "cases": "koli",
  "Cases": "Vakalar",
  "Cashier": "Kasiyer",
  "Cashier/Manager": "Kasiyer/Müdür",
  "Catch weight": "Değişken ağırlık",
  "CATEGORY": "KATEGORİ",
  "Category mix": "Kategori dağılımı",
  "cell is a month that cohort has not lived through yet. The two used to look identical, which made a real zero read as missing data.": "hücre ise o kohortun henüz yaşamadığı bir aydır. İkisi eskiden aynı görünüyordu; bu da gerçek bir sıfırın eksik veri gibi okunmasına yol açıyordu.",
  "Champion": "Şampiyon",
  "Change": "Değiştir",
  "CHANGE": "DEĞİŞİM",
  "Change it": "Değiştir",
  "Change something": "Bir şeyi değiştir",
  "Change the menu": "Menüyü değiştir",
  "changed in the panel": "panelde değiştirildi",
  "Changes apply the moment you save — this deal is {0}.": "Değişiklikler kaydettiğiniz anda geçerli olur — bu kampanya {0}.",
  "changes as you type": "yazdıkça değişir",
  "CHANNEL": "KANAL",
  "Channel Breakdown": "Kanal dağılımı",
  "Channel Detail": "Kanal ayrıntısı",
  "Channel Distribution by Store": "Mağazaya göre kanal dağılımı",
  "Channel Mix Error": "Kanal dağılımı hatası",
  "Channels": "Kanallar",
  "Channels ›": "Kanallar ›",
  "Chart": "Grafik",
  "Chat": "Sohbet",
  "Chat is not installed on this server yet.": "Sohbet bu sunucuda henüz kurulu değil.",
  "check": "kontrol et",
  "Check & save": "Kontrol et & kaydet",
  "Check and create": "Kontrol et ve oluştur",
  "Check and finish": "Kontrol et ve bitir",
  "Check and save": "Kontrol et ve kaydet",
  "Check on the stores": "Mağazaları kontrol et",
  "check this": "bunu kontrol edin",
  "Checked": "Seçili",
  "Checked out:": "Sipariş verildi:",
  "Checkout completed": "Ödeme tamamlandı",
  "Chicken": "Tavuk",
  "Choice {0}": "Seçim {0}",
  "Choice {0} needs a name (e.g. “Pick a pizza”)": "Seçim {0} için bir ad gerekli (ör. “Pick a pizza”)",
  "Choice {0}: pick a category or some items": "Seçim {0}: bir kategori ya da birkaç ürün seçin",
  "Choose a date": "Bir tarih seçin",
  "Choose a deal type": "Bir kampanya türü seçin",
  "Choose a deal type in step 1 first.": "Önce 1. adımda bir kampanya türü seçin.",
  "Choose a deal type to see what customers will get.": "Müşterilerin ne alacağını görmek için bir kampanya türü seçin.",
  "Choose a deal…": "Kampanya seçin…",
  "Choose a month": "Bir ay seçin",
  "Choose a picture": "Resim seç",
  "Choose a picture from this computer": "Bu bilgisayardan görsel seç",
  "Choose a product…": "Ürün seçin…",
  "Choose a store special…": "Mağazaya özel ürün seçin…",
  "Choose a week": "Bir hafta seçin",
  "Choose an image": "Bir görsel seçin",
  "Choose another picture": "Başka bir görsel seç",
  "Choose the dates": "Tarihleri seçin",
  "Choose the free item": "Ücretsiz ürünü seçin",
  "Choose what is added to the order": "Siparişe eklenecek ürünü seçin",
  "Choose…": "Seçin…",
  "chosen items": "seçilen ürünler",
  "Churn": "Kayıp riski",
  "CHURN": "KAYIP RİSKİ",
  "Clear": "Temizle",
  "Clear the filters": "Filtreleri temizle",
  "Clear this conversation": "Bu sohbeti temizle",
  "Clear this conversation?": "Bu sohbet temizlensin mi?",
  "Clear {0} not approved": "Onaylanmayan {0} bildirimi temizle",
  "Click a store to open its stock on hand. Stock value uses the prices on the Stock list, and \"To order\" is the same suggestion each store sees on its Reorder page.": "Eldeki stoğunu açmak için bir mağazaya tıklayın. Stok değeri Stok listesindeki fiyatları kullanır; \"Sipariş edilecek\" ise her mağazanın kendi Yeniden sipariş sayfasında gördüğü önerinin aynısıdır.",
  "Click to upload image": "Görsel yüklemek için tıklayın",
  "Clickable": "Tıklanabilir",
  "Clickable Link": "Tıklanabilir bağlantı",
  "Close": "Kapat",
  "Close {0}": "Kapat: {0}",
  "CLOSED": "KAPANIŞ",
  "Closed": "Kapandı",
  "Closed: {0}": "Kapatıldı: {0}",
  "Closing": "Kapanış",
  "Closing text": "Kapanış metni",
  "closing text": "kapanış metni",
  "Code": "Kod",
  "CODE": "KOD",
  "CODE ATTEMPTS": "KOD DENEMELERİ",
  "CODE CARRIED, NOT APPLIED": "KOD GETİRİLDİ, UYGULANMADI",
  "COHORT": "KOHORT",
  "Cohort triangle": "Kohort üçgeni",
  "Cohorts are rebuilt nightly; check back after the next run.": "Kohortlar her gece yeniden oluşturulur; bir sonraki çalışmadan sonra tekrar bakın.",
  "COHORTS TRACKED": "İZLENEN KOHORTLAR",
  "Collapse the menu": "Menüyü daralt",
  "COLLECTED": "TAHSİL EDİLEN",
  "columns are empty for all of them. Until that changes, only": "sütunları hepsi için boştur. Bu değişene kadar teklifleri birbirinden yalnızca",
  "Combo": "Kombo",
  "Combo builder screen": "Kombo oluşturma ekranı",
  "Coming soon": "Çok yakında",
  "Commands": "Komutlar",
  "Comment": "Yorum",
  "Company": "Firma",
  "Company Address": "Firma adresi",
  "Company cannot be empty": "Firma boş olamaz",
  "Company E-mail": "Firma e-postası",
  "compared with {0}, and with {1} a year ago, on the same weekdays": "{0} ve bir yıl önceki {1} ile aynı hafta günleri bazında karşılaştırma",
  "Completed": "Tamamlandı",
  "Complimentary": "İkram",
  "Confirm": "Onayla",
  "Confirmed": "Onaylandı",
  "Confirmed by store": "Mağaza onayladı",
  "Connect": "Connect",
  "Connect change": "Connect değişikliği",
  "Connect changes waiting": "Bekleyen Connect değişiklikleri",
  "Connect could not answer just now.": "Connect şu anda yanıt veremedi.",
  "Connect could not answer.": "Connect yanıt veremedi.",
  "Connect could not reach the voice service.": "Connect ses servisine ulaşamadı.",
  "Connect is speaking": "Connect konuşuyor",
  "Connect is thinking…": "Connect düşünüyor…",
  "Connect Panel": "Connect Panel",
  "Connect proposes": "Connect öneriyor",
  "Connect, the assistant": "Connect, asistanınız",
  "Connect, the assistant: ask it anything about the panel": "Connect, asistanınız: panelle ilgili her şeyi sorun",
  "Connecting…": "Bağlanıyor…",
  "Connect’s Deliveries page has {0} {1} for this month ({2}).": "Connect’in Teslimatlar sayfasında bu ay için {0} fatura var ({2}).",
  "Connect’s sales for this month changed since you checked them (late orders were closed out). Please look at them again.": "Connect’in bu ayki satışları siz kontrol ettikten sonra değişti (geç gelen siparişler kapatıldı). Lütfen bunlara yeniden bakın.",
  "Contact": "İletişim",
  "CONTACT": "İLETİŞİM",
  "Continue the sync": "Eşitlemeye devam et",
  "Conversations could not be loaded.": "Sohbetler yüklenemedi.",
  "Conversion Error": "Dönüşüm hatası",
  "Conversion rate": "Dönüşüm oranı",
  "Conversions": "Dönüşümler",
  "Cooking Time (secs)": "Pişirme süresi (sn)",
  "Copied": "Kopyalandı",
  "Copy": "Kopyala",
  "Copy all": "Tümünü kopyala",
  "Copy Menu": "Menüyü kopyala",
  "Copy Menus": "Menüleri kopyala",
  "Copy Product": "Ürünü kopyala",
  "Copy this role": "Bu rolü kopyala",
  "Copying...": "Kopyalanıyor...",
  "COST": "MALİYET",
  "Cost": "Maliyet",
  "Cost: {0}": "Maliyet: {0}",
  "Could not apply the rest just now.": "Geri kalanı şu anda uygulanamadı.",
  "Could not apply the rest.": "Geri kalanı uygulanamadı.",
  "Could not approve the proposal.": "Öneri onaylanamadı.",
  "Could not approve.": "Onaylanamadı.",
  "Could not build links": "Bağlantılar oluşturulamadı",
  "Could not change banner status.": "Banner durumu değiştirilemedi.",
  "Could not change that just now.": "Bu şu anda değiştirilemedi.",
  "Could not change that.": "Bu ayar değiştirilemedi.",
  "Could not change the deal status.": "Kampanya durumu değiştirilemedi.",
  "Could not change the model just now.": "Model şu anda değiştirilemedi.",
  "Could not change the model.": "Model değiştirilemedi.",
  "Could not change the points.": "Puanlar değiştirilemedi.",
  "Could not change the role.": "Rol değiştirilemedi.",
  "Could not clear the conversation.": "Sohbet temizlenemedi.",
  "Could not close the session.": "Oturum kapatılamadı.",
  "Could not confirm the order.": "Sipariş onaylanamadı.",
  "Could not copy product": "Ürün kopyalanamadı",
  "Could not create the group.": "Grup oluşturulamadı.",
  "Could not delete banner.": "Banner silinemedi.",
  "Could not delete notification.": "Bildirim silinemedi.",
  "Could not delete that file just now.": "Bu dosya şu anda silinemedi.",
  "Could not delete that file.": "Bu dosya silinemedi.",
  "Could not delete the deal.": "Kampanya silinemedi.",
  "Could not delete the group.": "Grup silinemedi.",
  "Could not delete the message.": "Mesaj silinemedi.",
  "Could not delete the role.": "Rol silinemedi.",
  "Could not do that just now.": "Bu işlem şu anda yapılamadı.",
  "Could not do that.": "Bu işlem yapılamadı.",
  "Could not encrypt the message.": "Mesaj şifrelenemedi.",
  "Could not get the file just now.": "Dosya şu anda alınamadı.",
  "Could not load creations.": "Kreasyonlar yüklenemedi.",
  "Could not load deals.": "Kampanyalar yüklenemedi.",
  "Could not load earlier messages.": "Önceki mesajlar yüklenemedi.",
  "Could not load featured products.": "Öne çıkan ürünler yüklenemedi.",
  "Could not load group orders.": "Grup siparişleri yüklenemedi.",
  "Could not load live orders.": "Canlı siparişler yüklenemedi.",
  "Could not load notifications.": "Bildirimler yüklenemedi.",
  "Could not load performance data.": "Performans verileri yüklenemedi.",
  "Could not load proposals.": "Öneriler yüklenemedi.",
  "Could not load roles.": "Roller yüklenemedi.",
  "Could not load targeting.": "Hedefleme yüklenemedi.",
  "Could not load that person's stores.": "Bu kişinin mağazaları yüklenemedi.",
  "Could not load the conversation.": "Sohbet yüklenemedi.",
  "Could not load the creation.": "Kreasyon yüklenemedi.",
  "Could not load the customer's points.": "Müşterinin puanları yüklenemedi.",
  "Could not load the deal.": "Kampanya yüklenemedi.",
  "Could not load the notification.": "Bildirim yüklenemedi.",
  "Could not load the order list.": "Sipariş listesi yüklenemedi.",
  "Could not load the order.": "Sipariş yüklenemedi.",
  "Could not load the permission list.": "Yetki listesi yüklenemedi.",
  "Could not load the product list.": "Ürün listesi yüklenemedi.",
  "Could not load the request.": "Talep yüklenemedi.",
  "Could not load the session.": "Oturum yüklenemedi.",
  "Could not load the story.": "Yazı yüklenemedi.",
  "Could not load users.": "Kullanıcılar yüklenemedi.",
  "Could not load your files just now.": "Dosyalarınız şu anda yüklenemedi.",
  "Could not load your files.": "Dosyalarınız yüklenemedi.",
  "Could not make the channel key.": "Kanal anahtarı oluşturulamadı.",
  "Could not make the file in this browser.": "Dosya bu tarayıcıda oluşturulamadı.",
  "Could not mark the order paid.": "Sipariş ödendi olarak işaretlenemedi.",
  "Could not prepare that just now.": "Bu şu anda hazırlanamadı.",
  "Could not prepare that.": "Bu işlem hazırlanamadı.",
  "Could not reach the blog service. It may not be installed on this server yet.": "Blog servisine ulaşılamadı. Bu sunucuda henüz kurulu olmayabilir.",
  "Could not reach the creations service. It may not be installed on this server yet.": "Kreasyon servisine ulaşılamadı. Bu sunucuda henüz kurulu olmayabilir.",
  "Could not reach the featured-products service. It may not be installed on this server yet.": "Öne çıkan ürünler servisine ulaşılamadı. Bu sunucuda henüz kurulu olmayabilir.",
  "Could not reach the group-orders service. It may not be installed on this server yet.": "Grup siparişleri servisine ulaşılamadı. Bu sunucuda henüz kurulu olmayabilir.",
  "Could not reach the live-orders service. It may not be installed on this server yet.": "Canlı siparişler servisine ulaşılamadı. Bu sunucuda henüz kurulu olmayabilir.",
  "Could not reach the loyalty service.": "Sadakat servisine ulaşılamadı.",
  "Could not reach the permissions service. It may not be installed on this server yet.": "Yetkiler servisine ulaşılamadı. Bu sunucuda henüz kurulu olmayabilir.",
  "Could not reach the server just now.": "Şu anda sunucuya ulaşılamadı.",
  "Could not reach the server.": "Sunucuya ulaşılamadı.",
  "Could not reject the proposal.": "Öneri reddedilemedi.",
  "Could not reject.": "Reddedilemedi.",
  "Could not remove it.": "Kaldırılamadı.",
  "Could not reorder banner.": "Banner'ın sırası değiştirilemedi.",
  "Could not reschedule.": "Yeniden planlanamadı.",
  "Could not resolve the request.": "Talep sonuçlandırılamadı.",
  "Could not retry just now.": "Şu anda yeniden denenemedi.",
  "Could not save": "Kaydedilemedi",
  "Could not save rates": "Oranlar kaydedilemedi",
  "Could not save targeting.": "Hedefleme kaydedilemedi.",
  "Could not save the deal.": "Kampanya kaydedilemedi.",
  "Could not save the loyalty rules.": "Sadakat kuralları kaydedilemedi.",
  "Could not save the role.": "Rol kaydedilemedi.",
  "Could not save the settings.": "Ayarlar kaydedilemedi.",
  "Could not save the stores.": "Mağazalar kaydedilemedi.",
  "Could not search customers.": "Müşteri araması yapılamadı.",
  "Could not send notification.": "Bildirim gönderilemedi.",
  "Could not send the message.": "Mesaj gönderilemedi.",
  "Could not send the request.": "Talep gönderilemedi.",
  "Could not set up the encryption in this browser.": "Bu tarayıcıda şifreleme kurulamadı.",
  "Could not submit": "Gönderilemedi",
  "Could not test notification.": "Bildirim test edilemedi.",
  "Could not update the creation.": "Kreasyon güncellenemedi.",
  "Could not update the photo.": "Fotoğraf güncellenemedi.",
  "Count not saved": "Sayım kaydedilmedi",
  "Count submitted": "Sayım gönderildi",
  "COUNTED": "SAYILAN",
  "Counted only": "Yalnızca sayılanlar",
  "counted orders": "sayılan sipariş",
  "COUNTER & MARKETPLACE": "KASA & PAZAR YERİ",
  "counts distinct visitors doing it. With a store selected these are placed at that store by following the visitor session to the order it placed or the cart it built, so a code advertised for one store showing attempts at another is customers trying it at the wrong till. A campaign with attempts but no redemptions is being tried and refused. A campaign with no attempts at all was applied at the till or automatically, never typed — which is why its redeem rate is blank rather than zero.": "bunu yapan farklı ziyaretçileri sayar. Bir mağaza seçiliyken bunlar, ziyaretçi oturumu verdiği siparişe ya da oluşturduğu sepete kadar izlenerek o mağazaya atanır; bu yüzden bir mağaza için duyurulan bir kodun başka bir mağazada deneme göstermesi, müşterilerin kodu yanlış kasada denediği anlamına gelir. Denemesi olup kullanımı olmayan bir kampanya deneniyor ama reddediliyor demektir. Hiç denemesi olmayan bir kampanya ise kasada ya da otomatik olarak uygulanmıştır, hiç yazılmamıştır — kullanım oranının sıfır yerine boş görünmesinin nedeni budur.",
  "counts every time the code was typed into the online coupon box,": "kodun online kupon kutusuna her yazılışını sayar,",
  "Coupon": "Kupon",
  "COUPON": "KUPON",
  "coupon": "kupon",
  "Coupon Code": "Kupon kodu",
  "Coupon code cannot be empty!": "Kupon kodu boş olamaz!",
  "Coupon code is required for coupon notifications.": "Kupon bildirimleri için kupon kodu gerekli.",
  "Coupon code must be at least 6 characters!": "Kupon kodu en az 6 karakter olmalı!",
  "coupon code, e.g. LRCQ50": "kupon kodu, ör. LRCQ50",
  "Coupon code, e.g. SAVE10": "Kupon kodu, ör. SAVE10",
  "Coupon Description": "Kupon açıklaması",
  "Coupon discount cannot be empty or zero!": "Kupon indirimi boş veya sıfır olamaz!",
  "Coupon discount cannot be negative!": "Kupon indirimi negatif olamaz!",
  "Coupon has been deleted successfully!": "Kupon silindi!",
  "Coupon has been saved successfully.": "Kupon kaydedildi.",
  "Coupon has been updated successfully.": "Kupon güncellendi.",
  "Coupon Name": "Kupon adı",
  "Coupon name cannot be empty!": "Kupon adı boş olamaz!",
  "Coupon Product": "Kupon ürünü",
  "Coupon Products": "Kupon ürünleri",
  "Coupon status updated": "Kupon durumu güncellendi",
  "Coupon Title": "Kupon başlığı",
  "Coupon: {0}": "Kupon: {0}",
  "Coupons": "Kuponlar",
  "coupons": "kupon",
  "Coupons are doing the work: {0} orders used one, against {1} that used a deal.": "İşi kuponlar yapıyor: {0} siparişte kupon, buna karşılık {1} siparişte kampanya kullanıldı.",
  "Create": "Oluştur",
  "Create a code and choose where it works": "Bir kod oluşturun ve nerede geçerli olacağını seçin",
  "Create a code customers can type in at checkout": "Müşterilerin ödeme adımında girebileceği bir kod oluşturun",
  "Create a new role": "Yeni rol oluştur",
  "Create Area": "Bölge oluştur",
  "Create Audit": "Denetim oluştur",
  "Create Bag": "Poşet oluştur",
  "Create Banner": "Banner oluştur",
  "Create Coupon": "Kupon oluştur",
  "Create Coupon Item": "Kupon ürünü oluştur",
  "Create deal (stays OFF)": "Kampanyayı oluştur (KAPALI kalır)",
  "Create Invoice": "Faturayı oluştur",
  "Create Menu": "Menü oluştur",
  "Create Menuboard": "Menü ekranı oluştur",
  "Create New Notification": "Yeni bildirim oluştur",
  "Create Notification": "Bildirim oluştur",
  "Create Option Item": "Seçenek oluştur",
  "Create or change an offer, step by step": "Adım adım kampanya oluşturun veya değiştirin",
  "Create Product": "Ürün oluştur",
  "Create role": "Rol oluştur",
  "Create Screen": "Ekran oluştur",
  "Create SMS Campaign": "SMS kampanyası oluştur",
  "Create Stock": "Stok oluştur",
  "Create Template": "Şablon oluştur",
  "Create User": "Kullanıcı oluştur",
  "Create Vendor": "Tedarikçi oluştur",
  "Create your first banner to start promoting.": "Tanıtıma başlamak için ilk banner'ınızı oluşturun.",
  "Create your first push notification to get started.": "Başlamak için ilk anlık bildiriminizi oluşturun.",
  "Create {0}": "{0} adet oluştur",
  "Created": "Oluşturulma",
  "CREATED": "OLUŞTURULMA",
  "Created Date": "Oluşturulma tarihi",
  "Created:": "Oluşturulma:",
  "Creates {0} notifications: first {1}, last {2}.": "{0} bildirim oluşturur: ilki {1}, sonuncusu {2}.",
  "Creating...": "Oluşturuluyor...",
  "Creation #{0}": "Kreasyon #{0}",
  "Creation #{0} approved.": "Kreasyon #{0} onaylandı.",
  "Creation #{0} deleted.": "Kreasyon #{0} silindi.",
  "Creation #{0} flagged.": "Kreasyon #{0} işaretlendi.",
  "Creation #{0} hidden.": "Kreasyon #{0} gizlendi.",
  "Creation #{0} {1}.": "Kreasyon #{0}: {1}.",
  "Creation Time": "Oluşturulma zamanı",
  "Creations": "Kreasyonlar",
  "Creations could not be loaded.": "Kreasyonlar yüklenemedi.",
  "Creator:": "Oluşturan:",
  "CRM Analytics": "CRM analizi",
  "CRM Error": "CRM hatası",
  "Cross-Sell": "Çapraz satış",
  "Cross-Sell Manager": "Çapraz satış yöneticisi",
  "Curating: {0}": "Düzenlenen: {0}",
  "Current Image": "Mevcut görsel",
  "Current Image:": "Mevcut görsel:",
  "Current menu image": "Mevcut menü görseli",
  "Current product image": "Mevcut ürün görseli",
  "Currently featured": "Şu an öne çıkanlar",
  "currently switched off": "şu anda kapalı",
  "Custom": "Özel",
  "Custom Range Error": "Özel aralık hatası",
  "Customer": "Müşteri",
  "CUSTOMER": "MÜŞTERİ",
  "Customer #{0}": "Müşteri #{0}",
  "Customer Acquisition Error": "Müşteri kazanımı hatası",
  "customer brought a code and paid full price": "müşteri kod getirdi ama tam fiyat ödedi",
  "Customer creations": "Müşteri kreasyonları",
  "Customer Insights": "Müşteri içgörüleri",
  "Customer list": "Müşteri listesi",
  "Customer notes:": "Müşteri notları:",
  "Customer photo": "Müşteri fotoğrafı",
  "Customer Queue Screens": "Müşteri sıra ekranları",
  "Customer's real photo": "Müşterinin gerçek fotoğrafı",
  "Customers": "Müşteriler",
  "CUSTOMERS": "MÜŞTERİLER",
  "Customers build a combo for {0}: no choices yet.": "Müşteriler {0} fiyatına kendi kombolarını oluşturur: henüz seçim yok.",
  "Customers build a combo for {0}: {1}.": "Müşteriler {0} fiyatına kendi kombolarını oluşturur: {1}.",
  "Customers Error": "Müşteriler hatası",
  "customers of every store": "tüm mağazaların müşterileri",
  "customers of its stores": "kendi mağazalarının müşterileri",
  "customers of {0}": "{0} müşterileri",
  "CUSTOMERS TRACKED": "İZLENEN MÜŞTERİ",
  "Customers who buy {0} of {1} get {2} × {3} at no charge.": "{0} adet {1} alan müşteriler, {2} × {3} ücretsiz alır.",
  "Customers who buy {0} of {1} get {2} × {3} at {4}% off.": "{0} adet {1} alan müşteriler, {2} × {3} %{4} indirimle alır.",
  "Customers who stopped": "Sipariş vermeyi bırakan müşteriler",
  "Customers' tiers, points and weekly streaks; give or take back points": "Müşterilerin seviyeleri, puanları ve haftalık serileri; puan verin veya geri alın",
  "CustomerScreen name cannnot be empty!.": "Müşteri ekranı adı boş olamaz!",
  "CustomerScreen Title": "Müşteri ekranı başlığı",
  "Daily": "Günlük",
  "Daily average ticket with 7-day rolling average": "Günlük ortalama sepet ve 7 günlük hareketli ortalama",
  "Daily Avg": "Günlük ortalama",
  "DAILY AVG ORDERS": "GÜNLÜK ORT. SİPARİŞ",
  "DAILY AVG SALES": "GÜNLÜK ORT. SATIŞ",
  "Daily Avg Ticket": "Günlük ortalama sepet",
  "Daily Breakdown": "Günlük döküm",
  "Daily Online Orders Trend": "Günlük online sipariş trendi",
  "Daily Report": "Günlük rapor",
  "Daily Report Error": "Günlük rapor hatası",
  "Daily Revenue": "Günlük ciro",
  "Daily Revenue Trend": "Günlük ciro trendi",
  "Daily Revenue Trend by Channel": "Kanala göre günlük ciro trendi",
  "Daily Revenue — {0} to {1}": "Günlük ciro — {0} – {1}",
  "Daily sales for the last seven complete days, with the seven days before as a dashed line": "Son yedi tam günün günlük satışları; önceki yedi gün kesikli çizgiyle",
  "Daily Size Sales": "Günlük boy satışları",
  "Daily, weekly and monthly takings, and what sold": "Günlük, haftalık ve aylık hasılat ve neyin satıldığı",
  "DATA AS OF": "VERİ TARİHİ",
  "date": "tarih",
  "Date": "Tarih",
  "DATE": "TARİH",
  "Dates": "Tarihler",
  "Day": "Gün",
  "DAY": "GÜN",
  "day": "gün",
  "DAY BY DAY": "GÜN GÜN",
  "Day Part Error": "Gün dilimi hatası",
  "Day Part Summary": "Gün dilimi özeti",
  "Day-by-Day Breakdown": "Gün gün döküm",
  "Day-by-Day Revenue — {0}": "Gün gün ciro — {0}",
  "Day-by-Day Sales — {0}": "Gün gün satış — {0}",
  "Day:": "Gün:",
  "days": "gün",
  "DAYS IN PERIOD": "DÖNEMDEKİ GÜN",
  "days of order tracking": "günlük sipariş takibi",
  "Days of the week": "Haftanın günleri",
  "Days since": "Son siparişten beri",
  "DAYS SINCE": "SON SİPARİŞTEN BERİ",
  "days up to today": "gün, bugüne kadar",
  "days up to yesterday": "gün, düne kadar",
  "DAYS W/ DISCOUNTS": "İNDİRİMLİ GÜN",
  "Deactivate": "Devre dışı bırak",
  "deal": "kampanya",
  "Deal": "Kampanya",
  "Deal applied": "Kampanya uygulandı",
  "Deal Builder": "Kampanya oluşturucu",
  "Deal created and left OFF — switch it on when you are ready.": "Kampanya oluşturuldu ve KAPALI bırakıldı — hazır olduğunuzda açın.",
  "Deal created — it is OFF until you switch it on.": "Kampanya oluşturuldu — siz açana kadar KAPALI kalır.",
  "Deal Engine": "Kampanya motoru",
  "Deal has been removed.": "Kampanya kaldırıldı.",
  "Deal has been updated.": "Kampanya güncellendi.",
  "Deal is no longer offered.": "Kampanya artık sunulmuyor.",
  "Deal is now visible to customers.": "Kampanya artık müşterilere görünüyor.",
  "Deal title": "Kampanya başlığı",
  "Deal: {0}": "Kampanya: {0}",
  "Deals": "Kampanyalar",
  "Deals on specific items": "Belirli ürünlere yönelik kampanyalar",
  "Deals on the whole order": "Siparişin tamamına yönelik kampanyalar",
  "Deals page": "Kampanyalar sayfası",
  "Deals the engine drafted from ordering patterns. Nothing here reaches a customer until you approve it and switch it on.": "Motorun sipariş alışkanlıklarından taslak olarak hazırladığı kampanyalar. Siz onaylayıp açana kadar buradakilerin hiçbiri müşteriye ulaşmaz.",
  "Deals: {0}": "Kampanyalar: {0}",
  "Decide in Approvals": "Onaylar'da karar ver",
  "Decide which customers an offer is shown to": "Kampanyanın hangi müşterilere gösterileceğine karar verin",
  "Decide who each deal is offered to. Leave a deal untargeted and everyone sees it.": "Her kampanyanın kime sunulacağına karar verin. Bir kampanyayı hedefsiz bırakırsanız herkes görür.",
  "Decline": "Reddet",
  "Decline {0}’s request?": "{0} adlı kişinin isteği reddedilsin mi?",
  "Declined": "Reddedildi",
  "Declined.": "Reddedildi.",
  "default": "varsayılan",
  "Default": "Varsayılan",
  "Delete": "Sil",
  "DELETE ALL": "TÜMÜNÜ SİL",
  "Delete Banner": "Banner'ı sil",
  "Delete creation #{0}?": "Kreasyon #{0} silinsin mi?",
  "Delete group": "Grubu sil",
  "Delete Notification": "Bildirimi sil",
  "Delete this draft": "Bu taslağı sil",
  "Delete this file?": "Bu dosya silinsin mi?",
  "Delete this group": "Bu grubu sil",
  "Delete this group?": "Bu grup silinsin mi?",
  "Delete this order's rows in": "Bu siparişin satırlarını şu tablolardan silin:",
  "Delete “{0}” from the website?": "“{0}” web sitesinden silinsin mi?",
  "Delete “{0}”?": "“{0}” silinsin mi?",
  "Deleted": "Silindi",
  "Delete…": "Sil…",
  "Deliverect": "Deliverect",
  "Deliverect recorded {0}. Leave blank to use it, or type the platform statement figure to replace it.": "Deliverect kaydı: {0}. Bunu kullanmak için boş bırakın ya da yerine geçmesi için platform ekstresindeki rakamı yazın.",
  "Deliverect Sync Completed": "Deliverect eşitlemesi tamamlandı",
  "Deliveries": "Teslimatlar",
  "DELIVERIES": "TESLİMATLAR",
  "Deliveries Error": "Teslimatlar hatası",
  "Delivery": "Teslimat",
  "DELIVERY": "TESLİMAT",
  "Delivery address:": "Teslimat adresi:",
  "Delivery by Distance": "Mesafeye göre teslimat",
  "Delivery by Hour": "Saate göre teslimat",
  "Delivery fee": "Teslimat ücreti",
  "DELIVERY FEE": "TESLİMAT ÜCRETİ",
  "Delivery Fees": "Teslimat ücretleri",
  "DELIVERY FEES": "TESLİMAT ÜCRETLERİ",
  "Delivery Locations": "Teslimat noktaları",
  "DELIVERY MAP": "TESLİMAT HARİTASI",
  "Delivery Map": "Teslimat haritası",
  "Delivery not recorded": "Teslimat kaydedilmedi",
  "Delivery Price:": "Teslimat fiyatı:",
  "Delivery recorded": "Teslimat kaydedildi",
  "Delivery Report Error": "Teslimat raporu hatası",
  "DELIVERY REV": "TESLİMAT CİROSU",
  "Delivery/Pickup": "Teslimat/Gel-al",
  "Deposit": "Depozito",
  "Deposits": "Depozitolar",
  "DEPOSITS": "DEPOZİTOLAR",
  "Description": "Açıklama",
  "Description...": "Açıklama...",
  "Description:": "Açıklama:",
  "Destination": "Hedef sayfa",
  "DESTINATION": "HEDEF SAYFA",
  "Details": "Ayrıntılar",
  "DIFFERENCE": "FARK",
  "Dine-in is counted per ticket, where the POS counts per table, so a dine-in store shows more orders and a lower average ticket than the POS report. Its sales are the same.": "Restoranda yenen siparişler burada fiş başına sayılır, POS ise masa başına sayar; bu yüzden restoranda yemek servisi olan bir mağaza, POS raporuna göre daha fazla sipariş ve daha düşük ortalama sepet gösterir. Satışları aynıdır.",
  "Dip Sauce": "Dip sos",
  "Direct messages": "Doğrudan mesajlar",
  "DISC %": "İND. %",
  "Discard": "Vazgeç",
  "Discard your unsaved changes?": "Kaydedilmemiş değişikliklerinizden vazgeçilsin mi?",
  "Discount": "İndirim",
  "DISCOUNT": "İNDİRİM",
  "DISCOUNT %": "İNDİRİM %",
  "Discount ({0})": "İndirim ({0})",
  "Discount depth": "İndirim oranı",
  "DISCOUNT DEPTH": "İNDİRİM ORANI",
  "Discount Detail": "İndirim ayrıntısı",
  "Discount for Same Second Product (%)": "Aynı ikinci ürüne indirim (%)",
  "Discount given at the till": "Kasada yapılan indirim",
  "Discount totals by date and store — alert if >5% of revenue": "Tarih ve mağazaya göre indirim toplamları — ciro içindeki payı >%5 olursa uyarı",
  "Discount Trend": "İndirim trendi",
  "Discount Type": "İndirim türü",
  "Discounts": "İndirimler",
  "DISCOUNTS": "İNDİRİMLER",
  "Discounts & Voids": "İndirimler ve iptaller",
  "Discounts & Voids Error": "İndirimler ve iptaller hatası",
  "Dispatch Board": "Dağıtım panosu",
  "Distance Breakdown": "Mesafe dökümü",
  "DISTANCE ZONE": "MESAFE BÖLGESİ",
  "Do they come back?": "Geri geliyorlar mı?",
  "Done": "Tamamlanan",
  "Done. {0}’s report for {1} is saved, and head office can see it.": "Tamamdır. {0} için {1} raporu kaydedildi; merkez ofis artık görebilir.",
  "DOORDASH": "DOORDASH",
  "DOUBLE": "ÇİFT",
  "down {0}% on the day before": "önceki güne göre %{0} düşüş",
  "Download": "İndir",
  "Download Excel": "Excel indir",
  "Download the Excel file": "Excel dosyasını indir",
  "Draft": "Taslak",
  "Drafted": "Taslak tarihi",
  "Drag to resize · double-click to reset": "Boyutlandırmak için sürükleyin · sıfırlamak için çift tıklayın",
  "Draw an area with at least 3 points before saving.": "Kaydetmeden önce en az 3 noktalı bir alan çizin.",
  "Drinks": "İçecekler",
  "Drive-Thru": "Arabaya servis",
  "Driver": "Kurye",
  "Driver notes:": "Kurye notları:",
  "DUE": "ÖDENECEK",
  "E-mail": "E-posta",
  "E-mail address cannot be empty!": "E-posta adresi boş olamaz!",
  "E-mail, phone, name or customer number…": "E-posta, telefon, ad veya müşteri numarası…",
  "E-mail:": "E-posta:",
  "e.g. Free 2L pop": "ör. Free 2L pop",
  "e.g. Kelowna Grand Opening": "ör. Kelowna Grand Opening",
  "e.g. Marketing": "ör. Marketing",
  "e.g. Pick a pizza": "ör. Pick a pizza",
  "e.g. pizza — counts every item with “pizza” in its name": "ör. pizza — adında “pizza” geçen her ürünü sayar",
  "e.g. soda — for the rewarded item": "ör. soda — ödül olarak verilen ürün için",
  "e.g. SY-88014": "ör. SY-88014",
  "Each customer can use it {0} time(s).": "Her müşteri en fazla {0} kez kullanabilir.",
  "Each repeat becomes its own notification in this list, with the same text, image and stores.": "Her tekrar, aynı metin, görsel ve mağazalarla bu listede ayrı bir bildirim olur.",
  "Each store manager fills in their own report with the assistant. Open a store to see its answers, or to fill it in for them.": "Her mağaza müdürü kendi raporunu asistanla doldurur. Yanıtlarını görmek ya da raporu onun yerine doldurmak için bir mağazayı açın.",
  "Each store's own numbers, one card per store": "Her mağazanın kendi rakamları, mağaza başına bir kart",
  "earned": "kazanıldı",
  "Easiest option. New items added to the category later join the combo by themselves.": "En kolay seçenek. Kategoriye sonradan eklenen ürünler komboya kendiliğinden katılır.",
  "Edit": "Düzenle",
  "Edit Audit": "Denetimi düzenle",
  "Edit Bag Item": "Poşet ürününü düzenle",
  "Edit Coupon": "Kuponu düzenle",
  "Edit Coupon Item": "Kupon ürününü düzenle",
  "Edit deal": "Kampanyayı düzenle",
  "Edit Image": "Görseli düzenle",
  "Edit Invoice": "Faturayı düzenle",
  "Edit Menu": "Menüyü düzenle",
  "Edit Notification": "Bildirimi düzenle",
  "Edit Option Item": "Seçeneği düzenle",
  "Edit Product Item": "Ürünü düzenle",
  "Edit role": "Rolü düzenle",
  "Edit Stock": "Stoğu düzenle",
  "Edit User": "Kullanıcıyı düzenle",
  "Edit Vendor": "Tedarikçiyi düzenle",
  "Email": "E-posta",
  "Email Campaigns": "E-posta kampanyaları",
  "Email cannot be empty": "E-posta boş olamaz",
  "Email not verified": "E-posta doğrulanmamış",
  "Emerald": "Zümrüt",
  "Empty = as soon as you switch it on.": "Boş = açtığınız anda başlar.",
  "Empty = until you switch it off. It stops by itself after this moment.": "Boş = siz kapatana kadar sürer. Bu andan sonra kendiliğinden durur.",
  "Encrypted in your browser; the server stores ciphertext": "Tarayıcınızda şifrelenir; sunucu şifreli metni saklar",
  "Encrypted with a key this browser does not have yet. It opens once a member with the key has the panel open.": "Bu tarayıcıda henüz bulunmayan bir anahtarla şifrelenmiş. Anahtara sahip bir üye paneli açtığında açılır.",
  "Encrypted — no key for it in this browser yet": "Şifreli — bu tarayıcıda henüz anahtarı yok",
  "End after silence": "Sessizlikten sonra bitir",
  "End date": "Bitiş tarihi",
  "End Date": "Bitiş tarihi",
  "End Time": "Bitiş saati",
  "End Time:": "Bitiş saati:",
  "End-to-end encryption": "Uçtan uca şifreleme",
  "ended {0}": "{0} tarihinde bitti",
  "Ends": "Bitiş",
  "Ends on": "Bitiş tarihi",
  "Engagement:": "Etkileşim:",
  "Enter an area name before saving.": "Kaydetmeden önce bir alan adı girin.",
  "Enter campaign title": "Kampanya başlığını girin",
  "Enter coupon code": "Kupon kodunu girin",
  "Enter coupon code if any": "Varsa kupon kodunu girin",
  "Enter notification message": "Bildirim mesajını girin",
  "Enter notification title": "Bildirim başlığını girin",
  "Enter product description...": "Ürün açıklamasını girin...",
  "Enter your email": "E-postanızı girin",
  "Enter your password": "Şifrenizi girin",
  "Enter your SMS message (max 250 characters)": "SMS mesajınızı girin (en fazla 250 karakter)",
  "Error": "Hata",
  "Error POS Sync": "POS eşitleme hatası",
  "Estimated total": "Tahmini toplam",
  "estimated, this page": "tahmini, bu sayfa",
  "events per order": "sipariş başına etkinlik",
  "every accepted order in this period, promotion or not": "bu dönemde kabul edilen tüm siparişler, promosyonlu olsun olmasın",
  "every extra one": "sınırsız",
  "every item": "menüdeki tüm ürünler",
  "Every item with a target level is above it. Nothing needs ordering right now.": "Hedef seviyesi olan her ürün bu seviyenin üzerinde. Şu anda sipariş verilmesi gereken bir şey yok.",
  "Every item, its prices and its photo": "Tüm ürünler, fiyatları ve fotoğrafları",
  "Every item, its prices and its photo.": "Tüm ürünler, fiyatları ve fotoğrafları.",
  "Every offer {0} runs. Switching one on makes it visible to customers straight away.": "{0} tarafından yürütülen tüm kampanyalar. Birini açtığınızda müşteriler onu hemen görür.",
  "Every offer, and whether it is switched on": "Tüm kampanyalar ve hangilerinin açık olduğu",
  "Every page, explained": "Tüm sayfalar, açıklamalarıyla",
  "Every registered account, and what they have spent": "Tüm kayıtlı hesaplar ve harcadıkları tutar",
  "Every registered account, what they have spent, and where they sit in the lifecycle": "Tüm kayıtlı hesaplar, harcadıkları tutar ve yaşam döngüsündeki yerleri",
  "Every store of the brand, added together": "Markanın tüm mağazaları, toplam olarak",
  "Every store ranked against the others": "Tüm mağazaların birbirine göre sıralaması",
  "Every store ›": "Tüm mağazalar ›",
  "Every store, including ones opened later.": "Sonradan açılacaklar dahil tüm mağazalar.",
  "Every store’s report compares its month with these targets, and uses these rates when a store asks Connect to estimate a cost.": "Her mağazanın raporu, kendi ayını bu hedeflerle karşılaştırır ve bir mağaza Connect'ten bir maliyeti tahmin etmesini istediğinde bu oranları kullanır.",
  "Every trading store side by side, and when they are busy": "Faaliyetteki tüm mağazalar yan yana ve yoğun oldukları saatler",
  "Every trading store side by side, today against yesterday": "Faaliyetteki tüm mağazalar yan yana, bugün ile dün karşılaştırmalı",
  "Every trading store side-by-side for the selected window": "Faaliyetteki tüm mağazalar, seçilen aralıkta yan yana",
  "every {0}": "her {0}",
  "Every {0}": "Her {0}",
  "Everyone": "Herkes",
  "everyone starts here": "herkes buradan başlar",
  "Everyone who can sign in to this panel, and the role each one holds.": "Bu panele giriş yapabilen herkes ve her birinin sahip olduğu rol.",
  "Everything": "Tümü",
  "Everything matched what the system expected.": "Her şey sistemin beklediğiyle eşleşti.",
  "Everything needed is filled in.": "Gerekli her şey dolduruldu.",
  "everything they ever spent, not a forecast": "şimdiye kadar harcadıklarının tamamı, tahmin değil",
  "Excel": "Excel",
  "Excel file": "Excel dosyası",
  "Exclude bottle deposits": "Şişe depozitolarını hariç tut",
  "Exclude delivery fees": "Teslimat ücretlerini hariç tut",
  "Expand": "Büyüt",
  "Expand the menu": "Menüyü genişlet",
  "EXPECTED": "BEKLENEN",
  "Expired": "Süresi doldu",
  "Expired Date": "Son geçerlilik tarihi",
  "Expires:": "Sona erme:",
  "Extra": "Ekstra",
  "EXTRA": "EKSTRA",
  "Extras": "Ekstralar",
  "Failed": "Başarısız",
  "Failed to copy menus.": "Menüler kopyalanamadı.",
  "Failed to copy product": "Ürün kopyalanamadı",
  "Failed to create SMS campaign": "SMS kampanyası oluşturulamadı",
  "Failed to load delivery map data": "Teslimat haritası verileri yüklenemedi",
  "Failed to load menus for selected store": "Seçilen mağazanın menüleri yüklenemedi",
  "Failed to load options data": "Seçenek verileri yüklenemedi",
  "Failed to load overview data": "Genel bakış verileri yüklenemedi",
  "Failed to load products data": "Ürün verileri yüklenemedi",
  "Failed to load report": "Rapor yüklenemedi",
  "Failed to load SMS campaigns": "SMS kampanyaları yüklenemedi",
  "Failed to reload store data": "Mağaza verileri yeniden yüklenemedi",
  "Failed to search coupon.": "Kupon aranamadı.",
  "Failed to send SMS to brand customers": "Marka müşterilerine SMS gönderilemedi",
  "Failed to send SMS to stores": "Mağazalara SMS gönderilemedi",
  "Failed to send test SMS": "Test SMS'i gönderilemedi",
  "Failed to sync with Deliverect": "Deliverect ile eşitlenemedi",
  "Family Feast": "Family Feast",
  "Featured": "Öne çıkanlar",
  "Featured products": "Öne çıkan ürünler",
  "Featured products could not be loaded.": "Öne çıkan ürünler yüklenemedi.",
  "Fees Paid to Driver": "Kuryeye ödenen ücretler",
  "figures getting old": "rakamlar eskiyor",
  "Files": "Dosyalar",
  "Filter products...": "Ürünleri filtrele...",
  "Filter...": "Filtrele...",
  "FINANCE": "FİNANS",
  "Financial Summary": "Finansal özet",
  "Find a customer": "Müşteri bul",
  "Find a page": "Sayfa bul",
  "Find a page…": "Sayfa bul…",
  "Find an item or code…": "Ürün veya kod bul…",
  "Find an item…": "Ürün bul…",
  "find this order and set": "tablosunda bu siparişi bulun ve şunu ayarlayın:",
  "Finish and make the Excel file": "Bitir ve Excel dosyasını oluştur",
  "Finished": "Tamamlandı",
  "FINISHED": "TAMAMLANAN",
  "First Register Coupon Selected": "İlk kayıt kuponu seçili",
  "First store they ordered from": "İlk sipariş verdikleri mağaza",
  "Fix the items listed above first": "Önce yukarıda listelenen maddeleri düzeltin",
  "Flag": "İşaretle",
  "Flag creation #{0}?": "Kreasyon #{0} işaretlensin mi?",
  "Flag photo": "Fotoğrafı işaretle",
  "Flag the customer photo on #{0}?": "Kreasyon #{0} için müşteri fotoğrafı işaretlensin mi?",
  "Flagged": "İşaretli",
  "Flagged or hidden": "İşaretli veya gizli",
  "Flash Deals": "Flaş kampanyalar",
  "Food Cost": "Yemek maliyeti",
  "Food Cost AvT": "Yemek maliyeti (gerçek/teorik)",
  "For": "İlgili soru",
  "For a store-specific code, pick that store's order page rather than the home page — it lands the customer on the menu": "Mağazaya özel bir kod için ana sayfa yerine o mağazanın sipariş sayfasını seçin — müşteriyi doğrudan menüye götürür",
  "For when the store's POS cannot close the order itself. Every action is saved to the audit log with your reason; the POS may still need a sync.": "Mağazanın POS'u siparişi kendisi kapatamadığında kullanılır. Her işlem, gerekçenizle birlikte denetim kaydına yazılır; POS'un yine de senkronize edilmesi gerekebilir.",
  "Force close": "Zorla kapat",
  "Force confirm": "Zorla onayla",
  "Force-confirm this order?": "Bu sipariş zorla onaylansın mı?",
  "Forgot it?": "Unuttunuz mu?",
  "Forgot the passphrase?": "Parolayı mı unuttunuz?",
  "Franchise royalty and marketing fees by store": "Mağaza bazında franchise royalti ve pazarlama ücretleri",
  "Free": "Ücretsiz",
  "Free Dif": "Ücretsiz fark",
  "Free garlic bread": "Free garlic bread",
  "Free Item": "Ücretsiz ürün",
  "Free item(s)": "Ücretsiz ürün(ler)",
  "Free soft drink": "Free soft drink",
  "Free toppings included": "Dahil ücretsiz malzeme",
  "Frequent and high value.": "Sık sipariş verir ve yüksek değerlidir.",
  "Fri": "Cum",
  "Friday": "Cuma",
  "From": "Başlangıç",
  "from account type": "hesap türünden",
  "from order #{0}": "sipariş #{0} ile kazanıldı",
  "from our own order table. Two independent sources, {0} of a point apart.": "kendi sipariş tablomuzdan geliyor. Birbirinden bağımsız iki kaynak; aralarındaki fark {0} puan.",
  "From Store": "Kaynak mağaza",
  "From the starting date on, with no end date": "Başlangıç tarihinden itibaren, bitiş tarihi olmadan",
  "From time": "Başlangıç saati",
  "from {0}": "{0} itibarıyla",
  "Fulfilment": "Teslim şekli",
  "GAP": "FARK",
  "GAP TO LEADER": "LİDERE FARK",
  "General": "Genel",
  "Generate Dates from Patterns": "Düzenlerden tarih oluştur",
  "Generated {0} date ranges from patterns!": "Düzenlerden {0} tarih aralığı oluşturuldu!",
  "Generating image…": "Görsel oluşturuluyor…",
  "Gift Cards": "Hediye kartları",
  "Give": "Ver",
  "Give or take back points": "Puan ver veya geri al",
  "Give the deal a title": "Kampanyaya bir başlık verin",
  "Give the role a name.": "Role bir ad verin.",
  "Give {0} the {1} role?": "{0} adlı kişiye {1} rolü verilsin mi?",
  "Given away": "Verilen indirim",
  "Go to a month": "Bir aya git",
  "Goes out on {0}.": "{0} tarihinde gönderilir.",
  "Gold": "Altın",
  "Good afternoon": "İyi günler",
  "Good evening": "İyi akşamlar",
  "Good morning": "Günaydın",
  "Goods and Services Tax cannot be empty!": "Mal ve Hizmet Vergisi (GST) boş olamaz!",
  "Gross sales (before discount)": "Brüt satış (indirim öncesi)",
  "Gross Sales (before discount)": "Brüt satış (indirim öncesi)",
  "Group created.": "Grup oluşturuldu.",
  "Group customers by the month they first ordered, then follow them forward": "Müşterileri ilk sipariş verdikleri aya göre gruplayın, sonra zaman içinde izleyin",
  "Group deleted.": "Grup silindi.",
  "Group name": "Grup adı",
  "Group Name": "Grup adı",
  "Group name is required": "Grup adı gerekli",
  "Group orders": "Grup siparişleri",
  "Group orders could not be loaded.": "Grup siparişleri yüklenemedi.",
  "GST": "GST",
  "GST (%)": "GST (%)",
  "gst content": "gst içeriği",
  "Guest": "Misafir",
  "Guest checkout, no account": "Misafir olarak ödeme, hesap yok",
  "Half & Half": "Yarım yarım",
  "Half & half:": "Yarım yarım:",
  "Hand out a coupon": "Kupon dağıt",
  "Has its own step-by-step screen in the app. Customers open it from the Deals page or the home-screen carousel.": "Uygulamada adım adım ilerleyen kendi ekranı vardır. Müşteriler onu Kampanyalar sayfasından ya da ana ekran karuselinden açar.",
  "Has never ordered.": "Hiç sipariş vermemiş.",
  "has not been given a role on this page, so the one shown is what their old account type has always meant. A person linked to fewer than all stores sees and changes only those stores, everywhere in the panel.": "bu sayfada henüz bir rol almamıştır; bu yüzden gösterilen rol, eski hesap türünün öteden beri karşılığı olan roldür. Tüm mağazalara değil de yalnızca bazılarına bağlı olan biri, panelin her yerinde yalnızca o mağazaları görür ve değiştirir.",
  "Has not ordered yet": "Henüz sipariş vermedi",
  "Has real photo": "Gerçek fotoğrafı var",
  "heading": "sayfa başlığı",
  "Heading": "Ana başlık",
  "Heatmap": "Isı haritası",
  "Heatmap Error": "Isı haritası hatası",
  "Hibernating": "Uykuda",
  "Hidden": "Gizli",
  "HIDDEN": "GİZLİ",
  "Hidden for this window: placing an attempt at a store means following its visitor session, which is skipped beyond four months. Narrow the range and the rate comes back.": "Bu aralıkta gizli: bir denemeyi bir mağazaya atamak, ziyaretçi oturumunu izlemeyi gerektirir; bu da dört ayı aşan aralıklarda atlanır. Aralığı daraltın, oran geri gelir.",
  "Hide": "Gizle",
  "Hide creation #{0}?": "Kreasyon #{0} gizlensin mi?",
  "Hide filters": "Filtreleri gizle",
  "Hide link box": "Bağlantı kutusunu gizle",
  "Hide password": "Şifreyi gizle",
  "Hide Pattern": "Tekrar düzenini gizle",
  "Hide POS reset help": "POS sıfırlama yardımını gizle",
  "Hide rates": "Oranları gizle",
  "Hide the list": "Listeyi gizle",
  "High": "Yüksek",
  "Highest spenders.": "En çok harcama yapanlar.",
  "Hi{0}. Let’s do {1}’s report for {2}. I’ll ask you one thing at a time and fill in what Connect already knows. You can type, talk to me, or scan your bills. Every answer is saved, so you can stop and come back.": "Merhaba{0}. {1} için {2} raporunu hazırlayalım. Size her seferinde tek bir şey soracağım ve Connect’in zaten bildiklerini dolduracağım. Yazabilir, benimle konuşabilir ya da faturalarınızı tarayabilirsiniz. Her yanıt kaydedilir; ara verip sonra kaldığınız yerden devam edebilirsiniz.",
  "Home": "Ana sayfa",
  "Host": "Düzenleyen",
  "Host locked the session for checkout": "Düzenleyen, oturumu ödeme için kilitledi",
  "Host removed a member": "Düzenleyen bir üyeyi çıkardı",
  "Host unlocked the session": "Düzenleyen oturumun kilidini açtı",
  "Host:": "Düzenleyen:",
  "Hour-of-week heatmap": "Haftanın saatlerine göre ısı haritası",
  "Hourly Revenue": "Saatlik ciro",
  "Hourly Sales by Channel": "Kanala göre saatlik satış",
  "Hourly Sales by Size": "Boya göre saatlik satış",
  "hours": "çalışma saatleri",
  "HOURS": "SAATLER",
  "Hours has been updated successfully": "Saatler güncellendi",
  "How customers can talk to the app's AI host: the voice modes on offer, the avatar's face and how long a voice session may last. Changes reach customers from their next voice session.": "Müşterilerin uygulamanın AI asistanıyla nasıl konuşabileceği: sunulan ses modları, avatarın yüzü ve bir sesli oturumun ne kadar sürebileceği. Değişiklikler müşterilere bir sonraki sesli oturumlarından itibaren yansır.",
  "How does the “buy some, get one” work?": "“Birkaç al, bir tane kazan” nasıl işlesin?",
  "How many do they pick here?": "Burada kaç tane seçecekler?",
  "How many free items per order": "Sipariş başına kaç ücretsiz ürün",
  "How many items get the discount": "Kaç ürün indirim alır",
  "how many orders": "kaç sipariş",
  "How many people signed up, and how many went on to order": "Kaç kişinin kaydolduğu ve kaçının ardından sipariş verdiği",
  "How many people who looked ended up ordering": "Bakanlardan kaçının sonunda sipariş verdiği",
  "How many visits to the website turn into an order": "Web sitesi ziyaretlerinin kaçı siparişe dönüşüyor",
  "How matching works:": "Eşleştirme nasıl çalışır:",
  "How much comes off, and from what order size?": "Ne kadar indirim olsun, hangi sipariş tutarından itibaren?",
  "how much each spends": "her birinin ne kadar harcadığı",
  "How often each offer was put in front of a customer, and what came of it. The engine leans on these numbers when it picks which offer to show.": "Her kampanyanın bir müşteriye ne sıklıkla gösterildiği ve bunun sonucu. Motor, hangi kampanyayı göstereceğini seçerken bu rakamlara dayanır.",
  "How often each offer was shown, and what came of it": "Her kampanyanın ne sıklıkla gösterildiği ve sonucu",
  "How people paid": "Müşteriler nasıl ödedi",
  "How recoverable they are": "Ne kadar geri kazanılabilirler",
  "How the pizza sizes sell against each other": "Pizza boylarının birbirine kıyasla satışı",
  "How those records were created": "Bu kayıtlar nasıl oluşturuldu",
  "How today was ordered": "Bugün nasıl sipariş verildi",
  "How {0} customers split across the tiers. Tiers come from {1}, counted every night.": "{0} müşterinin seviyelere dağılımı. Seviyeler şuna göre belirlenir: {1}; her gece yeniden sayılır.",
  "https://…": "https://…",
  "https://… or a page of the website, like /menu": "https://… veya web sitesinden bir sayfa, ör. /menu",
  "I": "I",
  "If you list several, the customer chooses one of them.": "Birden fazla eklerseniz müşteri bunlardan birini seçer.",
  "Image": "Görsel",
  "Image error:": "Görsel hatası:",
  "Image is required.": "Görsel gereklidir.",
  "Image worker:": "Görsel işleyici:",
  "Impressions": "Gösterimler",
  "In": "Eklendi:",
  "in cart": "sepette",
  "In carts": "Sepetlerde",
  "IN PROGRESS": "DEVAM EDEN",
  "In store": "Mağazada",
  "In the app": "Uygulamada",
  "In the apps a tap opens: {0}": "Uygulamalarda dokununca açılan: {0}",
  "in the Chat tab.": "düğmesini Sohbet sekmesinde bulabilirsiniz.",
  "in the kitchen now": "şu an mutfakta",
  "In the oven": "Fırında",
  "in this window": "bu aralıkta",
  "In this window that is {0} from {1} marketplace orders, not included below.": "Bu aralıkta bunlar {1} pazaryeri siparişinden {0} tutarındadır ve aşağıdaki rakamlara dahil değildir.",
  "In use": "Kullanımda",
  "In view": "Listelenen",
  "in {0}": "{0} cinsinden",
  "In {0}": "Eklendi: {0}",
  "In-Store": "Mağaza içi",
  "Inactive": "Pasif",
  "included": "dahil",
  "Incomplete Area": "Eksik alan",
  "Info": "Bilgi",
  "Information": "Bilgilendirici",
  "Informative": "Bilgilendirici",
  "Ingredient Amount: {0}": "Malzeme miktarı: {0}",
  "Ingredient Hash: {0}": "Malzeme hash değeri: {0}",
  "Ingredient is required in Group Name {0}": "{0} grubunda malzeme gerekli",
  "Ingredient Name: {0}": "Malzeme adı: {0}",
  "Ingredient Unit: {0}": "Malzeme birimi: {0}",
  "Ingredient {0} is not registered correctly in Group Name {1}": "{1} grubundaki {0}. malzeme doğru kaydedilmemiş",
  "Ink": "Antrasit",
  "Instore": "Mağaza içi",
  "Internal key": "Dahili anahtar",
  "Invalid e-mail address!": "Geçersiz e-posta adresi!",
  "Invalid email format!": "Geçersiz e-posta biçimi!",
  "Invalid phone number!": "Geçersiz telefon numarası!",
  "Inventory": "Envanter",
  "Inventory (old)": "Envanter (eski)",
  "Inviting a friend": "Arkadaş daveti",
  "Invoice": "Fatura",
  "INVOICE": "FATURA",
  "invoice": "fatura",
  "Invoice Date": "Fatura tarihi",
  "Invoice Date cannot be empty": "Fatura tarihi boş olamaz",
  "Invoice has been deleted successfully": "Fatura silindi",
  "Invoice has been saved successfully": "Fatura kaydedildi",
  "Invoice has been updated successfully": "Fatura güncellendi",
  "Invoice has not been deleted successfully": "Fatura silinemedi",
  "Invoice has not been saved successfully": "Fatura kaydedilemedi",
  "Invoice has not been updated successfully": "Fatura güncellenemedi",
  "Invoice list has not been loaded successfully": "Fatura listesi yüklenemedi",
  "Invoice number": "Fatura numarası",
  "Invoice Number": "Fatura numarası",
  "Invoice Number cannot be empty": "Fatura numarası boş olamaz",
  "Invoice Picture cannot be empty": "Fatura görseli boş olamaz",
  "Invoice price differs": "Fatura fiyatı farklı",
  "Invoices": "Faturalar",
  "invoices": "fatura",
  "is a month that has already passed with nobody coming back; a": "kimsenin geri dönmediği, çoktan geçmiş bir aydır;",
  "is an order that carried the code and still paid full price; above roughly a quarter of the campaign that points at a rule the customer cannot satisfy.": "kodu taşıdığı hâlde yine de tam fiyat ödenen siparişi ifade eder; bu oran kampanyanın kabaca dörtte birini aşıyorsa, müşterinin karşılayamadığı bir kurala işaret eder.",
  "is net sales on those orders divided by what the offer gave away; it is a ratio, not profit, and it does not prove the order would have been smaller without the offer. Under $1.00 is red: the offer gave away more than the orders brought in. An order can carry a coupon and a deal at once, so it appears in both tables and its money is split evenly between them; it is still counted once in \"orders on a promotion\".": "o siparişlerdeki net satışın, promosyonun verdiği indirime bölünmesiyle bulunur; bu bir orandır, kâr değildir ve promosyon olmasaydı siparişin daha küçük olacağını kanıtlamaz. $1.00'ın altı kırmızıdır: promosyon, siparişlerin getirdiğinden fazlasını vermiştir. Bir sipariş aynı anda hem kupon hem kampanya taşıyabilir; bu yüzden iki tabloda da görünür ve tutarı ikisi arasında eşit bölünür; yine de \"promosyonlu siparişler\" içinde bir kez sayılır.",
  "Is the free item something different?": "Ücretsiz ürün farklı bir şey mi?",
  "is the same figure as every Connect sales page: after discount, without tax, tips, delivery fees or bottle deposits, accepted orders only, on the day the POS closed them out. Tax and tips are collected on the restaurant's behalf, so counting them would flatter every number on this page.": "Connect'in tüm satış sayfalarındaki rakamla aynıdır: indirim sonrası; vergi, bahşiş, teslimat ücreti ve şişe depozitosu hariç; yalnızca kabul edilen siparişler, POS'un onları kapattığı güne göre. Vergi ve bahşiş restoran adına toplanır; bunları saymak bu sayfadaki her rakamı olduğundan iyi gösterirdi.",
  "It becomes visible to every customer.": "Tüm müşterilere görünür hâle gelir.",
  "It could not be saved.": "Kaydedilemedi.",
  "It deletes or takes away 1 thing.": "Bu işlem 1 öğeyi siler veya kaldırır.",
  "It deletes or takes away {0} things.": "Bu işlem {0} öğeyi siler veya kaldırır.",
  "It goes off the stories page and its address stops working now.": "Yazılar sayfasından hemen kalkar ve adresi çalışmaz hâle gelir.",
  "It goes out to every customer at its scheduled time, or on the sender’s next run if that time has passed.": "Planlanan zamanda tüm müşterilere gönderilir; bu zaman geçtiyse gönderim görevinin bir sonraki çalışmasında gönderilir.",
  "It is hidden from other customers.": "Diğer müşterilerden gizlenir.",
  "It is marked flagged and taken out of the public feed.": "İşaretlenir ve herkese açık akıştan çıkarılır.",
  "it is on the website.": "web sitesinde yayında.",
  "It opens another page": "Başka bir sayfa açar",
  "It opens the story's own page": "Yazının kendi sayfasını açar",
  "It runs now with {0}’s permissions and stores; they see the result in their chat with Connect.": "Hemen {0} adlı kişinin yetkileri ve mağazalarıyla çalışır; sonucu Connect ile olan sohbetinde görür.",
  "It stays in the database but nobody sees it.": "Veritabanında kalır ama kimse göremez.",
  "It stays on the website until an administrator approves.": "Bir yönetici onaylayana kadar web sitesinde kalır.",
  "Italic": "İtalik",
  "ITEM": "ÜRÜN",
  "item": "kalem",
  "Item Price": "Birim fiyat",
  "item price content": "birim fiyat içeriği",
  "items": "ürün",
  "Items": "Ürünler",
  "ITEMS": "KALEM",
  "Items ({0})": "Ürünler ({0})",
  "Items that must be bought": "Satın alınması gereken ürünler",
  "items, all stores": "kalem, tüm mağazalar",
  "JOINED": "KAYIT TARİHİ",
  "JPG, PNG or WebP, up to 2 MB. No picture = the app shows the picture of the first item in the deal.": "JPG, PNG veya WebP, en fazla 2 MB. Görsel yok = uygulama, kampanyadaki ilk ürünün görselini gösterir.",
  "Just now": "Az önce",
  "Keep at least the avatar or the voice-only mode on, so customers always have one that works.": "Müşterilerin her zaman çalışan bir seçeneği olması için en azından avatar ya da yalnızca ses modunu açık tutun.",
  "Keep it": "Kalsın",
  "Keep it under {0} characters.": "En fazla {0} karakter yazın.",
  "Keep the answer as it was": "Yanıtı olduğu gibi bırak",
  "Keep the current picture": "Mevcut görsel kalsın",
  "Key {0}": "Anahtar {0}",
  "Keyed in at the counter or on the phone. Usually no e-mail, and the record is created as the order is taken.": "Kasada veya telefonda personel tarafından sisteme girilir. Genellikle e-posta adresi yoktur; kayıt, sipariş alınırken oluşturulur.",
  "Kind of discount": "İndirim türü",
  "Kiosk": "Kiosk",
  "Kiosk: OFF": "Kiosk: KAPALI",
  "Kiosk: ON": "Kiosk: AÇIK",
  "Kitchen & Cooking Settings": "Mutfak & pişirme ayarları",
  "Kitchen Hash": "Mutfak hash kodu",
  "Kitchen Status": "Mutfak durumu",
  "KPI summary for any custom period": "İstediğiniz herhangi bir dönem için KPI özeti",
  "label": "etiket",
  "Label": "Etiket",
  "LABEL": "ETİKET",
  "Label on the picture": "Görselin üzerindeki etiket",
  "label this set, e.g. August BOGO push": "bu sete ad verin, ör. Ağustos BOGO kampanyası",
  "lands on": "açılış sayfası:",
  "Lapsed": "Uzaklaşan",
  "Lapsed customers": "Uzaklaşan müşteriler",
  "Lapsed Customers Error": "Uzaklaşan müşteriler hatası",
  "LARGEST CHANNEL": "EN BÜYÜK KANAL",
  "Last 14 days": "Son 14 gün",
  "Last 3 days": "Son 3 gün",
  "Last 30 days": "Son 30 gün",
  "Last 6 hours": "Son 6 saat",
  "Last 7 days": "Son 7 gün",
  "Last 7 days, biggest first by what those orders were worth.": "Son 7 gün; bu siparişlerin değerine göre büyükten küçüğe.",
  "Last 90 days": "Son 90 gün",
  "Last activity {0}": "Son etkinlik: {0}",
  "Last activity:": "Son etkinlik:",
  "LAST CHANGE": "SON DEĞİŞİKLİK",
  "Last changed {0}": "Son değişiklik: {0}",
  "Last conversation": "Son sohbet",
  "LAST COUNT": "SON SAYIM",
  "LAST COUNTED": "SON SAYIM",
  "Last counted here: {0}": "Bu mağazada son sayım: {0}",
  "Last counted {0}.": "Son sayım: {0}.",
  "Last hour": "Son 1 saat",
  "LAST INVOICE": "SON FATURA",
  "Last message": "Son mesaj",
  "Last month": "Geçen ay",
  "Last streak week": "Son seri haftası",
  "Last Update:": "Son güncelleme:",
  "Last week": "Geçen hafta",
  "Last week (Mon – Sun)": "Geçen hafta (Pzt – Paz)",
  "Last week (Sun – Sat)": "Geçen hafta (Paz – Cmt)",
  "Last {0} days": "Son {0} gün",
  "LEAD DAYS": "TEDARİK SÜRESİ",
  "Leave at least one mode on, or the app has no voice at all.": "En az bir modu açık bırakın; yoksa uygulamanın hiç sesi olmaz.",
  "Leave without saving your changes to this story?": "Bu yazıdaki değişiklikleri kaydetmeden çıkılsın mı?",
  "LEFT": "SOL",
  "Lifetime spend now quiet": "Sessizleşen müşterilerin toplam harcaması",
  "LIFETIME VALUE": "YAŞAM BOYU DEĞER",
  "Light": "Az",
  "Like a giveaway or a promotion": "Çekiliş ya da promosyon gibi",
  "like EVENT": "ör. EVENT",
  "Limit per customer": "Müşteri başına sınır",
  "line": "satır",
  "lines": "satır",
  "Link": "Bağlantı",
  "Link not saved": "Bağlantı kaydedilmedi",
  "Link the selected words": "Seçili sözcüklere bağlantı ekle",
  "Links to the old address stop working.": "Eski adrese giden bağlantılar artık çalışmaz.",
  "List": "Liste",
  "Listening…": "Dinleniyor…",
  "Live": "Yayında",
  "LIVE": "CANLI",
  "live": "yayında",
  "Live orders": "Canlı siparişler",
  "Live orders could not be loaded.": "Canlı siparişler yüklenemedi.",
  "live to customers right now": "şu anda müşteriler için yayında",
  "Load earlier": "Öncekileri yükle",
  "Loading banners...": "Bannerlar yükleniyor...",
  "Loading conversation…": "Sohbet yükleniyor…",
  "Loading creation…": "Kreasyon yükleniyor…",
  "Loading customer…": "Müşteri yükleniyor…",
  "Loading menus...": "Menüler yükleniyor...",
  "Loading notifications...": "Bildirimler yükleniyor...",
  "Loading order…": "Sipariş yükleniyor…",
  "Loading product catalogue…": "Ürün kataloğu yükleniyor…",
  "Loading session…": "Oturum yükleniyor…",
  "Loading shifts...": "Vardiyalar yükleniyor...",
  "Loading stores…": "Mağazalar yükleniyor…",
  "Loading the report": "Rapor yükleniyor",
  "Loading…": "Yükleniyor…",
  "Location Analytics": "Mağaza analizi",
  "Locations": "Mağazalar",
  "Locked": "Kilitli",
  "Locked at:": "Kilitlenme:",
  "Locked · ready to check out": "Kilitli · ödemeye hazır",
  "Logging in...": "Giriş yapılıyor...",
  "Login": "Giriş yap",
  "Login failed. Please try again.": "Giriş başarısız oldu. Lütfen tekrar deneyin.",
  "Logout": "Çıkış yap",
  "Long gone, mostly one-time guests who were never really retained.": "Çoktan kopmuş; çoğu, hiçbir zaman gerçekten elde tutulamamış tek seferlik misafirler.",
  "Longest session": "En uzun oturum",
  "Longest streak": "En uzun seri",
  "Lost": "Kayıp",
  "Low": "Düşük",
  "Lower number shows first.": "Küçük sayı önce gösterilir.",
  "LOWEST DAY": "EN DÜŞÜK GÜN",
  "Loyal": "Sadık",
  "Loyalty": "Sadakat",
  "Loyalty could not be loaded.": "Sadakat verileri yüklenemedi.",
  "Loyalty settings": "Sadakat ayarları",
  "Loyalty Settings": "Sadakat ayarları",
  "Loyalty · publish": "Loyalty · publish",
  "Lunch, dinner, late": "Öğle, akşam, gece",
  "made from the title": "başlıktan oluşturulur",
  "Made from the title automatically. Only letters, numbers and underscores.": "Başlıktan otomatik oluşturulur. Yalnızca harf, rakam ve alt çizgi.",
  "MAIN": "ANA",
  "Make a new key?": "Yeni anahtar oluşturulsun mu?",
  "Make the new key": "Yeni anahtarı oluştur",
  "Making the file…": "Dosya hazırlanıyor…",
  "Making the report…": "Rapor hazırlanıyor…",
  "Manage promotional banners for your app and website": "Uygulamanız ve web siteniz için tanıtım bannerlarını yönetin",
  "Map": "Harita",
  "Map Load Error": "Harita yükleme hatası",
  "Mark as paid": "Ödendi olarak işaretle",
  "Mark this order as paid?": "Bu sipariş ödendi olarak işaretlensin mi?",
  "Marked deleted for everyone. Say why.": "Herkes için silinmiş olarak işaretlenir. Nedenini yazın.",
  "Markers": "İşaretçiler",
  "Marketing": "Pazarlama",
  "Marketing %": "Pazarlama %",
  "MARKETING & CRM": "PAZARLAMA & CRM",
  "MARKETING DUE": "PAZARLAMA BORCU",
  "MARKETING PAID": "ÖDENEN PAZARLAMA",
  "Match items by a word in their name": "Ürünleri adlarındaki bir kelimeyle eşleştir",
  "Match key: order ID": "Eşleştirme anahtarı: sipariş ID",
  "Max Discount Amount ($)": "Maksimum indirim tutarı ($)",
  "Max Discount for Same Second Product(%)": "Aynı ikinci üründe maksimum indirim (%)",
  "Max total ($)": "Maks. toplam ($)",
  "Max {0} rewarded": "En fazla {0} ödül",
  "Max: ${0}": "En fazla: ${0}",
  "MEASUREMENT HEALTH": "ÖLÇÜM SAĞLIĞI",
  "Member": "Üye",
  "members": "üye",
  "Members": "Üyeler",
  "Members ({0})": "Üyeler ({0})",
  "menu": "menü",
  "MENU & PRODUCTS": "MENÜ & ÜRÜNLER",
  "Menu Engineering": "Menü mühendisliği",
  "Menu has been deleted successfully.": "Menü silindi.",
  "Menu has been saved successfully.": "Menü kaydedildi.",
  "Menu has been updated successfully.": "Menü güncellendi.",
  "Menu image cannnot be empty!.": "Menü görseli boş olamaz!",
  "Menu name cannnot be empty!.": "Menü adı boş olamaz!",
  "Menu sync completed successfully": "Menü eşitlemesi tamamlandı",
  "Menu Title": "Menü başlığı",
  "Menu Type": "Menü türü",
  "Menuboard": "Menü ekranı",
  "Menuboard name cannnot be empty!.": "Menü ekranı adı boş olamaz!",
  "Menuboard Title": "Menü ekranı başlığı",
  "Menus": "Menüler",
  "Menus copied successfully.": "Menüler kopyalandı.",
  "Menus, products, prices and modifiers": "Menüler, ürünler, fiyatlar ve seçenekler",
  "Message": "Mesaj",
  "message": "mesaj",
  "Message customers": "Müşterilere mesaj gönder",
  "Message on Invoice": "Faturadaki mesaj",
  "message removed": "mesaj silindi",
  "Messages": "Mesajlar",
  "messages": "mesaj",
  "Messages are encrypted in your browser; the server only ever stores ciphertext. Choose a passphrase so you can open your messages from another browser or phone. It cannot be recovered for you.": "Mesajlar tarayıcınızda şifrelenir; sunucu yalnızca şifreli metni saklar. Mesajlarınızı başka bir tarayıcıdan veya telefondan açabilmek için bir parola belirleyin. Bu parola sizin için kurtarılamaz.",
  "METHOD": "YÖNTEM",
  "min": "dk",
  "Min qty {0}": "En az {0} adet",
  "Min spend {0}": "En az {0} harcama",
  "Min total ($)": "Min. toplam ($)",
  "Min.": "Min.",
  "Min.Amount:": "Min. tutar:",
  "Minimum": "Minimum",
  "Minimum Price": "Minimum fiyat",
  "Minimum Quantity": "Minimum miktar",
  "minute": "dakika",
  "minutes": "dakika",
  "Mobile": "Mobil",
  "Mobile App": "Mobil uygulama",
  "Mobile app, web ordering, delivery & 3rd party channel breakdown": "Mobil uygulama, web siparişi, teslimat & 3. taraf kanal dağılımı",
  "Mobile: OFF": "Mobil: KAPALI",
  "Mobile: ON": "Mobil: AÇIK",
  "Model": "Model",
  "Modified Date": "Değiştirilme tarihi",
  "Mon": "Pzt",
  "Monday": "Pazartesi",
  "Money": "Tutar",
  "MONEY": "PARA",
  "Money ($)": "Tutar ($)",
  "Money taken off at the till, and orders cancelled": "Kasada düşülen tutarlar ve iptal edilen siparişler",
  "Month": "Ay",
  "month": "ay",
  "Month 0 is the cohort itself, so it is 100% by definition — the shading starts at month 1 so the tint tracks the retention you can actually move. A cell reading": "Ay 0 kohortun kendisidir, bu yüzden tanım gereği %100'dür — renklendirme 1. aydan başlar, böylece renk tonu gerçekten etkileyebileceğiniz elde tutmayı izler. Bir hücredeki",
  "MONTH ORDERS": "AYLIK SİPARİŞ",
  "MONTH REVENUE": "AYLIK CİRO",
  "Month {0}": "Ay {0}",
  "MONTH-1 REPEAT": "1. AY TEKRAR",
  "Monthly": "Aylık",
  "Monthly Report": "Aylık rapor",
  "Monthly report": "Aylık rapor",
  "Monthly Report Error": "Aylık rapor hatası",
  "months": "ay",
  "More filters": "Daha fazla filtre",
  "more than you have": "elinizdekinden fazla",
  "More than {0} stores: the app opens it at the customer's own store.": "{0} mağazadan fazla: uygulama bunu müşterinin kendi mağazasında açar.",
  "Most of the business is still ordered at the counter, which is worth remembering before reading any app figure as the whole picture.": "İşin büyük kısmı hâlâ kasadan sipariş ediliyor; herhangi bir uygulama rakamını resmin tamamı sanmadan önce bunu hatırlamakta fayda var.",
  "Most orders": "En çok sipariş",
  "Most orders are in-store POS tickets synced from the till": "Siparişlerin çoğu, kasadan aktarılan mağaza içi POS fişleridir",
  "Most popular": "En popüler",
  "Move down": "Aşağı taşı",
  "Move it to another time, or repeat it": "Başka bir zamana taşıyın ya da tekrarlayın",
  "Move left": "Sola taşı",
  "Move right": "Sağa taşı",
  "Move up": "Yukarı taşı",
  "Multi-Use": "Çok kullanımlık",
  "Multiple": "Çoklu",
  "MULTIPLE": "ÇOKLU",
  "Must be picked": "Seçilmesi zorunlu",
  "M{0}": "Ay {0}",
  "n={0}": "n={0}",
  "Name": "Ad",
  "NAME": "AD",
  "Name in the app": "Uygulamadaki adı",
  "Name is required": "Ad gerekli",
  "Name Required": "Ad gerekli",
  "Name, email or phone": "Ad, e-posta veya telefon",
  "Narrowing it to visits that landed on a store page looks tempting and is wrong: those are under half of all visits, while most web orders come from sessions that never landed on one.": "Bunu bir mağaza sayfasına ulaşan ziyaretlerle sınırlamak cazip görünür ama yanlıştır: bunlar tüm ziyaretlerin yarısından azıdır, web siparişlerinin çoğu ise hiç mağaza sayfasına uğramayan oturumlardan gelir.",
  "need ordering": "sipariş edilmeli",
  "Needs review": "İnceleme bekliyor",
  "Needs two counts at least three days apart": "En az üç gün arayla iki sayım gerekir",
  "Needs your confirmation": "Onayınızı bekliyor",
  "Net Product Sales (after discount)": "Net ürün satışı (indirim sonrası)",
  "net sales": "net satış",
  "Net sales": "Net satış",
  "NET SALES": "NET SATIŞ",
  "Net sales (after discount)": "Net satış (indirim sonrası)",
  "Net sales are after discounts, so the discount column is what was taken off, not part of the figure. Tips belong to staff and are not in net sales either.": "Net satış indirimlerden sonraki tutardır; bu yüzden indirim sütunu düşülen tutarı gösterir, rakamın bir parçası değildir. Bahşişler personele aittir ve net satışa da dahil değildir.",
  "Net sales per store for any dates, against the days before and last year. A Monday to Sunday week is the figure royalties are worked out from": "İstediğiniz tarihler için mağaza bazında net satış; önceki günlerle ve geçen yılla karşılaştırmalı. Royalti, pazartesiden pazara bir haftanın rakamı üzerinden hesaplanır",
  "Net sales vs the day before": "Net satış, önceki güne göre",
  "Net sales vs the week before": "Net satış, önceki haftaya göre",
  "Net sales vs the {0} days before": "Net satış, önceki {0} güne göre",
  "Never": "Hiçbir zaman",
  "Never counted": "Hiç sayılmamış",
  "Never counted: {0}. Until a store's first count its stock value is only what has been delivered since, so its row reads low.": "Hiç sayım yapılmamış: {0}. Bir mağaza ilk sayımını yapana kadar stok değeri yalnızca o tarihten beri gelen teslimatlardan oluşur; bu yüzden satırı düşük görünür.",
  "Never expires": "Süresiz",
  "Never Ordered": "Hiç sipariş vermemiş",
  "NEVER ORDERED": "HİÇ SİPARİŞ VERMEYEN",
  "New": "Yeni",
  "New Audit": "Yeni denetim",
  "New Bag": "Yeni poşet",
  "New Coupon": "Yeni kupon",
  "New Coupon Item": "Yeni kupon ürünü",
  "New customers": "Yeni müşteriler",
  "New deal": "Yeni kampanya",
  "New delivery": "Yeni teslimat",
  "New group": "Yeni grup",
  "New group…": "Yeni grup…",
  "New Image": "Yeni görsel",
  "New Invoice": "Yeni fatura",
  "New key": "Yeni anahtar",
  "New key…": "Yeni anahtar…",
  "New Menu": "Yeni menü",
  "New Option Item": "Yeni seçenek",
  "New order": "Yeni sipariş",
  "New Product": "Yeni ürün",
  "New Signups": "Yeni kayıtlar",
  "New signups across the brand, and how many of them went on to order": "Marka genelindeki yeni kayıtlar ve bunların kaçının sipariş verdiği",
  "New SMS Campaign": "Yeni SMS kampanyası",
  "New Stock": "Yeni stok",
  "New stories waiting for approval": "Onay bekleyen yeni yazılar",
  "New story": "Yeni yazı",
  "New time": "Yeni zaman",
  "New User": "Yeni kullanıcı",
  "New Vendor": "Yeni tedarikçi",
  "New, unconfirmed": "Yeni, onaylanmamış",
  "New: talk with Connect": "Yeni: Connect ile konuşun",
  "Newer app versions open this. Older ones use Banner Type and Product above, so keep a product on a clickable banner.": "Uygulamanın yeni sürümleri bunu açar. Eski sürümler yukarıdaki Banner türü ve Ürün alanlarını kullanır; bu yüzden tıklanabilir bir bannerda bir ürün seçili tutun.",
  "Newest": "En yeni",
  "Newest first ↓": "Yeniden eskiye ↓",
  "Next": "İleri",
  "Next month": "Sonraki ay",
  "Next week": "Gelecek hafta",
  "Next ›": "İleri ›",
  "Next →": "İleri →",
  "nightly cache, not live": "gecelik önbellek, canlı değil",
  "No": "Hayır",
  "NO": "HAYIR",
  "No AI image yet · status: {0}": "Henüz AI görseli yok · durum: {0}",
  "No answer from the server.": "Sunucudan yanıt gelmedi.",
  "No attempts logged — this code was applied at the till or automatically, never typed into the online coupon box.": "Kayıtlı deneme yok — bu kod kasada ya da otomatik olarak uygulandı, online kupon kutusuna hiç yazılmadı.",
  "No Banners Yet": "Henüz banner yok",
  "No benchmark data for this period.": "Bu dönem için karşılaştırma verisi yok.",
  "No category": "Kategori yok",
  "No changes": "Değişiklik yok",
  "No cohort has reached this month yet": "Henüz hiçbir kohort bu aya ulaşmadı",
  "No cohorts in this window yet. Cohorts are rebuilt nightly.": "Bu aralıkta henüz kohort yok. Kohortlar her gece yeniden oluşturulur.",
  "no comparable period before this": "bundan önce karşılaştırılabilir bir dönem yok",
  "no comparable prior window": "karşılaştırılabilir önceki dönem yok",
  "No Connect change is waiting.": "Bekleyen Connect değişikliği yok.",
  "No coupon activity in this window.": "Bu aralıkta kupon hareketi yok.",
  "No coupon was redeemed in this period.": "Bu dönemde hiç kupon kullanılmadı.",
  "No creations match these filters. Try another filter or a wider time window.": "Bu filtrelere uyan kreasyon yok. Başka bir filtre ya da daha geniş bir zaman aralığı deneyin.",
  "No customers match this filter.": "Bu filtreye uyan müşteri yok.",
  "No customers to show.": "Gösterilecek müşteri yok.",
  "No daily data": "Günlük veri yok",
  "No daily data.": "Günlük veri yok.",
  "No data": "Veri yok",
  "No data available": "Veri bulunmuyor",
  "No data for selected range": "Seçilen aralık için veri yok",
  "No deal ran in this period.": "Bu dönemde yayında olan kampanya yok.",
  "No deals to target yet.": "Henüz hedeflenecek kampanya yok.",
  "No deals yet. Create one to get started.": "Henüz kampanya yok. Başlamak için bir tane oluşturun.",
  "No Deliverect host is configured for this brand.": "Bu marka için Deliverect sunucusu ayarlanmamış.",
  "No detail data": "Ayrıntı verisi yok",
  "No Details": "Ayrıntı yok",
  "No direct messages yet — pick someone below.": "Henüz özel mesaj yok — aşağıdan birini seçin.",
  "No distance data": "Mesafe verisi yok",
  "No encryption key yet: they have not opened the chat": "Henüz şifreleme anahtarı yok: bu kişi sohbeti açmadı",
  "No events recorded.": "Kaydedilmiş etkinlik yok.",
  "No figures for these dates.": "Bu tarihler için rakam yok.",
  "No fulfilment breakdown.": "Servis türü dağılımı yok.",
  "No hourly data": "Saatlik veri yok",
  "No hourly data.": "Saatlik veri yok.",
  "No image": "Görsel yok",
  "No items found.": "Ürün bulunamadı.",
  "No items yet.": "Henüz ürün yok.",
  "No lapsed customers at this threshold.": "Bu eşikte uzaklaşan müşteri yok.",
  "no longer a deal": "artık kampanya değil",
  "No matching products": "Eşleşen ürün yok",
  "no matter what the customer picks.": "— müşteri ne seçerse seçsin.",
  "No members yet.": "Henüz üye yok.",
  "No messages.": "Mesaj yok.",
  "No microphone was found.": "Mikrofon bulunamadı.",
  "No new dates were generated. All pattern dates already exist.": "Yeni tarih oluşturulmadı. Düzendeki tüm tarihler zaten var.",
  "No notification is waiting.": "Bekleyen bildirim yok.",
  "No Notifications Yet": "Henüz bildirim yok",
  "No offer has been shown to a customer yet, so there is nothing to compare.": "Henüz hiçbir müşteriye teklif gösterilmedi; bu yüzden karşılaştırılacak bir şey yok.",
  "No open store is linked to your account.": "Hesabınıza bağlı açık mağaza yok.",
  "no order in {0} days": "{0} gündür sipariş yok",
  "No orders": "Sipariş yok",
  "no orders": "sipariş yok",
  "No orders in this period.": "Bu dönemde sipariş yok.",
  "No orders match these filters — try a wider time window.": "Bu filtrelere uyan sipariş yok — daha geniş bir zaman aralığı deneyin.",
  "No orders match these filters.": "Bu filtrelere uyan sipariş yok.",
  "no orders to rank": "sıralanacak sipariş yok",
  "No passphrase: your messages open in this browser only": "Parola yok: mesajlarınız yalnızca bu tarayıcıda açılır",
  "No permission": "Yetki yok",
  "No picture": "Görsel yok",
  "No pictures in the row.": "Sırada görsel yok.",
  "No points yet.": "Henüz puan yok.",
  "No products found": "Ürün bulunamadı",
  "No products yet.": "Henüz ürün yok.",
  "No result found.": "Sonuç bulunamadı.",
  "No results found": "Sonuç bulunamadı",
  "No roles yet.": "Henüz rol yok.",
  "No schedule": "Zamanlama yok",
  "No sessions match these filters. Try a wider time window or another status.": "Bu filtrelere uyan oturum yok. Daha geniş bir zaman aralığı ya da başka bir durum deneyin.",
  "No shifts found for this store.": "Bu mağaza için vardiya bulunamadı.",
  "No signups from the selected sources in this period.": "Bu dönemde seçilen kaynaklardan kayıt yok.",
  "No SMS campaigns found. Create your first campaign to get started.": "SMS kampanyası bulunamadı. Başlamak için ilk kampanyanızı oluşturun.",
  "No store data for this period.": "Bu dönem için mağaza verisi yok.",
  "No store selected": "Mağaza seçilmemiş",
  "No store took an order in this period.": "Bu dönemde hiçbir mağaza sipariş almadı.",
  "No stores selected": "Mağaza seçilmedi",
  "No stories yet.": "Henüz yazı yok.",
  "No streak rewards for this tier yet.": "Bu seviye için henüz seri ödülü yok.",
  "No target levels have been set yet, so there is nothing to compare stock against. The table below suggests them from what you have actually been using — look them over and save.": "Henüz hedef stok seviyesi belirlenmedi, bu yüzden stoğun karşılaştırılacağı bir değer yok. Aşağıdaki tablo bunları gerçekte kullandıklarınıza göre önerir — gözden geçirip kaydedin.",
  "No toppings or sauces selected.": "Malzeme veya sos seçilmedi.",
  "No trading stores in this month.": "Bu ay satış yapan mağaza yok.",
  "No trading stores in this period.": "Bu dönemde satış yapan mağaza yok.",
  "No trend data available": "Trend verisi yok",
  "No user found.": "Kullanıcı bulunamadı.",
  "No users found.": "Kullanıcı bulunamadı.",
  "No website blog change is waiting.": "Bekleyen web sitesi blog değişikliği yok.",
  "No weekly data": "Haftalık veri yok",
  "Nobody has talked to the AI yet.": "Henüz kimse AI ile konuşmadı.",
  "Nobody has {0} yet.": "Henüz kimsede {0} yok.",
  "Nobody is waiting for access.": "Erişim bekleyen kimse yok.",
  "Nobody matches “{0}”.": "“{0}” ile eşleşen kimse yok.",
  "Nobody matching that has talked to the AI.": "Aramanızla eşleşen kimse AI ile konuşmamış.",
  "None": "Hiçbiri",
  "None of these is one of our campaigns, so none counts towards the numbers above. Rewards are the points customers spent, as the BI dashboard's Rewards. The marketplace figure is what Uber, DoorDash and Skip took off their own orders (a free side, two-for-one, dollars off), as Deliverect records it. Those orders never reach the POS, so they are outside every figure on this page.": "Bunların hiçbiri bizim kampanyalarımızdan biri değil, bu yüzden hiçbiri yukarıdaki rakamlara sayılmaz. Ödüller, müşterilerin harcadığı puanlardır; BI panosundaki Rewards ile aynıdır. Pazaryeri rakamı, Uber, DoorDash ve Skip'in kendi siparişlerinden düştüğü tutardır (bedava yan ürün, bir alana bir bedava, dolar indirimi); Deliverect'in kaydettiği şekliyle. Bu siparişler POS'a hiç ulaşmaz, bu yüzden bu sayfadaki tüm rakamların dışındadır.",
  "Normal": "Normal",
  "Not applied": "Uygulanmadı",
  "NOT APPLIED": "UYGULANMADI",
  "not approved": "onaylanmayan",
  "Not approved": "Onaylanmadı",
  "Not approved.": "Onaylanmadı.",
  "not counted": "sayılmadı",
  "NOT COUNTED IN A WEEK": "BİR HAFTADIR SAYILMAYAN",
  "Not counted lately": "Son zamanlarda sayılmamış",
  "Not counted yet: until the nightly count runs, everyone shows as Bronze.": "Henüz sayılmadı: gece sayımı çalışana kadar herkes Bronz olarak görünür.",
  "Not encrypted: Connect has to read it": "Şifreli değil: Connect'in okuyabilmesi gerekiyor",
  "Not in use": "Kullanımda değil",
  "Not kept": "Saklanmıyor",
  "Not on the website yet": "Henüz web sitesinde değil",
  "Not on this page, and why": "Bu sayfada olmayanlar ve nedeni",
  "Not paid yet": "Henüz ödenmedi",
  "Not part of a campaign": "Kampanyaya dahil olmayanlar",
  "Not reached yet": "Bu aya henüz ulaşılmadı",
  "Not recorded": "Kaydedilmedi",
  "Not saved": "Kaydedilmedi",
  "Not Showing in Branch": "Mağazada gösterilmiyor",
  "Not Showing on Kiosk": "Kioskta gösterilmiyor",
  "Not Showing on Mobile App": "Mobil uygulamada gösterilmiyor",
  "Not Showing on Website": "Web sitesinde gösterilmiyor",
  "not shown on the website": "web sitesinde gösterilmez",
  "NOT STARTED": "BAŞLANMADI",
  "Not switched on": "Açık değil",
  "Not Synced Yet": "Henüz senkronize edilmedi",
  "not used any more": "artık kullanılmıyor",
  "not yet": "henüz değil",
  "Not yet": "Henüz değil",
  "Note": "Not",
  "Note: {0}": "Not: {0}",
  "Nothing": "Hiçbir şey",
  "Nothing changed yet.": "Henüz bir şey değişmedi.",
  "nothing entered yet": "henüz hiçbir şey girilmedi",
  "Nothing has been counted at {0} yet. Once a count is submitted, what is left appears here.": "{0} mağazasında henüz hiçbir şey sayılmadı. Bir sayım gönderildiğinde kalan miktarlar burada görünür.",
  "Nothing has been ordered today at {0}.": "Bugün şu mağazalara hiç sipariş gelmedi: {0}.",
  "Nothing has been recorded as taken against any offer yet, so the": "Henüz hiçbir teklif için alım kaydedilmedi, bu yüzden",
  "Nothing here right now.": "Şu anda burada bir şey yok.",
  "Nothing here yet. Say hello.": "Burada henüz bir şey yok. Merhaba deyin.",
  "Nothing is in stock yet — count first, then anything spoiled can be written off.": "Henüz stokta hiçbir şey yok — önce sayım yapın, ardından bozulan her şeyi atık olarak kaydedebilirsiniz.",
  "Nothing is lost: on the new device press": "Hiçbir şey kaybolmaz: yeni cihazda şu düğmeye basın:",
  "Nothing is waiting for you": "Sizi bekleyen bir şey yok",
  "Nothing matches “{0}”.": "“{0}” ile eşleşen bir şey yok.",
  "Nothing matches “{0}”. Try a word from the page name or what it shows — “sales”, “coupon”, “store”…": "“{0}” ile eşleşen bir şey yok. Sayfa adından ya da sayfanın gösterdiği şeyden bir kelime deneyin — “satış”, “kupon”, “mağaza”…",
  "Nothing matches.": "Eşleşen sonuç yok.",
  "Nothing pinned to": "Şuraya henüz bir şey sabitlenmedi:",
  "Nothing selected = every day.": "Seçim yok = her gün.",
  "Nothing to order": "Sipariş edilecek bir şey yok",
  "Nothing written yet. New notifications wait here for approval before they go out.": "Henüz bir şey yazılmadı. Yeni bildirimler gönderilmeden önce onay için burada bekler.",
  "Nothing yet. Ask Connect for one, for example “Make a PDF report of last week's sales by store”.": "Henüz bir şey yok. Connect'ten bir tane isteyin, örneğin “Geçen haftanın satışlarından mağaza bazında PDF rapor hazırla”.",
  "Nothing {0} right now.": "Şu anda “{0}” durumunda öneri yok.",
  "Nothing — pick permissions by hand": "Hiçbiri — yetkileri elle seçin",
  "notification": "bildirim",
  "Notification created successfully.": "Bildirim oluşturuldu.",
  "Notification Image": "Bildirim görseli",
  "Notification Title": "Bildirim başlığı",
  "Notification Type": "Bildirim türü",
  "Notifications waiting": "Bekleyen bildirimler",
  "Now list what the customer picks, one choice at a time. Each choice becomes a step in the app: “Pick a pizza”, then “Pick a drink”…": "Şimdi müşterinin seçeceklerini tek tek listeleyin. Her seçim uygulamada bir adım olur: “Pick a pizza”, ardından “Pick a drink”…",
  "Now pick the last day.": "Şimdi son günü seçin.",
  "Number of days up to today": "Bugüne kadarki gün sayısı",
  "Number of days up to yesterday": "Düne kadarki gün sayısı",
  "Numbered list": "Numaralı liste",
  "occurrences": "gönderim",
  "of food after discounts, before delivery, tax and tip. 0 counts every order.": "tutarında yemek; indirimler düşülmüş, teslimat, vergi ve bahşiş hariç. 0 her siparişi sayar.",
  "of our web orders reached Analytics": "web siparişlerimizin Analytics'e ulaşan kısmı",
  "Of the people who joined in a given month, how many ordered again": "Belirli bir ayda katılanların kaçı yeniden sipariş verdi",
  "of them at": "tanesini",
  "of these items…": "adet bu ürünlerden…",
  "of those signups, at any time since": "bu kayıtlardan; kayıttan sonra herhangi bir zamanda",
  "of what the food would have sold for": "yemeğin normal satış değerine oranla",
  "of {0} customers with at least one order": "en az bir siparişi olan {0} müşteri içinde",
  "of {0} items": "/ {0} kalem",
  "Off": "Kapalı",
  "off": "kapalı",
  "OFF": "KAPALI",
  "off the order when it is at least $": "indirim uygulanır; sipariş en az $",
  "Offer": "Teklif",
  "Offer performance": "Teklif performansı",
  "Offers that paid off": "Karşılığını veren teklifler",
  "Offers the system has drafted from what has been selling": "Sistemin satılanlara bakarak hazırladığı teklif taslakları",
  "Offers used fewer than five times are left out.": "Beşten az kullanılan teklifler dahil edilmez.",
  "Oldest first ↑": "Eskiden yeniye ↑",
  "On": "Şu tarihte",
  "ON HAND": "MEVCUT",
  "On hand is worked out, not stored: the last count, plus everything recorded as arriving since. It is only ever as good as the last count — that is why the date is in the table rather than hidden away.": "Mevcut miktar saklanmaz, hesaplanır: son sayım ve o zamandan beri gelen olarak kaydedilen her şey. Bu yüzden ancak son sayım kadar doğrudur — tarihin gizlenmeyip tabloda yer almasının nedeni de budur.",
  "On the website": "Web sitesinde",
  "On the website now": "Şu an web sitesinde",
  "on {0}": "{0} günleri",
  "On: every change Connect prepares waits for your Confirm. Off: it runs as soon as you ask; a delete still asks you to type how many go, and Undo stays on the card.": "Açık: Connect'in hazırladığı her değişiklik, siz Onayla'ya basana kadar bekler. Kapalı: istediğiniz anda uygulanır; silme işleminde yine de kaç kaydın silineceğini yazmanız istenir ve Geri al kartta kalır.",
  "One channel, one link. Reusing the Instagram URL in an email folds the two together and neither can be told apart afterwards.": "Bir kanal, bir bağlantı. Instagram URL'sini bir e-postada tekrar kullanmak ikisini birleştirir ve sonradan ikisi birbirinden ayırt edilemez.",
  "One day, hour by hour": "Bir gün, saat saat",
  "One fixed price. You list the choices the customer makes (pizza, drink…).": "Tek bir sabit fiyat. Müşterinin yapacağı seçimleri siz listelersiniz (pizza, içecek…).",
  "One list for every store. A price here sets the stock value everywhere, and the cost of a delivery entered without a price. When the last invoice says something else, \"Use invoice price\" takes it over, with that invoice as its source. An item not in use leaves the count sheets; what was recorded for it stays.": "Tüm mağazalar için tek bir liste. Buradaki fiyat, stok değerini her yerde belirler; fiyatsız girilen bir teslimatın maliyetini de. Son fatura farklı bir fiyat gösteriyorsa \"Fatura fiyatını kullan\" bu fiyatı alır ve kaynak olarak o faturayı gösterir. Kullanımda olmayan bir kalem sayım listelerinden çıkar; onun için kaydedilenler kalır.",
  "One month, and how it compares with the last": "Bir ay ve bir önceki ayla karşılaştırması",
  "one per first-order month": "her ilk sipariş ayı için bir tane",
  "One store": "Tek mağaza",
  "One to three sentences under the title on the card": "Kartta başlığın altında yer alan bir ila üç cümle",
  "One week, day by day": "Bir hafta, gün gün",
  "One-line description": "Tek satırlık açıklama",
  "Online": "Online",
  "Online & Delivery Orders": "Online & teslimat siparişleri",
  "Online App": "Online uygulama",
  "Online Orders": "Online siparişler",
  "Online Orders Error": "Online siparişler hatası",
  "Only at the {0} selected store(s).": "Yalnızca seçili {0} mağazada.",
  "Only at {0}.": "Yalnızca şu mağazalarda: {0}.",
  "Only Delivery": "Yalnızca teslimat",
  "Only entered ({0})": "Yalnızca girilenler ({0})",
  "Only items in stock ({0})": "Yalnızca stokta olan kalemler ({0})",
  "Only items with usage data ({0})": "Yalnızca kullanım verisi olan kalemler ({0})",
  "Only JPG and PNG pictures can go in the row.": "Sıraya yalnızca JPG ve PNG görseller eklenebilir.",
  "Only Pickup": "Yalnızca gel-al",
  "Only someone who covers every store can add items or change prices: the list is shared.": "Yalnızca tüm mağazalardan sorumlu biri kalem ekleyebilir veya fiyat değiştirebilir: liste ortaktır.",
  "Only these sizes?": "Yalnızca bu boylar mı?",
  "Only this Store": "Yalnızca bu mağaza",
  "Only three of the engine's segments can appear here: a customer classed champion, loyal or regular has ordered recently, so they are not lapsed by definition. A dominant": "Burada motorun segmentlerinden yalnızca üçü görünebilir: şampiyon, sadık veya düzenli olarak sınıflanan bir müşteri yakın zamanda sipariş vermiştir, dolayısıyla tanım gereği uzaklaşmış sayılmaz. Baskın bir",
  "Only what I have entered ({0})": "Yalnızca girdiklerim ({0})",
  "Only what is actually on the shelf can be written off — you cannot throw away more than you have. If an item refuses, it usually means a delivery was never recorded rather than that the amount is wrong.": "Yalnızca gerçekten rafta olan atık olarak kaydedilebilir — elinizdekinden fazlasını atamazsınız. Bir kalem kabul edilmiyorsa, bu genellikle miktarın yanlış olduğunu değil, bir teslimatın hiç kaydedilmediğini gösterir.",
  "only {0}": "yalnızca {0} mağaza",
  "Open": "Aç",
  "Open a deal": "Bir kampanya aç",
  "Open a product": "Bir ürün aç",
  "Open a store special": "Mağazaya özel bir ürün aç",
  "Open a web page": "Bir web sayfası aç",
  "Open one to read the whole conversation, oldest message first.": "Sohbetin tamamını okumak için birini açın; en eski mesaj en üstte.",
  "open or locked, this page": "açık veya kilitli, bu sayfada",
  "Open the menu": "Menüyü aç",
  "Open the newest version": "En yeni sürümü aç",
  "Open the store's POS admin tool": "Mağazanın POS yönetim aracını açın",
  "Open · members joining": "Açık · üyeler katılıyor",
  "OPENED": "AÇILIŞ",
  "Opening": "Açılış",
  "Opening Atlas…": "Atlas açılıyor…",
  "Opening hours, delivery area and till users": "Çalışma saatleri, teslimat bölgesi ve kasa kullanıcıları",
  "Opens {0}": "{0} açılır",
  "open–{0}": "açılış–{0}",
  "OPERATING PROFIT": "FAALİYET KÂRI",
  "Operations": "Operasyonlar",
  "OPERATIONS": "OPERASYONLAR",
  "Option Amount: {0}": "Seçenek miktarı: {0}",
  "Option Hash: {0}": "Seçenek hash değeri: {0}",
  "Option item has been added successfully.": "Seçenek eklendi.",
  "Option Name: {0}": "Seçenek adı: {0}",
  "Option Unit: {0}": "Seçenek birimi: {0}",
  "Options item deleted!": "Seçenek silindi!",
  "Options item updated!": "Seçenek güncellendi!",
  "Options Load Error": "Seçenek yükleme hatası",
  "options marked LEFT or RIGHT are on one side only; unmarked options cover the whole pizza.": "SOL veya SAĞ işaretli seçenekler yalnızca bir taraftadır; işaretsiz seçenekler pizzanın tamamını kaplar.",
  "or any": "veya herhangi bir",
  "or drop it here": "ya da buraya bırakın",
  "or drop them here": "ya da buraya bırakın",
  "Or type in Turkish or English. It answers from the same numbers the pages show, with your permissions, and can draw charts and make PDF reports and Excel files.": "Ya da Türkçe veya İngilizce yazın. Sayfalarda görünen rakamlarla, sizin yetkilerinizle yanıt verir; grafik çizebilir, PDF rapor ve Excel dosyası hazırlayabilir.",
  "ORDER": "SİPARİŞ",
  "Order #{0}": "Sipariş #{0}",
  "Order #{0} force-confirmed.": "Sipariş #{0} zorla onaylandı.",
  "Order #{0} marked as paid.": "Sipariş #{0} ödendi olarak işaretlendi.",
  "ORDER %": "SİPARİŞ %",
  "Order & revenue intensity by day of week and hour": "Haftanın günü ve saate göre sipariş & ciro yoğunluğu",
  "Order channel": "Sipariş kanalı",
  "Order in the carousel": "Karuseldeki sıra",
  "Order now": "Order now",
  "Order on the Deals page": "Kampanyalar sayfasındaki sıra",
  "Order this": "Sipariş edilecekler",
  "ordered": "sipariş veren",
  "Ordered": "Sipariş veren",
  "Ordered from {0}": "Sipariş kaynağı: {0}",
  "Ordering regularly.": "Düzenli olarak sipariş veriyor.",
  "orders": "sipariş",
  "Orders": "Siparişler",
  "ORDERS": "SİPARİŞLER",
  "Orders by Channel": "Kanala göre siparişler",
  "Orders by day": "Güne göre siparişler",
  "Orders by hour": "Saate göre siparişler",
  "Orders counted": "Siparişler sayıldı",
  "Orders in 12 months": "12 aydaki siparişler",
  "orders in the last 12 months": "son 12 aydaki siparişler",
  "Orders in the last 12 months": "Son 12 aydaki siparişler",
  "Orders now and then.": "Ara sıra sipariş verir.",
  "Orders of {0} or more get {1} free ({2} per order).": "{0} ve üzeri siparişlerde {1} ücretsiz (sipariş başına {2} adet).",
  "Orders of {0} or more get {1} free.": "{0} ve üzeri siparişlerde {1} ücretsiz.",
  "Orders on a promotion": "Promosyonlu siparişler",
  "ORDERS PER WEEK": "HAFTALIK SİPARİŞ",
  "Orders placed on the website and in the apps": "Web sitesinden ve uygulamalardan verilen siparişler",
  "Orders regularly.": "Düzenli olarak sipariş verir.",
  "orders that got the discount": "indirim alan sipariş",
  "ORDERS {0}": "SİPARİŞLER {0}",
  "Orders, 12 months": "Siparişler, 12 ay",
  "Orders, 7 days": "Siparişler, 7 gün",
  "Other": "Diğer",
  "OTHER": "DİĞER",
  "Our Stories": "Our Stories",
  "Out for delivery": "Teslimata çıktı",
  "Outside the dates this page has": "Bu sayfanın tarih aralığının dışında",
  "Oven": "Fırında",
  "Oven Status": "Fırın durumu",
  "Overview": "Genel bakış",
  "Overview Error": "Genel bakış hatası",
  "P&L": "Kâr/Zarar",
  "PACK SIZE": "PAKET MİKTARI",
  "PACK UNIT": "PAKET BİRİMİ",
  "PACKS IN A CASE": "CASE BAŞINA PAKET",
  "Page": "Sayfa",
  "page the card opens": "kartın açtığı sayfa",
  "Page the card opens": "Kartın açtığı sayfa",
  "Page {0}": "Sayfa {0}",
  "page, in the order it shows them.": "sayfasında, göründükleri sırayla.",
  "Pages of one {0}": "Tek bir belgenin sayfaları",
  "Paid": "Ödendi",
  "Paragraph": "Paragraf",
  "Partly done": "Kısmen tamamlandı",
  "Passcode": "Giriş kodu",
  "Passphrase": "Parola",
  "Passphrase (8 characters or more)": "Parola (en az 8 karakter)",
  "Password": "Şifre",
  "Pasta": "Makarna",
  "Pattern Generation": "Düzenden tarih oluşturma",
  "Pattern Generation Completed": "Düzenden tarihler oluşturuldu",
  "Patterns need an end date: choose one in Expired Date.": "Tekrar düzenleri için bir bitiş tarihi gerekir: Son geçerlilik tarihi alanından bir tarih seçin.",
  "Paused": "Duraklatıldı",
  "Payment": "Ödeme",
  "Payment Breakdown Error": "Ödeme dağılımı hatası",
  "Payment by Service": "Servise göre ödeme",
  "Payment Detail": "Ödeme ayrıntısı",
  "PAYMENT METHOD": "ÖDEME YÖNTEMİ",
  "Payment Method Share": "Ödeme yöntemi payı",
  "Payments": "Ödemeler",
  "PDF": "PDF",
  "PDF report": "PDF raporu",
  "PEAK DAY": "EN YÜKSEK GÜN",
  "Peak Times Error": "Yoğun saatler hatası",
  "Pending": "Bekliyor",
  "pending": "bekliyor",
  "People": "Kişiler",
  "people": "kişi",
  "People found": "Bulunan kişiler",
  "People in the list": "Listedeki kişiler",
  "People still hold this role. Move them first.": "Bu role sahip kişiler var. Önce onları başka bir role taşıyın.",
  "People who used to order and have gone quiet": "Eskiden sipariş verip artık vermeyen kişiler",
  "Per $1": "$1 başına",
  "per order (0 = no cap):": "sipariş başına (0 = sınır yok):",
  "PER UNIT": "BİRİM BAŞINA",
  "PER WEEK": "HAFTALIK",
  "Per-store health metrics with period comparison": "Mağaza bazında sağlık göstergeleri, dönem karşılaştırmalı",
  "Percentage": "Yüzde",
  "Percentage (%)": "Yüzde (%)",
  "PERFORMANCE": "PERFORMANS",
  "Period": "Dönem",
  "PERIOD": "DÖNEM",
  "permission.": "yetkisi gerekir.",
  "Permissions": "Yetkiler",
  "person": "kişi",
  "Phone": "Telefon",
  "Phone number": "Telefon numarası",
  "Phone number cannot be empty!": "Telefon numarası boş olamaz!",
  "Phone:": "Telefon:",
  "Photo approved on #{0}.": "Kreasyon #{0} fotoğrafı onaylandı.",
  "Photo flagged": "Fotoğraf işaretlendi",
  "Photo flagged on #{0}.": "Kreasyon #{0} fotoğrafı işaretlendi.",
  "Photo needs review": "Fotoğraf inceleme bekliyor",
  "Photos awaiting": "Bekleyen fotoğraflar",
  "Photos or PDFs of invoices and bills": "Faturaların fotoğrafları veya PDF'leri",
  "Photos or PDFs: drop them all here. Each one goes to its question for you to check.": "Fotoğraflar veya PDF'ler: hepsini buraya bırakın. Her biri, kontrol etmeniz için kendi sorusuna gider.",
  "Pick a date": "Tarih seçin",
  "Pick a month": "Ay seçin",
  "Pick a store": "Bir mağaza seçin",
  "Pick at least one permission.": "En az bir yetki seçin.",
  "Pick dates": "Tarih aralığı seçin",
  "Pick one": "Birini seçin",
  "Pick the one that sounds like what you want to offer. You can change it later.": "Sunmak istediğinize en yakın olanı seçin. Daha sonra değiştirebilirsiniz.",
  "Pick your own dates": "Tarihleri kendiniz seçin",
  "pick {0}": "{0} adet seçilir",
  "Pickup": "Gel-al",
  "picture": "görsel",
  "Picture": "Görsel",
  "pictures": "görseller",
  "Pictures": "Görseller",
  "Pipeline": "Satış süreci",
  "Pizza": "Pizza",
  "Pizza contents": "Pizza içeriği",
  "Pizza size breakdown & hourly channel analysis": "Pizza boylarına göre dağılım ve saatlik kanal analizi",
  "Pizzamaker": "Pizza ustası",
  "Pizzas customers built and shared in the app. Approve the good ones, flag or hide the rest. Real photos customers upload are reviewed separately from the AI image.": "Müşterilerin uygulamada oluşturup paylaştığı pizzalar. İyi olanları onaylayın, kalanları işaretleyin veya gizleyin. Müşterilerin yüklediği gerçek fotoğraflar, AI görselinden ayrı olarak incelenir.",
  "Pizzas customers built and shared in the app: approve, flag or hide them, and review their photos": "Müşterilerin uygulamada oluşturup paylaştığı pizzalar: onaylayın, işaretleyin veya gizleyin; fotoğraflarını inceleyin",
  "plain": "şifresiz",
  "Plain text again": "Düz metne döndür",
  "Platform": "Platform",
  "PLATFORM": "PLATFORM",
  "Platinum": "Platin",
  "Please add at least one code!": "Lütfen en az bir kod ekleyin!",
  "Please add at least one date!": "Lütfen en az bir tarih ekleyin!",
  "Please add at least one pattern!": "Lütfen en az bir tekrar düzeni ekleyin!",
  "Please choose a JPG, PNG or WebP picture.": "Lütfen JPG, PNG veya WebP biçiminde bir görsel seçin.",
  "Please enter a name.": "Lütfen bir ad girin.",
  "Please enter a passcode.": "Lütfen bir giriş kodu girin.",
  "Please fill all fields!": "Lütfen tüm alanları doldurun!",
  "Please fill all pattern times!": "Lütfen tekrar düzenlerindeki tüm saatleri doldurun!",
  "Please fill date start and date end areas!": "Lütfen başlangıç ve bitiş tarihi alanlarını doldurun!",
  "Please select a product for clickable banner.": "Tıklanabilir banner için bir ürün seçin.",
  "Please select a store": "Lütfen bir mağaza seçin",
  "Please select at least one platform!": "Lütfen en az bir platform seçin!",
  "Please select at least one store": "Lütfen en az bir mağaza seçin",
  "Please select at least one store!": "Lütfen en az bir mağaza seçin!",
  "Please select both source and destination stores.": "Lütfen hem kaynak hem de hedef mağazayı seçin.",
  "Please set start and end date range first!": "Lütfen önce tarih aralığının başlangıç ve bitişini belirleyin!",
  "Please upload both web and app banner images.": "Lütfen hem web hem de uygulama banner görsellerini yükleyin.",
  "PM": "PM",
  "points": "puan",
  "Points": "Puan",
  "Points for each of them": "Her birine verilecek puan",
  "Points history, last 50": "Puan geçmişi, son 50",
  "POS": "POS",
  "POS Print": "POS yazdırma",
  "POS reset happens on the store's own POS server": "POS sıfırlama, mağazanın kendi POS sunucusunda yapılır",
  "POS reset help": "POS sıfırlama yardımı",
  "POS SALES": "POS SATIŞLARI",
  "POS Sync Completed": "POS eşitlemesi tamamlandı",
  "POS View": "POS görünümü",
  "POS {0}": "POS {0}",
  "POS: OFF": "POS: KAPALI",
  "POS: ON": "POS: AÇIK",
  "pre-selects the store, so the code has somewhere to be typed.": "mağazayı önceden seçer; böylece kodun yazılacağı bir yer olur.",
  "Prepare the sync": "Senkronizasyonu hazırla",
  "Preparing Time (secs)": "Hazırlama süresi (sn)",
  "Preparing…": "Hazırlanıyor…",
  "Press": "Şuna basın:",
  "Preview": "Önizleme",
  "Previous": "Önceki",
  "Previous month": "Önceki ay",
  "Price": "Fiyat",
  "PRICE FROM": "FİYAT KAYNAĞI",
  "Price to check": "Kontrol edilecek fiyat",
  "Printing": "Yazdırma",
  "prodcut total content": "ürün toplamı içeriği",
  "Product": "Ürün",
  "PRODUCT": "ÜRÜN",
  "Product Calculation": "Ürün hesaplaması",
  "Product cannot be empty": "Ürün boş olamaz",
  "Product cannot be empty!": "Ürün boş olamaz!",
  "product content": "ürün içeriği",
  "Product copied successfully": "Ürün kopyalandı",
  "Product has been deleted successfully.": "Ürün silindi.",
  "Product has been saved successfully.": "Ürün kaydedildi.",
  "Product image is required!": "Ürün görseli gerekli!",
  "Product is not registered in the system!": "Ürün sistemde kayıtlı değil!",
  "Product Mix Error": "Ürün dağılımı hatası",
  "Product Name": "Ürün adı",
  "Product name is required!": "Ürün adı gerekli!",
  "Product order has been updated successfully.": "Ürün sırası güncellendi.",
  "Product price is required!": "Ürün fiyatı gerekli!",
  "Product Sales": "Ürün satışları",
  "PRODUCT SALES": "ÜRÜN SATIŞLARI",
  "Product Type": "Ürün türü",
  "Product Type & Tax": "Ürün türü ve vergi",
  "Product type not recognized.": "Ürün türü tanınmadı.",
  "Product: {0}": "Ürün: {0}",
  "Products": "Ürünler",
  "Products Load Error": "Ürün yükleme hatası",
  "profit {0}": "kâr {0}",
  "Proposal has been dismissed.": "Öneri geri çevrildi.",
  "Provincial Sales Tax cannot be empty!": "Eyalet Satış Vergisi (PST) boş olamaz!",
  "PST": "PST",
  "PST (%)": "PST (%)",
  "pst content": "pst içeriği",
  "Publish": "Yayımla",
  "Published as deal #{0} — {1}": "Kampanya #{0} olarak yayımlandı — {1}",
  "Push notification": "Anlık bildirim",
  "Push Notifications": "Anlık bildirimler",
  "Put aside": "Kenara ayır",
  "Put aside ·": "Kenara ayrıldı ·",
  "QTY": "MİKTAR",
  "Qty %": "Miktar %",
  "Qty Sold": "Satılan miktar",
  "Quantities are in": "Miktarların birimi:",
  "Quantity": "Miktar",
  "Quantity & Nutrition": "Miktar ve besin değerleri",
  "Quantity by Size": "Boya göre miktar",
  "Question {0} of {1}": "Soru {0}/{1}",
  "Queue 1": "Sıra 1",
  "Queue 2": "Sıra 2",
  "Queue 3": "Sıra 3",
  "quiet": "sakin",
  "Quiet for a while. Worth one attempt.": "Bir süredir sessiz. Bir kez denemeye değer.",
  "Quiet for at least": "Sipariş vermeyeli en az",
  "Ranked by lifetime spend, not by how long they have been gone — a win-back offer is worth sending to the person who used to spend, even if someone else lapsed more recently.": "Ne kadar süredir uzak kaldıklarına göre değil, toplam harcamalarına göre sıralanır — geri kazanma teklifi, başka biri daha yakın zamanda kopmuş olsa bile, eskiden harcama yapan kişiye gönderilmeye değer.",
  "rate": "oran",
  "RATE": "ORAN",
  "Rate settings": "Oran ayarları",
  "Rates": "Oranlar",
  "Reach a minimum order and a chosen item is added free.": "Sipariş belirli bir tutara ulaşınca seçilen bir ürün ücretsiz eklenir.",
  "Reachable": "Ulaşılabilir",
  "Read Now": "Read Now",
  "Ready": "Hazır",
  "Real photo": "Gerçek fotoğraf",
  "Real-time sales from {0} — {1}": "{0} anlık satışları — {1}",
  "REASON": "NEDEN",
  "Reason (optional)": "Neden (isteğe bağlı)",
  "Reason for all lines": "Tüm satırlar için neden",
  "Receive Template Updates": "Şablon güncellemelerini al",
  "receiving template changes": "şablon değişikliklerini alıyor",
  "Recent deliveries": "Son teslimatlar",
  "Recently gone quiet — the group a win-back offer can still reach.": "Yakın zamanda sessizleşmiş — geri kazanma teklifinin hâlâ ulaşabileceği grup.",
  "Record": "Kaydet",
  "Record another": "Bir tane daha kaydet",
  "Record delivery": "Teslimatı kaydet",
  "Record more": "Daha fazla kaydet",
  "Record this delivery?": "Bu teslimat kaydedilsin mi?",
  "Recorded": "Kaydedildi",
  "Recorded as “{0}”. This cannot be undone.": "Kayıt nedeni: “{0}”. Bu işlem geri alınamaz.",
  "Recording the same invoice twice is refused, so a mistake here means entering a correcting count rather than deleting anything.": "Aynı faturanın iki kez kaydedilmesine izin verilmez; bu yüzden buradaki bir hata, bir şey silinerek değil, düzeltici bir sayım girilerek giderilir.",
  "Recovery actions": "Kurtarma işlemleri",
  "Red": "Kırmızı",
  "REDEEM RATE": "KULLANIM ORANI",
  "REDEEMED": "KULLANILAN",
  "Reducted between": "Düşüm tarihi aralığı",
  "Reducted Reports": "Düşüm raporları",
  "Reducted Reports (old)": "Düşüm raporları (eski)",
  "Referral code": "Davet kodu",
  "referral reward": "davet ödülü",
  "Refreshes every minute": "Her dakika yenilenir",
  "REGISTERED": "KAYITLI",
  "Registered, has not ordered.": "Kaydolmuş, sipariş vermemiş.",
  "Regular": "Normal",
  "Reject": "Reddet",
  "Reject it?": "Reddedilsin mi?",
  "Reject this draft?": "Bu taslak reddedilsin mi?",
  "Reject “{0}”?": "“{0}” bildirimi reddedilsin mi?",
  "Rejected": "Reddedildi",
  "Rejected. The writer has your note.": "Reddedildi. Notunuz yazan kişiye iletildi.",
  "Rejected: {0}": "Reddedildi: {0}",
  "Reject…": "Reddet…",
  "Remove": "Kaldır",
  "Remove Common Products": "Ortak ürünleri kaldır",
  "Remove the link": "Bağlantıyı kaldır",
  "Remove this deal": "Bu kampanyayı kaldır",
  "Remove this pattern": "Bu kalıbı kaldır",
  "Removed.": "Kaldırıldı.",
  "Reorder": "Yeniden sipariş",
  "Reorder Error": "Yeniden sipariş hatası",
  "Repeat": "Tekrarla",
  "Repeat every": "Tekrar aralığı",
  "Repeat it": "Tekrar girin",
  "Repeat on": "Tekrar günleri",
  "Replace": "Değiştir",
  "REPORT": "RAPOR",
  "Report assistant": "Rapor asistanı",
  "Report Error": "Rapor hatası",
  "Report Permissions": "Rapor yetkileri",
  "Reports and sheets Connect made for you, kept {0} days. Only you see them.": "Connect’in sizin için hazırladığı raporlar ve tablolar {0} gün saklanır. Bunları yalnızca siz görürsünüz.",
  "Request access": "Erişim iste",
  "Request access…": "Erişim iste…",
  "Request failed": "İstek başarısız oldu",
  "Reschedule": "Yeniden planla",
  "Rescheduled": "Yeniden planlandı",
  "Retention Cohorts Error": "Elde tutma kohortları hatası",
  "Retry the failed stores": "Başarısız mağazaları yeniden dene",
  "Return": "Getiri",
  "Returning": "Geri dönen",
  "REV %": "CİRO %",
  "revenue": "ciro",
  "Revenue": "Ciro",
  "REVENUE": "CİRO",
  "Revenue analysis & orders by ordering channels": "Sipariş kanallarına göre ciro analizi ve siparişler",
  "Revenue basis": "Ciro esası",
  "Revenue by Channel": "Kanala göre ciro",
  "Revenue by Day Part": "Gün dilimine göre ciro",
  "Revenue by Size": "Boya göre ciro",
  "Revenue by Store": "Mağazaya göre ciro",
  "Revenue Comparison": "Ciro karşılaştırması",
  "Revenue Drop": "Ciro düşüşü",
  "REVENUE RANK": "CİRO SIRASI",
  "Revenue Shape": "Ciro profili",
  "Revenue split by meal periods — Breakfast, Lunch, Afternoon, Dinner, Late Night": "Öğün dilimlerine göre ciro — Kahvaltı, Öğle, Öğleden sonra, Akşam, Gece",
  "Revenue split by payment method": "Ödeme yöntemine göre ciro dağılımı",
  "REVENUE {0}": "CİRO {0}",
  "Revenue, this window": "Ciro, bu aralık",
  "Review": "İncele",
  "Review every change ({0})": "Tüm değişiklikleri incele ({0})",
  "Rewards": "Ödüller",
  "Rewards at weeks {0}": "Ödül verilen haftalar: {0}",
  "Rewards QR on the More tab": "More sekmesinde ödül QR kodu",
  "RIGHT": "SAĞ",
  "Right now this only records who should have what. Nothing is enforced yet; the panel behaves exactly as before until the roles you build here are switched on.": "Şu anda bu yalnızca kimin neye sahip olması gerektiğini kaydeder. Henüz hiçbir şey uygulanmıyor; burada oluşturduğunuz roller açılana kadar panel tam olarak eskisi gibi çalışır.",
  "role": "rol",
  "Role": "Rol",
  "Role deleted.": "Rol silindi.",
  "Role name": "Rol adı",
  "role not loaded": "rol yüklenmedi",
  "Role saved.": "Rol kaydedildi.",
  "Role updated.": "Rol güncellendi.",
  "Roles": "Roller",
  "Roles could not be loaded.": "Roller yüklenemedi.",
  "Row of pictures": "Görsel sırası",
  "Royalty": "Royalti",
  "Royalty %": "Royalti %",
  "Royalty & fees": "Royalti ve ücretler",
  "Royalty & Fees": "Royalti ve ücretler",
  "Royalty and marketing fees per store, per month": "Mağaza ve ay bazında royalti ve pazarlama ücretleri",
  "ROYALTY BASIS": "ROYALTİ ESASI",
  "ROYALTY DUE": "ÖDENECEK ROYALTİ",
  "Royalty Error": "Royalti hatası",
  "ROYALTY PAID": "ÖDENEN ROYALTİ",
  "Rules": "Kurallar",
  "Run an offer": "Kampanya başlat",
  "Runs whenever it is switched on.": "Kampanya açık olduğu sürece geçerlidir.",
  "Runs {0}.": "Kampanya {0} geçerlidir.",
  "Salat": "Salata",
  "Sales": "Satış",
  "SALES": "SATIŞ",
  "Sales by Platform": "Platforma göre satış",
  "Sales by Product Types": "Ürün türlerine göre satış",
  "Sales by Products": "Ürünlere göre satış",
  "Sales by Service": "Servise göre satış",
  "Sales by size": "Boya göre satış",
  "sales per $1 off": "$1 indirim başına satış",
  "Sales Reports": "Satış raporları",
  "Sales so far today": "Bugün şu ana kadarki satışlar",
  "Sales summary": "Satış özeti",
  "Sales summary error": "Satış özeti hatası",
  "Sales tax and tips are never in the basis — they were never the store's money to keep. Bottle deposits are left out by default for the same reason: they go back to the customer with the bottle.": "Satış vergisi ve bahşişler asla esasa dahil edilmez — bunlar zaten hiçbir zaman mağazanın kendisine kalacak para değildi. Şişe depozitoları da aynı nedenle varsayılan olarak hariç tutulur: şişeyle birlikte müşteriye geri döner.",
  "Sales to Report": "Raporlanacak satış",
  "Sales vs the day before": "Satış, önceki güne göre",
  "Sales vs the week before": "Satış, önceki haftaya göre",
  "Sales vs the {0} days before": "Satış, önceki {0} güne göre",
  "Sales, 7 days": "Satış, 7 gün",
  "Sales, day by day": "Satış, gün gün",
  "SALES, FINISHED STORES": "SATIŞ, TAMAMLANAN MAĞAZALAR",
  "Same as assigning it on the Users page. They will see it after signing in again.": "Kullanıcılar sayfasında atamakla aynıdır. Yeniden giriş yaptıktan sonra görür.",
  "same orders, after discounts": "aynı siparişler, indirimlerden sonra",
  "Same period before": "Önceki eş dönem",
  "Sat": "Cmt",
  "Saturday": "Cumartesi",
  "Save": "Kaydet",
  "SAVE": "KAYDET",
  "SAVE $12": "SAVE $12",
  "Save and publish": "Kaydet ve yayımla",
  "Save changes": "Değişiklikleri kaydet",
  "Save Changes": "Değişiklikleri kaydet",
  "Save failed.": "Kaydedilemedi.",
  "Save failed. The featured-products service may not be installed yet.": "Kaydedilemedi. Öne çıkan ürünler servisi henüz kurulmamış olabilir.",
  "Save levels": "Seviyeleri kaydet",
  "Save rates": "Oranları kaydet",
  "Save targeting": "Hedeflemeyi kaydet",
  "Save targets and rates": "Hedefleri ve oranları kaydet",
  "Save the corrections": "Düzeltmeleri kaydet",
  "Save the loyalty rules?": "Sadakat kuralları kaydedilsin mi?",
  "Save to publish to the app.": "Uygulamada yayımlamak için kaydedin.",
  "Saved": "Kaydedildi",
  "Saved 1 featured product.": "1 öne çıkan ürün kaydedildi.",
  "Saved links": "Kayıtlı bağlantılar",
  "saved {0}": "son kayıt: {0}",
  "Saved {0} featured products.": "{0} öne çıkan ürün kaydedildi.",
  "Saved.": "Kaydedildi.",
  "Saved. Customers get it from their next voice session.": "Kaydedildi. Müşterilerin bir sonraki sesli oturumundan itibaren geçerli olacak.",
  "Saved. The app uses the new rules from now on.": "Kaydedildi. Uygulama bundan sonra yeni kuralları kullanacak.",
  "Saving puts your changes on the website at once.": "Kaydettiğinizde değişiklikleriniz hemen web sitesinde yayımlanır.",
  "Saving sends it back for approval.": "Kaydettiğinizde yeniden onaya gönderilir.",
  "Saving sends your changes to an administrator. They go on the website once an administrator approves them.": "Kaydettiğinizde değişiklikleriniz bir yöneticiye gönderilir. Bir yönetici onayladığında web sitesinde yayımlanır.",
  "Saving...": "Kaydediliyor...",
  "Saving…": "Kaydediliyor…",
  "Scan bills": "Faturaları tara",
  "Scan or upload": "Tara veya yükle",
  "scheduled": "planlandı",
  "Scheduled": "Planlanan",
  "Scheduled At": "Planlanan zaman",
  "Scheduled time cannot be in the past.": "Planlanan zaman geçmişte olamaz.",
  "Scheduled time is required.": "Planlanan zaman gerekli.",
  "Scheduled: {0}": "Planlanan: {0}",
  "Schedules": "Zamanlamalar",
  "Scope": "Kapsam",
  "Scope:": "Kapsam:",
  "Search by coupon name/code/message": "Kupon adı/kodu/mesajına göre ara",
  "Search by creation name, creator e-mail or customer ID…": "Kreasyon adı, oluşturanın e-postası veya müşteri ID'sine göre ara…",
  "Search by invite code, host e-mail or customer ID…": "Davet kodu, düzenleyenin e-postası veya müşteri ID'sine göre ara…",
  "Search by name or area": "Ada veya alana göre ara",
  "Search by order #, name, email or phone…": "Sipariş #, ad, e-posta veya telefona göre ara…",
  "Search key is too short!": "Arama ifadesi çok kısa!",
  "Search products by name or menu...": "Ürünleri ada veya menüye göre ara...",
  "Search products by name…": "Ürünleri ada göre ara…",
  "Search...": "Ara...",
  "Second Item": "İkinci ürün",
  "Second Item (Max)": "İkinci ürün (maks.)",
  "seconds": "saniye",
  "section. Pick": "bölümü. Seçin:",
  "See how sales are going": "Satışların gidişatını gör",
  "See it on the website": "Web sitesinde gör",
  "Segment": "Segment",
  "SEGMENT": "SEGMENT",
  "Segments": "Segmentler",
  "Select a menu": "Menü seçin",
  "Select a shift": "Bir vardiya seçin",
  "Select a store": "Bir mağaza seçin",
  "Select at least one store.": "En az bir mağaza seçin.",
  "Select Products": "Ürünleri seçin",
  "Select Unit": "Birim seçin",
  "selected above": "yukarıda seçili",
  "selected segment": "seçili segment",
  "Selected Stores": "Seçili mağazalar",
  "selected tier — the two lists are combined with OR, not AND. Targeting a deal also hides it from customers who are not signed in, since there is no profile to match against.": "seçili seviye — iki liste VE ile değil, VEYA ile birleştirilir. Bir kampanyayı hedeflemek, onu oturum açmamış müşterilerden de gizler; çünkü eşleştirilecek bir profil yoktur.",
  "Send": "Gönder",
  "Send a message to the app on a customer's phone": "Müşterinin telefonundaki uygulamaya mesaj gönderin",
  "Send a push notification to the app": "Uygulamaya anlık bildirim gönderin",
  "Send a text message to customers": "Müşterilere kısa mesaj gönderin",
  "Send again": "Tekrar gönder",
  "Send for approval": "Onaya gönder",
  "Send it again at another time, or repeat it": "Başka bir zamanda yeniden gönderin ya da tekrarlayın",
  "Send my last menu change to the tills": "Son menü değişikliğimi kasalara gönder",
  "Send request": "İsteği gönder",
  "Send targeted push notifications to your customers": "Müşterilerinize hedefli anlık bildirimler gönderin",
  "Send to All Customers": "Tüm müşterilere gönder",
  "Send to Brand": "Markaya gönder",
  "Send to Stores": "Mağazalara gönder",
  "Send {0} times": "{0} kez gönder",
  "Sends again once, on {0}.": "{0} tarihinde bir kez yeniden gönderir.",
  "Sends again {0} times: first {1}, last {2}.": "{0} kez yeniden gönderir: ilki {1}, sonuncusu {2}.",
  "Sends exactly what customers' phones will get (as the sender does), to the team's test phones": "Müşteri telefonlarına gidecek olanın aynısını (gönderici gibi) ekibin test telefonlarına gönderir",
  "Sent": "Gönderildi",
  "sent": "gönderildi",
  "Sent {0}": "Gönderildi: {0}",
  "Sent. An administrator will see it in their Approvals.": "Gönderildi. Bir yönetici bunu Onaylar bölümünde görecek.",
  "Sent:": "Gönderildi:",
  "Separate": "Ayrı",
  "Seperated": "Ayrı",
  "Service": "Servis",
  "SERVICE": "SERVİS",
  "Service type": "Servis türü",
  "Service Type": "Servis türü",
  "Session": "Oturum",
  "Session closed for everyone.": "Oturum herkes için kapatıldı.",
  "Session expired (inactive too long)": "Oturumun süresi doldu (çok uzun süre işlem yapılmadı)",
  "Session was cancelled": "Oturum iptal edildi",
  "Session was created": "Oturum oluşturuldu",
  "sessions": "oturumlar",
  "SESSIONS": "OTURUMLAR",
  "Sessions in view": "Görünen oturumlar",
  "Sessions where several people add to one shared cart and check out together.": "Birkaç kişinin tek bir ortak sepete ürün ekleyip birlikte ödeme yaptığı oturumlar.",
  "Set": "Ayarlayın:",
  "Set how much the rewarded item is discounted (100 = free)": "Ödül olarak verilen ürünün ne kadar indirimli olacağını belirleyin (100 = ücretsiz)",
  "Set the amount taken off the order": "Siparişten düşülecek tutarı belirleyin",
  "Set the combo price": "Kombo fiyatını belirleyin",
  "Set the discount percentage": "İndirim yüzdesini belirleyin",
  "Set the minimum order amount": "Minimum sipariş tutarını belirleyin",
  "Set the minimum to 0 to give the discount on every order.": "Her siparişte indirim vermek için minimumu 0 yapın.",
  "Set up a store": "Mağaza ayarla",
  "Set up the encryption first (top of the Chat tab).": "Önce şifrelemeyi kurun (Sohbet sekmesinin en üstünde).",
  "Sets it to paid and clears the remaining balance on the central record only.": "Siparişi ödendi olarak işaretler ve kalan bakiyeyi yalnızca merkezi kayıtta sıfırlar.",
  "Sets the status to 'Confirmed by store'. Your reason is also appended to the store notes.": "Durumu 'Mağaza onayladı' yapar. Gerekçeniz mağaza notlarına da eklenir.",
  "Settings": "Ayarlar",
  "SETTINGS": "AYARLAR",
  "settled": "tam ödendi",
  "Shaded against the busiest single slot ({0} orders), on a square-root ramp: a dinner rush is several times any lunch hour, and a linear ramp would flatten every other trading hour to the same near-empty grey. Hours are 24-hour store local time, and the row is the day the order was placed — a 01:00 Saturday cell is Friday night's late trade. {1}": "Tonlar en yoğun tek zaman dilimine göre verilir ({0} sipariş), karekök ölçeğiyle: akşam yoğunluğu herhangi bir öğle saatinin birkaç katıdır ve doğrusal bir ölçek diğer tüm satış saatlerini aynı, neredeyse boş griye düzleştirirdi. Saatler mağazanın yerel saatine göre 24 saat biçimindedir ve satır, siparişin verildiği gündür — Cumartesi 01:00 hücresi, Cuma gecesinin geç saat satışıdır. {1}",
  "Share": "Pay",
  "SHARE": "PAY",
  "Share of everyone who ever ordered": "Şimdiye kadar sipariş veren herkes içindeki pay",
  "SHARE OF ORDERS": "SİPARİŞ PAYI",
  "Share of signups": "Kayıt payı",
  "SHARE OF THAT TRAFFIC": "BU TRAFİKTEKİ PAY",
  "Shared-cart sessions: who joined, what they added, and a way to close one": "Ortak sepet oturumları: kim katıldı, ne ekledi; ayrıca oturumu kapatma seçeneği",
  "Shift": "Vardiya",
  "Shift Permissions": "Vardiya yetkileri",
  "Shift Report": "Vardiya raporu",
  "Shift Report Error": "Vardiya raporu hatası",
  "Short by": "Eksik",
  "SHORT BY": "EKSİK",
  "short delivery, missing item…": "eksik teslimat, gelmeyen ürün…",
  "Short description shown in the app": "Uygulamada gösterilen kısa açıklama",
  "short text": "kısa metin",
  "Short text": "Kısa metin",
  "Short. “SAVE $12”, “2 FOR 1”, “NEW”.": "Kısa. “SAVE $12”, “2 FOR 1”, “NEW”.",
  "Show": "Göster",
  "Show all {0}": "Tümünü göster ({0})",
  "Show as table": "Tablo olarak göster",
  "Show chart": "Grafiği göster",
  "Show fewer": "Daha az göster",
  "Show less": "Daha az göster",
  "Show password": "Şifreyi göster",
  "Show the coupons in one state": "Kuponları tek bir duruma göre göster",
  "Show this day in the list": "Bu günü listede göster",
  "Showing in Branch": "Şubede gösteriliyor",
  "Showing on Kiosk": "Kioskta gösteriliyor",
  "Showing on Mobile App": "Mobil uygulamada gösteriliyor",
  "Showing on Website": "Web sitesinde gösteriliyor",
  "Showing the last {0} days of {1}. The rate above covers the whole window.": "Son {0} gün gösteriliyor (toplam {1} gün). Yukarıdaki oran tüm dönemi kapsar.",
  "Showing the {0} {1} {2}.": "Gösterilen: {0} kupon ({1}).",
  "Showing {0} of {1} — narrow the filters to see the rest.": "Gösterilen: {0}/{1} — geri kalanını görmek için filtreleri daraltın.",
  "Showing {0}–{1} of {2}": "Gösterilen: {0}–{1} / {2}",
  "shown": "gösterilen",
  "Shown so the basis can be reconciled against a bank statement: total collected is what the customer paid on the POS sales, which is larger than their basis by tax, tips and whatever the rate settings leave out (deposits, and delivery fees when excluded).": "Esasın banka ekstresiyle karşılaştırılabilmesi için gösterilir: toplam tahsilat, müşterinin POS satışlarında ödediği tutardır; bu da esastan vergi, bahşiş ve oran ayarlarının dışarıda bıraktığı kalemler (depozitolar ve hariç tutulduğunda teslimat ücretleri) kadar fazladır.",
  "Shows up as:": "Şurada görünür:",
  "Side panel": "Yan panel",
  "Sign out": "Çıkış yap",
  "Signed up in the iOS or Android app.": "iOS veya Android uygulamasından kaydoldu.",
  "Signed up on the website.": "Web sitesinden kaydoldu.",
  "Signed up via": "Kayıt kanalı",
  "signed up → first order": "kayıt → ilk sipariş",
  "Signups": "Kayıtlar",
  "signups ({0} activated)": "kayıt ({0} aktive oldu)",
  "Signups are brand-wide however the location picker is set.": "Mağaza seçici nasıl ayarlanırsa ayarlansın kayıtlar marka genelindedir.",
  "Signups per day": "Günlük kayıtlar",
  "Signups per day between {0} and {1}": "{0} ile {1} arasındaki günlük kayıtlar",
  "Silver": "Gümüş",
  "Simli face ID": "Simli yüz kimliği",
  "since {0}": "{0} tarihinden beri",
  "Single": "Tekli",
  "SINGLE": "TEKLİ",
  "Single Use": "Tek kullanımlık",
  "Size": "Boy",
  "SIZE": "BOY",
  "Size Detail": "Boy ayrıntısı",
  "Size is required": "Boy gerekli",
  "Size of the free item": "Ücretsiz ürünün boyu",
  "Size Sales Error": "Boy satışları hatası",
  "Size View": "Boy görünümü",
  "Size × Channel Matrix": "Boy × kanal matrisi",
  "Size: {0}": "Boy: {0}",
  "Sizes & Pricing": "Boylar ve fiyatlar",
  "Sizes for the free item:": "Ücretsiz ürün için boylar:",
  "sizes: {0}": "boylar: {0}",
  "SKIP": "SKIP",
  "SKU": "SKU",
  "Slice": "Dilim",
  "Slot {0}": "Parça {0}",
  "Slots": "Kombo parçaları",
  "Slowing down.": "Siparişleri seyrekleşiyor.",
  "Small badge": "Küçük rozet",
  "SMALLEST CHANNEL": "EN KÜÇÜK KANAL",
  "Smallest order that counts for a week": "Haftaya sayılan en küçük sipariş",
  "SMS": "SMS",
  "SMS campaign created successfully": "SMS kampanyası oluşturuldu",
  "SMS Campaigns": "SMS kampanyaları",
  "SMS Error": "SMS hatası",
  "SMS Load Error": "SMS yükleme hatası",
  "SMS Message": "SMS mesajı",
  "SMS message is required": "SMS mesajı gerekli",
  "SMS Panel": "SMS paneli",
  "SMS Save Error": "SMS kaydetme hatası",
  "SMS sent to brand customers successfully": "Marka müşterilerine SMS gönderildi",
  "SMS sent to store customers successfully": "Mağaza müşterilerine SMS gönderildi",
  "So far": "Şu ana kadar",
  "Social Hub": "Social Hub",
  "Social Templates": "Sosyal medya şablonları",
  "Someone joined": "Biri katıldı",
  "Someone left": "Biri ayrıldı",
  "someone may do; their locations say": "yapabileceğini belirler; bağlı olduğu mağazalar ise",
  "Something went wrong!": "Bir sorun oluştu!",
  "Something went wrong, Please try again later": "Bir sorun oluştu, lütfen daha sonra tekrar deneyin",
  "Something went wrong.": "Bir sorun oluştu.",
  "Source": "Kaynak",
  "Source and destination stores must be different.": "Kaynak ve hedef mağaza farklı olmalı.",
  "sparkles": "sparkles",
  "Speak in any language. Each answer shows below as it is saved; you can still type.": "Herhangi bir dilde konuşun. Her cevap kaydedildikçe aşağıda görünür; yine de yazabilirsiniz.",
  "Speak in any language; changes still wait for your Confirm on the card.": "Herhangi bir dilde konuşun; değişiklikler yine de karttaki Onayla düğmesine basmanızı bekler.",
  "Special Product": "Özel ürün",
  "Special Products": "Özel ürünler",
  "Spend": "Harcama",
  "SPEND": "HARCAMA",
  "Spend $60, get a free garlic bread": "$60 harca, ücretsiz sarımsaklı ekmek kazan",
  "Spend & get free": "Harca & ücretsiz kazan",
  "Spend how much, and get what?": "Ne kadar harcasın, karşılığında ne alsın?",
  "spent": "harcandı",
  "spent on order #{0}": "sipariş #{0} için harcandı",
  "Split by shift rather than by clock hour": "Saat yerine vardiyaya göre bölünmüş",
  "staff discount, no coupon, deal or points": "personel indirimi; kupon, kampanya veya puan yok",
  "Standard": "Standart",
  "Start": "Başlat",
  "Start a new count": "Yeni sayım başlat",
  "Start a new role from this one": "Bunu temel alarak yeni rol oluştur",
  "Start date": "Başlangıç tarihi",
  "Start Date": "Başlangıç tarihi",
  "Start from": "Başlangıç noktası",
  "Start syncing.": "Eşitleme başladı.",
  "Start Time": "Başlangıç saati",
  "Start time must be before end time!": "Başlangıç saati bitiş saatinden önce olmalı!",
  "Start Time:": "Başlangıç saati:",
  "Started {0}": "Başlangıç: {0}",
  "started {0}; visits go back much further": "başlangıç: {0}; ziyaret verileri çok daha eskiye uzanır",
  "started, not finished": "başlanmış, bitmemiş",
  "Starting Date": "Başlangıç tarihi",
  "Starts": "Başlangıç",
  "starts {0}": "{0} tarihinde başlıyor",
  "Status": "Durum",
  "Stock Amount": "Stok miktarı",
  "Stock at every store side by side": "Her mağazadaki stok, yan yana",
  "Stock Audit has been saved successfully": "Stok denetimi kaydedildi",
  "Stock Audit has been updated successfully": "Stok denetimi güncellendi",
  "Stock Audit has not been saved successfully": "Stok denetimi kaydedilemedi",
  "Stock Audit has not been updated successfully": "Stok denetimi güncellenemedi",
  "Stock Audit list loaded successfully": "Stok denetimi listesi yüklendi",
  "Stock Audit list not loaded": "Stok denetimi listesi yüklenemedi",
  "Stock cannot be blank!": "Stok boş olamaz!",
  "Stock Count": "Stok sayımı",
  "Stock Count Error": "Stok sayımı hatası",
  "Stock Error": "Stok hatası",
  "Stock has been deleted successfully": "Stok silindi",
  "Stock has been deleted successfully!": "Stok silindi!",
  "Stock has been saved successfully!": "Stok kaydedildi!",
  "Stock has been updated successfully!": "Stok güncellendi!",
  "Stock has not been deleted successfully": "Stok silinemedi",
  "Stock is held per store. Choose which one from the selector at the top left.": "Stok mağaza bazında tutulur. Sol üstteki seçiciden mağazayı seçin.",
  "Stock list": "Stok listesi",
  "Stock Name": "Stok adı",
  "Stock name cannot be empty!": "Stok adı boş olamaz!",
  "Stock on hand": "Eldeki stok",
  "Stock Quantity": "Stok miktarı",
  "Stock Report list not loaded": "Stok raporu listesi yüklenemedi",
  "Stock SKU cannot be empty!": "Stok SKU'su boş olamaz!",
  "Stock Transactions": "Stok hareketleri",
  "Stock Unit": "Stok birimi",
  "Stock unit cannot be empty!": "Stok birimi boş olamaz!",
  "Stock unit price cannot be empty!": "Stok birim fiyatı boş olamaz!",
  "Stock unit price cannot be zero or negative!": "Stok birim fiyatı sıfır veya negatif olamaz!",
  "STOCK VALUE": "STOK DEĞERİ",
  "Stocks": "Stoklar",
  "Stop": "Durdur",
  "Stop talking": "Konuşmayı bitir",
  "Store": "Mağaza",
  "STORE": "MAĞAZA",
  "store #{0}": "mağaza #{0}",
  "Store #{0}": "Mağaza #{0}",
  "Store Benchmark": "Mağaza kıyaslaması",
  "Store Benchmark Error": "Mağaza karşılaştırma hatası",
  "Store Breakdown": "Mağaza dağılımı",
  "Store Comparison": "Mağaza karşılaştırması",
  "STORE COMPARISON": "MAĞAZA KARŞILAŞTIRMASI",
  "Store Dashboard Error": "Mağaza panosu hatası",
  "STORE DEMAND AND STORE PAGE TRAFFIC": "MAĞAZA TALEBİ VE MAĞAZA SAYFASI TRAFİĞİ",
  "Store detail": "Mağaza ayrıntısı",
  "Store league table": "Mağaza sıralama tablosu",
  "Store Location": "Mağaza konumu",
  "Store Menu": "Mağaza menüsü",
  "Store notes:": "Mağaza notları:",
  "STORE PAGE VISITS": "MAĞAZA SAYFASI ZİYARETLERİ",
  "Store performance": "Mağaza performansı",
  "Store Rankings": "Mağaza sıralaması",
  "Store scorecard": "Mağaza karnesi",
  "Store Scorecard": "Mağaza karnesi",
  "Store Scorecard Error": "Mağaza karnesi hatası",
  "Store special: {0}": "Mağazaya özel ürün: {0}",
  "Store Switch Error": "Mağaza değiştirme hatası",
  "STORE {0}": "MAĞAZA {0}",
  "STORE'S MENU": "MAĞAZANIN MENÜSÜ",
  "Store:": "Mağaza:",
  "stores": "mağaza",
  "Stores": "Mağazalar",
  "Stores saved.": "Mağazalar kaydedildi.",
  "Stores today": "Mağazalarda bugün",
  "STORES TRADING": "SATIŞ YAPAN MAĞAZALAR",
  "stores, {0}": "mağaza, {0}",
  "Story": "Yazı",
  "Story Content/Article": "Hikâye içeriği/Makale",
  "Story Cover Page": "Hikâye kapak sayfası",
  "Streak": "Seri",
  "Streak reward": "Seri ödülü",
  "Subheading": "Alt başlık",
  "Submit": "Gönder",
  "Submit count": "Sayımı gönder",
  "Submit this count?": "Bu sayım gönderilsin mi?",
  "Subtotal": "Ara toplam",
  "Subtotal :": "Ara toplam :",
  "Success": "Başarılı",
  "SUGGESTED": "ÖNERİLEN",
  "Suggested deals": "Önerilen kampanyalar",
  "suggested, all stores": "önerilen, tüm mağazalar",
  "Sum: {0}": "Toplam: {0}",
  "Summary": "Özet",
  "Sun": "Paz",
  "Sunday": "Pazar",
  "Suppliers offered first (one per line)": "Önce önerilecek tedarikçiler (her satıra bir tane)",
  "Switch a product back on at this store": "Bir ürünü bu mağazada yeniden aç",
  "Switch off": "Kapat",
  "Switch on": "Aç",
  "Switch to dark": "Koyu temaya geç",
  "Switch to light": "Açık temaya geç",
  "switched off": "kapalı",
  "Sync Deliverect": "Deliverect ile senkronize et",
  "Sync failed": "Eşitleme başarısız oldu",
  "Sync List": "Listeyi senkronize et",
  "Sync paused": "Eşitleme duraklatıldı",
  "Sync to the tills": "Kasalarla eşitle",
  "Sync unavailable": "Eşitleme kullanılamıyor",
  "Synced": "Eşitlendi",
  "Synced successfully.": "Eşitlendi.",
  "Syncing": "Eşitleniyor",
  "Sysco SUPC": "Sysco SUPC",
  "Table": "Tablo",
  "Take $": "Siparişe $",
  "Take back": "Geri al",
  "Take it again": "Yeniden çek",
  "taken": "alınan",
  "Takeout": "Al-götür",
  "Takings and orders for the last few days at a glance": "Son birkaç günün cirosu ve siparişleri tek bakışta",
  "Talk": "Konuş",
  "Talk again": "Yeniden konuş",
  "Talk with Connect": "Connect ile konuş",
  "Talk with Connect in any language": "Connect ile herhangi bir dilde konuş",
  "Talking with Connect": "Connect ile konuşma",
  "Talking with the report assistant": "Rapor asistanıyla konuşma",
  "Tall, about 3 × 4": "Dikey, yaklaşık 3 × 4",
  "Target": "Hedef",
  "TARGET": "HEDEF",
  "Target levels": "Hedef seviyeler",
  "target levels updated": "hedef seviyeler güncellendi",
  "Target Menu": "Hedef menü",
  "Target Store": "Hedef mağaza",
  "Targeted": "Hedefli",
  "Targeting has been updated.": "Hedefleme güncellendi.",
  "Targets and rates": "Hedefler ve oranlar",
  "Tax": "Vergi",
  "TAX": "VERGİ",
  "Taxes (Delivery)": "Vergiler (Teslimat)",
  "Taxes (GST)": "Vergiler (GST)",
  "Taxes (PST)": "Vergiler (PST)",
  "Team chat": "Ekip sohbeti",
  "Term": "Terim",
  "Test": "Test et",
  "Test (live format)": "Test et (canlı biçim)",
  "Test Phone Number:": "Test telefon numarası:",
  "Test SMS": "SMS'i test et",
  "Test SMS sent successfully": "Test SMS'i gönderildi",
  "Text": "Metin",
  "text above the pictures": "görsellerin üstündeki metin",
  "Text above the pictures": "Görsellerin üstündeki metin",
  "text below the pictures": "görsellerin altındaki metin",
  "Text below the pictures": "Görsellerin altındaki metin",
  "That backup does not match the key on the server. Make a new key instead.": "Bu yedek, sunucudaki anahtarla eşleşmiyor. Bunun yerine yeni bir anahtar oluşturun.",
  "That change could not be opened.": "Bu değişiklik açılamadı.",
  "That file is not there any more.": "Bu dosya artık yok.",
  "That is not the passphrase.": "Parola yanlış.",
  "That new story is no longer waiting for approval.": "Bu yeni yazı artık onay beklemiyor.",
  "That picture is {0} MB. The limit is 2 MB — make it smaller and try again.": "Bu görsel {0} MB. Sınır 2 MB — görseli küçültüp yeniden deneyin.",
  "That picture link does not load.": "Bu görsel bağlantısı yüklenmiyor.",
  "That story is not on the website any more.": "Bu yazı artık web sitesinde değil.",
  "That’s everything for {0}. Here is the month. If it looks right, I’ll make the Excel report.": "{0} için hepsi bu kadar. İşte ayın özeti. Doğru görünüyorsa Excel raporunu hazırlayacağım.",
  "The AI host's voice modes, avatar face and session limits": "Uygulamadaki AI asistanının ses modları, avatar yüzü ve oturum sınırları",
  "The app asks the customer which one they want.": "Uygulama, müşteriye hangisini istediğini sorar.",
  "The app uses them at once: tiers are counted again tonight, and streak rewards change straight away.": "Uygulama bunları hemen kullanır: seviyeler bu gece yeniden hesaplanır, seri ödülleri ise anında değişir.",
  "The apps report no visits at all — they carry no analytics SDK, only server-sent purchases. {0} app orders in this window have no denominator anywhere, so adding them would inflate the rate by about half again.": "Uygulamalar hiç ziyaret bildirmez — içlerinde analiz SDK'sı yoktur, yalnızca sunucudan gönderilen satın almalar vardır. Bu dönemdeki {0} uygulama siparişinin hiçbir yerde paydası yoktur; bunları eklemek oranı yaklaşık bir buçuk katına çıkarırdı.",
  "The area a store delivers to, and the fee for each zone": "Mağazanın teslimat yaptığı alan ve her bölgenin ücreti",
  "The area a store delivers to, and the fee for each zone.": "Mağazanın teslimat yaptığı alan ve her bölgenin ücreti.",
  "The article you write in step 3": "3. adımda yazacağınız makale",
  "The assistant is not switched on on this server.": "Asistan bu sunucuda açık değil.",
  "The assistant is the server; its lines are not encrypted": "Asistan sunucunun kendisidir; mesajları şifrelenmez",
  "The assistant is writing": "Asistan yazıyor",
  "The avatar's face": "Avatarın yüzü",
  "The badge, title and picture above are what the carousel card shows. Website picture banners are separate (Marketing → Banners).": "Karusel kartında yukarıdaki rozet, başlık ve görsel gösterilir. Web sitesindeki görselli banner'lar ayrıdır (Pazarlama → Banner'lar).",
  "The banner is saved, but where it goes when tapped is not.": "Banner kaydedildi, ancak dokunulduğunda gideceği yer kaydedilmedi.",
  "The bottom stays as every visit": "Payda tüm ziyaretler olarak kalır",
  "The browser blocked the new tab. Allow pop-ups for Connect and try again.": "Tarayıcı yeni sekmeyi engelledi. Connect için açılır pencerelere izin verin ve tekrar deneyin.",
  "The card opens": "Kart şunu açar:",
  "The card people see on the website's stories page.": "Ziyaretçilerin web sitesindeki hikayeler sayfasında gördüğü kart.",
  "The choices customers add to an item, and what they cost": "Müşterilerin bir ürüne eklediği seçenekler ve fiyatları",
  "The choices customers add to an item, and what they cost.": "Müşterilerin bir ürüne eklediği seçenekler ve fiyatları.",
  "The code customers show in the store to collect points.": "Müşterilerin puan toplamak için mağazada gösterdiği kod.",
  "The customer buys": "Müşteri satın alır:",
  "The customer can choose from these menu categories": "Müşteri bu menü kategorilerinden seçebilir",
  "The customer named this base pizza without customising it.": "Müşteri bu temel pizzayı özelleştirmeden adlandırdı.",
  "The day after": "Sonraki gün",
  "The day before": "Önceki gün",
  "The day split into trading periods": "Satış dilimlerine ayrılmış gün",
  "The deal is created switched OFF — turn it on from the Dashboard when you are ready.": "Kampanya KAPALI olarak oluşturulur — hazır olduğunuzda Pano'dan açın.",
  "The end date is before the start date": "Bitiş tarihi başlangıç tarihinden önce",
  "The end is before the start.": "Bitiş zamanı başlangıçtan önce.",
  "The engine could not validate this draft": "Motor bu taslağı doğrulayamadı",
  "the headline": "ana rakam",
  "The host and members will see it as cancelled. This cannot be undone.": "Düzenleyen ve üyeler bunu iptal edilmiş olarak görür. Bu işlem geri alınamaz.",
  "The internal key is empty (More options)": "Dahili anahtar boş (Diğer seçenekler)",
  "The items every store counts, and their prices": "Her mağazanın saydığı stok kalemleri ve fiyatları",
  "The last 100 messages.": "Son 100 mesaj.",
  "the last 14 days": "son 14 gün",
  "the last 30 days": "son 30 gün",
  "the last 7 days": "son 7 gün",
  "The last 7 days against the 7 before": "Son 7 gün, önceki 7 günle karşılaştırmalı",
  "the last 90 days": "son 90 gün",
  "the last seven complete days, against the seven before": "tamamlanan son yedi gün, önceki yedi günle karşılaştırmalı",
  "The list is shared, so the stock value changes at every store.": "Liste ortak olduğu için stok değeri her mağazada değişir.",
  "The loyalty rules could not be loaded.": "Sadakat kuralları yüklenemedi.",
  "The menu": "Menü",
  "The month": "Ayın tamamı",
  "The new story": "Yeni yazı",
  "The nightly scoring job has not classified these yet.": "Gece çalışan puanlama işi bunları henüz sınıflandırmadı.",
  "The notification has already been sent and cannot be deleted!": "Bildirim zaten gönderildi, silinemez!",
  "The option item could not be deleted.": "Seçenek silinemedi.",
  "The option item could not be loaded.": "Seçenek yüklenemedi.",
  "The PDF reports and Excel files Connect made for you": "Connect'in sizin için hazırladığı PDF raporları ve Excel dosyaları",
  "The people in this list by the day of their latest message, over the last 14 days.": "Bu listedeki kişiler, son 14 gün içinde en son mesaj attıkları güne göre.",
  "The photo": "Fotoğraf",
  "The picture could not be uploaded.": "Resim yüklenemedi.",
  "The picture could not be uploaded. Try again or paste a link instead.": "Görsel yüklenemedi. Yeniden deneyin ya da bunun yerine bir bağlantı yapıştırın.",
  "The picture will be removed.": "Görsel kaldırılacak.",
  "The pizzas pinned to the top of the app's": "Uygulamada şu bölümün en üstüne sabitlenen pizzalar:",
  "The pizzas pinned to the top of the app's Most popular section": "Uygulamanın En popüler bölümünün en üstüne sabitlenen pizzalar",
  "The points the customer and the friend they invited each get once the friend's first online order goes through. A friend who signs up with a code gets these instead of the welcome points.": "Arkadaşın ilk online siparişi tamamlandığında müşterinin ve davet ettiği arkadaşın her birine verilen puan. Kodla kaydolan bir arkadaş, hoş geldin puanı yerine bunları alır.",
  "The promotional images customers see in the app": "Müşterilerin uygulamada gördüğü tanıtım görselleri",
  "The report can’t open": "Rapor açılamıyor",
  "The result didn't find.": "Sonuç bulunamadı.",
  "The row holds {0} pictures: only the first one is added.": "Sıra en fazla {0} görsel alır: yalnızca ilki eklendi.",
  "The row holds {0} pictures: only the first {1} are added.": "Sıra en fazla {0} görsel alır: yalnızca ilk {1} görsel eklendi.",
  "The rule": "Kural",
  "The rules behind the app's loyalty: what each tier needs, the weekly streak rewards and the reward for inviting a friend. The app uses them as soon as they are saved.": "Uygulamadaki sadakat programının kuralları: her seviye için gerekenler, haftalık seri ödülleri ve arkadaş davet etme ödülü. Uygulama, kaydedildikleri anda bunları kullanır.",
  "the same days last year": "geçen yılın aynı günleri",
  "the same figure as every sales page": "tüm satış sayfalarındakiyle aynı rakam",
  "The scanned page": "Taranan sayfa",
  "The separate tool for scheduling social posts": "Sosyal medya gönderilerini planlamak için ayrı araç",
  "The server refused the key.": "Sunucu anahtarı reddetti.",
  "The server refused the request.": "Sunucu isteği reddetti.",
  "The settings could not be loaded.": "Ayarlar yüklenemedi.",
  "The status could not be changed.": "Durum değiştirilemedi.",
  "The stories could not be loaded.": "Hikayeler yüklenemedi.",
  "The stories on the website's": "Web sitesindeki hikayeler:",
  "The stories on the website's Our Stories page: write, change or remove them": "Web sitesinin Our Stories sayfasındaki hikayeler: yazın, değiştirin veya kaldırın",
  "The story after the change": "Değişiklikten sonraki yazı",
  "The story is no longer on the website, so this cannot be approved. Reject it with a note.": "Hikaye artık web sitesinde değil, bu yüzden bu değişiklik onaylanamaz. Bir notla reddedin.",
  "The story is no longer on the website. Reject it with a note.": "Hikaye artık web sitesinde değil. Bir notla reddedin.",
  "the story is off the website.": "yazı web sitesinden kaldırıldı.",
  "The story that would go off the website": "Web sitesinden kaldırılacak yazı",
  "The story's own page, from top to bottom as the website lays it out. Leave out any part you do not need.": "Hikayenin kendi sayfası; web sitesinin yerleşimine göre yukarıdan aşağıya. İhtiyacınız olmayan bölümleri boş bırakın.",
  "The story's own page, or another page of the website.": "Hikayenin kendi sayfası ya da web sitesinin başka bir sayfası.",
  "The system's own figure is deliberately not shown while you count. Seeing it first makes it very hard not to simply agree with it, and then a count confirms a mistake instead of catching it. The difference appears as soon as you submit.": "Siz sayarken sistemin kendi rakamı bilerek gösterilmez. Önce onu görmek, ona öylece katılmamayı çok zorlaştırır; o zaman sayım bir hatayı yakalamak yerine onu onaylar. Fark, gönderdiğiniz anda görünür.",
  "The target is how much you want on the shelf at the start of a week. Suggestions come from your own counts: average weekly use, stretched to cover the {0} days until the next order plus the days waiting for delivery, with {1}% on top so an average week is not also a week you run out.": "Hedef, hafta başında rafta olmasını istediğiniz miktardır. Öneriler kendi sayımlarınızdan gelir: ortalama haftalık kullanım, bir sonraki siparişe kadarki {0} günü ve teslimatı beklerken geçen günleri karşılayacak şekilde uzatılır ve üstüne %{1} eklenir; böylece ortalama bir hafta aynı zamanda stoğun tükendiği bir hafta olmaz.",
  "The title, when left empty": "Boş bırakılırsa başlık kullanılır",
  "The two share columns can be read against each other — a store taking a larger slice of the traffic than of the orders is being looked at more than it is being bought from. The counts themselves cannot be divided into a rate: a session can see several store pages, a fifth of web orders begin a session with no landing page at all because returning from the payment provider starts a new one, and app orders have no page. That is why there is no per-store percentage here.": "İki pay sütunu birbiriyle karşılaştırılabilir — trafikten, siparişlerden aldığından daha büyük pay alan bir mağazaya, sipariş verildiğinden daha çok bakılıyor demektir. Sayıların kendisi bir orana bölünemez: bir oturum birkaç mağaza sayfası görebilir, ödeme sağlayıcısından dönüş yeni bir oturum başlattığı için web siparişlerinin beşte biri hiç giriş sayfası olmayan bir oturumla başlar ve uygulama siparişlerinin sayfası yoktur. Bu yüzden burada mağaza bazında yüzde yok.",
  "The upload failed.": "Yükleme başarısız oldu.",
  "The voice service closed the connection.": "Ses servisi bağlantıyı kapattı.",
  "The voice session ended. Tap the mic to talk again.": "Sesli oturum sona erdi. Yeniden konuşmak için mikrofona dokunun.",
  "The voice session reached its time limit (about ten minutes). Tap the mic to go on.": "Sesli oturum süre sınırına ulaştı (yaklaşık on dakika). Devam etmek için mikrofona dokunun.",
  "The voice session stopped ({0}). Tap the mic to talk again.": "Sesli oturum durdu ({0}). Yeniden konuşmak için mikrofona dokunun.",
  "The website has this now instead:": "Web sitesinde artık bunun yerine şu var:",
  "The website’s {0} changed after {1} asked, so approving would undo that. Reject it with a note and they can ask again from the newest version.": "Web sitesindeki {0}, {1} istekte bulunduktan sonra değişti; bu yüzden onaylamak o değişikliği geri alır. Bir notla reddedin; en yeni sürümden yeniden isteyebilirler.",
  "The website’s {0} changed after {1} asked, so approving would undo that. Reject it with a note and they can ask again.": "Web sitesindeki {0}, {1} istekte bulunduktan sonra değişti; bu yüzden onaylamak o değişikliği geri alır. Bir notla reddedin; yeniden isteyebilirler.",
  "The website’s {0} changed since you asked; open the story and make your change again.": "Web sitesindeki {0}, siz istedikten sonra değişti; yazıyı açın ve değişikliğinizi yeniden yapın.",
  "The week after": "Sonraki hafta",
  "The week before": "Önceki hafta",
  "the whole bill": "faturanın tamamı",
  "The whole combo costs $": "Kombonun tamamı $",
  "The writer gets your note in a direct message.": "Notunuz yazan kişiye doğrudan mesajla iletilir.",
  "The {0} days after": "Sonraki {0} gün",
  "The {0} days before": "Önceki {0} gün",
  "the {0} days before {1}": "{1} öncesindeki {0} gün",
  "them": "onları",
  "There is no option items.": "Hiç seçenek yok.",
  "These add up to {0}, which is {1} above net sales.": "Bunların toplamı {0}; bu, net satışın {1} üzerinde.",
  "These add up to {0}, which is {1} below net sales.": "Bunların toplamı {0}; bu, net satışın {1} altında.",
  "These come from the reporting service, so the figures are produced outside this panel and cannot be changed here.": "Bunlar raporlama servisinden gelir; rakamlar bu panelin dışında üretilir ve burada değiştirilemez.",
  "These keep the voice and avatar costs in check: 1–60 minutes a session, 15–600 seconds of silence.": "Bunlar ses ve avatar maliyetlerini kontrol altında tutar: oturum başına 1–60 dakika, 15–600 saniye sessizlik.",
  "They are created by staff while taking a phone or counter order, so they arrive with an order already attached and usually without an e-mail address — counting them as \"signups\" inflates both the total and the activation rate. Switch them on above to see the full picture.": "Bunları personel telefon ya da tezgâh siparişi alırken oluşturur; bu yüzden bu kayıtlar zaten bir siparişle birlikte ve genellikle e-posta adresi olmadan gelir — bunları \"yeni kayıt\" olarak saymak hem toplamı hem de aktivasyon oranını şişirir. Tam tabloyu görmek için yukarıdan açın.",
  "They buy a number of items and one (or more) of them is free or discounted.": "Müşteriler belirli sayıda ürün alır; bunlardan biri (ya da daha fazlası) ücretsiz veya indirimli olur.",
  "They get your note in a direct message.": "Notunuz isteyen kişiye doğrudan mesajla iletilir.",
  "Things other people wrote or asked for that need a yes from you before they happen.": "Başkalarının yazdığı ya da istediği, gerçekleşmeden önce sizin onayınızı bekleyen şeyler.",
  "Thinking…": "Düşünüyor…",
  "This action cannot be undone.": "Bu işlem geri alınamaz.",
  "This browser cannot do the encryption (no Web Crypto). Use a current Chrome, Safari, Firefox or Edge over https.": "Bu tarayıcı şifrelemeyi yapamıyor (Web Crypto yok). https üzerinden güncel bir Chrome, Safari, Firefox veya Edge kullanın.",
  "This browser only": "Yalnızca bu tarayıcı",
  "This cannot be undone — a correcting count would have to be entered instead.": "Bu işlem geri alınamaz — bunun yerine düzeltici bir sayım girilmesi gerekir.",
  "This card deletes or takes away {0} thing. Undo can put it back.": "Bu kart {0} öğeyi siler veya kaldırır. Geri al ile geri getirilebilir.",
  "This card deletes or takes away {0} things. Undo can put them back.": "Bu kart {0} öğeyi siler veya kaldırır. Geri al ile hepsi geri getirilebilir.",
  "This code already exists!": "Bu kod zaten var!",
  "This date range already exists!": "Bu tarih aralığı zaten var!",
  "This deal does not run at {0}.": "Bu kampanya {0} için geçerli değil.",
  "This deal is switched off: the app will say it is not available.": "Bu kampanya kapalı: uygulama, kampanyanın mevcut olmadığını söyleyecek.",
  "This deal runs only at {0}: customers of other stores are told it is not available there.": "Bu kampanya yalnızca {0} için geçerli: diğer mağazaların müşterilerine kampanyanın orada geçerli olmadığı söylenir.",
  "This is a built-in role and cannot be changed. Copy it to make your own version.": "Bu yerleşik bir roldür ve değiştirilemez. Kendi sürümünüzü oluşturmak için kopyalayın.",
  "This is the first count here, so there is nothing to compare against yet — from now on every count will show what moved.": "Bu, buradaki ilk sayım; bu yüzden henüz karşılaştırılacak bir şey yok — bundan sonra her sayım nelerin değiştiğini gösterecek.",
  "This month": "Bu ay",
  "This notification has already gone out. Saving changes its record only; nothing is sent again. To send the new version, reschedule it.": "Bu bildirim zaten gönderildi. Kaydetmek yalnızca kaydını değiştirir; hiçbir şey yeniden gönderilmez. Yeni sürümü göndermek için yeniden zamanlayın.",
  "This page": "Bu sayfa",
  "this page": "bu sayfada",
  "This price looked wrong when the list was imported": "Liste içe aktarılırken bu fiyat hatalı görünüyordu",
  "This removes the deal for good and customers stop seeing it. Switching it off instead keeps it for later.": "Bu işlem kampanyayı kalıcı olarak kaldırır ve müşteriler artık onu görmez. Bunun yerine kapatırsanız kampanya ileride kullanmak üzere saklanır.",
  "This section is under development.": "Bu bölüm geliştirme aşamasında.",
  "This sends": "Bu işlem",
  "this store": "bu mağaza",
  "This store": "Bu mağaza",
  "This store has no store specials.": "Bu mağazada mağazaya özel ürün yok.",
  "THIS WEEK": "BU HAFTA",
  "This week": "Bu hafta",
  "This week (Mon – Today)": "Bu hafta (Pzt – Bugün)",
  "This week (Sun – Today)": "Bu hafta (Paz – Bugün)",
  "This will send the notification to every customer.": "Bu işlem bildirimi tüm müşterilere gönderecek.",
  "through Connect, the assistant": "asistan Connect aracılığıyla",
  "thrown away in total": "toplam atılan",
  "Thu": "Per",
  "Thursday": "Perşembe",
  "Ticket": "Sepet",
  "TICKET": "SEPET",
  "Tier": "Seviye",
  "Tier mix": "Seviye dağılımı",
  "Tiers": "Seviyeler",
  "Tiers come from": "Seviyelerin kaynağı",
  "Till (POS)": "Kasa (POS)",
  "Till (POS) records are left out by default.": "Kasa (POS) kayıtları varsayılan olarak hariç tutulur.",
  "till user": "kasa kullanıcısı",
  "Till users": "Kasa kullanıcıları",
  "Time window": "Zaman aralığı",
  "Tip": "Bahşiş",
  "TIPS": "BAHŞİŞ",
  "title": "başlık",
  "Title": "Başlık",
  "Title and Body are required.": "Başlık ve metin gerekli.",
  "To": "Bitiş",
  "To close a shift instead: use": "Bunun yerine vardiyayı kapatmak için:",
  "to feature one everywhere, or a single store to feature it only there. Lower position shows first.": "— bir pizzayı her yerde öne çıkarmak için; yalnızca bir mağazada öne çıkarmak için o mağazayı seçin. Sıra numarası küçük olan önce gösterilir.",
  "TO ORDER": "SİPARİŞ EDİLECEK",
  "To Store": "Hedef mağaza",
  "To time": "Bitiş saati",
  "Today": "Bugün",
  "Today (24 h)": "Bugün (24 saat)",
  "Today is not over yet, so its sales are still coming in.": "Bugün henüz bitmedi, bu yüzden satışları hâlâ geliyor.",
  "TODAY ORDERS": "BUGÜNKÜ SİPARİŞLER",
  "TODAY REVENUE": "BUGÜNKÜ CİRO",
  "Today so far": "Bugün şu ana kadar",
  "Tomorrow": "Yarın",
  "took at least one order": "en az bir sipariş aldı",
  "Took back {0} points.": "{0} puan geri alındı.",
  "Top 10 items": "En çok satan 10 ürün",
  "Top 3 Peak Moments": "En yoğun 3 an",
  "Top customers": "En iyi müşteriler",
  "TOP ITEMS": "EN ÇOK SATANLAR",
  "Top Items Today": "Bugün en çok satanlar",
  "top picture": "üst görsel",
  "Top picture": "Üst görsel",
  "Top Products": "En çok satan ürünler",
  "Top Products — {0}": "En çok satan ürünler — {0}",
  "Top spend": "En yüksek harcama",
  "TOP ZONE": "EN YOĞUN BÖLGE",
  "Top {0}": "İlk {0}",
  "Topping Limit": "Malzeme sınırı",
  "Toppings": "Malzemeler",
  "Toppings & options": "Malzemeler & seçenekler",
  "Total": "Toplam",
  "TOTAL": "TOPLAM",
  "Total :": "Toplam :",
  "TOTAL COLLECTED": "TOPLAM TAHSİLAT",
  "TOTAL DISCOUNTS": "TOPLAM İNDİRİM",
  "Total Discounts Applied": "Uygulanan toplam indirim",
  "TOTAL DUE": "ÖDENECEK TOPLAM",
  "TOTAL ITEMS SOLD": "SATILAN TOPLAM ÜRÜN",
  "TOTAL ORDERS": "TOPLAM SİPARİŞ",
  "Total paid": "Ödenen toplam",
  "Total Price": "Toplam fiyat",
  "TOTAL QUANTITY": "TOPLAM MİKTAR",
  "Total Revenue": "Toplam ciro",
  "TOTAL REVENUE": "TOPLAM CİRO",
  "Total sales": "Toplam satış",
  "Total Sales": "Toplam satış",
  "TOTAL SALES": "TOPLAM SATIŞ",
  "Total Sales by Source": "Kaynağa göre toplam satış",
  "Total Taxes": "Toplam vergi",
  "Total {0}": "Toplam {0}",
  "Total: {0}": "Toplam: {0}",
  "Traffic": "Trafik",
  "Tried at one store": "Bir mağazada denendi",
  "Try asking": "Şunları sormayı deneyin",
  "Try at one store first": "Önce tek mağazada dene",
  "Try it": "Dene",
  "Tue": "Sal",
  "Tuesday": "Salı",
  "Turn on": "Etkinleştir",
  "Two extras on the app's screens.": "Uygulama ekranları için iki ek özellik.",
  "Two large pizzas and a side": "Two large pizzas and a side",
  "Type": "Tür",
  "TYPE": "TÜR",
  "Type a date like {0}.": "{0} gibi bir tarih yazın.",
  "Type the platform statement figure, if there is one.": "Varsa platform ekstresindeki rakamı yazın.",
  "Type to search products": "Ürün aramak için yazın",
  "Type {0} to delete": "Silmek için {0} yazın",
  "Type:": "Tür:",
  "typed into the online coupon box": "online kupon kutusuna girilen",
  "UBER": "UBER",
  "Uber / DoorDash / Skip": "Uber / DoorDash / Skip",
  "Uber / DoorDash / Skip promotions": "Uber / DoorDash / Skip promosyonları",
  "Uber, DoorDash and Skip": "Uber, DoorDash ve Skip",
  "Uber, DoorDash and Skip orders that come in through Deliverect never reach the store's POS, so they are not in POS sales; they are counted once, in the third-party columns, from our records (the grey figure). Type the platform's statement figure to replace a recorded one; it is never added on top. Leave a column blank, or 0, to use the record. Blank \"paid\" means nothing has been entered yet; 0 means nothing was collected — the gap column stays empty until one of them is filled.": "Deliverect üzerinden gelen Uber, DoorDash ve Skip siparişleri mağazanın POS'una hiç ulaşmaz, bu yüzden POS satışlarında yer almaz; bunlar kendi kayıtlarımızdan (gri rakam) üçüncü taraf sütunlarında bir kez sayılır. Kayıtlı bir rakamın yerine geçmesi için platform ekstresindeki rakamı yazın; bu rakam asla üstüne eklenmez. Kaydı kullanmak için sütunu boş bırakın ya da 0 yazın. Boş \"ödenen\", henüz hiçbir şey girilmediği; 0 ise hiçbir şey tahsil edilmediği anlamına gelir — bunlardan biri doldurulana kadar fark sütunu boş kalır.",
  "under the bottom picture": "alt görselin altında",
  "Understand the customers": "Müşterileri tanı",
  "Undo": "Geri al",
  "Undo a {0} change": "Bir {0} değişikliğini geri al",
  "Undo changes": "Değişiklikleri geri al",
  "Undo my last change": "Son değişikliğimi geri al",
  "UNIQUE ORDERS": "TEKİL SİPARİŞ",
  "UNIQUE PRODUCTS": "TEKİL ÜRÜN",
  "Unit": "Birim",
  "Unit Multiplier": "Birim çarpanı",
  "Unit Name": "Birim adı",
  "unit name content": "birim adı içeriği",
  "Unit Price": "Birim fiyatı",
  "UNITS": "ADET",
  "Unknown": "Bilinmiyor",
  "Unknown shift": "Bilinmeyen vardiya",
  "Unlink": "Bağlantıyı kaldır",
  "Unlock": "Kilidi aç",
  "Unremovable": "Çıkarılamaz",
  "Unsaved changes": "Kaydedilmemiş değişiklikler",
  "Unsaved changes.": "Kaydedilmemiş değişiklikler.",
  "Unscored": "Puanlanmamış",
  "Untick to make this choice optional.": "Bu seçimi isteğe bağlı yapmak için işareti kaldırın.",
  "Until it is off": "Kapatılana kadar",
  "until {0}": "{0} tarihine kadar",
  "Untitled draft": "Adsız taslak",
  "Unused": "Kullanılmadı",
  "up to 6; the old stories have 3": "en fazla 6; eski hikayelerde 3 tane var",
  "Up to {0} days at a time.": "Tek seferde en fazla {0} gün.",
  "Up to {0} days here": "Burada en fazla {0} gün",
  "up {0}% on the day before": "önceki güne göre %{0} artış",
  "Update": "Güncelle",
  "Update Banner": "Banner'ı güncelle",
  "Update Hours": "Saatleri güncelle",
  "Update Time": "Güncellenme zamanı",
  "Update User": "Güncelleyen kullanıcı",
  "Updated": "Güncellendi",
  "Updated {0}": "Son güncelleme: {0}",
  "Updated {0} · refreshes every 30 s": "Son güncelleme: {0} · 30 sn'de bir yenilenir",
  "Updating...": "Güncelleniyor...",
  "Upload New Image:": "Yeni görsel yükle:",
  "uploaded image": "yüklenen görsel",
  "Uploading…": "Yükleniyor…",
  "Usage": "Kullanım",
  "Usage Type": "Kullanım türü",
  "Use a coupon code": "Kupon kodu kullan",
  "Use a JPG or PNG picture.": "JPG veya PNG bir görsel kullanın.",
  "Use an https:// address or a page of the website starting with /.": "https:// ile başlayan bir adres ya da web sitesinin / ile başlayan bir sayfasını kullanın.",
  "Use in": "Şurada kullan:",
  "Use invoice price": "Fatura fiyatını kullan",
  "Use it": "Bunu kullan",
  "Use the invoice price?": "Fatura fiyatı kullanılsın mı?",
  "Use Type": "Kullanım türü",
  "Use {0} {1}": "Kullan: {0} {1}",
  "Use {0}: {1}": "Payı kullan ({0}): {1}",
  "Used": "Kullanıldı",
  "USED": "KULLANILAN",
  "USED BY THEN": "O ZAMANA KADAR KULLANILAN",
  "Used to order, has gone quiet.": "Eskiden sipariş verirdi, sessizleşti.",
  "user": "kullanıcı",
  "User #{0}": "Kullanıcı #{0}",
  "User has been deleted successfully!": "Kullanıcı silindi!",
  "User has been saved successfully.": "Kullanıcı kaydedildi.",
  "User status updated successfully.": "Kullanıcı durumu güncellendi.",
  "User Type": "Kullanıcı türü",
  "Users": "Kullanıcılar",
  "Users could not be loaded.": "Kullanıcılar yüklenemedi.",
  "Uses": "Kullanım",
  "Usually 1. 0 = no cap.": "Genellikle 1. 0 = sınır yok.",
  "UTM Links": "UTM bağlantıları",
  "UTM Links Error": "UTM bağlantıları hatası",
  "utm_campaign": "utm_campaign",
  "Validation": "Doğrulama",
  "Validation Error": "Doğrulama hatası",
  "VALUE": "DEĞER",
  "Vendor": "Tedarikçi",
  "VENDOR": "TEDARİKÇİ",
  "Vendor has been deleted successfully.": "Tedarikçi silindi.",
  "Vendor has been saved successfully.": "Tedarikçi kaydedildi.",
  "Vendor has been updated successfully.": "Tedarikçi güncellendi.",
  "Vendor is not added!": "Tedarikçi eklenmedi!",
  "Vendor is not as same as invoice vendor!": "Tedarikçi, faturadaki tedarikçiyle aynı değil!",
  "Vendor list cannot be duplicated!": "Tedarikçi listesinde tekrar olamaz!",
  "Vendor list cannot be empty!": "Tedarikçi listesi boş olamaz!",
  "Vendor Name": "Tedarikçi adı",
  "Vendor name cannot be empty!": "Tedarikçi adı boş olamaz!",
  "Vendors": "Tedarikçiler",
  "Version {0}, finished by {1} {2}.": "Sürüm {0}, {1} tarafından tamamlandı ({2}).",
  "View": "Görüntüle",
  "View only": "Yalnızca görüntüleme",
  "VIP": "VIP",
  "Vision AI": "Vision AI",
  "Visitors, orders and where they came from, plus which deals and coupons were used": "Ziyaretçiler, siparişler ve nereden geldikleri; ayrıca hangi kampanya ve kuponların kullanıldığı",
  "VISITS": "ZİYARET",
  "Visits that became orders": "Siparişe dönüşen ziyaretler",
  "Visualize delivery locations, distance zones & peak delivery hours": "Teslimat konumlarını, mesafe bölgelerini & yoğun teslimat saatlerini görselleştirin",
  "Voice AI": "Voice AI",
  "Voice could not start just now.": "Sesli konuşma şu anda başlatılamadı.",
  "Voice could not start.": "Sesli konuşma başlatılamadı.",
  "Voice is off": "Sesli konuşma kapalı",
  "Voice modes customers can choose": "Müşterilerin seçebileceği ses modları",
  "Voice orb": "Ses küresi",
  "Voice session limits": "Sesli oturum sınırları",
  "VS AVG": "ORTALAMAYA GÖRE",
  "VS BEFORE": "ÖNCEKİNE GÖRE",
  "vs prev: {0} · {1} orders": "önceki dönem: {0} · {1} sipariş",
  "VS TARGET": "HEDEFE GÖRE",
  "vs the day before": "önceki güne göre",
  "vs the week before": "önceki haftaya göre",
  "vs the {0} days before": "önceki {0} güne göre",
  "vs {0} prior": "önceki dönem: {0}",
  "Waiting": "Bekliyor",
  "waiting approval": "onay bekliyor",
  "Waiting change": "Bekleyen değişiklik",
  "Waiting for an administrator": "Yönetici onayı bekliyor",
  "waiting for approval": "onay bekliyor",
  "Waiting for approval": "Onay bekliyor",
  "Waiting for the person who asked.": "İsteyen kişi bekleniyor.",
  "waiting for the store to accept": "mağazanın kabul etmesini bekliyor",
  "Waiting — an administrator decides in Approvals (top bar ✓)": "Bekliyor — kararı bir yönetici Onaylar'da verir (üst çubuk ✓)",
  "Warning": "Uyarı",
  "Waste": "Atık",
  "WASTE": "ATIK",
  "Waste and deliveries over": "Atık ve teslimatlar:",
  "Waste belongs to one store. Choose which one from the selector at the top left.": "Atık tek bir mağazaya aittir. Sol üstteki seçiciden mağazayı seçin.",
  "Waste Error": "Atık hatası",
  "Waste is kept apart from sales on purpose. It still comes off the shelf, so it counts towards how much to order — you have to buy back what you throw away — but it is never counted as something a customer bought.": "Atık, satışlardan bilerek ayrı tutulur. Yine de raftan düşer, bu yüzden ne kadar sipariş verileceğine dahil edilir — attığınızı yeniden satın almanız gerekir — ama asla bir müşterinin satın aldığı bir şey olarak sayılmaz.",
  "Web": "Web",
  "WEB": "WEB",
  "WEB ORDER RATE": "WEB SİPARİŞ ORANI",
  "web orders": "web siparişleri",
  "WEB ORDERS": "WEB SİPARİŞLERİ",
  "web visits": "web ziyaretleri",
  "Web: OFF": "Web: KAPALI",
  "Web: ON": "Web: AÇIK",
  "Website": "Web sitesi",
  "Website & app traffic": "Web sitesi & uygulama trafiği",
  "Website & Mobile App": "Web sitesi & mobil uygulama",
  "Website Banner Image": "Web sitesi banner görseli",
  "Website blog": "Web sitesi blogu",
  "Website blog changes waiting": "Bekleyen web sitesi blog değişiklikleri",
  "Website, app, phone and the delivery platforms": "Web sitesi, uygulama, telefon ve teslimat platformları",
  "Wed": "Çar",
  "Wednesday": "Çarşamba",
  "Week": "Hafta",
  "week": "hafta",
  "Week of {0} — {1} data": "{0} haftası — {1} verileri",
  "WEEK ORDERS": "HAFTALIK SİPARİŞ",
  "Weekly": "Haftalık",
  "Weekly Orders": "Haftalık siparişler",
  "Weekly Report": "Haftalık rapor",
  "Weekly Report Error": "Haftalık rapor hatası",
  "Weekly Revenue": "Haftalık ciro",
  "Weekly streak rewards": "Haftalık seri ödülleri",
  "weeks": "hafta",
  "Weeks that start on Sunday or Monday: {0}": "Pazar veya pazartesi başlayan haftalar: {0}",
  "Weight varies per case": "Ağırlık koliden koliye değişir",
  "Weighted across 1 cohort ({0} customers)": "1 kohort üzerinden ağırlıklı ({0} müşteri)",
  "Weighted across {0} cohorts ({1} customers)": "{0} kohort üzerinden ağırlıklı ({1} müşteri)",
  "weighted by cohort size": "kohort büyüklüğüne göre ağırlıklı",
  "Welcome back{0}. {1} of {2} answers were already in for {3}, {4}. Let’s carry on.": "Tekrar hoş geldiniz{0}. {3}, {4} için {1}/{2} yanıt zaten girilmişti. Devam edelim.",
  "Went on to order": "Sonra sipariş verenler",
  "what": "ne",
  "What a typical order is worth, over time": "Tipik bir siparişin zaman içindeki değeri",
  "What changes": "Değişenler",
  "What Connect can do": "Connect neler yapabilir",
  "What coupons and deals gave away, and what came back": "Kupon ve kampanyaların ne verdiği, karşılığında ne geldiği",
  "What customers asked the app's AI host, and its answers": "Müşterilerin uygulamadaki AI asistanına sordukları ve aldıkları cevaplar",
  "What customers asked the app's AI host, and what it answered. Use it to help a customer who had trouble, or to see where the AI falls short.": "Müşterilerin uygulamadaki AI asistanına sordukları ve asistanın verdiği cevaplar. Sorun yaşayan bir müşteriye yardım etmek ya da AI asistanının nerede yetersiz kaldığını görmek için kullanın.",
  "What customers see": "Müşterilerin gördüğü",
  "What do you want to do?": "Ne yapmak istiyorsunuz?",
  "What each store owes in royalty and marketing fees, month by month": "Her mağazanın ay ay ödeyeceği royalti ve pazarlama ücretleri",
  "What each tier needs": "Her seviye için gerekenler",
  "What each tier needs, the weekly streak rewards and the reward for inviting a friend": "Her seviye için gerekenler, haftalık seri ödülleri ve arkadaş davet etme ödülü",
  "what every store shares": "tüm mağazalarda ortak olanlar",
  "What is in the combo, and what does it cost?": "Komboda neler var, fiyatı ne?",
  "What is in the kitchen right now, store by store, with recovery actions for stuck orders": "Şu an mutfakta olanlar, mağaza mağaza; takılı kalan siparişler için kurtarma işlemleriyle",
  "What is in the kitchen right now, store by store.": "Şu an mutfakta olanlar, mağaza mağaza.",
  "What is not in the basis": "Matraha dahil olmayanlar",
  "What is off at this store, or mark a product sold out": "Bu mağazada kapalı olanlar ya da bir ürünü tükendi olarak işaretle",
  "What is the passphrase?": "Parola nedir?",
  "What is waiting for me": "Beni bekleyenler",
  "what it is counted in": "hangi birimle sayıldığı",
  "What kind": "Ne tür",
  "What kind of deal is this?": "Bu ne tür bir kampanya?",
  "What must they buy, and what is added?": "Ne satın almaları gerekiyor, karşılığında ne ekleniyor?",
  "What sold": "Satılanlar",
  "WHAT SOLD, AND WHEN": "NE SATILDI, NE ZAMAN",
  "What the app says": "Uygulamada görünen metin",
  "What the coupons and deals gave away, and what came back": "Kupon ve kampanyaların ne verdiği, karşılığında ne geldiği",
  "What the offers cost": "Tekliflerin maliyeti",
  "What the photos are": "Fotoğrafların türü",
  "What they cost ›": "Maliyetleri ›",
  "WHAT THIS PAGE CAN AND CANNOT SEE": "BU SAYFANIN GÖREBİLDİKLERİ VE GÖREMEDİKLERİ",
  "What this page can see": "Bu sayfanın görebildikleri",
  "What this role is for, in one line": "Bu rolün ne işe yaradığı, tek satırda",
  "What will customers see?": "Müşteriler ne görecek?",
  "What you actually used": "Gerçekte kullandığınız",
  "When each store opens for delivery and pickup": "Her mağazanın teslimat ve gel-al için açık olduğu saatler",
  "When each store opens for delivery and pickup.": "Her mağazanın teslimat ve gel-al için açık olduğu saatler.",
  "When each store takes most of its orders": "Her mağazanın en çok sipariş aldığı zamanlar",
  "When people last talked to the AI": "Kişilerin AI asistanıyla en son ne zaman konuştuğu",
  "When someone clicks it": "Biri tıkladığında",
  "When someone clicks the card": "Biri karta tıkladığında",
  "When tapped": "Dokunulduğunda",
  "When tapped in the apps": "Uygulamalarda dokunulduğunda",
  "When the customer buys": "Müşteri satın aldığında:",
  "When the order is at least $": "Sipariş tutarı en az $",
  "When the orders actually land — every hour of the week, side by side": "Siparişlerin gerçekte geldiği zamanlar — haftanın her saati, yan yana",
  "where": "nerede yapabileceğini",
  "Where & when": "Nerede & ne zaman",
  "Where and when does it run?": "Nerede ve ne zaman geçerli?",
  "Where deliveries went": "Teslimatlar nereye gitti",
  "Where orders came from": "Siparişler nereden geldi",
  "Where the app's customers stand: their tier, points and weekly streak. Find someone to see their points or give some back.": "Uygulama müşterilerinin durumu: seviyeleri, puanları ve haftalık serileri. Puanlarını görmek ya da puan iade etmek için birini bulun.",
  "Where the live ones work": "Aktif olanların geçerli olduğu yerler",
  "Where they signed up": "Nereden kaydoldular",
  "Which hours of which days are busy": "Hangi günlerin hangi saatleri yoğun",
  "Which items are discounted, and by how much?": "Hangi ürünler indirimli, ne kadar?",
  "Which items count?": "Hangi ürünler geçerli?",
  "Which items sold, and how much each brought in": "Hangi ürünlerin satıldığı ve her birinin ne kadar getirdiği",
  "Which menu each store shows, and when": "Her mağazanın hangi menüyü ne zaman gösterdiği",
  "Which menu each store shows, and when.": "Her mağazanın hangi menüyü ne zaman gösterdiği.",
  "Which model answers you (/model)": "Size hangi modelin cevap verdiği (/model)",
  "Which model answers you here. Only your own conversation changes.": "Burada size cevap veren model. Yalnızca kendi konuşmanız değişir.",
  "Which model answers you: Gemini or DeepSeek": "Size hangi modelin cevap verdiği: Gemini veya DeepSeek",
  "Which question it is for": "Hangi soru için",
  "Which reports": "Hangi raporlar",
  "Which role?": "Hangi rol?",
  "Which store the panel is looking at": "Panelin baktığı mağaza",
  "Who can sign in to the till in each store": "Her mağazada kasaya kimlerin giriş yapabileceği",
  "Who can sign in to the till in each store.": "Her mağazada kasaya kimlerin giriş yapabileceği.",
  "Who can sign in to this panel, and which role each one holds": "Bu panele kimlerin giriş yapabileceği ve her birinin rolü",
  "Who has stopped ordering, how much spend went quiet with them, and who you can still reach": "Kimlerin sipariş vermeyi bıraktığı, onlarla birlikte ne kadar harcamanın kesildiği ve hâlâ kimlere ulaşabileceğiniz",
  "Who sees a deal": "Kampanyayı kimler görür",
  "Who signs up, who comes back, who has gone quiet": "Kim kayıt oluyor, kim geri geliyor, kim sessizleşti",
  "Why do you need it? One sentence is enough.": "Neden ihtiyacınız var? Tek cümle yeterli.",
  "Why sales moved": "Satışlar neden değişti",
  "WHY THIS IS NOT 45%": "BU NEDEN %45 DEĞİL",
  "Why? Optional — saved to the audit log.": "Neden? İsteğe bağlı — denetim kaydına yazılır.",
  "Why? Required — this is saved to the audit log.": "Neden? Zorunlu — bu, denetim kaydına yazılır.",
  "Why? Saved to the audit log.": "Neden? Denetim kaydına yazılır.",
  "Wide, like a banner": "Geniş, banner gibi",
  "will be added to stock at": "şu mağazanın stoğuna eklenecek:",
  "Win-back list": "Geri kazanma listesi",
  "With Coupon Code": "Kupon kodlu",
  "With or without photo": "Fotoğraflı veya fotoğrafsız",
  "With this many deals the store list does not fit in the link: the app opens it at the customer's own store.": "Bu kadar çok kampanyayla mağaza listesi bağlantıya sığmıyor: uygulama bunu müşterinin kendi mağazasında açar.",
  "Withdraw": "Geri çek",
  "Withdraw it": "Bunu geri çek",
  "Withdrawn": "Geri çekildi",
  "Work out what is owed": "Ödenecek tutarı hesapla",
  "Working": "İşleniyor",
  "WORKING HOURS": "ÇALIŞMA SAATLERİ",
  "Working Hours": "Çalışma saatleri",
  "Working on it…": "İşlem yapılıyor…",
  "Worth": "Getiri",
  "worth {0}": "toplam {0} değerinde",
  "Write": "Yaz",
  "Write a message… Enter to send": "Bir mesaj yazın… Enter ile gönderin",
  "Write down what is actually on the shelf. Leave anything you do not count empty — it will be left alone rather than recorded as zero.": "Rafta gerçekte ne varsa onu yazın. Saymadığınız her şeyi boş bırakın — sıfır olarak kaydedilmez, olduğu gibi bırakılır.",
  "Write off": "Atık olarak kaydet",
  "Write the first one with": "İlkini yazmak için şunu kullanın:",
  "Write the story here, or below the pictures.": "Hikayeyi buraya ya da görsellerin altına yazın.",
  "Write this off?": "Atık olarak kaydedilsin mi?",
  "XLSX": "XLSX",
  "YEAR ON YEAR": "GEÇEN YILA GÖRE",
  "Year on year compares against the same weekdays 52 weeks back, not the same calendar dates. A store with no orders is ranked — rather than last, so a closed till never looks like a failing one.": "Geçen yılla karşılaştırma, aynı takvim tarihlerine göre değil, 52 hafta önceki aynı hafta günlerine göre yapılır. Siparişi olmayan bir mağazanın sırası sonuncu yerine — olarak gösterilir; böylece kapalı bir kasa hiçbir zaman kötü giden bir kasa gibi görünmez.",
  "Yes": "Evet",
  "YES": "EVET",
  "Yes, it’s right": "Evet, doğru",
  "Yes, Send": "Evet, gönder",
  "Yesterday": "Dün",
  "yet. Use the search below to add pizzas here.": "— buraya pizza eklemek için aşağıdaki aramayı kullanın.",
  "You": "Siz",
  "You can look at these rules; changing them needs the": "Bu kuralları görüntüleyebilirsiniz; değiştirmek için",
  "You can look at these settings; changing them needs the": "Bu ayarları görüntüleyebilirsiniz; değiştirmek için",
  "You have not asked for anything. Use": "Henüz hiçbir şey istemediniz. Bunun için",
  "You pick from {0}'s menu; the same item is matched at the other stores automatically.": "Ürünleri {0} menüsünden seçersiniz; aynı ürün diğer mağazalarda otomatik olarak eşleştirilir.",
  "Your access requests": "Erişim talepleriniz",
  "Your account covers {0} of the stores": "Hesabınız {0} mağazayı kapsıyor",
  "Your change is waiting": "Değişikliğiniz bekliyor",
  "Your change is waiting for approval": "Değişikliğiniz onay bekliyor",
  "Your changes go on the website as soon as you save them; anyone else's wait for an administrator in Approvals.": "Değişiklikleriniz kaydettiğiniz anda web sitesinde yayımlanır; başkalarının değişiklikleri ise Onaylar'da bir yöneticiyi bekler.",
  "Your changes wait for an administrator's approval before they go on the website.": "Değişiklikleriniz web sitesinde yayımlanmadan önce bir yöneticinin onayını bekler.",
  "Your chat key was made on another browser and has no passphrase backup, so the only way here is a new key.": "Sohbet anahtarınız başka bir tarayıcıda oluşturuldu ve parola yedeği yok; bu yüzden burada tek yol yeni bir anahtar.",
  "Your chat key was made on another browser. Enter the passphrase you chose there to use it here.": "Sohbet anahtarınız başka bir tarayıcıda oluşturuldu. Burada kullanmak için orada seçtiğiniz parolayı girin.",
  "Your notifications": "Bildirimleriniz",
  "Your old backup stops working. Messages people sent before now open again once one of them has the panel open (it re-shares the channel keys with your new key).": "Eski yedeğiniz artık çalışmaz. Daha önce gönderilen mesajlar, gönderenlerden biri paneli açtığında yeniden açılır (panel, kanal anahtarlarını yeni anahtarınızla yeniden paylaşır).",
  "Your report": "Raporunuz",
  "Your role can arrange this list but not publish it.": "Rolünüz bu listeyi düzenleyebilir ama yayımlayamaz.",
  "Your role can look at orders but not change them.": "Rolünüz siparişleri görebilir ama değiştiremez.",
  "Your role can see this report but not fill it in.": "Rolünüz bu raporu görebilir ama dolduramaz.",
  "Your role cannot open that page (needs '{0}').": "Rolünüz bu sayfayı açamaz (gereken yetki: '{0}').",
  "Your stores and where they rank — heat-colored by performance": "Mağazalarınız ve sıralamaları — performansa göre renklendirilmiş",
  "Your website blog changes": "Web sitesi blog değişiklikleriniz",
  "Your whole conversation with Connect is removed for you. This cannot be undone.": "Connect ile olan tüm konuşmanız sizin için silinir. Bu işlem geri alınamaz.",
  "YoY": "Yıllık",
  "YYYY-MM-DD": "YYYY-AA-GG",
  "zone": "teslimat bölgesi",
  "{0} (Current)": "{0} (Mevcut)",
  "{0} (off)": "{0} (kapalı)",
  "{0} +{1} more": "{0} +{1} daha",
  "{0} - (Bag)": "{0} - (Poşet)",
  "{0} - (Group)": "{0} - (Grup)",
  "{0} - (Hidden)": "{0} - (Gizli)",
  "{0} - (Template)": "{0} - (Şablon)",
  "{0} - Brand": "{0} - Marka",
  "{0} - Store": "{0} - Mağaza",
  "{0} / BRAND": "{0} / MARKA",
  "{0} / case": "{0} / koli",
  "{0} / STORE": "{0} / MAĞAZA",
  "{0} a person on average": "Kişi başına ortalama {0}",
  "{0} and {1}": "{0} ve {1}",
  "{0} applied": "{0} uygulandı",
  "{0} asks Connect to": "{0}, Connect’ten şunu istiyor:",
  "{0} asks for": "{0} şu rolü istiyor:",
  "{0} asks through Connect to": "{0}, Connect üzerinden şunu istiyor:",
  "{0} asks to": "{0} şunu istiyor:",
  "{0} banners": "{0} banner",
  "{0} by {1} {2}": "{0} ({1} tarafından, {2})",
  "{0} came off today's tickets in discounts of every kind.": "Bugünkü fişlerden her türden indirim olarak {0} düşüldü.",
  "{0} categories": "{0} kategori",
  "{0} change": "{0} değişikliği",
  "{0} changes": "{0} değişiklik",
  "{0} changes waiting": "{0} değişiklik bekliyor",
  "{0} codes": "{0} kod",
  "{0} cohort · month {1}": "{0} kohortu · ay {1}",
  "{0} could not be loaded, so the totals leave it out.": "{0} mağazası yüklenemedi, bu yüzden toplamlara dahil edilmedi.",
  "{0} could not be loaded, so the totals leave them out.": "{0} mağazaları yüklenemedi, bu yüzden toplamlara dahil edilmedi.",
  "{0} coupons · {1} deals": "kupon {0} · kampanya {1}",
  "{0} days": "{0} gün",
  "{0} days ago": "{0} gün önce",
  "{0} days up to today": "Bugüne kadarki {0} gün",
  "{0} days up to yesterday": "Düne kadarki {0} gün",
  "{0} did not answer at {1}, so Gemini answered instead: {2}": "{0} yanıt vermedi ({1}); bu yüzden onun yerine Gemini yanıt verdi: {2}",
  "{0} done, {1} being made, {2} new": "{0} tamamlandı, {1} hazırlanıyor, {2} yeni",
  "{0} failed": "{0} başarısız",
  "{0} from anything": "tüm menüden {0}",
  "{0} from {1}": "{1} arasından {0}",
  "{0} gets your note in a direct message.": "Notunuz {0} adlı kişiye doğrudan mesajla iletilir.",
  "{0} gets your note in their chat with Connect.": "Notunuz {0} adlı kişiye, Connect ile olan sohbetinde iletilir.",
  "{0} given away": "{0} indirim olarak verildi",
  "{0} given away in coupons and deals": "{0} kupon ve kampanya indirimi",
  "{0} has no figures in the sales reports.": "Satış raporlarında {0} mağazasına ait rakam yok.",
  "{0} have no figures in the sales reports.": "Satış raporlarında {0} mağazalarına ait rakam yok.",
  "{0} have ordered at least once": "{0} en az bir kez sipariş verdi",
  "{0} hours ago": "{0} saat önce",
  "{0} in the prior period": "önceki dönemde {0}",
  "{0} in {1}": "{1}: {0}",
  "{0} in {1}: {2}": "{1} için {0}: {2}",
  "{0} item(s)": "{0} ürün",
  "{0} items": "{0} ürün",
  "{0} items counted at {1}.": "{0} kalem sayıldı ({1}).",
  "{0} items have been counted once. Usage needs two counts to exist at all, so they will appear here after the next count.": "{0} kalem yalnızca bir kez sayıldı. Kullanım ancak iki sayımla hesaplanabildiği için bu kalemler bir sonraki sayımdan sonra burada görünecek.",
  "{0} items have no usage figure yet. Usage needs two counts at least {1} days apart — a same-day recount is a correction, not a week of consumption, so it is left out rather than counted as an enormous week.": "{0} kalemin henüz kullanım rakamı yok. Kullanım için iki sayım arasında en az {1} gün olmalı — aynı gün yapılan yeniden sayım bir düzeltmedir, bir haftalık tüketim değildir; bu yüzden çok büyük bir hafta olarak sayılmak yerine dışarıda bırakılır.",
  "{0} items on invoice": "{0} kalem, fatura no",
  "{0} items show more stock than could possibly be there. That is not a rounding error — either a count was mistyped, or a delivery arrived and was never recorded. Worth resolving before trusting the rest.": "{0} kalem, mümkün olabilecekten fazla stok gösteriyor. Bu bir yuvarlama hatası değil — ya bir sayım yanlış girildi ya da gelen bir teslimat hiç kaydedilmedi. Geri kalan rakamlara güvenmeden önce bunu çözmekte fayda var.",
  "{0} items sold — {1} data": "{0} ürün satıldı — {1} verileri",
  "{0} items will be recorded at": "{0} kalemin kaydedileceği mağaza",
  "{0} lines could not be saved": "{0} satır kaydedilemedi",
  "{0} lines were not recorded": "{0} satır kaydedilmedi",
  "{0} locations": "{0} mağaza",
  "{0} marketplace orders": "{0} pazaryeri siparişi",
  "{0} member": "{0} üye",
  "{0} min ago": "{0} dk önce",
  "{0} months": "{0} ay",
  "{0} More options (usually not needed)": "{0} Diğer seçenekler (genelde gerekmez)",
  "{0} not changed, edited since": "{0} değiştirilmedi, sonradan düzenlenmiş",
  "{0} notifications": "{0} bildirim",
  "{0} of all signups": "tüm kayıtlar içinde {0}",
  "{0} of registered": "kayıtlı müşteriler içinde {0}",
  "{0} of stock": "{0} değerinde stok",
  "{0} of them by e-mail, the rest by phone only": "{0} kişiye e-postayla, kalanına yalnızca telefonla ulaşılabilir",
  "{0} of {1}": "{0}/{1}",
  "{0} of {1} answered": "{0}/{1} yanıtlandı",
  "{0} of {1} customers ordered ({2})": "{1} müşteriden {0} kişi sipariş verdi ({2})",
  "{0} of {1} on": "{0}/{1} açık",
  "{0} of {1} online": "{0}/{1} çevrimiçi",
  "{0} of {1} permissions selected": "{0}/{1} yetki seçildi",
  "{0} of {1} stores": "{0}/{1} mağaza",
  "{0} off": "{0} indirim",
  "{0} off every order.": "Her siparişte {0} indirim.",
  "{0} off orders of {1} or more.": "{1} ve üzeri siparişlerde {0} indirim.",
  "{0} on an offer": "{0} teklifli",
  "{0} orders": "{0} sipariş",
  "{0} orders on points": "puanla verilen {0} sipariş",
  "{0} orders today": "bugün {0} sipariş",
  "{0} orders · avg {1}": "{0} sipariş · ort. {1}",
  "{0} orders · complete day": "{0} sipariş · tam gün",
  "{0} orders · {1} average": "{0} sipariş · ortalama {1}",
  "{0} orders · {1} coupon, {2} deal": "{0} sipariş · {1} kupon, {2} kampanya",
  "{0} orders · {1}%": "{0} sipariş · %{1}",
  "{0} over": "{0} fazla",
  "{0} per customer": "Müşteri başına {0}",
  "{0} photos: are they": "{0} fotoğraf: bunlar",
  "{0} POS orders": "{0} POS siparişi",
  "{0} pts": "{0} puan",
  "{0} qualifying products": "{0} geçerli ürün",
  "{0} reward products": "{0} ödül ürünü",
  "{0} seconds": "{0} saniye",
  "{0} seen against {1} placed": "{0} görüldü / {1} verildi",
  "{0} segments": "{0} segment",
  "{0} separate {1}s": "{0} ayrı belge",
  "{0} short": "{0} eksik",
  "{0} shown": "{0} gösteriliyor",
  "{0} sold": "{0} adet satıldı",
  "{0} specific products": "{0} belirli ürün",
  "{0} stores": "{0} mağaza",
  "{0} tiers": "{0} seviye",
  "{0} to do": "{0} yapılacak",
  "{0} unsaved": "Kaydedilmemiş: {0}",
  "{0} uses": "{0} kullanım",
  "{0} vs last week": "{0} geçen haftaya göre",
  "{0} vs yesterday": "{0} düne göre",
  "{0} waiting for you": "Sizi bekleyen: {0}",
  "{0} wants to add “{1}”": "{0}, “{1}” yazısını eklemek istiyor",
  "{0} wants to change “{1}”": "{0}, “{1}” yazısını değiştirmek istiyor",
  "{0} wants to delete “{1}”": "{0}, “{1}” yazısını silmek istiyor",
  "{0} web orders from {1} visits": "{1} ziyaretten {0} web siparişi",
  "{0} weeks": "{0} hafta",
  "{0} works one store at a time. Choose the store to open it for.": "{0} aynı anda tek bir mağaza için çalışır. Hangi mağaza için açılacağını seçin.",
  "{0} {1} on hand": "Mevcut: {0} {1}",
  "{0} {1} Share is a share of the mix, not of net sales.": "{0} {1} Pay, net satışın değil, bu dağılımın payıdır.",
  "{0} {1} talked to it in the last 7 days": "Son 7 günde {0} kişi onunla konuştu",
  "{0} {1} used or put aside": "{0}: kullanılan ya da kenara ayrılan {1} belge",
  "{0} {1} will come off stock at": "{0} kalemin stoktan düşüleceği mağaza",
  "{0} {1} written off on {2}": "{2} tarihinde {0} kalem stoktan düşüldü",
  "{0} {1} — OPEN": "{0} {1} — AÇIK",
  "{0} {1}% vs last month": "{0} %{1} geçen aya göre",
  "{0} {1}% vs prior week": "{0} %{1} önceki haftaya göre",
  "{0} · already sent": "{0} · zaten gönderildi",
  "{0} · kept until {1}": "{0} · {1} tarihine kadar saklanır",
  "{0} · loading": "{0} · yükleniyor",
  "{0} · no longer kept": "{0} · artık saklanmıyor",
  "{0} · {1} of {2} answered": "{0} · {1}/{2} yanıtlandı",
  "{0} · {1}% rev": "{0} · %{1} ciro",
  "{0} — Channel Details": "{0} — Kanal ayrıntıları",
  "{0} — home": "{0} — ana sayfa",
  "{0} — not in the rate": "{0} — orana dahil değil",
  "{0} — {1} live data": "{0} — {1} canlı verileri",
  "{0} — {1} orders, {2}": "{0} — {1} sipariş, {2}",
  "{0}% of all orders, never measurable here": "tüm siparişler içindeki payı %{0}; burada hiçbir zaman ölçülemez",
  "{0}% of basis": "matrah üzerinden %{0}",
  "{0}% of revenue": "ciro payı %{0}",
  "{0}% off": "%{0} indirim",
  "{0}% off {1} once {2} are in the cart, on up to {3} item(s).": "Şu ürünlerde %{0} indirim, sepette {2} adet olduğunda ve en fazla {3} üründe: {1}.",
  "{0}% off {1} once {2} are in the cart.": "Şu ürünlerde %{0} indirim, sepette {2} adet olduğunda: {1}.",
  "{0}% off {1}, on up to {2} item(s).": "Şu ürünlerde %{0} indirim, en fazla {2} üründe: {1}.",
  "{0}% off {1}.": "Şu ürünlerde %{0} indirim: {1}.",
  "{0}% peak": "zirve %{0}",
  "{0}% vs {1}": "{1} ile kıyasla {0}%",
  "{0}+ orders a year": "yılda {0}+ sipariş",
  "{0}+ points": "{0}+ puan",
  "{0}, today": "{0}, bugün",
  "{0}/250 characters": "{0}/250 karakter",
  "{0}/blogs/": "{0}/blogs/",
  "{0}/blogs/{1}": "{0}/blogs/{1}",
  "{0}/events/blogs": "{0}/events/blogs",
  "{0}: formatting": "{0}: biçimlendirme",
  "{0}: time": "{0}: saat",
  "{0}: {1} orders ({2}%)": "{0}: {1} sipariş (%{2})",
  "{0}: {1} — {2} orders": "{0}: {1} — {2} sipariş",
  "{0}: {1}, {2}. Change": "{0}: {1}, {2}. Değiştir",
  "{0}: {1}. Change": "{0}: {1}. Değiştir",
  "{0}h": "{0}",
  "{0}w": "{0} hafta",
  "{0}W{1}": "{0}H{1}",
  "{0}–close": "{0}–kapanış",
  "{0}’s report for {1} is finished.": "{0} için {1} raporu tamamlandı.",
  "· by {0}": "· oluşturan: {0}",
  "· changed {0}": "· son değişiklik: {0}",
  "· coupon {0}": "· kupon {0}",
  "· its address is taken now": "· adresi artık kullanımda",
  "· not in use": "· kullanımda değil",
  "· reads the panel for you; write @connect in any channel to call it there": "· paneli sizin için okur; herhangi bir kanalda çağırmak için @connect yazın",
  "· {0} by {1}": "· {0} ({1} tarafından)",
  "· {0} in / {1} out": "· {0} girdi / {1} çıktı",
  "· {0} of discounts already taken off": "· {0} indirim zaten düşülmüş",
  "· {0} stores": "· {0} mağaza",
  "· −{0} deal": "· −{0} kampanya indirimi",
  "· 🔒 end-to-end encrypted": "· 🔒 uçtan uca şifreli",
  "— goes out to customers at its scheduled time.": "— planlanan saatte müşterilere gönderilir.",
  "— its order tables are not in this database.": "— sipariş tabloları bu veritabanında değil.",
  "— nothing scheduled here": "— burada planlanmış bir şey yok",
  "— the app cannot open this link": "— uygulama bu bağlantıyı açamaz",
  "— {0} items": "— {0} kalem",
  "“Buy” must be at least 2 for a buy-some-get-one deal": "“Birkaç al, bir tane kazan” kampanyasında alınacak adet en az 2 olmalı",
  "“Never ordered” is its own segment here, not a lifecycle stage — those accounts registered and stopped, so churn and days-since have nothing to measure yet.": "“Hiç sipariş vermemiş” burada bir yaşam döngüsü aşaması değil, kendi başına bir segmenttir — bu hesaplar kaydolup orada kaldı, bu yüzden kayıp riski ve son siparişten beri geçen gün için henüz ölçülecek bir şey yok.",
  "“Rate” is conversions divided by impressions. An arm with very few impressions can show a misleadingly high rate — the engine allows for that, a glance at this table does not.": "“Oran”, dönüşümlerin gösterimlere bölünmesidir. Çok az gösterimi olan bir varyant yanıltıcı derecede yüksek bir oran gösterebilir — motor bunu hesaba katar, ama tabloya şöyle bir göz atmak bunu hesaba katmaz.",
  "“{0}” disappears from everyone’s list. Its messages stay in the database for the record.": "“{0}” grubu herkesin listesinden kalkar. Mesajları kayıt için veritabanında kalır.",
  "“{0}” is removed for good.": "“{0}” dosyası kalıcı olarak silinir.",
  "• List": "• Liste",
  "…and gets": "…ve alır:",
  "…or only these exact items": "…ya da yalnızca şu ürünler",
  "…or paste a link": "…ya da bağlantı yapıştır",
  "…this is added at": "…şu ürün eklenir,",
  "‹ Prev": "‹ Önceki",
  "← Previous": "← Önceki",
  "↻ Refresh": "↻ Yenile",
  "↻ Reload": "↻ Yenile",
  "− Discounts": "− İndirimler",
  "− Total Tips": "− Toplam bahşiş",
  "⌘K": "⌘K",
  "♥ {0} likes · 🛒 {1} orders": "♥ {0} beğeni · 🛒 {1} sipariş",
  "⚠ Force-closed from the panel": "⚠ Panelden zorla kapatıldı",
  "✓ Approve": "✓ Onayla",
  "🔒 Encrypted end to end · your key {0}": "🔒 Uçtan uca şifreli · anahtarınız: {0}",
  "🔒 Finish the encryption setup above to write here.": "🔒 Buraya yazmak için yukarıdaki şifreleme kurulumunu tamamlayın.",
  // Inventory (the 11-04 go): the package's template words, translated by the panel TR/EN session on 11-03.
  "— No ball —": "— Top yok —",
  "— Restored from the saved count — submit or discard them.": "— Kayıtlı sayımdan getirildi — gönderin ya da bunlardan vazgeçin.",
  "— Saved locally — will retry automatically when the network recovers. Last attempt {0}.": "— Bu cihaza kaydedildi — bağlantı geri gelince otomatik olarak yeniden denenecek. Son deneme: {0}.",
  "— Select prep recipe —": "— Ara ürün tarifi seçin —",
  "— Select stock —": "— Stok seçin —",
  "— Select unit —": "— Birim seçin —",
  "— Select vendor —": "— Tedarikçi seçin —",
  ", so they grow as the last lines come in": ", bu yüzden son satırlar girildikçe artar",
  ": check the recipe": ": tarifi kontrol edin",
  ". Type the measured qty next to each ingredient, then submit.": ". Her kalemin yanına ölçtüğünüz miktarı yazın, sonra gönderin.",
  "… and {0} more": "… ve {0} tane daha",
  "· {0} total ·": "· toplam {0} ·",
  "· 48h cold ferment cycle · FIFO · {0}": "· 48 saatlik soğuk fermantasyon döngüsü · FIFO · {0}",
  "· base unit: {0}": "· temel birim: {0}",
  "· est. {0}": "· tahmini {0}",
  "· in {0} recipe(s)": "· {0} tarifte",
  "· ordered {0}": "· sipariş: {0}",
  "· Set target to portion sum ({0} kg)": "· Hedefi porsiyon toplamına eşitle ({0} kg)",
  "· sold {0}": "· satış: {0}",
  "· use the sum of ingredients ({0} kg)": "· malzemelerin toplamını kullan ({0} kg)",
  "\"Every size\" fits all sizes; a size of its own replaces it there. One product can have its own amount of a topping.": "\"Her boy\" tüm boylara uyar; bir boya özel değer, o boyda onun yerine geçer. Bir ürünün bir malzeme için kendi miktarı olabilir.",
  "({0} balls · est. {1})": "({0} top · tahmini {1})",
  "({0} balls) of": "({0} top) /",
  "({0} of 7d sales)": "(7 günlük satışın {0} kadarı)",
  "({0}g)": "({0} g)",
  "(base)": "(temel birim)",
  "(Dynamic 14d Velocity Par)": "(14 günlük satış hızına göre dinamik par)",
  "(leave empty for now)": "(şimdiki saat için boş bırakın)",
  "(locked at log time)": "(kayıt anında sabitlenir)",
  "(no detail)": "(ayrıntı yok)",
  "(the first {0} are shown)": "(ilk {0} tanesi gösteriliyor)",
  "(unknown)": "(bilinmiyor)",
  "(vendor name missing)": "(tedarikçi adı yok)",
  "(vendor)": "(tedarikçi)",
  "), and the slices each is:": ") ve her birinin dilim sayısı:",
  "{0} — All stocks ({1})": "{0} — Tüm stoklar ({1})",
  "{0} · {1} · book: {2}": "{0} · {1} · kayıtta: {2}",
  "{0} · {1} g": "{0} · {1} g",
  "{0} · {1} in {2} days": "{0} · son {2} gün: {1}",
  "{0} · {1} menu": "{0} · menü fiyatı {1}",
  "{0} · {1} size(s)": "{0} · {1} boy",
  "{0} (std yield {1} {2} · {3}/{4})": "{0} (standart verim {1} {2} · {3}/{4})",
  "{0} {1} · est.": "{0} satır · tahmini",
  "{0} {1} · est. {2}": "{0} satır · tahmini {2}",
  "{0} {1} below reorder but missing purchasing data": "{0} stok yeniden sipariş noktasının altında ama satın alma bilgisi eksik",
  "{0} {1} no price and {2} not in this figure.": "{0} satırın fiyatı yok ve bu rakama dahil değil.",
  "{0} {1} no price: committed may be more.": "Açık siparişlerdeki {0} satırın fiyatı yok: sipariş tutarı daha fazla olabilir.",
  "{0} {1} no price: spent may be more.": "{0} teslimat satırının fiyatı yok: harcanan tutar daha fazla olabilir.",
  "{0} {1} not approved before, left out": "Daha önce onaylanmamış {0} kopya dışarıda bırakıldı",
  "{0} {1} still to come. When every box above is green, the month is shown here and the Excel file can be made.": "{0} yanıt daha bekleniyor. Yukarıdaki tüm kutular yeşil olduğunda ay burada gösterilir ve Excel dosyası oluşturulabilir.",
  "{0} {1} to receive": "Teslim alınacak {0} satır",
  "{0} {1} you": "{0} tanesi sizi bekliyor",
  "{0} / {1} critical/low": "{0} / {1} kritik/düşük",
  "{0} → {1} line(s) · {2} row {3}": "{0} → {1} satır · {2} sayfası, {3}. satır",
  "{0} active": "{0} aktif",
  "{0} active · {1} cancelled": "{0} aktif · {1} iptal edildi",
  "{0} as they are": "{0} olduğu gibi kalıyor",
  "{0} cancelled line(s)": "{0} iptal edilen satır",
  "{0} count{1} waiting to sync": "{0} sayım eşitlenmeyi bekliyor",
  "{0} counted": "{0} sayıldı",
  "{0} entries · {1} · {2}": "{0} kayıt · {1} · {2}",
  "{0} FIFO": "{0} FIFO",
  "{0} h": "{0} sa",
  "{0} in range": "Aralıkta {0} fatura",
  "{0} items shown": "{0} kalem gösteriliyor",
  "{0} K": "{0} K",
  "{0} kg": "{0} kg",
  "{0} kg · for {1} on {2}": "{0} kg · {2} için {1} adet",
  "{0} kg left over is kept as {1} stock.": "Artan {0} kg, {1} stoğu olarak kalır.",
  "{0} left when ready": "Hazır olunca {0} kalır",
  "{0} line(s) · {1}{2} value": "{0} satır · değer: {1}{2}",
  "{0} line(s) · est {1}": "{0} satır · tahmini {1}",
  "{0} logged": "{0} kayıt",
  "{0} new": "{0} yeni",
  "{0} new · {1} changed": "{0} yeni · {1} değişen",
  "{0} new · {1} changed · {2} removed": "{0} yeni · {1} değişen · {2} kaldırılan",
  "{0} not on this page": "{0} tanesi bu sayfada değil",
  "{0} of {1} counted": "{0}/{1} sayıldı",
  "{0} of {1} food ingredients": "{0}/{1} yiyecek kalemi",
  "{0} of {1} items · darker = heavier use": "{0}/{1} kalem · koyu = daha çok kullanım",
  "{0} of {1} mapped": "{0}/{1} eşleştirildi",
  "{0} ordered": "{0} sipariş edildi",
  "{0} page{1}": "{0} sayfa",
  "{0} people": "{0} kişi",
  "{0} POs": "PO'lar: {0}",
  "{0} ready": "{0} hazır",
  "{0} remaining": "{0} kaldı",
  "{0} row(s) will change · {1} skipped": "{0} satır değişecek · {1} atlandı",
  "{0} rows": "{0} satır",
  "{0} rules": "{0} kural",
  "{0} selected": "{0} seçildi",
  "{0} size(s)": "{0} boy",
  "{0} stocks": "{0} stok",
  "{0} typed, not sent": "{0} yazıldı, gönderilmedi",
  "{0} used · {1} to come": "{0} kullanıldı · {1} bekleniyor",
  "{0} vendor(s) · {1} line(s) · est. {2}": "{0} tedarikçi · {1} satır · tahmini {2}",
  "{0} with a complete recipe": "Tarifi tamamlanmış {0}",
  "{0} with purchase history": "Alım geçmişi olan {0} kalem",
  "{0}–{1} of {2}{3}": "{0}–{1} / {2}{3}",
  "{0}'s own recipe": "{0} mağazasının kendi tarifi",
  "{0}’s report for {1} is saved, and head office can see it.": "{0} için {1} raporu kaydedildi; merkez ofis artık görebilir.",
  "{0}{1} {2} outside sales": "Satış dışında {0}{1} {2}",
  "{0}/{1} ready": "{0}/{1} hazır",
  "{0}/ball": "{0}/top",
  "{0}% portioned": "%{0} porsiyonlandı",
  "{0}d": "{0} gün",
  "{0}g": "{0} g",
  "% of sales": "Satışa oranı (%)",
  "← Back to every product's amounts": "← Tüm ürünler için geçerli miktarlara dön",
  "+ {0} through Uber, DoorDash and Skip": "+ Uber, DoorDash ve Skip üzerinden {0}",
  "+ {0} with no price": "+ fiyatı olmayan {0} satır",
  "+ New invoice": "+ Yeni fatura",
  "+{0} for {1}d transit": "+{0}, {1} günlük teslim süresi için",
  "< 2 days cover": "< 2 günlük stok",
  "< 5 days": "< 5 gün",
  "¢/g": "¢/g",
  "1 year": "1 yıl",
  "1-Click Sysco Autopilot Draft": "Tek tıkla Sysco Autopilot taslağı",
  "1-Sentence Voice Waste Logger": "Tek cümleyle sesli atık kaydı",
  "1× Batch ({0} kg)": "1× parti ({0} kg)",
  "14-day usage": "14 günlük kullanım",
  "180 days": "180 gün",
  "2× Batch ({0} kg)": "2× parti ({0} kg)",
  "30 days": "30 gün",
  "48h cold-ferment cooler inventory and demand forecasts are store-specific. Pick a store in the top bar": "Soğutucudaki 48 saatlik soğuk fermantasyon stoğu ve talep tahminleri mağazaya özeldir. Üst çubuktan bir mağaza seçin",
  "48h ferment target": "48 saatlik fermantasyon hedefi",
  "7d Revenue": "7 günlük ciro",
  "90 days": "90 gün",
  "A $0 shelf ticket takes its pizza's ingredients off the stock and adds slices of one slice item. Slice products (Slice, 2 Slices …) use that item in their recipes, and the toppings on those products are already in the slice. Unsold slices go on the Waste page.": "$0'lık bir raf fişi, pizzasının malzemelerini stoktan düşer ve tek bir dilim kalemine dilim ekler. Dilim ürünleri (Slice, 2 Slices …) tariflerinde bu kalemi kullanır; bu ürünlerdeki malzemeler zaten dilimin içindedir. Satılmayan dilimler Atık sayfasına girilir.",
  "A ball is so many grams of the dough, made ahead and counted.": "Top, önceden hazırlanıp sayılan, belirli gramlık bir hamur parçasıdır.",
  "A line below for the same item replaces it for this product; 0 takes it away.": "Aşağıda aynı kalem için girilen satır, bu üründe onun yerine geçer; 0 onu kaldırır.",
  "A one-minute walk around Inventory": "Envanterde bir dakikalık tur",
  "A product can use its own amount of this topping (a meat lover's pizza with more pepperoni). It replaces the amounts above on that product only.": "Bir ürün, bu malzemenin kendine özel bir miktarını kullanabilir (daha çok pepperonili bir meat lover's pizza gibi). Bu miktar, yalnızca o üründe yukarıdaki miktarların yerine geçer.",
  "A raise over 30% is never made by itself.": "%30'un üstünde bir zam asla kendiliğinden yapılmaz.",
  "a share of {0}": "{0} pizzasından pay",
  "A slice uses its share of the pizza's food: the dough ball, sauce, cheese and toppings (not the box). \"Slice\" is one slice, \"2 Slices …\" two, \"8 Slices\" eight. A slice product's own recipe adds its extras, such as the pop of a Pop Combo.": "Bir dilim, pizzanın yiyeceğinden kendi payını kullanır: hamur topu, sos, peynir ve malzemeler (kutu hariç). \"Slice\" bir dilim, \"2 Slices …\" iki, \"8 Slices\" sekiz dilimdir. Bir dilim ürününün kendi tarifi, Pop Combo'daki içecek gibi eklerini de katar.",
  "Accepted columns: sku, name, unit_price, par_level, reorder_point, safety_stock. Rows are matched to this store's ingredients by SKU first, then by exact name. Unmatched rows are skipped — nothing is created or deleted.": "Kabul edilen sütunlar: sku, name, unit_price, par_level, reorder_point, safety_stock. Satırlar bu mağazanın kalemleriyle önce SKU'ya, sonra tam ada göre eşleştirilir. Eşleşmeyen satırlar atlanır — hiçbir şey oluşturulmaz ya da silinmez.",
  "Access & admin events": "Erişim ve yönetim işlemleri",
  "Account {0}": "Hesap {0}",
  "Account number": "Hesap numarası",
  "Ack": "Gördüm",
  "Acked": "Görüldü",
  "Action": "İşlem",
  "Active Dough Ball Batches (48h Cold Ferment · FIFO)": "Aktif hamur topu partileri (48 saat soğuk fermantasyon · FIFO)",
  "Actual": "Gerçek",
  "Add any details about this waste": "Bu atıkla ilgili ayrıntıları ekleyin",
  "Add ball size": "Top boyu ekle",
  "Add ingredient": "Kalem ekle",
  "Add line": "Satır ekle",
  "Add pack size": "Paket boyu ekle",
  "Add packaging item": "Ambalaj kalemi ekle",
  "Add packaging rule": "Ambalaj kuralı ekle",
  "ADD PACKAGING RULE": "AMBALAJ KURALI EKLE",
  "Add rule": "Kural ekle",
  "Add size rule": "Boy kuralı ekle",
  "ADD SIZE RULE": "BOY KURALI EKLE",
  "Add stock": "Stok ekle",
  "Add Stock": "Stok ekle",
  "Add Stock (ad-hoc receive)": "Stok ekle (evraksız teslim alma)",
  "Add vendor": "Tedarikçi ekle",
  "Add with this time": "Bu saatle ekle",
  "Adjust →": "Düzenle →",
  "Adjust the date range or click": "Tarih aralığını değiştirin ya da",
  "Administration": "Yönetim",
  "Affected recipes / pizza names": "Etkilenen tarifler / pizza adları",
  "Affected recipes counts distinct pizza products (the Pizzas group) whose recipes use the prep, directly or through a dough ball.": "Etkilenen tarifler, tarifinde bu ara ürünü doğrudan ya da bir hamur topu üzerinden kullanan farklı pizza ürünlerini (Pizzas grubu) sayar.",
  "After-Cart Balance": "Sipariş sonrası bakiye",
  "Ahead — counted; a sale takes the prep itself": "Önceden yapılır — sayılır; satış ara ürünün kendisini düşer",
  "Alerts": "Uyarılar",
  "all": "tümü",
  "All groups ({0})": "Tüm gruplar ({0})",
  "All ingredients": "Tüm kalemler",
  "All Inventory pages": "Tüm Envanter sayfaları",
  "All items in this count sheet are counted! Great job. Submit to save them.": "Bu sayım listesindeki tüm kalemler sayıldı! Harika iş. Kaydetmek için gönderin.",
  "All my stores": "Tüm mağazalarım",
  "All packaging rules": "Tüm ambalaj kuralları",
  "All POs": "Tüm PO'lar",
  "All recipe margins healthy": "Tüm tarif marjları sağlıklı",
  "All statuses": "Tüm durumlar",
  "All stocks": "Tüm stoklar",
  "All stocks moved recently": "Tüm stoklar yakın zamanda hareket etti",
  "All Stores shows products across your accessible stores. Pick a store at the top to see what it sells and to give it a recipe of its own.": "Tüm mağazalar, erişebildiğiniz mağazalardaki ürünleri gösterir. Bir mağazanın ne sattığını görmek ve ona özel bir tarif vermek için üstten o mağazayı seçin.",
  "All types": "Tüm türler",
  "Allowed spend ({0}%)": "İzin verilen harcama (%{0})",
  "Already spent + open POs": "Harcanan + açık siparişler",
  "Amounts are before GST and PST. Totals count only the lines that are in{0}. Food and paper cost = stock at the start + food, drinks and paper bought − stock at the end.": "Tutarlar GST ve PST hariçtir. Toplamlar yalnızca girilmiş satırları içerir{0}. Yemek ve kâğıt maliyeti = ay başındaki stok + alınan yiyecek, içecek ve kâğıt ürünleri − ay sonundaki stok.",
  "Amounts cover {0}% of what sold in {1} days": "Miktarlar, son {1} günde satılanların %{0} kadarını kapsıyor",
  "An item is suggested when it has a par level and is at or below its reorder point (below its par when it has none). Items without a par are never suggested.": "Bir kalem, par seviyesi varsa ve yeniden sipariş noktasında ya da altındaysa önerilir (yeniden sipariş noktası yoksa par seviyesinin altındaysa). Par seviyesi olmayan kalemler asla önerilmez.",
  "An order line's toppings take their amounts off the stock: a topping on one half uses half, an extra topping its extra amount.": "Bir sipariş satırındaki malzemeler kendi miktarlarını stoktan düşer: pizzanın yarısındaki bir malzeme miktarın yarısını, ekstra malzeme ise ekstra miktarını kullanır.",
  "and at most": "ve en fazla",
  "and in cases": "ve koli olarak",
  "Annual impact": "Yıllık etki",
  "Annualised drift": "Yıllık fiyat kayması",
  "answer is": "yanıt",
  "answers are": "yanıt",
  "Any status": "Tüm durumlar",
  "Apart: packaging {0} · cleaning {1}": "Ayrı tutulan: ambalaj {0} · temizlik {1}",
  "Apply the list": "Listeyi uygula",
  "Applying…": "Uygulanıyor…",
  "are": "-dir",
  "Ask Connect: questions, invoices, price lists": "Connect'e sorun: sorular, faturalar, fiyat listeleri",
  "at": "saat",
  "At": "Saat",
  "At most this share of today's price": "Bugünkü fiyatın en fazla şu kadarı",
  "AT RISK": "RİSKTE",
  "Attach a document for Connect to read: Excel, CSV, PDF or a photo of a page": "Connect'in okuması için bir belge ekleyin: Excel, CSV, PDF ya da bir sayfanın fotoğrafı",
  "Audit trail": "Denetim kaydı",
  "Audit Trail": "Denetim kaydı",
  "auto": "otomatik",
  "Auto-Fill": "Otomatik doldur",
  "Automated Verification": "Otomatik doğrulama",
  "Autopilot is on: an item without a par gets one from its own use — 7 days of use plus its safety stock (at least 2 packs), reordered when what is left covers only the vendor's lead time plus the safety stock (at least 1 pack; 3 days when no lead time is set). Pars and reorder points you set always win, and an item with no recorded use is not ordered.": "Autopilot açık: par seviyesi olmayan bir kaleme kendi kullanımından bir par verilir — 7 günlük kullanım artı güvenlik stoğu (en az 2 paket); kalan miktar yalnızca tedarikçinin teslim süresine ve güvenlik stoğuna yetecek kadar olduğunda (en az 1 paket; teslim süresi girilmemişse 3 gün) yeniden sipariş edilir. Sizin girdiğiniz par seviyeleri ve yeniden sipariş noktaları her zaman önceliklidir; kullanımı kaydedilmemiş bir kalem sipariş edilmez.",
  "Autopilot Mode": "Autopilot modu",
  "Avg {0}": "Ort. {0}",
  "Avg $": "Ort. $",
  "Avg margin": "Ort. marj",
  "Back to Connect": "Connect'e dön",
  "Baker's %": "Fırıncı %",
  "Baker's percentage": "Fırıncı yüzdesi",
  "BALL": "TOP",
  "Ball size": "Top boyu",
  "Ball sizes · weights & costs": "Top boyları · ağırlıklar ve maliyetler",
  "balls": "top",
  "Balls / batch": "Top / parti",
  "Base / sale %": "Taban / satış %",
  "Base cost": "Taban maliyet",
  "Base ingredients": "Temel malzemeler",
  "base unit": "temel birim",
  "Base units in one": "Bir paketteki temel birim",
  "Base units per vendor pack (e.g. \"1 case = 4 kg\" → 4).": "Tedarikçi paketi başına temel birim (ör. \"1 koli = 4 kg\" → 4).",
  "Base: {0}": "Temel birim: {0}",
  "based on current ledger stock vs par level.": "— kayıtlardaki güncel stok ile par seviyesine göre.",
  "Baseline": "Başlangıç",
  "Batch": "Parti",
  "Batch Cost": "Parti maliyeti",
  "Batch size": "Parti büyüklüğü",
  "Before this order": "Bu siparişten önce",
  "Best sellers first": "Önce en çok satanlar",
  "Best sellers first: their recipes take the most stock off by themselves.": "Önce en çok satanlar: stoğu en çok onların tarifleri düşer.",
  "Book:": "Kayıtta:",
  "brand-wide": "marka geneli",
  "Bucket": "Grup",
  "Build recipes in": "Tarifleri şu sayfalarda oluşturun:",
  "By": "Yapan",
  "By movement type": "Hareket türüne göre",
  "By product": "Ürüne göre",
  "By size": "Boya göre",
  "By Store": "Mağazaya göre",
  "Can't delete — referenced by {0} base recipe row(s)": "Silinemez — {0} temel tarif satırında kullanılıyor",
  "Cancel PO": "PO'yu iptal et",
  "Cancel this line": "Bu satırı iptal et",
  "cancelled": "iptal edildi",
  "Cancelled: {0}": "İptal edildi: {0}",
  "Cancelling…": "İptal ediliyor…",
  "Cap non-critical lines to strictly fit within remaining weekly budget": "Kritik olmayan satırları kalan haftalık bütçeye kesin olarak sığacak şekilde sınırla",
  "Cart: {0}": "Bu sipariş: {0}",
  "Case ×{0}": "Koli ×{0}",
  "Categories": "Kategoriler",
  "Caveats": "Dikkat edilecekler",
  "changed by hand": "elle değiştirildi",
  "Changes": "Değişiklikler",
  "Changes to ingredients, hydration %, or ball gram weights (10\"–18\") automatically recalculate Predictive Prep Matrix mix weights and Log Production batch costs.": "Malzemelerde, hidrasyon yüzdesinde ya da top gramajlarında (10\"–18\") yapılan değişiklikler, Tahmini hazırlık tablosundaki karışım ağırlıklarını ve Üretim kaydındaki parti maliyetlerini otomatik olarak yeniden hesaplar.",
  "Check now": "Şimdi kontrol et",
  "Check the list": "Listeyi kontrol et",
  "Checked · {0} lines": "Kontrol edildi · {0} satır",
  "Checking menu prices…": "Menü fiyatları kontrol ediliyor…",
  "Checking…": "Kontrol ediliyor…",
  "Choose a pizza…": "Bir pizza seçin…",
  "Choose a single store for Predictive Prep Matrix": "Tahmini hazırlık tablosu için tek bir mağaza seçin",
  "Choose a single store to Log Production": "Üretim kaydı için tek bir mağaza seçin",
  "Choose All stores to compare": "Karşılaştırmak için Tüm mağazalar seçeneğini seçin",
  "Choose one store": "Tek bir mağaza seçin",
  "Claim $": "Talep $",
  "Claim amount in dollars": "Dolar cinsinden talep tutarı",
  "Claim for": "Talebin ilgili olduğu PO ya da tedarikçi",
  "Claim reason": "Talep nedeni",
  "Clear what was read": "Okunanları temizle",
  "Click any prep recipe to log a production batch in Stage 3.": "3. aşamada bir üretim partisi kaydetmek için herhangi bir ara ürün tarifine tıklayın.",
  "Click Pre-fill Today's Mix or Log Dough Ball Batch above to log a mix.": "Bir karışım kaydetmek için yukarıdaki \"Bugünkü karışımı doldur\" ya da \"Hamur topu partisini kaydet\" düğmesine tıklayın.",
  "Click to copy recommended mix": "Önerilen karışımı kopyalamak için tıklayın",
  "Click to upload delivery slip photo": "Teslimat fişi fotoğrafını yüklemek için tıklayın",
  "Close early": "Erken kapat",
  "Close list": "Listeyi kapat",
  "Close PO with received qty preserved; remaining lines marked cancelled.": "PO, teslim alınan miktarlar korunarak kapatılır; kalan satırlar iptal edildi olarak işaretlenir.",
  "Closing…": "Kapatılıyor…",
  "COGS": "COGS",
  "COGS Variance": "COGS farkı",
  "Column": "Sütun",
  "Compares usage per $1,000 sales across stores to flag portion drift and variance.": "Porsiyon sapmasını ve farkları yakalamak için mağazaların her $1,000 satıştaki kullanımını karşılaştırır.",
  "Computing suggestions…": "Öneriler hesaplanıyor…",
  "Connected to Dough Recipe ({0}/kg) · Master: {1} · {2}": "Hamur tarifine bağlı ({0}/kg) · Ana tarif: {1} · {2}",
  "Connected to Dough Recipe & Predictive Prep Matrix": "Hamur tarifine ve Tahmini hazırlık tablosuna bağlı",
  "Connected to Predictive Matrix & Production": "Tahmini hazırlık tablosuna ve üretime bağlı",
  "Connected to Prep Recipes & Dough Recipe": "Ara ürün tariflerine ve Hamur tarifine bağlı",
  "Copied!": "Kopyalandı!",
  "copies": "kopya",
  "copy": "kopya",
  "Copy for WhatsApp / Sysco Rep": "WhatsApp / Sysco temsilcisi için kopyala",
  "Cost (mix-time)": "Maliyet (karışım anı)",
  "Cost / ball": "Maliyet / top",
  "Cost / gram": "Maliyet / gram",
  "Cost / unit": "Maliyet / birim",
  "Cost / Unit": "Maliyet / birim",
  "cost from today's recipe": "maliyet bugünkü tariften",
  "Cost locked at mix time": "Maliyet karışım anında sabitlenir",
  "cost not known yet: a topping without amounts or an item without a price": "maliyet henüz bilinmiyor: miktarı girilmemiş bir malzeme ya da fiyatı olmayan bir kalem",
  "Cost not verified": "Maliyet doğrulanmadı",
  "Cost per gram of dough at mix time": "Karışım anında hamurun gram maliyeti",
  "Costs include PST, not GST.": "Maliyetlere PST dahil, GST hariç.",
  "Could not load food ingredients for this store.": "Bu mağazanın yiyecek kalemleri yüklenemedi.",
  "Couldn't load alerts.": "Uyarılar yüklenemedi.",
  "Couldn't load audit data": "Denetim verileri yüklenemedi",
  "Couldn't load Dough Management.": "Hamur yönetimi yüklenemedi.",
  "Couldn't load ingredients.": "Kalemler yüklenemedi.",
  "Couldn't load invoices.": "Faturalar yüklenemedi.",
  "Couldn't load PO.": "PO yüklenemedi.",
  "Couldn't load preps.": "Ara ürünler yüklenemedi.",
  "Couldn't load production.": "Üretim kayıtları yüklenemedi.",
  "Couldn't load products.": "Ürünler yüklenemedi.",
  "Couldn't load rules.": "Kurallar yüklenemedi.",
  "Couldn't load stock health.": "Stok sağlığı yüklenemedi.",
  "Couldn't load stocks.": "Stoklar yüklenemedi.",
  "Couldn't load suggestions.": "Öneriler yüklenemedi.",
  "Couldn't load the COGS dashboard.": "COGS panosu yüklenemedi.",
  "Couldn't load the ingredient matrix.": "Malzeme matrisi yüklenemedi.",
  "Couldn't load the menu matrix.": "Menü matrisi yüklenemedi.",
  "Couldn't load the roster.": "Ekip listesi yüklenemedi.",
  "Couldn't load this store's recipe.": "Bu mağazanın tarifi yüklenemedi.",
  "Couldn't load this topping.": "Bu malzeme yüklenemedi.",
  "Couldn't load toppings.": "Malzemeler yüklenemedi.",
  "Couldn't load variance.": "Fark verileri yüklenemedi.",
  "Couldn't load vendors.": "Tedarikçiler yüklenemedi.",
  "Couldn't load.": "Yüklenemedi.",
  "Count": "Say",
  "Count freshness": "Sayım güncelliği",
  "Count progress": "Sayım ilerlemesi",
  "Count sheet": "Sayım listesi",
  "Counted": "Sayılan",
  "Counterpart": "Karşı mağaza",
  "Counting": "Sayım",
  "Cover": "Yeterlilik",
  "Coverage": "Yeterlilik",
  "covered by its size": "boyu karşılıyor",
  "Create / refresh draft POs for every vendor below": "Aşağıdaki her tedarikçi için taslak siparişleri oluştur / yenile",
  "Create draft": "Taslak oluştur",
  "Credited": "Ödendi",
  "Credited: {0}": "Ödenen: {0}",
  "Critical buffer — fallback for \"Low\" classification when reorder_point isn't set. Keep small.": "Kritik tampon — yeniden sipariş noktası girilmemişse \"Düşük\" sınıflandırması için yedek değer. Küçük tutun.",
  "Critical only": "Yalnızca kritik",
  "Cross-Store Portion & Usage Benchmark": "Mağazalar arası porsiyon ve kullanım karşılaştırması",
  "CSV file": "CSV dosyası",
  "CSV row": "CSV satırı",
  "Ctrl": "Ctrl",
  "Curing in cooler (<48h)": "Soğutucuda dinlenen (<48 sa)",
  "Current": "Güncel",
  "Current definition; historical unit not saved": "Güncel tanım; geçmişteki birim kaydedilmedi",
  "Daily consumption value": "Günlük tüketim değeri",
  "Daily use is the last 14 days of the ledger (sales, waste); before sales take stock off, the last two counts.": "Günlük kullanım, hareket kaydının son 14 gününden (satış, atık) hesaplanır; satışlar stoktan düşmeye başlamadan önce ise son iki sayımdan.",
  "Damaged / crushed": "Hasarlı / ezik",
  "Dashboard": "Pano",
  "Date *": "Tarih *",
  "Dates and times use this store's time zone. Future times are not allowed. The calendar uses occurrence time. Waste before or at the latest physical count is history only; later waste deducts stock when logged. Cost is captured when logged.": "Tarih ve saatler bu mağazanın saat dilimindedir. Gelecekteki bir saat girilemez. Takvim, atığın gerçekleştiği zamanı kullanır. En son fiziksel sayımdan önceki ya da o andaki atık yalnızca geçmiş kaydıdır; sonraki atık, kaydedildiğinde stoktan düşer. Maliyet, kayıt anında alınır.",
  "Default options and ingredients": "Varsayılan seçenekler ve malzemeler",
  "Defaults to last vendor price": "Varsayılan: son tedarikçi fiyatı",
  "Delete ingredient": "Kalemi sil",
  "Delete invoice": "Faturayı sil",
  "delivery line has": "teslimat satırının",
  "delivery lines have": "teslimat satırının",
  "Delivery Slip Photo (OCR)": "Teslimat fişi fotoğrafı (OCR)",
  "Depleted": "Kullanılan",
  "detail": "ayrıntı",
  "Details (optional)": "Ayrıntılar (isteğe bağlı)",
  "Different vendor than the previous purchase": "Önceki alımdan farklı bir tedarikçi",
  "Direction": "Yön",
  "Dough ball": "Hamur topu",
  "Dough Management": "Hamur yönetimi",
  "Dough Management Connected Workflow": "Hamur yönetimi: bağlantılı iş akışı",
  "Dough mix": "Hamur karışımı",
  "Dough Recipe": "Hamur tarifi",
  "Dough Recipe Ingredients & Today's Recommended Mix ({0} kg)": "Hamur tarifi malzemeleri ve bugünkü önerilen karışım ({0} kg)",
  "Dough Recipe, Log Production, and Predictive Prep Matrix live together under Dough Management.": "Hamur tarifi, Üretim kaydı ve Tahmini hazırlık tablosu, Hamur yönetimi altında bir arada.",
  "Download every row that matches the filters (all pages)": "Filtrelere uyan tüm satırları indir (tüm sayfalar)",
  "Download the list": "Listeyi indir",
  "Download the list (.xlsx)": "Listeyi indir (.xlsx)",
  "DRAFT": "TASLAK",
  "Draft {0} ready:": "Taslak siparişler hazır:",
  "Draft POs": "Taslak siparişler",
  "Drag to reorder": "Sıralamak için sürükleyin",
  "Drift": "Sapma",
  "Driver note / item / invoice…": "Şoför notu / kalem / fatura…",
  "Dynamically derive par and reorder points from 14-day sales velocity": "Par seviyelerini ve yeniden sipariş noktalarını 14 günlük satış hızından dinamik olarak hesapla",
  "e.g. \"1 box = 25 kg\" — operator can then count in boxes. One pack size per item; the case is the vendor pack size above.": "ör. \"1 kutu = 25 kg\" — personel bu durumda kutu olarak sayabilir. Kalem başına bir paket boyu; koli, yukarıdaki tedarikçi paket boyudur.",
  "e.g. 25": "ör. 25",
  "e.g. 4": "ör. 4",
  "e.g. 7": "ör. 7",
  "e.g. morning batch, Marco": "ör. sabah partisi, Marco",
  "e.g. morning mix, Marco": "ör. sabah karışımı, Marco",
  "e.g., Vendor delivery without invoice": "ör. Faturasız tedarikçi teslimatı",
  "Each item is read out in turn; say how much is on the shelf, in English or Turkish. What you say fills the sheet below, and nothing is saved until you submit.": "Her kalem sırayla okunur; rafta ne kadar olduğunu İngilizce ya da Türkçe söyleyin. Söyledikleriniz aşağıdaki listeyi doldurur; siz gönderene kadar hiçbir şey kaydedilmez.",
  "Each slice is 1/": "Her dilim 1/",
  "Edit Dough Recipe": "Hamur tarifini düzenle",
  "Edit ingredient": "Kalemi düzenle",
  "Edit invoice": "Faturayı düzenle",
  "EDIT PREP": "ARA ÜRÜNÜ DÜZENLE",
  "Edit Recipe": "Tarifi düzenle",
  "Edit vendor": "Tedarikçiyi düzenle",
  "Enter": "Enter",
  "Enter Portions Cut Manually (Weights locked from recipe):": "Kesilen porsiyonları elle girin (ağırlıklar tarifte sabit):",
  "Enter recipes in Products in Menu and this watch starts by itself.": "Menüdeki ürünler sayfasında tarifleri girin; bu takip kendiliğinden başlar.",
  "Entered: {0} {1}": "Girilen: {0} {1}",
  "entries": "kayıt",
  "entry": "kayıt",
  "Esc": "Esc",
  "Est. $": "Tahmini $",
  "Est. cost": "Tahmini maliyet",
  "Est. Cost": "Tahmini maliyet",
  "Est. line $": "Tahmini satır $",
  "Est. Loss": "Tahmini kayıp",
  "Est. Mix Cost": "Tahmini karışım maliyeti",
  "Est. unit $": "Tahmini birim $",
  "Est. value": "Tahmini değer",
  "Estimated cost — from Dough Recipe": "Tahmini maliyet — Hamur tarifinden",
  "Every amount and the yield change together, so one batch still makes what its yield says.": "Tüm miktarlar ve verim birlikte değişir; böylece bir parti yine veriminde yazan kadar çıkarır.",
  "Every Inventory page, by name": "Tüm Envanter sayfaları, ada göre",
  "Every line on this PO is fully received or cancelled.": "Bu PO'daki her satır tamamen teslim alındı ya da iptal edildi.",
  "Every number with where it comes from. Connect fills in what it knows; a line marked": "Her rakam, nereden geldiğiyle birlikte. Connect bildiklerini doldurur;",
  "Every pizza sold in a size takes one ball of it from stock. A size's other lines (its box) stay as Packaging sets them.": "Bir boyda satılan her pizza, o boyun topundan birini stoktan düşer. Boyun diğer satırları (kutusu) Ambalaj sayfasındaki ayara göre kalır.",
  "Every row of these dates and filters (all pages)": "Bu tarih ve filtrelerdeki tüm satırlar (tüm sayfalar)",
  "Every size": "Her boy",
  "Every size sold is at or under the food cost target": "Satılan her boy, yemek maliyeti hedefinde ya da altında",
  "Every store": "Tüm mağazalar",
  "Every store's recipe": "Tüm mağazaların tarifi",
  "Everything above reorder point": "Her şey yeniden sipariş noktasının üstünde",
  "Everything Inventory needs once, in one workbook: the stock list with its prices, prep recipes, what every size uses, each topping's grams per size, and each product's own lines. Download it, fill in the amounts and prices, upload it, check what will change, then apply.": "Envanterin bir kez ihtiyaç duyduğu her şey, tek bir Excel dosyasında: fiyatlarıyla stok listesi, ara ürün tarifleri, her boyun kullandıkları, her malzemenin boy başına gramı ve her ürünün kendi satırları. İndirin, miktarları ve fiyatları doldurun, yükleyin, nelerin değişeceğini kontrol edin, sonra uygulayın.",
  "Everything is in": "Her şey girildi",
  "Everything is in order": "Her şey yolunda",
  "Everything is saved together, or nothing is. Recipes that change make the sales job look at the last three weeks again.": "Ya hepsi birlikte kaydedilir ya da hiçbiri. Değişen tarifler, satışları işleyen görevin son üç haftayı yeniden işlemesini sağlar.",
  "Exact matches: {0}": "Tam eşleşenler: {0}",
  "Export CSV": "CSV dışa aktar",
  "FC %": "Maliyet %",
  "Few buyers and little money — think about removing them.": "Az alıcı, az kazanç — menüden çıkarmayı düşünün.",
  "Fill all remaining": "Kalanların hepsini doldur",
  "Fill in": "Doldur",
  "Fill the qty actually received per line + the supplier's unit price.": "Her satıra gerçekten teslim alınan miktarı ve tedarikçinin birim fiyatını girin.",
  "Filled in below:": "Aşağıda doldurulan:",
  "Filter": "Filtrele",
  "Find": "Bul",
  "Find a page (Ctrl K)": "Sayfa bul (Ctrl K)",
  "Find a product": "Ürün bul",
  "Find a product…": "Ürün bul…",
  "Find an Inventory page": "Envanter sayfası bul",
  "Find an Inventory page…": "Envanter sayfası bul…",
  "First list": "İlk liste",
  "Fix the rows above in the file and upload it again.": "Yukarıdaki satırları dosyada düzeltip dosyayı yeniden yükleyin.",
  "Fix these {0} first": "Önce bu {0} hatayı düzeltin",
  "flour": "un",
  "FLOUR BASE": "ESAS UN",
  "Food · Packaging · Cleaning": "Yiyecek · Ambalaj · Temizlik",
  "Food cost": "Yemek maliyeti",
  "Food Cost %": "Yemek maliyeti yüzdesi",
  "Food cost % by store · target {0}%": "Mağazaya göre yemek maliyeti yüzdesi · hedef %{0}",
  "Food cost % is worked out over the sales whose cost is known: an order line with a missing price or recipe is left out, never counted as free.": "Yemek maliyeti yüzdesi, maliyeti bilinen satışlar üzerinden hesaplanır: fiyatı ya da tarifi eksik olan bir sipariş satırı hesaba katılmaz, asla bedava sayılmaz.",
  "Food delivered": "Gelen yiyecek",
  "Food grouping is inferred from inventory item names. Packaging and supplies are excluded.": "Yiyecek grubu, stok kalemlerinin adlarından çıkarılır. Ambalaj ve sarf malzemeleri dahil değildir.",
  "Food ingredient": "Yiyecek malzemesi",
  "Food Ingredients": "Yiyecek malzemeleri",
  "Food on order": "Siparişteki yiyecek",
  "Food purchases + Open POs": "Yiyecek alımları + açık siparişler",
  "For which PO or vendor?": "Hangi PO ya da tedarikçi için?",
  "Formatted for your Sysco rep / driver. Ready to copy into WhatsApp, SMS, or email. One message per vendor; Connect does not send it.": "Sysco temsilciniz / şoförünüz için biçimlendirildi. WhatsApp, SMS ya da e-postaya kopyalanmaya hazır. Her tedarikçi için bir mesaj; Connect bunu göndermez.",
  "From store": "Gönderen mağaza",
  "From suggestions": "Önerilerden oluştur",
  "From the {0} size rule": "{0} boy kuralından",
  "Full Recipe Editor": "Tarifin tamamını düzenle",
  "Getting your numbers": "Rakamlarınız getiriliyor",
  "Gift cards, fees: nothing is taken off the stock": "Hediye kartları, ücretler: stoktan hiçbir şey düşülmez",
  "goal ${0}": "hedef ${0}",
  "Good earners, few buyers · {0}": "İyi kazandıran, az satılanlar · {0}",
  "Good to know": "Bilmekte fayda var",
  "Got it": "Anladım",
  "Grams": "Gram",
  "Group": "Grup",
  "GST %": "GST %",
  "Had movements since count": "Sayımdan beri hareket görenler",
  "Hands-free voice count": "Eller serbest sesli sayım",
  "has a recipe": "tarifi var",
  "Has variance row": "Fark satırı olanlar",
  "Head office": "Merkez ofis",
  "Head to": "Lütfen",
  "Health": "Sağlık",
  "healthy": "sağlıklı",
  "Help": "Yardım",
  "Hide the detail chart": "Ayrıntılı grafiği gizle",
  "Hide the lines": "Satırları gizle",
  "Hide the numbers": "Rakamları gizle",
  "How is the store doing?": "Mağaza nasıl gidiyor?",
  "How it works": "Nasıl çalışır",
  "How many": "Kaç adet",
  "How much of the purchase budget is used": "Alım bütçesinin ne kadarı kullanıldı",
  "How much of the target is portioned": "Hedefin ne kadarı porsiyonlandı",
  "How suggestions work": "Öneriler nasıl çalışır",
  "How this page works": "Bu sayfa nasıl çalışır",
  "How to fill it in": "Doldurma şekli",
  "Import CSV": "CSV içe aktar",
  "Import ingredient CSV": "Kalem CSV'si içe aktar",
  "in {0} recipe row(s)": "{0} tarif satırında",
  "In transit": "Yolda",
  "incl. shelf pizzas": "raf pizzaları dahil",
  "Included in count: {0} ({1})": "Sayıma dahil: {0} ({1})",
  "Incoming (we requested)": "Gelen (biz istedik)",
  "Ingredient": "Malzeme",
  "Ingredient / Store": "Malzeme / Mağaza",
  "Ingredients": "Kalemler",
  "Ingredients by how many products use them and their products' margin": "Kullanıldıkları ürün sayısına ve bu ürünlerin marjına göre malzemeler",
  "Inv {0}": "Fatura {0}",
  "Inventory home": "Envanter ana sayfası",
  "Inventory Items": "Stok listesi",
  "Inventory sections": "Envanter bölümleri",
  "Inventory value": "Envanter değeri",
  "Inventory value, count freshness, and per-store status — at-a-glance.": "Envanter değeri, sayımların güncelliği ve mağaza bazında durum — tek bakışta.",
  "Invoice # *": "Fatura # *",
  "Invoice #…": "Fatura #…",
  "Invoice preview": "Fatura önizlemesi",
  "Invoice subtotal:": "Fatura ara toplamı:",
  "Invorest keeps what a topping uses in its database, with no screen to enter it. This page is where head office sets it.": "Invorest, bir malzemenin ne kullandığını veritabanında tutar ama bunu girecek bir ekranı yoktur. Merkez ofis bunu bu sayfada belirler.",
  "is already recorded at this store. Recording it again is refused.": "bu mağazada zaten kayıtlı. Yeniden kaydedilmesine izin verilmez.",
  "is something only the store knows.": "olarak işaretlenen satırları yalnızca mağaza bilir.",
  "It came after the count": "Sayımdan sonra geldi",
  "It came in at": "Geldiği saat:",
  "It came in on": "Geldiği gün:",
  "It came on PO #{0}": "PO #{0} ile geldi",
  "It comes filled with what Connect has: the stock list, the preps, the menu's sizes, its toppings (most ordered first) and its products. Type only what is missing. A blank cell of an item keeps what Connect has; for a recipe the list is the recipe: a topping's size left blank has no amount.": "Liste, Connect'te olanlarla dolu gelir: stok listesi, ara ürünler, menünün boyları, malzemeleri (en çok sipariş edilenler önce) ve ürünleri. Yalnızca eksik olanları yazın. Bir kalemin boş hücresi Connect'teki değeri korur; tariflerde ise liste tarifin kendisidir: bir malzemenin boş bırakılan boyunda miktar yoktur.",
  "Item": "Kalem",
  "Item / Note": "Kalem / Not",
  "Item / SUPC": "Kalem / SUPC",
  "Items that change ({0})": "Değişecek kalemler ({0})",
  "Items With Cost": "Maliyeti olan kalemler",
  "Items with nothing on the shelf, at their safety stock, or whose stock (with what is on order) runs out before the vendor's lead time are always ordered; the rest of the food is added, most urgent first, while it fits. Packaging and cleaning are never cut by the food budget.": "Rafta hiç kalmamış, güvenlik stoğunda olan ya da stoğu (siparişte olanla birlikte) tedarikçinin teslim süresinden önce bitecek kalemler her zaman sipariş edilir; yiyeceğin geri kalanı, en acil olandan başlayarak sığdığı sürece eklenir. Ambalaj ve temizlik, yiyecek bütçesi yüzünden asla kesilmez.",
  "its recipe": "kendi tarifinden",
  "Its size": "Boyu",
  "JPEG, PNG, camera snapshot or PDF · read once, never kept": "JPEG, PNG, kamera görüntüsü ya da PDF · bir kez okunur, asla saklanmaz",
  "Jump to a group": "Bir gruba atla",
  "kg": "kg",
  "Kind": "Tür",
  "Kitchen Prep Recipes Matrix → Quick Production Handoff": "Mutfak ara ürün tarifleri tablosu → Hızlı üretim aktarımı",
  "last {0} days": "son {0} gün",
  "Last count": "Son sayım",
  "Last month’s people are listed: fill in this month’s hours and pay.": "Geçen ayın çalışanları listelendi: bu ayın saatlerini ve maaşlarını doldurun.",
  "Last move": "Son hareket",
  "Last variance": "Son fark",
  "Latest": "Son",
  "Lead": "Teslim süresi",
  "Lead time (days)": "Teslim süresi (gün)",
  "Leave empty for free/internal or zero-cost items like water or ice.": "Su veya buz gibi ücretsiz, şirket içi ya da maliyetsiz kalemler için boş bırakın.",
  "Left out to stay within budget: {0}.": "Bütçe içinde kalmak için çıkarılanlar: {0}.",
  "line has": "satırın",
  "Line items": "Fatura satırları",
  "line on order has": "açık siparişlerdeki satırın",
  "Line total": "Satır toplamı",
  "Lines": "Satırlar",
  "lines have": "satırın",
  "lines on order have": "açık siparişlerdeki satırın",
  "Listening to microphone": "Mikrofon dinleniyor",
  "Live COGS": "Canlı COGS",
  "Loading alerts…": "Uyarılar yükleniyor…",
  "Loading COGS dashboard…": "COGS panosu yükleniyor…",
  "Loading credit memos…": "Alacaklar yükleniyor…",
  "Loading Dough Management…": "Hamur yönetimi yükleniyor…",
  "Loading ingredient matrix…": "Malzeme matrisi yükleniyor…",
  "Loading ingredients…": "Kalemler yükleniyor…",
  "Loading invoice…": "Fatura yükleniyor…",
  "Loading invoices…": "Faturalar yükleniyor…",
  "Loading lines…": "Satırlar yükleniyor…",
  "Loading menu matrix…": "Menü matrisi yükleniyor…",
  "Loading PO…": "PO yükleniyor…",
  "Loading POs…": "PO'lar yükleniyor…",
  "Loading preps…": "Ara ürünler yükleniyor…",
  "Loading price history…": "Fiyat geçmişi yükleniyor…",
  "Loading purchases…": "Alımlar yükleniyor…",
  "Loading roster…": "Ekip listesi yükleniyor…",
  "Loading rules…": "Kurallar yükleniyor…",
  "Loading stock health…": "Stok sağlığı yükleniyor…",
  "Loading stock units…": "Stok birimleri yükleniyor…",
  "Loading stocks…": "Stoklar yükleniyor…",
  "Loading store detail…": "Mağaza ayrıntıları yükleniyor…",
  "Loading topping…": "Malzeme yükleniyor…",
  "Loading toppings…": "Malzemeler yükleniyor…",
  "Loading variance…": "Fark verileri yükleniyor…",
  "Loading vendors…": "Tedarikçiler yükleniyor…",
  "Log Batch": "Partiyi kaydet",
  "Log Claim": "Talebi kaydet",
  "Log delivery": "Teslimatı kaydet",
  "Log Dough Ball Batch": "Hamur topu partisini kaydet",
  "Log dough batch": "Hamur partisini kaydet",
  "Log Dough Batch ({0} kg)": "Hamur partisini kaydet ({0} kg)",
  "Log manual credit claim:": "Elle alacak talebi kaydet:",
  "Log Prep Batch": "Ara ürün partisini kaydet",
  "Log Prep Recipe Batch (Drains Raw Ingredients)": "Ara ürün tarifi partisini kaydet (hammaddeleri stoktan düşer)",
  "Log Production": "Üretim kaydı",
  "Log Production with this Recipe": "Bu tarifle üretim kaydet",
  "Log supplier deliveries against open purchase orders. Search jumps to a line; Enter moves down; blank lines are ignored.": "Tedarikçi teslimatlarını açık siparişlere göre kaydedin. Arama bir satıra atlar; Enter aşağı iner; boş satırlar yok sayılır.",
  "Log This Mix": "Bu karışımı kaydet",
  "Log waste": "Atığı kaydet",
  "Log with this time": "Bu saatle kaydet",
  "Logged: {0}": "Kayıt: {0}",
  "Logging…": "Kaydediliyor…",
  "Looks right": "Doğru görünüyor",
  "Low only": "Yalnızca düşük",
  "Low stock": "Düşük stok",
  "Made": "Yapılış şekli",
  "Made ahead": "Önceden yapılan",
  "Made at": "Yapılış zamanı",
  "Made to order": "Siparişte yapılan",
  "Make small raises by themselves, without approval": "Küçük zamları onaysız yap",
  "Margin %": "Marj %",
  "Margin/unit": "Marj/birim",
  "Mark Credited": "Ödendi olarak işaretle",
  "Master dough": "Ana hamur",
  "MASTER DOUGH": "ANA HAMUR",
  "Master list of everything you buy, stock, or consume.": "Satın aldığınız, stokta tuttuğunuz veya tükettiğiniz her şeyin ana listesi.",
  "Master Recipe ({0} kg)": "Ana tarif ({0} kg)",
  "Match Status": "Eşleşme durumu",
  "Matched ingredient": "Eşleşen kalem",
  "Median": "Medyan",
  "Median count {0} · median margin {1}": "Medyan ürün sayısı {0} · medyan marj {1}",
  "Median qty {0} · median margin {1}": "Medyan adet {0} · medyan marj {1}",
  "Memo #": "Alacak #",
  "Menu & Recipes": "Menü ve tarifler",
  "Menu items by popularity and margin per unit": "Popülerliğe ve birim başına marja göre menü ürünleri",
  "Menu items where recipe cost % has crept above target margins.": "Tarif maliyeti yüzdesi hedef marjların üzerine çıkmış menü ürünleri.",
  "Menu Pizzas Linked": "Bağlı menü pizzaları",
  "Min {0} · Max {1} · {2} purchases from {3} vendor(s)": "En düşük {0} · En yüksek {1} · {3} tedarikçiden {2} alım",
  "Min change": "En az değişim",
  "Missing": "Eksik",
  "Mix today (balls & kg)": "Bugün karılacak (top ve kg)",
  "Mixed": "Karılma zamanı",
  "Mixed at": "Karılma zamanı",
  "Money you took in": "Satıştan gelen para",
  "move": "gezin",
  "Move stock between stores instead of emergency-buying it. Every leg writes the ledger.": "Acil alım yapmak yerine stoğu mağazalar arasında taşıyın. Her aşama stok defterine işlenir.",
  "Movement": "Hareket",
  "Muted": "Sessiz",
  "n/a": "yok",
  "Name *": "Ad *",
  "Name A→Z": "Ad A→Z",
  "Name, unit, price, vendor, codes, taxes and pack sizes of this brand item are set by head office. The levels below are this store's.": "Bu marka kaleminin adını, birimini, fiyatını, tedarikçisini, kodlarını, vergilerini ve paket boylarını merkez ofis belirler. Aşağıdaki seviyeler bu mağazaya aittir.",
  "need": "bekliyor",
  "needs": "bekliyor",
  "Needs a recipe": "Tarif gerekiyor",
  "Needs amounts": "Miktar gerekiyor",
  "Needs you": "Sizi bekliyor",
  "Net sales {0} → {1}, delivery apps included": "Net satış {0} → {1}, teslimat uygulamaları dahil",
  "New Dough Batch — Standard {0} kg Mix": "Yeni hamur partisi — Standart {0} kg karışım",
  "New invoice": "Yeni fatura",
  "New item's name": "Yeni kalemin adı",
  "New prep": "Yeni ara ürün",
  "NEW PREP": "YENİ ARA ÜRÜN",
  "New slice item…": "Yeni dilim kalemi…",
  "Next page": "Sonraki sayfa",
  "Next try {0}": "Sonraki deneme: {0}",
  "No active batches.": "Aktif parti yok.",
  "No active stocks for this store.": "Bu mağazada aktif stok yok.",
  "No administrative event in this window.": "Bu aralıkta yönetim işlemi yok.",
  "No audits yet": "Henüz sayım yok",
  "No ball sizes yet — add them on the Dough Recipe.": "Henüz top boyu yok — Hamur tarifi sekmesinden ekleyin.",
  "No ball sizes yet — head office sets them up.": "Henüz top boyu yok — bunları merkez ofis belirler.",
  "No ball sizes yet.": "Henüz top boyu yok.",
  "No conversion from {0} to {1} — cost unknown.": "{0} biriminden {1} birimine dönüşüm yok — maliyet bilinmiyor.",
  "No credit memos logged.": "Kayıtlı alacak yok.",
  "No default options saved for this size.": "Bu boy için kayıtlı varsayılan seçenek yok.",
  "No demand (0)": "Talep yok (0)",
  "No Dough recipe for this brand yet": "Bu marka için henüz hamur tarifi yok",
  "No forecast yet": "Henüz tahmin yok",
  "No ingredient data yet for this brand": "Bu marka için henüz malzeme verisi yok",
  "No ingredient matches these filters.": "Bu filtrelere uyan kalem yok.",
  "No ingredients saved for this size.": "Bu boy için kayıtlı malzeme yok.",
  "No ingredients yet": "Henüz kalem yok",
  "No inventory spend recorded for this period.": "Bu dönem için kayıtlı envanter harcaması yok.",
  "No invoices in range": "Bu aralıkta fatura yok",
  "No item costs configured yet": "Henüz kalem maliyeti ayarlanmadı",
  "No item has a cost yet, so there is nothing to place.": "Henüz hiçbir ürünün maliyeti yok; bu yüzden yerleştirilecek bir şey yok.",
  "No items in this quadrant.": "Bu bölgede ürün yok.",
  "No items moved enough to flag — or no priced items yet.": "Öne çıkacak kadar değişen kalem yok — ya da henüz maliyeti bilinen kalem yok.",
  "No items sold in this window.": "Bu aralıkta satılan ürün yok.",
  "No items yet. Use the search below to add ingredients.": "Henüz malzeme yok. Eklemek için aşağıdaki aramayı kullanın.",
  "No line items yet — click \"+ Add line\".": "Henüz satır yok — \"+ Satır ekle\" düğmesine tıklayın.",
  "No matches for \"{0}\".": "\"{0}\" ile eşleşen bir şey yok.",
  "No menu item has a recipe cost yet": "Henüz hiçbir menü ürününün tarif maliyeti yok",
  "No menu items currently exceeding target food cost %.": "Şu anda hedef yemek maliyeti yüzdesini aşan menü ürünü yok.",
  "No movement in this window.": "Bu aralıkta hareket yok.",
  "No pack size set for vendor": "Tedarikçi için paket boyu girilmemiş",
  "No pack sizes configured. Stock will only be countable in its base unit ({0}){1}.": "Paket boyu tanımlanmamış. Stok yalnızca temel biriminde ({0}){1} sayılabilir.",
  "No packaging items yet. Search below to add some.": "Henüz ambalaj kalemi yok. Eklemek için aşağıda arayın.",
  "No packaging matches for \"{0}\". Try \"box\", \"bag\", \"liner\"…": "\"{0}\" ile eşleşen ambalaj yok. \"box\", \"bag\", \"liner\" gibi kelimeler deneyin…",
  "No packaging rules yet": "Henüz ambalaj kuralı yok",
  "No page called “{0}”. Try another word.": "“{0}” adında bir sayfa yok. Başka bir kelime deneyin.",
  "No PO is awaiting delivery.": "Teslimat bekleyen PO yok.",
  "No prep matches \"{0}\".": "\"{0}\" ile eşleşen ara ürün yok.",
  "No prep production runs logged in the last 7 days.": "Son 7 günde kaydedilmiş ara ürün üretimi yok.",
  "No prep recipes found for this brand.": "Bu marka için ara ürün tarifi bulunamadı.",
  "No prep recipes yet": "Henüz ara ürün tarifi yok",
  "No prices on these items yet, so we cannot draw the chart.": "Bu ürünlerin henüz fiyatı yok, bu yüzden grafik çizilemiyor.",
  "No product matches \"{0}\".": "\"{0}\" ile eşleşen ürün yok.",
  "No products for this brand.": "Bu marka için ürün yok.",
  "No purchase deliveries in this window, so there is no price history to compare yet.": "Bu aralıkta alım teslimatı yok; bu yüzden henüz karşılaştırılacak fiyat geçmişi yok.",
  "No purchases in this window.": "Bu aralıkta alım yok.",
  "No receipt logged in the last 30 days.": "Son 30 günde kaydedilmiş teslim alma yok.",
  "no recipe yet": "henüz tarifi yok",
  "No rule matches \"{0}\".": "\"{0}\" ile eşleşen kural yok.",
  "No sales last 7 days": "Son 7 günde satış yok",
  "No sales recorded yet for these days.": "Bu günler için henüz kayıtlı satış yok.",
  "No sales recorded yet this period to calculate purchase budget.": "Alım bütçesini hesaplamak için bu dönemde henüz kayıtlı satış yok.",
  "No sibling store in this brand": "Bu markada başka mağaza yok",
  "No stock matches for \"{0}\".": "\"{0}\" ile eşleşen stok yok.",
  "No stock matches these filters.": "Bu filtrelere uyan stok yok.",
  "No stock with this status.": "Bu durumda stok yok.",
  "No stocks found for this store": "Bu mağaza için stok bulunamadı",
  "No store-level data for this brand.": "Bu marka için mağaza bazında veri yok.",
  "No toppings match.": "Eşleşen malzeme yok.",
  "No transfers yet for this store.": "Bu mağaza için henüz transfer yok.",
  "no usage in window": "bu aralıkta kullanım yok",
  "No user is attached to this brand yet.": "Bu markaya henüz bağlı kullanıcı yok.",
  "No valid stock units are available.": "Geçerli stok birimi yok.",
  "No variance data available.": "Fark verisi yok.",
  "No variance data yet": "Henüz fark verisi yok",
  "No vendor — free/internal item": "Tedarikçi yok — ücretsiz/şirket içi kalem",
  "No vendor mapping": "Tedarikçi atanmamış",
  "No vendors yet": "Henüz tedarikçi yok",
  "No waste logged in this period.": "Bu dönemde kaydedilmiş atık yok.",
  "Non-food in this order: {0}, apart": "Bu siparişteki yiyecek dışı: {0}, ayrı tutulur",
  "Non-Sale Drift": "Satış dışı sapma",
  "Not a delivery: the next count puts the stock right.": "Teslimat değil: bir sonraki sayım stoğu düzeltir.",
  "Not counted in yet": "Henüz sayılmadı",
  "Not enough sales yet to compare with the days before.": "Önceki günlerle karşılaştırmak için henüz yeterli satış yok.",
  "Not in the stock list": "Stok listesinde yok",
  "Not now": "Şimdi değil",
  "not on a pizza size yet": "henüz hiçbir pizza boyunda yok",
  "not on the menu any more": "artık menüde değil",
  "Not set": "Ayarlanmadı",
  "Not started": "Başlanmadı",
  "Not started at this brand yet. When Inventory goes live here, every accepted order line takes its recipe's ingredients off the stock by itself, and the food cost below fills in.": "Bu markada henüz başlanmadı. Envanter burada devreye girdiğinde kabul edilen her sipariş satırı, tarifindeki malzemeleri stoktan kendiliğinden düşer ve aşağıdaki yemek maliyeti dolmaya başlar.",
  "Not working · {0}": "Tutmayanlar · {0}",
  "Not yet counted ({0})": "Henüz sayılmayanlar ({0})",
  "Note (optional)": "Not (isteğe bağlı)",
  "Notes": "Notlar",
  "Notes (optional)": "Notlar (isteğe bağlı)",
  "NOTHING": "HİÇBİR ŞEY",
  "Nothing in this group.": "Bu grupta ürün yok.",
  "Nothing in this list differs from what Connect has.": "Bu listede Connect'tekinden farklı bir şey yok.",
  "Nothing sold in the last {0} days": "Son {0} günde hiçbir şey satılmadı",
  "nothing to order right now.": "şu anda sipariş edilecek bir şey yok.",
  "Nothing to order right now.": "Şu anda sipariş edilecek bir şey yok.",
  "notified": "bildirildi",
  "Now": "Şimdi",
  "Occurred at": "Tarih ve saat",
  "Occurred on": "Tarih",
  "Occurrence not saved; using logged time": "Olay zamanı kaydedilmemiş; kayıt zamanı kullanılıyor",
  "of": "oranında, kesildiği pizza:",
  "of what sold in {0} days is covered": "son {0} günde satılanlardan tariflerin kapsadığı pay",
  "off the menu": "menüden kalktı",
  "Offline mode — counts are saved locally and will sync when the connection returns.": "Çevrimdışı mod — sayımlar bu cihazda saklanır ve bağlantı gelince senkronize edilir.",
  "OK": "Yeterli",
  "OK only": "Yalnızca yeterli",
  "Oldest count age": "En eski sayımdan beri",
  "Oldest first · Cost locked from Dough Recipe at mix time.": "Önce en eskiler · Maliyet, karışım anında hamur tarifinden sabitlenir.",
  "On hand": "Mevcut",
  "On hand × the cost of a unit with PST, as every Inventory page values stock": "Mevcut miktar × PST dahil birim maliyeti; her Envanter sayfası stoğu bu şekilde değerlendirir",
  "One line per item: the SUPC first, the cases shipped and the case price last.": "Her kalem için bir satır: önce SUPC, sonra gönderilen koli sayısı, en sonda koli fiyatı.",
  "One master batch": "Bir ana parti",
  "One page": "Tek sayfa",
  "One-Click Sysco Autopilot": "Tek tıkla Sysco Autopilot",
  "Only head office imports the first list.": "İlk listeyi yalnızca merkez ofis içe aktarır.",
  "Only on one product": "Sadece bir üründe",
  "Only weights have a baker's percentage": "Fırıncı yüzdesi yalnızca ağırlıklar için vardır",
  "open": "açın",
  "Open claims: {0}": "Açık talepler: {0}",
  "Open Dough Recipe": "Hamur tarifini aç",
  "Open Inventory": "Envanteri aç",
  "Open PO #{0}": "PO #{0} siparişini aç",
  "Open PO editor": "PO düzenleyicisini aç",
  "Open POs": "Açık siparişler",
  "Open Roles": "Rolleri aç",
  "Open Users": "Kullanıcıları aç",
  "Option group": "Seçenek grubu",
  "Option mappings are shown separately from the base recipe and are read only here.": "Seçenek eşleştirmeleri temel tariften ayrı gösterilir ve burada yalnızca okunabilir.",
  "optional": "isteğe bağlı",
  "Optional notes (e.g. morning mix, Marco)": "İsteğe bağlı notlar (ör. sabah karışımı, Marco)",
  "Or speak: \"skip\", \"geç\", \"back\", \"geri\", \"repeat\"": "Ya da söyleyin: \"geç\", \"geri\", \"tekrar\" (İngilizce: \"skip\", \"back\", \"repeat\")",
  "order": "sipariş",
  "Order": "Sipariş",
  "Order → delivery days. Used by safety-aware Suggested Orders.": "Siparişten teslimata kadar geçen gün. Güvenlik stoğunu dikkate alan Önerilen siparişler bunu kullanır.",
  "Order again": "Yeniden sipariş et",
  "Order cutoff": "Sipariş son saati",
  "Ordered, not delivered": "Sipariş edildi, teslim edilmedi",
  "Orders email": "Sipariş e-postası",
  "Orders: {0}": "Siparişler: {0}",
  "Other charges": "Diğer masraflar",
  "Other charges (delivery, fuel)": "Diğer masraflar (teslimat, yakıt)",
  "Other flour preps: {0}. The master is the prep named Dough, else the first.": "Unlu diğer ara ürünler: {0}. Ana hamur, adı Dough olan ara üründür; yoksa ilkidir.",
  "Other lines kept": "Korunan diğer satırlar",
  "out": "giden",
  "Out": "Tükendi",
  "Out of stock": "Stok tükendi",
  "Outgoing (we send)": "Giden (biz gönderiyoruz)",
  "Outstanding": "Kalan",
  "Over-shipped: {0}": "Fazla gönderim: {0}",
  "Own amounts on": "Özel miktarlı ürünler",
  "Pack": "Paket",
  "Pack count": "Paket sayısı",
  "Pack sizes": "Paket boyları",
  "Pack unit": "Paket birimi",
  "Packaging": "Ambalaj",
  "Packaging {0} · Cleaning {1}, not in this budget": "Ambalaj {0} · Temizlik {1}, bu bütçeye dahil değil",
  "Packaging item": "Ambalaj kalemi",
  "Packaging items": "Ambalaj kalemleri",
  "Packaging rules": "Ambalaj kuralları",
  "Packs ordered": "Sipariş edilen paket",
  "Pages": "Sayfalar",
  "Par": "Par",
  "Par {0}": "Par {0}",
  "Par at {0}": "{0} için par",
  "Par from the item's own use: a week of use plus the safety stock, at least 2 packs; reorder at the use until the delivery comes plus the safety stock": "Par, kalemin kendi kullanımından hesaplanır: bir haftalık kullanım artı güvenlik stoğu, en az 2 paket; yeniden sipariş noktası, teslimat gelene kadarki kullanım artı güvenlik stoğudur",
  "Par level": "Par seviyesi",
  "People love them but they earn little — raise the price or cut the cost.": "Müşteriler seviyor ama az kazandırıyor — fiyatı artırın ya da maliyeti düşürün.",
  "Per store": "Mağaza bazında",
  "Per-stock variance = non-sale outflow (waste / count variance / production / adjustment) in dollars, not recipe drift. Top-level variance is recipe-driven.": "Stok bazında fark = satış dışı çıkış (atık / sayım farkı / üretim / düzeltme), dolar cinsinden; tarif sapması değildir. Üst düzeydeki fark tariflere dayanır.",
  "Period-to-date food cost % with movers vs prior period.": "Dönem başından bugüne yemek maliyeti yüzdesi ve önceki döneme göre en çok değişenler.",
  "Physical inventory for": "Fiziksel envanter sayımı:",
  "Pick a group on the left, then an item.": "Soldan bir grup, ardından bir ürün seçin.",
  "Pick a PO on the left to start receiving.": "Teslim almaya başlamak için soldan bir PO seçin.",
  "Pick your store first": "Önce mağazanızı seçin",
  "Pieces (adet)": "Adet",
  "Pizza box rules by size for the selected brand.": "Seçili marka için boya göre pizza kutusu kuralları.",
  "Pizza size": "Pizza boyu",
  "Pizza sizes": "Pizza boyları",
  "Pizza sizes → dough ball": "Pizza boyları → hamur topu",
  "PO / Inv": "PO / Fatura",
  "PO #": "PO #",
  "PO #{0} — {1}": "PO #{0} — {1}",
  "PO #{0} · prices only": "PO #{0} · yalnızca fiyatlar",
  "PO Price": "PO fiyatı",
  "PO Qty": "PO miktarı",
  "Popular but cheap · {0}": "Sevilen ama az kazandıranlar · {0}",
  "Popularity × contribution margin — Stars, Plowhorses, Puzzles, Dogs (margin-based, not price-based)": "Popülerlik × katkı marjı — Stars, Plowhorses, Puzzles, Dogs (fiyata değil, marja dayalı)",
  "Popularity vs Margin": "Popülerlik ve marj",
  "Portion": "Porsiyon",
  "Portion (a dough ball…)": "Porsiyon (bir hamur topu…)",
  "Portioned:": "Porsiyonlanan:",
  "POs": "PO'lar",
  "Pre-fill Recommended Dough Mix ({0} kg)": "Önerilen hamur karışımını doldur ({0} kg)",
  "Pre-fill Today's Mix": "Bugünkü karışımı doldur",
  "Predictive 48h Dough & Prep Shield": "Tahmini 48 saatlik hamur ve hazırlık kalkanı",
  "Predictive Prep Matrix": "Tahmini hazırlık tablosu",
  "Predictive Prep Matrix · Connected to Dough Recipe": "Tahmini hazırlık tablosu · Hamur tarifine bağlı",
  "Predictive Prep Matrix recommends mixing": "Tahmini hazırlık tablosunun önerdiği karışım:",
  "Prep": "Ara ürün",
  "PREP": "ARA ÜRÜN",
  "Prep (sauce, dough…)": "Ara ürün (sos, hamur…)",
  "Prep batch": "Ara ürün partisi",
  "Prep name": "Ara ürün adı",
  "Prep name (e.g. Dough, Tomato sauce)…": "Ara ürün adı (ör. Dough, Tomato sauce)…",
  "Prep Recipe": "Ara ürün tarifi",
  "Prep recipes": "Ara ürün tarifleri",
  "Prep Recipes": "Ara ürün tarifleri",
  "Preparing the list…": "Liste hazırlanıyor…",
  "Preparing the photo…": "Fotoğraf hazırlanıyor…",
  "Preps": "Ara ürünler",
  "Preps ({0})": "Ara ürünler ({0})",
  "Prev": "Önceki",
  "Previous item (or say 'back' / 'geri')": "Önceki kalem (ya da 'geri' / 'back' deyin)",
  "Previous page": "Önceki sayfa",
  "Price before tax": "Vergisiz fiyat",
  "Price discrepancy": "Fiyat farkı",
  "Price drift": "Fiyat kayması",
  "Price Drift": "Fiyat kayması",
  "price not known": "fiyat bilinmiyor",
  "Price spikes: {0}": "Ani fiyat artışları: {0}",
  "Price suggestions": "Fiyat önerileri",
  "Prior": "Önceki",
  "Prior period": "Önceki dönem",
  "Product Engineering": "Ürün mühendisliği",
  "Production Workstation · 48h Cold Ferment": "Üretim istasyonu · 48 saat soğuk fermantasyon",
  "Products in Menu": "Menüdeki ürünler",
  "Profit and loss": "Kâr ve zarar",
  "Projected runout": "Tahmini tükenme",
  "PST %": "PST %",
  "Purchase Budget Cap": "Alım bütçesi sınırı",
  "Purchase orders": "Satın alma siparişleri",
  "Purchase spend": "Alım harcaması",
  "Purchases": "Alım",
  "Purchasing": "Satın alma",
  "Qty": "Miktar",
  "Qty (base) *": "Miktar (temel birim) *",
  "Qty ordered": "Sipariş edilen miktar",
  "Qty received": "Teslim alınan miktar",
  "Qty short": "Eksik miktar",
  "Qty Short": "Eksik miktar",
  "Quality rejection": "Kalite nedeniyle ret",
  "Quantity not configured": "Miktar girilmemiş",
  "Quantity Produced": "Üretilen miktar",
  "Quantity short": "Eksik miktar",
  "Raw Slip Lines (SUPC · Qty · UnitPrice)": "Fişin ham satırları (SUPC · Miktar · Birim fiyatı)",
  "read from a photo": "fotoğraftan okundu",
  "Read from the invoice": "Faturadan okunanlar",
  "Read item prompt again (or say 'repeat' / 'tekrar')": "Kalemi yeniden sesli okur (ya da 'repeat' / 'tekrar' deyin)",
  "Read items aloud": "Kalemleri sesli oku",
  "Read only — dough recipes are set by head office.": "Salt okunur — hamur tariflerini merkez ofis belirler.",
  "Reading the stock list and the menu's sales; this takes a few seconds, then the file downloads by itself.": "Stok listesi ve menünün satışları okunuyor; bu birkaç saniye sürer, ardından dosya kendiliğinden iner.",
  "Reading…": "Okunuyor…",
  "Ready = balls from mixes at least 48 hours old; the oldest are used first. Demand is the same weekday over the last 8 weeks, shelf pizzas included. A mix made now is ready {0} on {1}: until then the balls ready and curing serve (the 48h target), and today's mix covers the first day it is used ({2}) and keeps the par: that day's demand + par − what is left when it is ready.": "Hazır = en az 48 saat önce yapılmış karışımlardan toplar; önce en eskiler kullanılır. Talep, son 8 haftanın aynı gününe göre hesaplanır; raf pizzaları dahildir. Şimdi yapılan bir karışım {1} saat {0} itibarıyla hazır olur: o zamana kadar hazır ve dinlenmekte olan toplar kullanılır (48 saat hedefi); bugünün karışımı ise kullanılacağı ilk günü ({2}) karşılar ve par seviyesini korur: o günün talebi + par − hazır olduğunda kalan.",
  "Ready at": "Hazır olma zamanı",
  "Ready for Vision OCR": "Vision OCR için hazır",
  "Ready now (≥48h)": "Şimdi hazır (≥48 sa)",
  "Reason": "Neden",
  "Rec: {0} · Open: {1}": "Gelen: {0} · Açık: {1}",
  "Rec: {0} · POs: {1}": "Gelen: {0} · PO'lar: {1}",
  "Rec: {0} {1}": "Öneri: {0} top",
  "Receive": "Teslim al",
  "Receive qty": "Teslim alınacak miktar",
  "Receive with this time": "Bu saatle teslim al",
  "Received": "Teslim alındı",
  "Receiving": "Teslim alma",
  "Receiving desk": "Teslim alma masası",
  "Receiving now": "Şimdi teslim alınan",
  "Recent Prep Production Runs (Last 7 Days)": "Son ara ürün üretimleri (son 7 gün)",
  "Recent receipts (this store)": "Son teslim almalar (bu mağaza)",
  "Recent waste": "Son atıklar",
  "RECIPE · {0}": "TARİF · {0}",
  "Recipe connection: {0} · {1} {2} by the recipe ratio.": "Tarif bağlantısı: {0} · {1} malzeme tarif oranına göre stoktan düşer.",
  "Recipe Cost / Ball": "Tarif maliyeti / top",
  "Recipe Margin Erosion Watch": "Tarif marjı erime takibi",
  "Recipes": "Tarifler",
  "Recipes cover {0}% of these sales.": "Tarifler bu satışların %{0} kadarını kapsıyor.",
  "Recipes cover {0}% of what sold in {1} days": "Tarifler son {1} günde satılanların %{0} kadarını kapsıyor",
  "Recipes that change ({0})": "Değişen tarifler ({0})",
  "Recommendation": "Öneri",
  "Recommended mix today:": "Bugün önerilen karışım:",
  "Record receipt": "Teslim almayı kaydet",
  "Record vendor invoices directly — stock is added to ledger on save.": "Tedarikçi faturalarını doğrudan kaydedin — kaydettiğinizde stok deftere eklenir.",
  "Record waste by the date and time it happened.": "Atığı, gerçekleştiği tarih ve saatle kaydedin.",
  "Recorded cost": "Kaydedilen maliyet",
  "Reference": "Referans",
  "Refresh": "Yenile",
  "Refresh ingredients": "Malzemeleri yenile",
  "Refreshing…": "Yenileniyor…",
  "Regular cost": "Normal maliyet",
  "Remaining": "Kalan",
  "Remaining budget": "Kalan bütçe",
  "Remaining Budget": "Kalan bütçe",
  "Remove item": "Kalemi kaldır",
  "Remove line": "Satırı kaldır",
  "Remove photo": "Fotoğrafı kaldır",
  "Reorder candidates for": "Yeniden sipariş adayları:",
  "Reorder point": "Yeniden sipariş noktası",
  "Reorder pt": "Yeniden sipariş noktası",
  "Request stock from another store": "Başka bir mağazadan stok iste",
  "Requested": "İstendi",
  "Requesting…": "İstek gönderiliyor…",
  "Required for Mix ({0} kg)": "Karışım için gereken ({0} kg)",
  "Reset": "Sıfırla",
  "Resolve": "Çözüldü",
  "Resolved": "Çözüldü",
  "Resumed {0} unsent {1}": "Gönderilmemiş {0} kayıt geri yüklendi",
  "Retry now": "Şimdi yeniden dene",
  "Revenue × food cost target": "Ciro × yemek maliyeti hedefi",
  "Review the quantity and unit after choosing. Changes are saved only with {0}.": "Seçtikten sonra miktarı ve birimi kontrol edin. Değişiklikler yalnızca {0} düğmesiyle kaydedilir.",
  "Roster": "Ekip listesi",
  "row": "satır",
  "Row": "Satır",
  "row {0}": "{0}. satır",
  "rows": "satır",
  "Rows": "Satır",
  "Rows per page": "Sayfa başına satır",
  "Rules by": "Kural türü",
  "Run 1-Click Autopilot to generate vendor draft POs": "Tedarikçi taslak siparişlerini oluşturmak için tek tıkla Autopilot'u çalıştır",
  "Run now": "Şimdi çalıştır",
  "Running Autopilot…": "Autopilot çalışıyor…",
  "Running…": "Çalışıyor…",
  "Safety stock": "Güvenlik stoğu",
  "Sale Outflow": "Satış çıkışı",
  "Sale price": "Satış fiyatı",
  "Sale prices and offered sizes: Connect's live menu. Base cost excludes the default options below.": "Satış fiyatları ve sunulan boylar: Connect'in canlı menüsü. Taban maliyete aşağıdaki varsayılan seçenekler dahil değildir.",
  "Sales day by day": "Gün gün satışlar",
  "sales of the last {0} days": "son {0} günün satışları",
  "Sales take stock off": "Satışların stoktan düşülmesi",
  "Same size": "Aynı boy",
  "Save qty": "Miktarı kaydet",
  "Save Recipe": "Tarifi kaydet",
  "Save Recipe Amounts": "Tarif miktarlarını kaydet",
  "Save rule": "Kuralı kaydet",
  "Save the recipe to change ball sizes.": "Top boylarını değiştirmek için önce tarifi kaydedin.",
  "Save with this time": "Bu saatle kaydet",
  "Saving will write purchase movements to the stock ledger.": "Kaydettiğinizde alım hareketleri stok defterine yazılır.",
  "Say or type a count or a command": "Bir miktar ya da komut söyleyin veya yazın",
  "Say or type e.g. \"2.5 kg mozzarella spoiled\" or \"3 kilo mantar bozuldu\"": "Söyleyin ya da yazın, ör. \"2,5 kg mozzarella bozuldu\" veya \"3 kilo mantar bozuldu\"",
  "Say or type e.g. \"3 case\", \"3 buçuk kasa\", \"12 adet\", \"skip\", \"back\", \"mozzarella 4 case\"": "Söyleyin ya da yazın, ör. \"3 kasa\", \"3 buçuk kasa\", \"12 adet\", \"geç\", \"geri\", \"mozzarella 4 kasa\"",
  "Say or type the waste in one sentence": "Atığı tek cümleyle söyleyin ya da yazın",
  "Scale": "Ölçekle",
  "Scale to": "Hedef verim",
  "Scan barcode or type SKU": "Barkod okutun veya SKU yazın",
  "Scan barcode or type SKU, then Enter": "Barkod okutun veya SKU yazıp Enter'a basın",
  "Scan or type an item name / code…": "Kalem adını / kodunu okutun ya da yazın…",
  "Scan or type an item name or code": "Kalem adını veya kodunu okutun ya da yazın",
  "Search": "Ara",
  "Search below for the first ingredient: a stock item, a prep or another product.": "İlk malzemeyi aşağıda arayın: bir stok kalemi, bir ara ürün ya da başka bir ürün.",
  "Search by ingredient name or SKU": "Malzeme adına veya SKU'ya göre ara",
  "Search food ingredients": "Yiyecek malzemelerinde ara",
  "Search ingredient": "Malzeme ara",
  "Search ingredient…": "Malzeme ara…",
  "Search name": "Ada göre ara",
  "Search name or SKU": "Ada veya SKU'ya göre ara",
  "Search name or SKU…": "Ada veya SKU'ya göre ara…",
  "Search name, email or role": "Ad, e-posta veya role göre ara",
  "Search name, email or role…": "Ad, e-posta veya role göre ara…",
  "Search name…": "Ada göre ara…",
  "Search product name": "Ürün adına göre ara",
  "Search product name…": "Ürün adına göre ara…",
  "Search stock": "Stok ara",
  "Search stock…": "Stok ara…",
  "Search toppings": "Malzeme ara",
  "Search toppings…": "Malzeme ara…",
  "Searching…": "Aranıyor…",
  "See every item": "Tüm ürünleri gör",
  "Select a brand": "Bir marka seçin",
  "Select a brand and store": "Bir marka ve mağaza seçin",
  "Select a food ingredient": "Bir yiyecek malzemesi seçin",
  "Select a reason": "Bir neden seçin",
  "Select a store…": "Bir mağaza seçin…",
  "Select an item": "Bir ürün seçin",
  "Select an item…": "Bir kalem seçin…",
  "Select this page": "Bu sayfadakileri seç",
  "Select unit…": "Birim seçin…",
  "Selected day": "Seçili gün",
  "Selected:": "Seçilen:",
  "Sell a lot and earn well — keep them on the menu.": "Çok satar, iyi kazandırır — menüde tutun.",
  "Selling less": "Daha az satanlar",
  "Selling more": "Daha çok satanlar",
  "Send PO": "Siparişi gönder",
  "Send Recommended Mix to Log Production": "Önerilen karışımı üretim kaydına aktar",
  "Send suggestions to Approvals": "Önerileri onaya gönder",
  "Sending…": "Gönderiliyor…",
  "Set it": "Ayarlayın",
  "Set target to portion sum ({0} kg)": "Hedefi porsiyon toplamına eşitle ({0} kg)",
  "sets them.": "sayfasında ayarlanır.",
  "Sheet": "Sayfa",
  "Shelf pizzas (slices)": "Raf pizzaları (dilimler)",
  "Shelf pizzas are on below: stop them first, so a slice is never counted twice.": "Aşağıda raf pizzaları açık: bir dilim asla iki kez sayılmasın diye önce onları durdurun.",
  "Ship": "Gönder",
  "Shipped": "Gönderildi",
  "Short shipped": "Eksik gönderim",
  "Short-shipped = billed but not delivered (the slip against your count in \"Receiving now\"). Price spike = billed more than {0}% above the PO price. Still to come = on the PO but not shipped and not billed: no claim.": "Eksik gönderilen = faturalandı ama teslim edilmedi (fiş, \"Şimdi teslim alınan\" sütunundaki sayımınızla karşılaştırılır). Ani fiyat artışı = fatura fiyatı PO fiyatını %{0} oranından fazla aşıyor. Henüz gelmeyen = PO'da var ama gönderilmedi ve faturalanmadı: talep oluşturulmaz.",
  "Short-shipped: {0}": "Eksik gönderilen: {0}",
  "Show all ({0})": "Tümünü göster ({0})",
  "show all items": "tüm kalemleri göster",
  "Show one quadrant": "Tek bir bölgeyi göster",
  "Show the detail chart": "Ayrıntılı grafiği göster",
  "Show the lines": "Satırları göster",
  "Show the numbers": "Rakamları göster",
  "Showing {0} of {1}": "Gösterilen: {0}/{1}",
  "Showing {0} of {1}, the most food cost over the target first.": "Gösterilen: {0}/{1}; yemek maliyeti hedefi en çok aşanlar önce.",
  "Since {0} · last run {1} · the next run looks at {2}.": "Başlangıç: {0} · son çalışma: {1} · sonraki çalışma şunlara bakacak: {2}.",
  "Since-last-count ledger for": "Son sayımdan bu yana stok defteri:",
  "Single store selected — pick \"All stores\" to compare.": "Tek mağaza seçili — karşılaştırmak için \"Tüm mağazalar\" seçeneğini seçin.",
  "Size & Spec": "Boy & özellik",
  "Size, e.g. 14\"": "Boy, ör. 14\"",
  "Size…": "Boy…",
  "Sizes": "Boylar",
  "Skip": "Geç",
  "Skip to next uncounted item (or say 'skip' / 'geç')": "Sayılmamış sonraki kaleme geçer (ya da 'skip' / 'geç' deyin)",
  "SKU {0}": "SKU {0}",
  "Slice item": "Dilim kalemi",
  "Slice products on the menu (": "Menüdeki dilim ürünleri (",
  "Slices": "Dilimler",
  "Slices a pizza": "Pizza başına dilim",
  "Slices are counted as a share of a pizza (Slices, above): shelf pizzas cannot be on at the same time.": "Dilimler bir pizzanın payı olarak sayılıyor (yukarıda, Dilimler): raf pizzaları aynı anda açık olamaz.",
  "Slip / invoice # (needed for a credit claim)": "Fiş / fatura # (alacak talebi için gerekli)",
  "Slip or invoice number": "Fiş veya fatura numarası",
  "Slip Price": "Fiş fiyatı",
  "Slip Qty": "Fiş miktarı",
  "Slowest movers (no movement 30+d)": "En yavaş hareket edenler (30+ gündür hareketsiz)",
  "Sold ({0} d)": "Satılan ({0} gün)",
  "Sold, {0} days": "{0} günde satılan",
  "some items unpriced": "bazı kalemler fiyatsız",
  "Some of what it uses has no price yet": "Kullandıklarının bir kısmının henüz fiyatı yok",
  "Sort": "Sırala",
  "Sort: Food, packaging, cleaning": "Sırala: Yiyecek, ambalaj, temizlik",
  "Sort: Highest cost / unit": "Sırala: En yüksek birim maliyet",
  "Sort: Highest quantity": "Sırala: En yüksek miktar",
  "Sort: Highest stock first": "Sırala: Önce en yüksek stok",
  "Sort: Highest subtotal": "Sırala: En yüksek ara toplam",
  "Sort: Highest value first": "Sırala: Önce en yüksek değer",
  "Sort: Lowest stock first": "Sırala: Önce en düşük stok",
  "Sort: Most affected pizzas": "Sırala: En çok pizzayı etkileyen",
  "Sort: Most items": "Sırala: En çok kalem",
  "Sort: Name A→Z": "Sırala: Ad A→Z",
  "Sort: Product A→Z": "Sırala: Ürün A→Z",
  "Sort: Sales (qty out) ↓": "Sırala: Satış (çıkan miktar) ↓",
  "Sort: Size": "Sırala: Boy",
  "Sort: Variance magnitude ↑": "Sırala: Fark büyüklüğü ↑",
  "Sort: Variance magnitude ↓": "Sırala: Fark büyüklüğü ↓",
  "sorted by absolute variance": "mutlak farka göre sıralı",
  "Source on hand": "Kaynak mağazadaki stok",
  "Speak": "Konuş",
  "Spend Split": "Harcama dağılımı",
  "Spikes": "Ani artışlar",
  "Standard mixer batch: {0} kg · Enter portion counts cut today · Mix cost: {1}": "Standart mikser partisi: {0} kg · Bugün kesilen porsiyon sayılarını girin · Karışım maliyeti: {1}",
  "Standard Yield": "Standart verim",
  "Start with {0}": "{0} ile başla",
  "State": "Durum",
  "Step by step": "Adım adım",
  "Steps": "Adımlar",
  "Still missing after this list": "Bu listeden sonra hâlâ eksik olanlar",
  "Still stuck? Ask Connect": "Hâlâ takıldınız mı? Connect'e sorun",
  "Still to come: {0}": "Henüz gelmeyen: {0}",
  "stock": "stok",
  "Stock": "Stok",
  "STOCK": "STOK",
  "Stock *": "Stok *",
  "Stock base unit": "Stok temel birimi",
  "Stock effect": "Stoğa etkisi",
  "Stock Health": "Stok sağlığı",
  "Stock health heatmap": "Stok sağlığı ısı haritası",
  "Stock ledger": "Stok defteri",
  "Stock quantities use base units. Costs use the value recorded when logged, including applicable stock taxes. Missing historical costs are shown as unavailable.": "Stok miktarları temel birimle gösterilir. Maliyetler, kaydedildiği andaki değeri kullanır (geçerli stok vergileri dahil). Geçmişe ait eksik maliyetler mevcut değil olarak gösterilir.",
  "Stock quantity": "Stok miktarı",
  "stocks": "stok",
  "stocks with the largest non-sale outflow": "satış dışı çıkışı en büyük stoklar",
  "Stop counting shelf pizzas": "Raf pizzalarını saymayı bırak",
  "Stop counting slices this way": "Dilimleri bu şekilde saymayı bırak",
  "Stop voice walk": "Sesli sayımı durdur",
  "Store rollup": "Mağaza özeti",
  "Store time: {0}": "Mağaza saati: {0}",
  "Strict Budget Cap (fit within remaining weekly budget)": "Sıkı bütçe sınırı (kalan haftalık bütçeye sığdır)",
  "Strict budget cap not applied: {0}": "Sıkı bütçe sınırı uygulanmadı: {0}",
  "Sub-recipes like dough, sauces, and sausages.": "Hamur, soslar ve sucuklar gibi alt tarifler.",
  "Submit with this time": "Bu saatle gönder",
  "Submitting…": "Gönderiliyor…",
  "Suggested": "Önerilen",
  "Suggested Credit": "Önerilen alacak",
  "Suggested Driver Credit: {0}": "Önerilen şoför alacağı: {0}",
  "Suggested order": "Önerilen sipariş",
  "Suggested orders": "Önerilen siparişler",
  "Suggested qty": "Önerilen miktar",
  "SUPC {0}": "SUPC {0}",
  "Supplier": "Tedarikçi",
  "Sysco Order (SUPC)": "Sysco siparişi (SUPC)",
  "Sysco order message": "Sysco sipariş mesajı",
  "Sysco Order Summary (SUPC)": "Sysco sipariş özeti (SUPC)",
  "Take the tour": "Tanıtım turunu başlat",
  "Taken back or credited": "Geri alınan veya alacak yazılan",
  "takes the size's away": "boyun ambalajını kaldırır",
  "Tallest bar = best day": "En uzun çubuk = en iyi gün",
  "Tap a card to fix it": "Düzeltmek için bir karta dokunun",
  "target": "hedef",
  "Target Budget ({0})": "Hedef bütçe ({0})",
  "Target dough in kg": "Kg cinsinden hedef hamur",
  "Target:": "Hedef:",
  "Target: {0}% of sales": "Hedef: satışların %{0} kadarı",
  "The {0} before this: {1}": "Önceki {0}: {1}",
  "The balls need {0} kg of dough but {1} kg is the target. Check ball counts.": "Toplar için {0} kg hamur gerekiyor ama hedef {1} kg. Top sayılarını kontrol edin.",
  "The day it came in": "Geldiği gün",
  "The day the delivery came in": "Teslimatın geldiği gün",
  "The day the goods came in": "Malın geldiği gün",
  "The document could not be sent.": "Belge gönderilemedi.",
  "The Excel file": "Excel dosyası",
  "The file is read and never kept. Nothing changes until you apply.": "Dosya okunur, asla saklanmaz. Uygula düğmesine basana kadar hiçbir şey değişmez.",
  "The filled list": "Doldurulmuş liste",
  "The last time an order is taken for the next delivery. Purchasing shows it.": "Bir sonraki teslimat için siparişin alındığı son saat. Satın alma sayfası bunu gösterir.",
  "The master dough is the prep named Dough (else the first prep with flour in it). Head office creates it under Prep recipes, then sets its ball sizes and weights here.": "Ana hamur, adı Dough olan ara üründür (yoksa içinde un olan ilk ara ürün). Merkez ofis onu Ara ürün tariflerinde oluşturur, ardından top boylarını ve ağırlıklarını burada belirler.",
  "The menu has no pizza sizes.": "Menüde pizza boyu yok.",
  "The month's profit and loss": "Ayın kâr ve zararı",
  "The numbers on the invoice don’t add up. Check these against the paper before recording:": "Faturadaki rakamlar tutmuyor. Kaydetmeden önce bunları kâğıttakiyle karşılaştırın:",
  "The other copies did not sell in {0} days, so nothing is sent.": "Diğer kopyalar {0} gün içinde satılmadı; bu yüzden onlar için bir şey gönderilmez.",
  "The pizza a slice is cut from": "Dilimin kesildiği pizza",
  "The server runs it every few minutes; this only makes it run at once.": "Sunucu bunu birkaç dakikada bir çalıştırır; bu düğme yalnızca hemen çalışmasını sağlar.",
  "The steps, in plain words": "Adımlar, sade bir dille",
  "The suggested quantity covers the par plus what is used while the order is on its way (daily use × lead time), rounded up to whole packs.": "Önerilen miktar, par seviyesini ve sipariş yoldayken kullanılacak miktarı (günlük kullanım × teslim süresi) karşılar; tam pakete yukarı yuvarlanır.",
  "The time it came in": "Geldiği saat",
  "The time the delivery came in": "Teslimatın geldiği saat",
  "The time the goods came in": "Malın geldiği saat",
  "Theo Food Cost": "Teorik yemek maliyeti",
  "Theoretical": "Teorik",
  "Theoretical vs actual cost — variance shows where ingredients drained outside of recorded sales.": "Teorik ve gerçek maliyet — fark, malzemelerin kayıtlı satışlar dışında nereye gittiğini gösterir.",
  "These are not added to stock. Head office can add an item on the Stock list.": "Bunlar stoğa eklenmez. Merkez ofis, Stok listesine kalem ekleyebilir.",
  "These do not stop the list. Until they are filled in, the sales they touch are taken off the stock only in part, and food cost leaves them out.": "Bunlar listeyi durdurmaz. Doldurulana kadar etkiledikleri satışlar stoktan ancak kısmen düşer ve yemek maliyetine katılmaz.",
  "They earn well — show them off more.": "İyi kazandırıyorlar — onları daha çok öne çıkarın.",
  "Things to look at": "Bakılması gerekenler",
  "This is the order as suggested now; running Autopilot turns it into draft POs.": "Bu, şu an önerilen sipariştir; Autopilot çalıştırılınca taslak siparişlere dönüşür.",
  "This item has no price yet: set one on Inventory Items, or it comes with the next invoice.": "Bu kalemin henüz fiyatı yok: Stok listesinde bir fiyat girin ya da bir sonraki faturayla gelir.",
  "This order's food": "Bu siparişteki yiyecek",
  "This page has no guide yet": "Bu sayfanın henüz rehberi yok",
  "This page needs a single store.": "Bu sayfa tek bir mağaza gerektirir.",
  "This store only": "Yalnızca bu mağaza",
  "This week's food allowance: the last 7 days of sales × the {0} food cost target, minus the food delivered and the food still on order. Packaging and cleaning are shown apart, never against this budget.": "Bu haftanın yiyecek bütçesi: son 7 günün satışları × {0} yemek maliyeti hedefi, eksi gelen yiyecek ve hâlâ siparişte olan yiyecek. Ambalaj ve temizlik ayrı gösterilir, asla bu bütçeden düşülmez.",
  "to create one.": "düğmesiyle yeni bir fatura oluşturun.",
  "to draft new ones from the engine.": "sayfasında öneri motoruyla yenilerini taslak olarak hazırlayın.",
  "To order — a sale takes its ingredients": "Siparişte yapılır — satış, malzemelerini stoktan düşer",
  "to start tracking food cost % here: every sale then takes its ingredients off the stock.": "— böylece yemek maliyeti yüzdesi burada izlenmeye başlar ve her satış malzemelerini stoktan düşer.",
  "To the tills": "Kasalara",
  "today ({0} balls · {1} at current Dough Recipe cost).": "bugün için ({0} top · güncel Hamur tarifi maliyetiyle {1}).",
  "Today's expected demand": "Bugünkü beklenen talep",
  "Toggle audio readback using speech synthesis": "Konuşma sentezi ile sesli okumayı aç/kapat",
  "Top 10 least used": "En az kullanılan 10 malzeme",
  "Top 10 most used": "En çok kullanılan 10 malzeme",
  "Top 10 variance items": "Farkı en büyük 10 kalem",
  "Top Cost Movers vs {0}": "Maliyeti en çok değişenler ({0} ile karşılaştırma)",
  "Top movers (last 7d)": "En çok hareket edenler (son 7 gün)",
  "Topping": "Malzeme",
  "TOPPING RECIPE{0}": "MALZEME TARİFİ{0}",
  "Topping Recipes": "Malzeme tarifleri",
  "Total {0} · Avg {1}/day": "Toplam {0} · Ort. {1}/gün",
  "Total cost": "Toplam maliyet",
  "Total cost (CAD)": "Toplam maliyet (CAD)",
  "Total grams": "Toplam gram",
  "Total Outflow": "Toplam çıkış",
  "Total with tax:": "Vergi dahil toplam:",
  "Transfer #{0}: {1}": "Transfer #{0}: {1}",
  "Transfers": "Transferler",
  "Transfers matched slip quantities & prices into the receiving table below (quantities only where you have not counted yet) and creates pending vendor credit claims for driver shortages and price spikes. The delivery itself is recorded when you press Log delivery.": "Eşleşen fiş miktarlarını ve fiyatlarını aşağıdaki teslim alma tablosuna aktarır (miktarları yalnızca henüz saymadığınız satırlara) ve şoför eksikleri ile ani fiyat artışları için bekleyen tedarikçi alacak talepleri oluşturur. Teslimatın kendisi, Teslimatı kaydet düğmesine bastığınızda kaydedilir.",
  "Trend": "Eğilim",
  "Try again": "Tekrar dene",
  "Turns the order below into draft POs and a message for your rep. Nothing is sent from Connect.": "Aşağıdaki siparişi taslak siparişlere ve temsilciniz için bir mesaja dönüştürür. Connect'ten hiçbir şey gönderilmez.",
  "Type another amount": "Başka bir tutar yazın",
  "Type at least 2 chars (box, bag, liner, napkin, cup…)": "En az 2 karakter yazın (kutu, poşet, altlık, peçete, bardak…)",
  "Type at least 2 chars (stock or prep)…": "En az 2 karakter yazın (stok veya ara ürün)…",
  "Type at least 2 chars (stocks or preps)…": "En az 2 karakter yazın (stok veya ara ürün)…",
  "Type at least 2 letters": "En az 2 harf yazın",
  "unit": "birim",
  "Unit *": "Birim *",
  "Unit $ (this receive)": "Birim $ (bu teslim alma)",
  "Unit cost": "Birim maliyet",
  "Unit cost ($/{0})": "Birim maliyet ($/{0})",
  "Unit price": "Birim fiyatı",
  "Unit price (CAD) *": "Birim fiyatı (CAD) *",
  "Unit price *": "Birim fiyatı *",
  "Unknown base unit": "Bilinmeyen temel birim",
  "unknown unit": "bilinmeyen birim",
  "Unmatched: {0}": "Eşleşmeyen: {0}",
  "Unspecified (legacy)": "Belirtilmemiş (eski kayıt)",
  "Up next": "Sıradaki",
  "Update prices and thresholds from a CSV": "Fiyatları ve seviyeleri bir CSV dosyasından güncelle",
  "Upload it": "Yükleyin",
  "Usage / $1k": "Kullanım / $1k",
  "Usage vs Margin": "Kullanım ve marj",
  "Use current time": "Şimdiki saat",
  "Used ($)": "Kullanılan ($)",
  "used by a product recipe": "bir ürün tarifinde kullanılıyor",
  "Used in {0} recipe row(s)": "{0} tarif satırında kullanılıyor",
  "User": "Kullanıcı",
  "Users & access": "Kullanıcılar & erişim",
  "Users & Access": "Kullanıcılar & erişim",
  "Uses nothing": "Hiçbir şey kullanmaz",
  "Uses nothing — no stock is taken when it sells (gift cards, fees).": "Hiçbir şey kullanmaz — satıldığında stoktan bir şey düşmez (hediye kartları, ücretler).",
  "uses this product's whole recipe": "bu ürünün tarifinin tamamını kullanır",
  "Value": "Değer",
  "Value with PST": "PST dahil değer",
  "Variance": "Fark",
  "Variance %": "Fark %",
  "Variance →": "Fark →",
  "Variance per stock": "Stok bazında fark",
  "Variance report": "Fark raporu",
  "Variance trend (last 5 counts)": "Fark eğilimi (son 5 sayım)",
  "velocity": "kullanım hızı",
  "Vendor (no PO)": "Tedarikçi (PO yok)",
  "Vendor (optional)": "Tedarikçi (isteğe bağlı)",
  "Vendor *": "Tedarikçi *",
  "vendor changed": "tedarikçi değişti",
  "Vendor Credit Memos (Driver Shortages & Price Claims)": "Tedarikçi alacakları (şoför eksikleri ve fiyat talepleri)",
  "vendor notified": "tedarikçiye bildirildi",
  "Vendor pack size": "Tedarikçi paket boyu",
  "Vendor price movement per ingredient, from purchase deliveries — with the annual cost of the change.": "Alım teslimatlarından, malzeme bazında tedarikçi fiyat hareketi — değişikliğin yıllık maliyetiyle birlikte.",
  "Vendors are set by head office.": "Tedarikçileri merkez ofis belirler.",
  "Verify Delivery Slip vs. PO": "Teslimat fişini PO'ya göre kontrol et",
  "View 48h Matrix": "48 saatlik tabloyu görüntüle",
  "View all POs": "Tüm PO'ları görüntüle",
  "View day": "Görüntülenecek gün",
  "View formatted Sysco SUPC order summary": "Biçimlendirilmiş Sysco SUPC sipariş özetini görüntüle",
  "View products and recipes": "Ürünleri ve tarifleri görüntüle",
  "View saved day": "Kaydedilen günü görüntüle",
  "Vision AI Sysco Slip Check-In": "Vision AI ile Sysco fişi kontrolü",
  "Voice language": "Konuşma dili",
  "vs. the time before": "önceki döneme göre",
  "Walk-In Freezer Hands-Free Voice Counter": "Soğuk oda için eller serbest sesli sayım",
  "Waste Log": "Atık kaydı",
  "We could not load your numbers": "Rakamlarınız yüklenemedi",
  "Weekly Purchase Budget Guardrail": "Haftalık alım bütçesi göstergesi",
  "Weight (g)": "Ağırlık (g)",
  "Weight in grams": "Gram cinsinden ağırlık",
  "What a role may do in Inventory comes from its boxes under Inventory on the Roles page: View opens the pages, Edit lets the person count, receive, order and log waste, and Head office adds the recipes, the stock list and its prices, vendors, costs and variance. Which stores they see comes from their store links.": "Bir rolün Envanter bölümünde neler yapabileceği, Roller sayfasında Envanter altındaki kutularından gelir: Görüntüle sayfaları açar, Düzenle kişinin sayım yapmasını, teslim almasını, sipariş vermesini ve atık kaydetmesini sağlar; Merkez ofis ise tarifleri, stok listesini ve fiyatlarını, tedarikçileri, maliyetleri ve farkı ekler. Kişinin hangi mağazaları göreceği, mağaza bağlantılarından gelir.",
  "What each product uses, size by size. Sales take these ingredients off the stock by themselves.": "Her ürünün boy boy kullandıkları. Satışlar bu malzemeleri stoktan kendiliğinden düşer.",
  "What each topping uses, size by size: a regular portion, and light or extra when the order says so.": "Her malzemenin boy boy kullandıkları: normal bir porsiyon; sipariş istediğinde de az ya da fazla.",
  "What food costs you": "Yemeğin size maliyeti",
  "What it changes": "Neler değişecek",
  "What sells more, what sells less": "Ne daha çok satıyor, ne daha az",
  "What shelf pizzas used is in this size's demand": "Raf pizzalarının kullandığı, bu boyun talebine dahildir",
  "What the vendor charges a unit, before tax (the price you edit)": "Tedarikçinin bir birim için istediği fiyat, vergi hariç (düzenlediğiniz fiyat)",
  "What to fix": "Düzeltilmesi gereken",
  "What to show": "Gösterilecek kayıtlar",
  "What was bought in these days (the deliveries recorded), by each item's group on Inventory Items. \"% of sales\" is of all sales, Uber, DoorDash and Skip included.": "Bu günlerde satın alınanlar (kaydedilen teslimatlar), her kalemin Stok listesindeki grubuna göre. Satış yüzdesi tüm satışlar üzerinden hesaplanır; Uber, DoorDash ve Skip dahil.",
  "When": "Zaman",
  "When a size's food cost goes over the {0}% target, Inventory works out the lowest price that brings it back to the target or under, keeping the cents the price ends in ($18.99 becomes $x.99). It looks at sizes sold in the last {1} days whose cost is complete. No price changes until an administrator approves it in Approvals. {2}": "Bir boyun yemek maliyeti %{0} hedefini aştığında Envanter, onu yeniden hedefe ya da altına indiren en düşük fiyatı hesaplar; fiyatın bittiği sentleri korur ($18.99, $x.99 olur). Son {1} günde satılan ve maliyeti eksiksiz olan boylara bakar. Bir yönetici Onaylar sayfasında onaylayana kadar hiçbir fiyat değişmez. {2}",
  "When on-hand drops below this, the stock is flagged \"Low\" and Suggested Orders triggers.": "Eldeki miktar bunun altına düşünce stok \"Düşük\" olarak işaretlenir ve Önerilen siparişler devreye girer.",
  "Where": "Nerede",
  "Where it comes from": "Nereden geldiği",
  "where the actual outflow went": "gerçek çıkışın nereye gittiği",
  "Where you want stock to refill TO. Used by Suggested Orders to compute reorder qty.": "Stoğun hangi seviyeye kadar tamamlanmasını istediğiniz. Önerilen siparişler, yeniden sipariş miktarını hesaplarken bunu kullanır.",
  "Which boxes, bags, and liners get consumed per product × size.": "Ürün × boy başına hangi kutu, poşet ve altlıkların kullanıldığı.",
  "Which ingredients drive your menu — usage frequency × margin contribution": "Menünüzü hangi malzemeler taşıyor — kullanım sıklığı × marj katkısı",
  "Who can act in this brand, with which role, in which stores. People, roles and store links are Connect's own: they are changed on the Users and Roles pages.": "Bu markada kimin, hangi rolle, hangi mağazalarda işlem yapabileceği. Kişiler, roller ve mağaza bağlantıları Connect'e aittir: Kullanıcılar ve Roller sayfalarında değiştirilir.",
  "Who changed what, when — for stock movements and for access and admin changes.": "Kim neyi ne zaman değiştirdi — stok hareketleri ile erişim ve yönetim değişiklikleri için.",
  "Who you buy from. Items are linked to a vendor in Inventory Items.": "Alım yaptığınız firmalar. Kalemler, Stok listesinde bir tedarikçiye bağlanır.",
  "Whose recipe": "Kimin tarifi",
  "Why — running out before the delivery, event prep…": "Neden — teslimattan önce bitiyor, etkinlik hazırlığı…",
  "Window": "Dönem",
  "Window avg": "Dönem ortalaması",
  "With entered qty ({0})": "Miktar girilenler ({0})",
  "Worked out from that product's own recipe when saved": "Kaydedilirken o ürünün kendi tarifinden hesaplanır",
  "Yield": "Verim",
  "Yield %": "Verim %",
  "Yield %: how much ends up on the plate (100 unless trimmed or lost)": "Verim %: tabağa ne kadarının ulaştığı (ayıklanmadıkça ya da fire vermedikçe 100)",
  "Yield in kg": "Kg cinsinden verim",
  "Yield unit": "Verim birimi",
  "Yields": "Verim",
  "you": "siz",
  "Your best-selling menu items by how many sold and what each earns": "En çok satan menü ürünleriniz: satış adedine ve her birinin kazandırdığına göre",
  "Your menu items": "Menü ürünleriniz",
  "Your role can view the roster but not change access.": "Rolünüz ekip listesini görebilir ama erişimi değiştiremez.",
  "Your winners · {0}": "Kazananlarınız · {0}",
  "Δ %": "Δ %",
  "Δ $": "Δ $",
  // Inventory and Monthly report text built in JavaScript (the 11-04 go), translated by the panel TR/EN session.
  "— no match —": "— eşleşme yok —",
  ", or edit the brand-wide": ", ya da marka geneli için düzenleyin:",
  "; with PST {0}": "; PST dahil {0}",
  "· {0} shown": "· {0} gösteriliyor",
  "· {0} typed": "· {0} yazıldı",
  "· actual {0}": "· gerçek {0}",
  "· No matching ingredients": "· Eşleşen kalem yok",
  "· Pack: {0} {1} / case": "· Paket: {0} {1} / koli",
  "“{0}” can’t be made smaller on this device. Take the photo with the camera button instead.": "“{0}” bu cihazda küçültülemiyor. Bunun yerine fotoğrafı kamera düğmesiyle çekin.",
  "“{0}” is not a photo or a PDF.": "“{0}” bir fotoğraf ya da PDF değil.",
  "“{0}” is too detailed to send. Take it a little closer, with only the page in the picture.": "“{0}” gönderilemeyecek kadar ayrıntılı. Biraz daha yakından, karede yalnızca sayfa olacak şekilde çekin.",
  "\"Can change\" lets them count, receive, order and log waste. \"Can see\" only opens the pages. \"Head office\" adds the recipes, the stock list and its prices, vendors, costs and variance. It all comes from their role's permissions.": "\"Değiştirebilir\" kişinin sayım yapmasını, teslim almasını, sipariş vermesini ve atık kaydetmesini sağlar. \"Görebilir\" yalnızca sayfaları açar. \"Merkez ofis\" ise tarifleri, stok listesini ve fiyatlarını, tedarikçileri, maliyetleri ve farkı ekler. Hepsi kişinin rolündeki yetkilerden gelir.",
  "\"Every store\" means they are linked to every open store of the brand. Otherwise the stores they are linked to are listed.": "\"Tüm mağazalar\", kişinin markanın açık olan tüm mağazalarına bağlı olduğu anlamına gelir. Aksi halde bağlı olduğu mağazalar listelenir.",
  "\"How this page works\" explains the page in a few steps. You can take this tour again from here too.": "\"Bu sayfa nasıl çalışır\" sayfayı birkaç adımda anlatır. Bu turu da buradan yeniden başlatabilirsiniz.",
  "\"Still missing after this list\" shows what is not filled in yet. It does not stop the list; those sales are taken off the stock only in part until it is filled in.": "\"Bu listeden sonra hâlâ eksik olanlar\" henüz doldurulmamış olanları gösterir. Listeyi durdurmaz; eksikler doldurulana kadar o satışlar stoktan ancak kısmen düşülür.",
  "({0} balls · {1})": "({0} top · {1})",
  "({0} kg)": "({0} kg)",
  "({0} months)": "({0} ay)",
  "(default)": "(varsayılan)",
  "(filed as {0})": "({0} adına)",
  "(master batch yield {0} kg).": "(ana parti verimi {0} kg).",
  "(no conversion)": "(dönüşüm yok)",
  "{0} — enter the counted qty ({1}).": "{0} — saydığınız miktarı girin ({1}).",
  "{0} — fill in the form below.": "{0} — aşağıdaki formu doldurun.",
  "{0} — sold {1} · earns {2} on each": "{0} — {1} adet satıldı · her biri {2} kazandırıyor",
  "{0} — type the amount in the sheet below.": "{0} — miktarı aşağıdaki listeye yazın.",
  "{0} · {1} products · {2} avg margin": "{0} · {1} ürün · ort. marj {2}",
  "{0} · 1 product · {1} avg margin": "{0} · 1 ürün · ort. marj {1}",
  "{0} · qty {1} · {2}/unit": "{0} · adet {1} · {2}/birim",
  "{0} · target {1}": "{0} · hedef {1}",
  "{0} {1} pts vs prior": "{0} {1} puan önceki döneme göre",
  "{0} {1} vs prior": "{0} {1} önceki döneme göre",
  "{0} {1}% vs prior": "{0} %{1} önceki döneme göre",
  "{0} / ball": "{0} / top",
  "{0} / batch": "{0} / parti",
  "{0} active dough batches": "{0} aktif hamur partisi",
  "{0} active stocks": "{0} aktif stok",
  "{0} already logged (#{1})": "{0} talep zaten kayıtlı (#{1})",
  "{0} already waiting": "{0} öneri zaten bekliyor",
  "{0} amount in {1}": "{1} cinsinden {0} miktarı",
  "{0} balls ready · {1} prep runs (7d)": "{0} top hazır · {1} ara ürün partisi (7 gün)",
  "{0} d": "{0} gün",
  "{0} d cover": "{0} günlük stok",
  "{0} days of counting": "{0} günlük sayım",
  "{0} deliveries have no price, so the real spend is higher.": "{0} teslimatın fiyatı yok; bu yüzden gerçek harcama daha yüksek.",
  "{0} food · {1} packaging · {2} cleaning": "{0} yiyecek · {1} ambalaj · {2} temizlik",
  "{0} g portioned": "{0} g porsiyonlandı",
  "{0} h ago": "{0} sa önce",
  "{0} half & half containers": "{0} yarım yarım ürün",
  "{0} in {1} days": "son {1} günde {0}",
  "{0} invoices were recorded in Inventory for {1}.": "{1} için Envantere {0} fatura kaydedildi.",
  "{0} is not among this store's food ingredients.": "{0}, bu mağazanın yiyecek kalemleri arasında yok.",
  "{0} is not on this count sheet.": "{0} bu sayım listesinde yok.",
  "{0} item(s) without a price": "fiyatı olmayan {0} kalem",
  "{0} items filled in below": "Aşağıda {0} kalem dolduruldu",
  "{0} line(s) exceed the remaining qty. Log anyway?": "{0} satır kalan miktarı aşıyor. Yine de kaydedilsin mi?",
  "{0} line(s) with no cost": "Maliyeti olmayan {0} satır",
  "{0} lines (packaging)": "{0} satır (ambalaj)",
  "{0} lines need you": "{0} satır sizi bekliyor",
  "{0} lines on order have no price, so Open is more than it shows.": "Siparişteki {0} satırın fiyatı yok; bu yüzden Açık tutarı gösterilenden fazla.",
  "{0} not sent again (not approved before)": "{0} öneri yeniden gönderilmedi (daha önce onaylanmamıştı)",
  "{0} of {1} in {2}": "{2}: {0}/{1}",
  "{0} of {1} sizes": "{0}/{1} boy",
  "{0} of {1} steps done": "{0}/{1} adım tamamlandı",
  "{0} of {1} with a complete recipe": "Tarifi tamamlanmış: {0}/{1}",
  "{0} of 1 size": "{0}/1 boy",
  "{0} of sales": "satışların {0} kadarı",
  "{0} of sales · target {1}": "satışların {0} kadarı · hedef {1}",
  "{0} of them are urgent.": "Bunların {0} tanesi acil.",
  "{0} OK, {1} low, {2} out": "{0} yeterli, {1} düşük, {2} tükendi",
  "{0} on hand": "Mevcut {0}",
  "{0} on hand of a par of {1}": "Mevcut {0} / par {1}",
  "{0} pages": "{0} sayfa",
  "{0} people · {1} hours": "{0} kişi · {1} saat",
  "{0} photos": "{0} fotoğraf",
  "{0} price drift alert(s)": "{0} fiyat kayması uyarısı",
  "{0} price drift alert(s) raised": "{0} fiyat kayması uyarısı oluştu",
  "{0} price drift alert(s).": "{0} fiyat kayması uyarısı.",
  "{0} products": "{0} ürün",
  "{0} products only on closed menus": "yalnızca kapalı menülerde olan {0} ürün",
  "{0} raised by themselves": "{0} zam kendiliğinden yapıldı",
  "{0} read": "{0} okundu",
  "{0} replaced by newer ones": "{0} öneri yenileriyle değiştirildi",
  "{0} retired sizes": "{0} kullanımdan kalkmış boy",
  "{0} sent to Approvals": "{0} öneri onaya gönderildi",
  "{0} sizes are over the {1}% target": "{0} boy %{1} hedefinin üzerinde",
  "{0} slice": "{0} dilim",
  "{0} slice products use it.": "{0} dilim ürünü bunu kullanıyor.",
  "{0} slices": "{0} dilim",
  "{0} suppliers": "{0} tedarikçi",
  "{0} taken back (not needed any more)": "{0} öneri geri alındı (artık gerekmiyor)",
  "{0} target levels updated": "{0} hedef seviye güncellendi",
  "{0} test products": "{0} test ürünü",
  "{0} updated with the new count (#{1})": "{0} talep yeni sayımla güncellendi (#{1})",
  "{0} waiting": "{0} bekliyor",
  "{0} withdrawn, nothing left to claim (#{1})": "{0} talep geri çekildi, talep edilecek bir şey kalmadı (#{1})",
  "{0}, line {1}": "{0}, satır {1}",
  "{0}, whose recipe is not complete yet": "{0}, tarifi henüz tamamlanmamış",
  "{0}/{1} of {2} {3}": "{0}/{1} {2} {3}",
  "{0}% of order lines took stock off by their recipes": "Sipariş satırlarının %{0} kadarında stok, tariflerine göre düşüldü",
  "{0}% of sales": "Satışların %{0} kadarı",
  "{0}% of theoretical": "Teorik maliyetin %{0} kadarı",
  "{0}d avg": "Ort. {0} gün",
  "{0}m ago": "{0} dk önce",
  "{0}s ago": "{0} sn önce",
  "* Some of what it uses has no price yet, so it costs more than shown.": "* Kullandıklarının bir kısmının henüz fiyatı yok; bu yüzden maliyeti gösterilenden fazla.",
  "← Lower popularity — Higher popularity →": "← Daha az popüler — Daha popüler →",
  "← Sells less · sells more →": "← Daha az satıyor · daha çok satıyor →",
  "← Used in fewer — Used in more →": "← Daha az üründe — Daha çok üründe →",
  "↑ Avg margin per product ($)": "↑ Ürün başına ort. marj ($)",
  "↑ Earns more · ↓ Earns less ($ on each)": "↑ Daha çok kazandırıyor · ↓ Daha az kazandırıyor (adet başına $)",
  "↑ Margin per unit ($)": "↑ Birim başına marj ($)",
  "+ {0} Uber, DoorDash and Skip": "+ Uber, DoorDash ve Skip üzerinden {0}",
  "+ {0}, worked out when saved": "+ {0}, kaydedilirken hesaplanır",
  "+ the product(s) it uses, worked out when saved": "+ kullandığı ürün(ler), kaydedilirken hesaplanır",
  "+{0} Over": "+{0} fazla",
  "+{0} row(s) uncosted": "+{0} maliyetsiz satır",
  "+{0}% Spike": "+%{0} ani artış",
  "+10% or worse vs previous buy": "+%10 veya üzeri, önceki alıma göre",
  "${0} / unit": "${0} / birim",
  "0 balls cut": "0 top kesildi",
  "1 active dough batch": "1 aktif hamur partisi",
  "1 case = {0} {1}": "1 koli = {0} {1}",
  "1 delivery has no price, so the real spend is higher.": "1 teslimatın fiyatı yok; bu yüzden gerçek harcama daha yüksek.",
  "1 half & half container": "1 yarım yarım ürün",
  "1 invoice was recorded in Inventory for {0}.": "{0} için Envantere 1 fatura kaydedildi.",
  "1 item filled in below": "Aşağıda 1 kalem dolduruldu",
  "1 line (packaging)": "1 satır (ambalaj)",
  "1 line on order has no price, so Open is more than it shows.": "Siparişteki 1 satırın fiyatı yok; bu yüzden Açık tutarı gösterilenden fazla.",
  "1 pack = {0} {1}": "1 paket = {0} {1}",
  "1 product": "1 ürün",
  "1 product only on closed menus": "yalnızca kapalı menülerde olan 1 ürün",
  "1 retired size": "1 kullanımdan kalkmış boy",
  "1 size is over the {0}% target": "1 boy %{0} hedefinin üzerinde",
  "1 slice product use it.": "1 dilim ürünü bunu kullanıyor.",
  "1 supplier": "1 tedarikçi",
  "1 test product": "1 test ürünü",
  "1-Click Sysco Autopilot makes the drafts and a message for your rep in one go. Nothing is sent from Connect: copy the message to your rep.": "Tek tıkla Sysco Autopilot, taslakları ve temsilciniz için bir mesajı tek seferde hazırlar. Connect'ten hiçbir şey gönderilmez: mesajı kopyalayıp temsilcinize iletin.",
  "14-day usage of {0}": "{0} için 14 günlük kullanım",
  "48h cold-ferment demand & prep forecast": "48 saatlik soğuk fermantasyon talebi ve hazırlık tahmini",
  "99+ d": "99+ gün",
  "A blank cell of an item keeps what Connect has. For a recipe, the list is the recipe: a topping's size left blank has no amount.": "Bir kalemin boş hücresi Connect'teki değeri korur. Tariflerde ise liste tarifin kendisidir: bir malzemenin boş bırakılan boyunda miktar yoktur.",
  "A cancelled order marked notified had already been sent: call the vendor so they do not ship it.": "İptal edilen bir sipariş bildirildi olarak işaretliyse zaten gönderilmiştir: sevk etmemeleri için tedarikçiyi arayın.",
  "A credit claim needs the slip or invoice number, so one delivery's claim is never mixed up with another's.": "Alacak talebi için fiş ya da fatura numarası gerekir; böylece bir teslimatın talebi asla başka bir teslimatınkiyle karışmaz.",
  "A dough batch's cost is locked from the Dough Recipe at the moment it is logged.": "Bir hamur partisinin maliyeti, kaydedildiği anda Hamur tarifinden sabitlenir.",
  "A line with no price is marked “some items unpriced”: check that price before trusting the cost.": "Fiyatı olmayan bir satır “bazı kalemler fiyatsız” olarak işaretlenir: maliyete güvenmeden önce o fiyatı kontrol edin.",
  "A little over your goal. Watch portion sizes and waste.": "Hedefinizin biraz üzerinde. Porsiyon boyutlarına ve atığa dikkat edin.",
  "A new count in Counting becomes the next baseline.": "Sayım sayfasında yapılan yeni bir sayım, bir sonraki başlangıç değeri olur.",
  "A photo or PDF of the bill. I read the charges before tax, and you check them.": "Faturanın fotoğrafı veya PDF'i. Vergi öncesi tutarları ben okurum, siz kontrol edersiniz.",
  "A photo or PDF of the invoice or bill. I read it and you check it.": "Faturanın fotoğrafı veya PDF'i. Ben okurum, siz kontrol edersiniz.",
  "A photo or PDF of the statement. I read the amount, and you check it.": "Ekstrenin fotoğrafı veya PDF'i. Tutarı ben okurum, siz kontrol edersiniz.",
  "A prep used in a recipe cannot be deleted; take it out of those recipes first.": "Bir tarifte kullanılan ara ürün silinemez; önce onu o tariflerden çıkarın.",
  "A product rule for the same item replaces the size's quantity. A quantity of 0 takes the size's item away for that product.": "Aynı kalem için bir ürün kuralı, boyun miktarının yerine geçer. 0 miktarı, o ürün için boyun kalemini kaldırır.",
  "A product that uses nothing has no other lines. Remove the {0} line(s) here?": "Hiçbir şey kullanmayan bir ürünün başka satırı olmaz. Buradaki {0} satır kaldırılsın mı?",
  "A reason is always needed; it tells head office why food was lost.": "Bir neden seçmek her zaman zorunludur; bu, merkez ofise yiyeceğin niçin kaybedildiğini anlatır.",
  "a share of {0} {1}": "bir {0} {1} payı",
  "a share of a pizza": "bir pizzanın payı",
  "A slice uses {0}, not the {1} size's lines; its toppings are in that share.": "Bir dilim için {1} boyunun satırları değil, {0} kullanılır; malzemeleri bu payın içindedir.",
  "A spike is a rise of 10% or more on the previous purchase.": "Ani artış, önceki alıma göre %10 ya da daha fazla bir yükseliştir.",
  "A topping on one half of a pizza uses half its amount; an extra topping uses its extra amount.": "Pizzanın yarısına konan bir malzeme, miktarının yarısını kullanır; ekstra malzeme ise ekstra miktarını kullanır.",
  "A transfer can be cancelled while it is requested or approved. You are asked why.": "Bir transfer, istenmiş ya da onaylanmış durumdayken iptal edilebilir. Size nedeni sorulur.",
  "about {0} days of delivery wait": "yaklaşık {0} günlük teslim süresi",
  "About 15 seconds a page. Keep this page open.": "Sayfa başına yaklaşık 15 saniye. Bu sayfayı açık tutun.",
  "About the same as before.": "Öncekiyle hemen hemen aynı.",
  "Accept it when it arrives so both stores show the right stock.": "Geldiğinde kabul edin; böylece iki mağaza da doğru stoğu gösterir.",
  "Accept the delivery": "Teslimatı kabul et",
  "Ack failed": "Görüldü olarak işaretlenemedi",
  "Ack it when you are on it": "İlgilenmeye başlayınca Gördüm'e basın",
  "Ack says you have seen it. It moves from Open to Acked, so the rest of the team knows someone is on it.": "Gördüm, uyarıyı gördüğünüzü bildirir. Uyarı Açık'tan Görüldü'ye geçer; böylece ekibin geri kalanı birinin ilgilendiğini bilir.",
  "acked": "görüldü",
  "acked {0}": "görüldü: {0}",
  "active": "aktif",
  "Actual minus theoretical, also as a % of theoretical. Over 1% either way is shown amber, over 5% red.": "Gerçek eksi teorik; teorik değerin yüzdesi olarak da gösterilir. İki yönde de %1'in üzerindeki fark sarı, %5'in üzerindeki kırmızı gösterilir.",
  "Add a line": "Bir satır ekle",
  "Add an invoice": "Fatura ekle",
  "Add an item": "Kalem ekle",
  "Add another": "Bir tane daha ekle",
  "Add another {0}": "Bir {0} daha ekle",
  "Add another line": "Bir satır daha ekle",
  "Add it": "Bunu ekle",
  "Add it to the list": "Listeye ekle",
  "Add its ingredients": "Kalemlerini ekleyin",
  "Add more {0}": "Daha fazla {0} ekle",
  "Add or edit a vendor (head office)": "Tedarikçi ekleyin ya da düzenleyin (merkez ofis)",
  "Add product rules where needed": "Gerektiğinde ürün kuralları ekleyin",
  "Add rules so each product × size consumes the right boxes, bags, and liners when an order drops.": "Bir sipariş geldiğinde her ürün × boyun doğru kutu, poşet ve altlıkları kullanması için kural ekleyin.",
  "Add Stock records goods that arrived without an invoice or a PO. The price starts at the last vendor price; change it if you paid something else.": "Stok ekle, faturası ya da PO'su olmadan gelen malları kaydeder. Fiyat, tedarikçinin son fiyatından başlar; başka bir fiyat ödediyseniz değiştirin.",
  "Add stock that came without paperwork": "Evraksız gelen stoğu ekleyin",
  "Add the companies you buy from; Sysco is added with the catalogue.": "Alım yaptığınız firmaları ekleyin; Sysco, katalogla birlikte eklenir.",
  "Add the ingredient, then the regular amount, the light and extra amounts when they differ, the unit and the yield %. The cost of a regular portion shows as you type.": "Kalemi ekleyin; ardından normal miktarı, farklıysa az ve ekstra miktarları, birimi ve verim yüzdesini girin. Normal bir porsiyonun maliyeti siz yazdıkça görünür.",
  "Add the ingredients": "Kalemleri ekleyin",
  "Add them": "Hepsini ekle",
  "Add these {0} lines": "Bu {0} satırı ekle",
  "Add to the next order": "Sonraki siparişe ekle",
  "Added below": "Aşağıya eklendi",
  "Added.": "Eklendi.",
  "Adjustment": "Düzeltme",
  "After a change on the Users or Roles page, press Refresh to see it here.": "Kullanıcılar ya da Roller sayfasında bir değişiklik yaptıktan sonra burada görmek için Yenile'ye basın.",
  "alert status::open": "Açık",
  "alerts": "uyarı",
  "Alerts are the warnings Inventory raises for this store: an item running low or out, a supplier price that moved, a count that is late. Most come from a check that runs about once a day; a price that moved on a delivery is flagged when the delivery is recorded.": "Uyarılar, Envanterin bu mağaza için bildirdiği sorunlardır: azalan ya da tükenen bir kalem, değişen bir tedarikçi fiyatı, geciken bir sayım. Çoğu, günde yaklaşık bir kez çalışan bir kontrolden gelir; bir teslimatta değişen fiyat ise teslimat kaydedilirken işaretlenir.",
  "Alerts belong to one store: pick the store at the top to see its list.": "Uyarılar tek bir mağazaya aittir: listesini görmek için üstten mağazayı seçin.",
  "All ({0})": "Tümü ({0})",
  "All {0} matching ingredients are selected.": "Eşleşen {0} kalemin tümü seçildi.",
  "All {0} on this page are selected.": "Bu sayfadaki {0} kalemin tümü seçildi.",
  "All clear. Worker re-scans every 24h.": "Her şey yolunda. Sistem her 24 saatte bir yeniden tarar.",
  "All costs": "Tüm maliyetler",
  "All items in count sheet completed!": "Sayım listesindeki tüm kalemler tamamlandı!",
  "All Stores supports products and recipe previews in Products in Menu.": "Tüm mağazalar seçiliyken Menüdeki ürünler sayfasında ürünleri ve tarif önizlemelerini görebilirsiniz.",
  "All stores within normal portion range": "Tüm mağazalar normal porsiyon aralığında",
  "all tracked outflows": "izlenen tüm çıkışlar",
  "Allow the microphone for this site to talk with the assistant.": "Asistanla konuşmak için bu siteye mikrofon izni verin.",
  "Allowed spend is your goal share of sales. Deliveries recorded and orders still open count against it; packaging and cleaning are shown beside it.": "İzin verilen harcama, satışlardan hedeflediğiniz paydır. Kaydedilen teslimatlar ve hâlâ açık olan siparişler bundan düşülür; ambalaj ve temizlik yanında ayrıca gösterilir.",
  "already in recipe": "zaten tarifte",
  "An invoice for a purchase order shows as prices only in the list.": "Bir satın alma siparişine ait fatura, listede yalnızca fiyat olarak görünür.",
  "An order line without a recipe, or with an ingredient that has no price, is left out of Food Cost %; it is never counted as free food.": "Tarifi olmayan ya da fiyatı olmayan bir kalem içeren sipariş satırı, Yemek maliyeti yüzdesine katılmaz; asla bedava yemek sayılmaz.",
  "and {0} more": "ve {0} tane daha",
  "Annual impact is what the latest price adds (or saves) over a year, at the quantity you bought in the window.": "Yıllık etki, son fiyatın bir yılda eklediği (ya da kazandırdığı) tutardır; dönem içinde aldığınız miktar üzerinden hesaplanır.",
  "Answer the question about orders": "Siparişle ilgili soruyu yanıtlayın",
  "Answer the request": "Talebi yanıtla",
  "Applied": "Uygulandı",
  "Applied {0} line(s) to PO · {1} credit claim(s) recorded": "{0} satır PO'ya uygulandı · {1} alacak talebi kaydedildi",
  "Applied: {0} item(s), {1} prep(s), {2} recipe(s) and {3} vendor(s) written.": "Uygulandı: {0} kalem, {1} ara ürün, {2} tarif ve {3} tedarikçi yazıldı.",
  "Apply {0} update(s)": "{0} güncellemeyi uygula",
  "Apply & log claims": "Uygula ve talepleri kaydet",
  "Apply & withdraw": "Uygula ve geri çek",
  "Apply Quantities to PO & Log Driver Credits": "Miktarları PO'ya uygula ve şoför alacaklarını kaydet",
  "Apply the list? {0} item(s), {1} prep(s) and {2} recipe(s) change. Everything is saved together; it cannot be undone from this page.": "Liste uygulansın mı? {0} kalem, {1} ara ürün ve {2} tarif değişecek. Her şey birlikte kaydedilir; bu sayfadan geri alınamaz.",
  "Apply to selected": "Seçilenlere uygula",
  "Applying {0}/{1}…": "Uygulanıyor {0}/{1}…",
  "Applying & logging…": "Uygulanıyor ve kaydediliyor…",
  "Approved prices go to the tills by themselves.": "Onaylanan fiyatlar kasalara kendiliğinden gider.",
  "Apr": "Nis",
  "as typed, not saved yet": "yazıldığı gibi, henüz kaydedilmedi",
  "Ask another store": "Başka bir mağazadan isteyin",
  "ask the assistant to sync {0} to the tills (the person who undid it, or an administrator, can).": "asistandan {0} için kasalarla eşitleme isteyin (bunu geri alan kişi ya da bir yönetici yapabilir).",
  "At the tills": "Kasalarda",
  "At the tills, then undone": "Kasalarda, sonra geri alındı",
  "Aug": "Ağu",
  "Autopilot draft failed": "Autopilot taslağı oluşturulamadı",
  "Autopilot made {0} draft POs. Check them, then send.": "Autopilot {0} taslak sipariş oluşturdu. Kontrol edin, sonra gönderin.",
  "Autopilot made 1 draft PO. Check them, then send.": "Autopilot 1 taslak sipariş oluşturdu. Kontrol edin, sonra gönderin.",
  "Avg {0} {1}/day over 14 days": "Son 14 günde ortalama {0} {1}/gün",
  "Bag": "Poşet",
  "Baker's percentage against the flour": "Una göre fırıncı yüzdesi",
  "ball": "top",
  "Ball": "Top",
  "Ball size added.": "Top boyu eklendi.",
  "Ball weights saved": "Top ağırlıkları kaydedildi",
  "Balls of {0}": "{0} top sayısı",
  "Base {0}": "Taban maliyet {0}",
  "Base cost incomplete": "Taban maliyet eksik",
  "Base cost is {0}% of the sale price": "Taban maliyet, satış fiyatının %{0} kadarı",
  "Base cost is what one sold uses at today's prices, with PST and without GST. Head office also sees it as a share of the sale price.": "Taban maliyet, satılan bir adedin bugünkü fiyatlarla kullandıklarının tutarıdır; PST dahil, GST hariç. Merkez ofis bunu satış fiyatına oranla da görür.",
  "Base cost unavailable": "Taban maliyet hesaplanamıyor",
  "Base recipe missing": "Temel tarif eksik",
  "Base unit": "Temel birim",
  "base units": "temel birim",
  "Baseline is what the last count found, with its date under the item. An item never counted adds up every movement it has had.": "Başlangıç, son sayımın bulduğu miktardır; tarihi kalemin altında yazar. Hiç sayılmamış bir kalem için o güne kadarki tüm hareketleri toplanır.",
  "Batch logging failed": "Parti kaydedilemedi",
  "Being changed": "Değiştiriliyor",
  "Best sellers come first, so the recipes that move the most stock get done first. Tick Needs a recipe to see only what is still missing.": "En çok satanlar önce gelir; böylece stoğu en çok hareket ettiren tarifler önce tamamlanır. Yalnızca hâlâ eksik olanları görmek için Tarif gerekiyor kutusunu işaretleyin.",
  "bill": "fatura",
  "Bottle": "Şişe",
  "Box": "Kutu",
  "box is coming from another store": "kutu başka bir mağazadan geliyor",
  "boxes are coming from other stores": "kutu başka mağazalardan geliyor",
  "Brand items keep the name, unit, price, vendor, codes, taxes and pack sizes head office set; the levels are this store's.": "Marka kalemlerinde ad, birim, fiyat, tedarikçi, kodlar, vergiler ve paket boyları merkez ofisin belirlediği gibi kalır; seviyeler bu mağazaya aittir.",
  "By movement type splits the actual by where it went. Top 10 variance items lists the stock items with the most leaving outside of sales.": "Hareket türüne göre bölümü, gerçek çıkışı gittiği yere göre ayırır. Farkı en büyük 10 kalem listesi, satış dışında en çok çıkışı olan stok kalemlerini gösterir.",
  "By product sets one product in one size, or in every size: press Add rule, pick the product, the size, then the items.": "Ürüne göre, tek bir ürünü tek bir boyda ya da her boyda ayarlar: Kural ekle'ye basın, ürünü ve boyu, ardından kalemleri seçin.",
  "By size sets what every pizza of a size uses — usually its box. Press Add size rule, pick the size, then add the packaging items and how many of each.": "Boya göre, bir boydaki her pizzanın ne kullandığını belirler — genellikle kutusunu. Boy kuralı ekle'ye basın, boyu seçin, ardından ambalaj kalemlerini ve her birinden kaç tane gerektiğini ekleyin.",
  "Can": "Teneke",
  "Can change": "Değiştirebilir",
  "Can see": "Görebilir",
  "Cancel failed": "İptal edilemedi",
  "Cancel if plans change": "Plan değişirse iptal et",
  "Cancel line": "Satırı iptal et",
  "Cancel line for {0}?": "{0} satırı iptal edilsin mi?",
  "Cancel reason? (optional)": "İptal nedeni? (isteğe bağlı)",
  "Cancel this transfer — why?": "Bu transferi iptal ediyorsunuz — neden?",
  "Cancel transfer": "Transferi iptal et",
  "Cart Exceeds Budget": "Sipariş bütçeyi aşıyor",
  "Case": "Koli",
  "Case price": "Koli fiyatı",
  "Case size": "Koli büyüklüğü",
  "Cash after loans and equipment": "Kredi ve ekipman sonrası nakit",
  "Cash left after them": "Bunlardan sonra kalan nakit",
  "Category": "Kategori",
  "Cells with a drop-down in the file offer the values that are allowed.": "Dosyada açılır listesi olan hücreler, izin verilen değerleri sunar.",
  "Change {0}": "Değiştir: {0}",
  "Change a price": "Fiyat değiştir",
  "Change access in Connect": "Erişimi Connect'te değiştir",
  "Change the packs ordered on a line and save it with the tick, or cancel a line you do not need. A cancelled line can be ordered again.": "Bir satırdaki paket sayısını değiştirip onay işaretiyle kaydedin ya da ihtiyacınız olmayan satırı iptal edin. İptal edilen satır yeniden sipariş edilebilir.",
  "changed": "değişen",
  "Check every line": "Her satırı kontrol et",
  "Check how it is doing": "Durumunu kontrol et",
  "Check in a delivery": "Gelen siparişi teslim al",
  "Check in what a supplier delivered against its purchase order, and keep track of what the vendor owes you back.": "Tedarikçinin getirdiklerini satın alma siparişiyle karşılaştırarak teslim alın ve tedarikçinin size geri ödemesi gerekenleri takip edin.",
  "Check Last variance": "Son farkı kontrol et",
  "Check the cost": "Maliyeti kontrol et",
  "Check the draft": "Taslağı kontrol et",
  "Check the slip (optional)": "Fişi kontrol et (isteğe bağlı)",
  "Check the suggestions": "Önerileri kontrol et",
  "Check their stores": "Mağazalarını kontrol et",
  "Check what is filled in": "Doldurulanları kontrol edin",
  "Checked: the {0} sizes that sold in these days.": "Kontrol edilenler: bu günlerde satılan {0} boy.",
  "Checking took too long. Try again in a moment.": "Kontrol çok uzun sürdü. Birazdan tekrar deneyin.",
  "Chemicals": "Kimyasallar",
  "Choose 30 days up to a year, how big a change to show, and this store or all your stores.": "30 gün ile bir yıl arasında bir dönem, gösterilecek değişimin büyüklüğünü ve bu mağazayı ya da tüm mağazalarınızı seçin.",
  "Choose a photo or a PDF.": "Bir fotoğraf ya da PDF seçin.",
  "Choose a reason.": "Bir neden seçin.",
  "Choose how it is made": "Nasıl yapılacağını seç",
  "Choose ingredient for {0}": "{0} için kalem seç",
  "Choose one store to add stock": "Stok eklemek için tek bir mağaza seçin",
  "Choose the size": "Boyu seç",
  "Choose the unit and enter the quantity.": "Birimi seçin ve miktarı girin.",
  "Choose the unit for {0}.": "{0} için birimi seçin.",
  "Choose what to look at": "Görüntülenecek listeyi seç",
  "Cleaning": "Temizlik",
  "Clear selection": "Seçimi temizle",
  "Clear the search or pick another group.": "Aramayı temizleyin ya da başka bir grup seçin.",
  "Click a price to type a new one, then press Enter. Prices are before tax.": "Yeni bir fiyat yazmak için fiyata tıklayın, ardından Enter'a basın. Fiyatlar vergi hariçtir.",
  "Click a row to see every purchase of that item in the window, with its invoice, vendor and price.": "O kalemin bu dönemdeki tüm alımlarını faturası, tedarikçisi ve fiyatıyla görmek için bir satıra tıklayın.",
  "Click a row to see its lines. On a draft you change quantities and send it; on a sent order you record what came in.": "Siparişin satırlarını görmek için bir satıra tıklayın. Taslakta miktarları değiştirip siparişi gönderirsiniz; gönderilmiş bir siparişte ise gelenleri kaydedersiniz.",
  "Click a store under By store to see every item with its on hand, par, reorder point, status and suggested order.": "Tüm kalemleri mevcut miktarı, par seviyesi, yeniden sipariş noktası, durumu ve önerilen siparişiyle görmek için Mağazaya göre altında bir mağazaya tıklayın.",
  "Close this PO with current received qty? Remaining lines will be cancelled.": "Bu PO şu ana kadar teslim alınan miktarlarla kapatılsın mı? Kalan satırlar iptal edilecek.",
  "Close-early failed": "Erken kapatılamadı",
  "closed": "kapandı",
  "closed early": "erken kapatıldı",
  "COGS Variance compares what your sales should have used, by their recipes, with everything that actually left the stock, in dollars. The difference is food that went somewhere other than a sale.": "COGS farkı, satışlarınızın tariflerine göre kullanması gerekeni stoktan gerçekten çıkan her şeyle dolar cinsinden karşılaştırır. Aradaki fark, satış dışında bir yere giden yiyecektir.",
  "Collapse panel": "Paneli daralt",
  "Compare stores": "Mağazaları karşılaştır",
  "Configure flour, hydration & ball weights": "Un, hidrasyon ve top ağırlıklarını ayarla",
  "Connect could not answer just now. Try again in a moment.": "Connect şu anda yanıt veremedi. Birazdan tekrar deneyin.",
  "Connect never e-mails a vendor: the orders e-mail is kept here for you.": "Connect tedarikçiye asla e-posta göndermez: sipariş e-posta adresi burada sizin için saklanır.",
  "Connect: {0} · {1}": "Connect: {0} · {1}",
  "Connect's sales, the invoices recorded in Inventory, your stock counts and last month's bills come in by themselves. A green box is filled in: check it and press Looks right.": "Connect'in satışları, Envantere kaydedilen faturalar, stok sayımlarınız ve geçen ayın faturaları kendiliğinden gelir. Yeşil kutu doldurulmuş demektir: kontrol edin ve Doğru görünüyor düğmesine basın.",
  "Continue": "Devam et",
  "Copied to clipboard!": "Kopyalandı!",
  "Corrected by the store": "Mağaza düzeltti",
  "Cost group": "Maliyet grubu",
  "Cost of food and paper": "Yemek ve kâğıt maliyeti",
  "Cost-bucket (Food / Packaging / Cleaning / ...) is derived from the name and the Sysco category; head office can set it by hand in the item.": "Maliyet grubu (Yiyecek / Ambalaj / Temizlik / ...) addan ve Sysco kategorisinden çıkarılır; merkez ofis bunu kalemin içinden elle belirleyebilir.",
  "Cost: today's recipe for one, with its default toppings. Price: {0}": "Maliyet: bir adet için bugünkü tarif, varsayılan malzemeleriyle. Fiyat: {0}",
  "Could not check the menu prices.": "Menü fiyatları kontrol edilemedi.",
  "Could not match food ingredient from: “{0}”. Please search by name.": "“{0}” ifadesiyle eşleşen bir yiyecek malzemesi bulunamadı. Lütfen adıyla arayın.",
  "Could not parse item: “{0}”": "Kalem anlaşılamadı: “{0}”",
  "Could not read that": "Bu anlaşılamadı",
  "Could not read the file.": "Dosya okunamadı.",
  "Could not save the new price.": "Yeni fiyat kaydedilemedi.",
  "Couldn't add the ball size.": "Top boyu eklenemedi.",
  "Couldn't create drafts": "Taslaklar oluşturulamadı",
  "Couldn't load credit memos": "Alacaklar yüklenemedi",
  "Couldn't load ingredient for editing.": "Düzenlenecek kalem yüklenemedi.",
  "Couldn't load open POs": "Açık siparişler yüklenemedi",
  "Couldn't load PO": "PO yüklenemedi",
  "Couldn't load recent receipts": "Son teslim almalar yüklenemedi",
  "Couldn't load this prep.": "Bu ara ürün yüklenemedi.",
  "Couldn't log the claim": "Talep kaydedilemedi",
  "Couldn't mark it credited": "Ödendi olarak işaretlenemedi",
  "Couldn't save the par.": "Par kaydedilemedi.",
  "Couldn't save the size map.": "Boy eşleştirmesi kaydedilemedi.",
  "Couldn't save the weight.": "Ağırlık kaydedilemedi.",
  "Count item by item": "Kalem kalem say",
  "count late": "geciken sayım",
  "Count what came in": "Gelen malları say",
  "Count your stock for the first time": "Stoğu ilk kez say",
  "Counted {0}": "{0} için sayılan miktar",
  "Counted {0} item(s).": "{0} kalem sayıldı.",
  "Counting often makes this page sharper: a count turns stock that went missing into a count correction.": "Sık sayım bu sayfayı daha isabetli yapar: sayım, kaybolan stoğu bir sayım düzeltmesine dönüştürür.",
  "Counts are per-store — pick the location you're counting.": "Sayımlar mağazaya özeldir — sayım yaptığınız mağazayı seçin.",
  "Counts, deliveries and waste belong to one store. Head office can also pick All stores to compare them.": "Sayımlar, teslimatlar ve atıklar tek bir mağazaya aittir. Merkez ofis, karşılaştırmak için Tüm mağazalar seçeneğini de seçebilir.",
  "Counts, deliveries, waste and sales all feed these numbers; nothing here is typed by hand.": "Bu rakamları sayımlar, teslimatlar, atıklar ve satışlar besler; burada hiçbir şey elle girilmez.",
  "Coverage is how many days the stock on hand lasts at the current use: red when it runs out before a delivery can come.": "Yeterlilik, eldeki stoğun mevcut kullanımla kaç gün yeteceğidir: bir teslimat gelmeden bitecekse kırmızıdır.",
  "covered by its size and its toppings": "boyu ve malzemeleri karşılıyor",
  "Covered by the size: every {0} product uses {1}.": "Boy karşılıyor: {0} boyundaki her ürün {1} kullanır.",
  "Create drafts ({0})": "Taslak oluştur ({0})",
  "Create drafts turns the suggestions into draft purchase orders, one per vendor. Open a draft to check it before you send it.": "Taslak oluştur düğmesi, önerileri her tedarikçiye bir tane olmak üzere taslak satın alma siparişlerine dönüştürür. Göndermeden önce taslağı açıp kontrol edin.",
  "Create invoice": "Faturayı oluştur",
  "Create invoice adds the goods to stock. Deleting an invoice takes its stock back out.": "Faturayı oluştur düğmesi malları stoğa ekler. Bir fatura silinirse, eklediği stok geri düşülür.",
  "Create the prep": "Ara ürünü oluştur",
  "Create your first prep — dough, sauce, sausage — anything that shows up as an ingredient in multiple products.": "İlk ara ürününüzü oluşturun — hamur, sos, sosis — birden fazla üründe malzeme olarak geçen her şey.",
  "Credit claim logged": "Alacak talebi kaydedildi",
  "Credit memo #{0} marked as credited": "Alacak #{0} ödendi olarak işaretlendi",
  "critical": "kritik",
  "Critical": "Kritik",
  "Critical alerts are red; the others are warnings in amber.": "Kritik uyarılar kırmızı, diğerleri sarı renkte gösterilir.",
  "CSV import updates price and threshold columns on existing rows matched by SKU or name — it never creates or deletes ingredients.": "CSV içe aktarma, SKU'ya ya da ada göre eşleşen mevcut satırlarda fiyat ve eşik sütunlarını günceller — asla kalem oluşturmaz ya da silmez.",
  "Current is the baseline plus all of these: what the shelf should hold now, in the item's base unit.": "Güncel, başlangıca bunların hepsinin eklenmesiyle bulunur: rafta şu an olması gereken miktar, kalemin temel biriminde.",
  "Daily consumption value shows what was used each day of the last 14 days. In the heatmap every item has a row of days: darker means heavier use, and the pill says how many days the stock will last.": "Günlük tüketim değeri, son 14 günün her birinde kullanılanı gösterir. Isı haritasında her kalemin bir gün satırı vardır: koyu renk daha yoğun kullanım demektir; etiket de stoğun kaç gün yeteceğini gösterir.",
  "Daily consumption value, total {0}": "Günlük tüketim değeri, toplam {0}",
  "Daily use: {0} per day (avg, last 14d)": "Günlük kullanım: günde {0} (ort., son 14 gün)",
  "Daily use: {0} per day (from the last two counts)": "Günlük kullanım: günde {0} (son iki sayımdan)",
  "Damaged or dropped": "Hasarlı ya da yere düşmüş",
  "Day-to-day entries (counts, invoices, waste) are made in Inventory and feed this report, so nothing is typed twice.": "Günlük kayıtlar (sayımlar, faturalar, atık) Envanterde girilir ve bu rapora aktarılır; böylece hiçbir şey iki kez yazılmaz.",
  "Dec": "Ara",
  "Deducted when logged": "Kaydedilince stoktan düşüldü",
  "Delete \"{0}\"? It will disappear from lists. (Soft delete — DB row marked inactive.)": "\"{0}\" silinsin mi? Listelerden kaybolur. (Kalıcı silme değildir — veritabanındaki kayıt pasif olarak işaretlenir.)",
  "Delete failed.": "Silinemedi.",
  "Delete invoice {0}? Stock movements from this invoice will be reversed.": "{0} numaralı fatura silinsin mi? Bu faturadan gelen stok hareketleri geri alınacak.",
  "Delete prep \"{0}\"? This cannot be undone.": "\"{0}\" ara ürünü silinsin mi? Bu işlem geri alınamaz.",
  "Delivered {0}, on order {1}, this order {2} of {3}": "Gelen {0}, siparişte {1}, bu sipariş {2}; bütçe {3}",
  "Delivery-app fees estimate": "Teslimat uygulaması ücretleri tahmini",
  "demand from orders": "siparişlerden gelen talep",
  "demand from sales": "satışlardan gelen talep",
  "demand from sales and orders": "satışlardan ve siparişlerden gelen talep",
  "depleted": "tükendi",
  "deposits {0}": "depozito {0}",
  "Desserts": "Tatlılar",
  "Didn't catch that — say it again, or type it.": "Anlaşılamadı — tekrar söyleyin ya da yazın.",
  "Directly scaled from": "Doğrudan şu tariften ölçeklenir:",
  "disabled": "devre dışı",
  "Discard {0}": "{0} toplarını at",
  "Discard {0}×{1} from {2}?\n\nReason:": "{2} partisinden {0}×{1} atılsın mı?\n\nNeden:",
  "Discard failed": "Atılamadı",
  "Discard unsaved changes?": "Kaydedilmemiş değişikliklerden vazgeçilsin mi?",
  "Do these {0} things today": "Bugün bu {0} işi yapın",
  "Do these once, in this order. After that the numbers keep themselves up to date.": "Bunları bir kez, bu sırayla yapın. Sonrasında rakamlar kendiliğinden güncel kalır.",
  "Do this 1 thing today": "Bugün bu 1 işi yapın",
  "document": "belge",
  "Dogs": "Dogs",
  "Dough ball for {0}": "{0} için hamur topu",
  "Dough Management · {0}": "Hamur yönetimi · {0}",
  "Dough Management plans and records the dough in three connected stages: the recipe, how much to mix today, and what was mixed. Balls need 48 hours in the cooler before they are used, so the plan always looks two days ahead.": "Hamur yönetimi, hamuru birbirine bağlı üç aşamada planlar ve kaydeder: tarif, bugün ne kadar karılacağı ve ne karıldığı. Toplar kullanılmadan önce soğutucuda 48 saat bekler; bu yüzden plan her zaman iki gün ileriye bakar.",
  "Dough Management plans and records the store's dough: how much to mix today, and what was mixed. Head office sets the dough recipe and the ball sizes. Balls need 48 hours in the cooler before they are used, so the plan always looks two days ahead.": "Hamur yönetimi, mağazanın hamurunu planlar ve kaydeder: bugün ne kadar karılacağı ve ne karıldığı. Hamur tarifini ve top boylarını merkez ofis belirler. Toplar kullanılmadan önce soğutucuda 48 saat bekler; bu yüzden plan her zaman iki gün ileriye bakar.",
  "Dough Recipe (head office)": "Hamur tarifi (merkez ofis)",
  "Dough Recipe is configured at the brand level and drives all stores' cost and ferment forecasts.": "Hamur tarifi marka düzeyinde ayarlanır ve tüm mağazaların maliyet ve fermantasyon tahminlerine yön verir.",
  "Down {0} out of every 100 — worse than before.": "Yüzde {0} düştü — öncekinden daha kötü.",
  "draft": "taslak",
  "Draft shows the orders not sent yet. Sent and Partial are waiting for goods; Closed and Cancelled are finished.": "Taslak, henüz gönderilmemiş siparişleri gösterir. Gönderildi ve Kısmi, malları bekleyen siparişlerdir; Kapandı ve İptal edildi ise tamamlanmıştır.",
  "Drafting…": "Taslaklar oluşturuluyor…",
  "Drift compares the price you type with the order's estimate: amber from 5%, red from 15%.": "Sapma, yazdığınız fiyatı siparişteki tahminle karşılaştırır: %5'ten itibaren sarı, %15'ten itibaren kırmızı.",
  "Drift compares the unit cost with the order's estimate: amber from 5%, red from 15%.": "Sapma, birim maliyeti siparişteki tahminle karşılaştırır: %5'ten itibaren sarı, %15'ten itibaren kırmızı.",
  "Driver shortages and price spikes checked with Vision AI will appear here.": "Vision AI ile kontrol edilen şoför eksikleri ve ani fiyat artışları burada görünecek.",
  "Drop an invoice, a price list or a count sheet here, or just ask. It shows you what it read before anything is saved.": "Buraya bir fatura, fiyat listesi ya da sayım listesi bırakın veya sadece sorun. Hiçbir şey kaydedilmeden önce ne okuduğunu size gösterir.",
  "each": "adet",
  "Each card is one job for today, with how many items it is about. Tap a card to go straight to the page that fixes it.": "Her kart bugün için bir iştir ve kaç kalemle ilgili olduğunu gösterir. Sorunu çözen sayfaya doğrudan gitmek için bir karta dokunun.",
  "Each item's row shows how many sold, its average price, what it earns on each one and its margin %, with what to do about it.": "Her ürünün satırında satış adedi, ortalama fiyatı, her birinden kazandırdığı ve marj yüzdesi, ne yapılması gerektiğiyle birlikte yer alır.",
  "Each line says what was seen against the usual level (observed vs baseline) and when it was first and last seen. ×2 or more means it came back.": "Her satır, görüleni olağan düzeyle karşılaştırır (gözlenen / olağan seviye) ve ilk ve son ne zaman görüldüğünü söyler. ×2 veya fazlası, uyarının tekrar geldiği anlamına gelir.",
  "Each row is one Connect user of this brand, with their email and role.": "Her satır, bu markanın bir Connect kullanıcısını e-postası ve rolüyle gösterir.",
  "Each rule shows the item's unit price and the subtotal for the quantity. A dash means the packaging item has no price yet.": "Her kural, kalemin birim fiyatını ve miktarın ara toplamını gösterir. Tire (—), ambalaj kaleminin henüz fiyatı olmadığı anlamına gelir.",
  "Each shelf pizza makes {0} × {1}; {2}": "Her raf pizzası {0} × {1} çıkarır; {2}",
  "Each size shows its price and what one costs. The dots next to a product say how its sizes stand: green has a recipe, blue is covered by its size, red has none yet.": "Her boy, fiyatını ve bir adedinin maliyetini gösterir. Ürünün yanındaki noktalar boylarının durumunu gösterir: yeşil tarifi var, mavi boyu karşılıyor, kırmızı henüz tarifi yok.",
  "Each slice is 1/{0} of {1} {2}.": "Her dilim, {1} {2} pizzasının 1/{0} kadarıdır.",
  "Each vendor card lists the items at or below their reorder point, with the quantity to order in whole packs and what it should cost.": "Her tedarikçi kartı, yeniden sipariş noktasında ya da altında olan kalemleri, tam paket olarak sipariş edilecek miktar ve tahmini maliyetiyle listeler.",
  "early close": "erken kapatma",
  "Edit {0}": "Düzenle: {0}",
  "Edit base ingredients for {0} and size. Default options are listed separately below.": "Temel malzemeleri {0} ve boy için düzenleyin. Varsayılan seçenekler aşağıda ayrıca listelenir.",
  "Edit Master Recipe ingredient amounts directly below (batch yield {0} kg).": "Ana tarifin malzeme miktarlarını doğrudan aşağıda düzenleyin (parti verimi {0} kg).",
  "Edit prep": "Ara ürünü düzenle",
  "Electricity": "Elektrik",
  "Employer CPP and EI": "CPP ve EI işveren payı",
  "Employer CPP and EI estimate": "CPP ve EI işveren payı tahmini",
  "Enter and review the replacement quantity before saving.": "Kaydetmeden önce yerine geçecek miktarı girin ve kontrol edin.",
  "Enter recipes in Products in Menu.": "Menüdeki ürünler sayfasında tarifleri girin.",
  "Enter the amounts": "Miktarları gir",
  "Enter the quantity.": "Miktarı girin.",
  "Enter the regular amount of every line before saving.": "Kaydetmeden önce her satırın normal miktarını girin.",
  "Enter the slip or invoice number to log or withdraw a credit claim.": "Alacak talebi kaydetmek ya da geri çekmek için fiş veya fatura numarasını girin.",
  "Enter the slip or invoice number: a credit claim is kept under it, so another delivery's claim is never taken for this one.": "Fiş veya fatura numarasını girin: alacak talebi bu numarayla saklanır; böylece başka bir teslimatın talebi asla bununla karıştırılmaz.",
  "Entered by the store": "Mağaza girdi",
  "Equipment bought": "Alınan ekipman",
  "est. {0}": "tahmini {0}",
  "Est. $ is worked out from the last known prices; lines with no price yet are counted apart.": "Tahmini $, bilinen son fiyatlardan hesaplanır; henüz fiyatı olmayan satırlar ayrı sayılır.",
  "Est. batch cost:": "Tahmini parti maliyeti:",
  "Est. value is at the items' cost; a dash means a line has no price yet.": "Tahmini değer, kalemlerin maliyetiyle hesaplanır; tire (—), satırın henüz fiyatı olmadığı anlamına gelir.",
  "estimated": "tahmini",
  "Every {0} product also uses {1} (the size's own lines). A line here for the same item replaces it; 0 takes it away.": "{0} boyundaki her ürün ayrıca {1} kullanır (boyun kendi satırları). Burada aynı kalem için girilen satır onun yerine geçer; 0 onu kaldırır.",
  "Every accepted order line takes its recipe's ingredients off the stock by itself. The card at the top shows when that last ran; head office can make it run at once with Run now.": "Kabul edilen her sipariş satırı, tarifindeki malzemeleri stoktan kendiliğinden düşer. Üstteki kart bunun en son ne zaman çalıştığını gösterir; merkez ofis Şimdi çalıştır düğmesiyle bunu hemen çalıştırabilir.",
  "Every answer is saved the moment you save it: you can stop and come back.": "Her yanıt, kaydettiğiniz anda saklanır: ara verip sonra kaldığınız yerden devam edebilirsiniz.",
  "Every line is in": "Tüm satırlar girildi",
  "Every purchase order of this store, by status: drafts to check and send, sent ones waiting for their goods, and the ones that are done.": "Bu mağazanın tüm satın alma siparişleri, durumlarına göre: kontrol edilip gönderilecek taslaklar, mallarını bekleyen gönderilmiş siparişler ve tamamlananlar.",
  "Every size fits all sizes; a size of its own replaces it on that size. A tick on a size means it already has amounts.": "Her boy seçeneği tüm boylara uyar; bir boyun kendi miktarları, o boyda onun yerine geçer. Bir boyda onay işareti varsa o boyun miktarları zaten girilmiştir.",
  "Every size sold is at or under the target": "Satılan her boy hedefte ya da hedefin altında",
  "Every size: used in each size that has no amounts of its own.": "Her boy: kendi miktarları olmayan her boyda kullanılır.",
  "Every step is done. Counts, deliveries and sales now keep the stock right by themselves.": "Tüm adımlar tamamlandı. Artık sayımlar, teslimatlar ve satışlar stoğu kendiliğinden doğru tutar.",
  "every store": "her mağaza",
  "EVERY STORE": "HER MAĞAZA",
  "every store's": "tüm mağazaların",
  "Every store's recipe is the usual one. When one store makes a product its own way, head office picks that store and saves its own recipe.": "Normalde geçerli olan, tüm mağazaların tarifidir. Bir mağaza bir ürünü kendi usulüyle yapıyorsa merkez ofis o mağazayı seçer ve ona özel tarifi kaydeder.",
  "Every store’s report for the month": "Her mağazanın aylık raporu",
  "Every vendor with its phone, e-mail, address, order cutoff and how many of your items it supplies.": "Tüm tedarikçiler; telefonu, e-postası, adresi, sipariş son saati ve kalemlerinizden kaçını sağladığıyla birlikte.",
  "Everything is answered · ready to finish": "Her şey yanıtlandı · bitirmeye hazır",
  "Everything that left the stock: sales, waste, count corrections, prep made and used, and changes made by hand.": "Stoktan çıkan her şey: satışlar, atıklar, sayım düzeltmeleri, yapılan ve kullanılan ara ürünler ve elle yapılan değişiklikler.",
  "Exact match": "Tam eşleşme",
  "Expand panel": "Paneli genişlet",
  "Export CSV saves every row of these dates and filters, on all pages, as a file you can open in Excel.": "CSV dışa aktar düğmesi, bu tarih ve filtrelere uyan tüm satırları, bütün sayfalardakiler dahil, Excel'de açabileceğiniz bir dosya olarak kaydeder.",
  "Failed to load waste": "Atıklar yüklenemedi",
  "Failed to log waste": "Atık kaydedilemedi",
  "Failed to save recipe: {0}": "Tarif kaydedilemedi: {0}",
  "Feb": "Şub",
  "Fees": "Ücretler",
  "Fewer": "Daha az",
  "Fewer than two stores have sales in these days, so the stores are compared by what they used, in dollars.": "Bu günlerde ikiden az mağazanın satışı var; bu yüzden mağazalar kullandıklarına göre, dolar cinsinden karşılaştırılıyor.",
  "Fill {0} receiving line(s) from the slip and log {1} credit claim(s) for {2}, and withdraw {3} open claim(s) this check no longer finds?": "Fişten {0} teslim alma satırı doldurulsun, toplam {2} tutarında {1} alacak talebi kaydedilsin ve bu kontrolün artık bulmadığı {3} açık talep geri çekilsin mi?",
  "Fill {0} receiving line(s) from the slip and log {1} credit claim(s) for {2}?": "Fişten {0} teslim alma satırı doldurulsun ve toplam {2} tutarında {1} alacak talebi kaydedilsin mi?",
  "Fill {0} receiving line(s) from the slip and withdraw {1} open claim(s) this check no longer finds?": "Fişten {0} teslim alma satırı doldurulsun ve bu kontrolün artık bulmadığı {1} açık talep geri çekilsin mi?",
  "Fill {0} receiving line(s) from the slip?": "Fişten {0} teslim alma satırı doldurulsun mu?",
  "Fill in the yellow boxes": "Sarı kutuları doldurun",
  "Fill it in": "Listeyi doldur",
  "Filled in by Connect": "Connect doldurdu",
  "Filter stocks and preps…": "Stokları ve ara ürünleri filtrele…",
  "Find an item": "Kalem bul",
  "Find an item fast": "Kalemi hızlıca bul",
  "Find any page by name": "Herhangi bir sayfayı adıyla bul",
  "Find the person": "Kişiyi bul",
  "Find the topping": "Malzemeyi bul",
  "Find where it went": "Nereye gittiğini bul",
  "Finish and download": "Bitirin ve indirin",
  "Finish the order": "Siparişi tamamla",
  "Finished · {0}": "Tamamlandı · {0}",
  "Finished · v{0}": "Tamamlandı · v{0}",
  "first {0}": "ilk görülme: {0}",
  "first buy": "ilk alım",
  "first count": "ilk sayım",
  "First numbers for this store — nothing to compare yet.": "Bu mağazanın ilk rakamları — henüz karşılaştırılacak bir şey yok.",
  "Fix what is missing": "Eksikleri tamamla",
  "Flagged above {0}% (your goal {1}% + 4).": "%{0} üzerindekiler işaretlenir (hedefiniz %{1} + 4).",
  "Flour {0} kg = 100%": "Un {0} kg = %100",
  "Focus on one group": "Tek bir gruba odaklan",
  "Follow the recommendation": "Öneriye uy",
  "Follow up the credits": "Alacakları takip et",
  "Follow what moved since": "O zamandan beri hareket edenleri izle",
  "Food": "Yiyecek",
  "Food and paper": "Yemek ve kâğıt",
  "Food and paper cost": "Yemek ve kâğıt maliyeti",
  "Food cost {0}% against a goal of {1}%": "Yemek maliyeti %{0}, hedef %{1}",
  "Food cost % by store, target {0}%": "Mağazaya göre yemek maliyeti yüzdesi, hedef %{0}",
  "Food delivered: {0}": "Gelen yiyecek: {0}",
  "Food on order: {0}": "Siparişte olan yiyecek: {0}",
  "Food, drinks and paper bought": "Alınan yiyecek, içecek ve kâğıt ürünleri",
  "For each ball size: the balls ready now (48 hours or older), the ones still curing, the expected demand (the same weekday over the last 8 weeks) and how many to mix today, in balls and kilograms.": "Her top boyu için: şu an hazır olan toplar (48 saatlik ya da daha eski), hâlâ dinlenmekte olanlar, beklenen talep (son 8 haftanın aynı günü) ve bugün ne kadar karılacağı, top ve kilogram olarak.",
  "for one sold": "satılan bir adet için",
  "franchise and delivery apps": "franchise ve teslimat uygulamaları",
  "From and To choose the days. The page opens on the last 14 days; press Apply after a change.": "Başlangıç ve Bitiş ile günleri seçin. Sayfa son 14 günle açılır; bir değişiklikten sonra Uygula'ya basın.",
  "from Connect": "Connect'ten",
  "From Connect": "Connect'ten",
  "From Inventory": "Envanterden",
  "from its recipe": "tarifinden",
  "From Royalty & fees": "Royalti ve ücretler sayfasından",
  "from the bill you scanned": "taradığınız faturadan",
  "from the recipe for every size": "her boy tarifinden",
  "from this store's last delivery": "bu mağazanın son teslimatından",
  "from your stock count": "stok sayımınızdan",
  "From your stock count": "Stok sayımınızdan",
  "fully received": "tamamen teslim alındı",
  "Gas": "Doğalgaz",
  "Getting it ready…": "Hazırlanıyor…",
  "Getting started": "Başlarken",
  "Getting the pages ready…": "Sayfalar hazırlanıyor…",
  "Give one product its own amount": "Bir ürüne kendi miktarını ver",
  "Gives every item a starting number. Everything after it is measured from this count.": "Her kaleme bir başlangıç sayısı verir. Sonrasındaki her şey bu sayıma göre ölçülür.",
  "Go to {0}": "{0} bölümüne git",
  "Good earners, few buyers": "İyi kazandıran, az satılanlar",
  "Gram": "Gram",
  "GST {0}": "GST {0}",
  "GST of line {0}": "{0}. satırın GST oranı",
  "Had movements since count keeps only the items that moved after their last count.": "Sayımdan beri hareket görenler seçeneği, yalnızca son sayımlarından sonra hareket gören kalemleri gösterir.",
  "half": "yarısı",
  "Half": "yarısı",
  "Head office adds the companies you buy from and keeps their details up to date. Sysco comes with the catalogue.": "Alım yaptığınız firmaları merkez ofis ekler ve bilgilerini güncel tutar. Sysco, katalogla birlikte gelir.",
  "Head office adds the vendors.": "Tedarikçileri merkez ofis ekler.",
  "Head office can pick All stores in the store picker to compare the stores side by side.": "Merkez ofis, mağazaları yan yana karşılaştırmak için mağaza seçicide Tüm mağazalar seçeneğini seçebilir.",
  "Head office searches a stock item, a prep or another product, then sets the amount, the unit and the yield %. A product built on another product of its size takes that product's whole recipe, and its dough ball and box only once.": "Merkez ofis bir stok kalemi, bir ara ürün ya da başka bir ürün arar; ardından miktarı, birimi ve verim yüzdesini girer. Aynı boydaki başka bir ürünün üzerine kurulan bir ürün, o ürünün tarifinin tamamını alır; hamur topunu ve kutusunu ise yalnızca bir kez alır.",
  "High service velocity": "Yüksek satış temposu",
  "High velocity": "Yoğun satış",
  "History only · stock unchanged": "Yalnızca geçmiş · stok değişmedi",
  "How {0} works": "{0} nasıl çalışır",
  "HST {0}": "HST {0}",
  "idle": "hareketsiz",
  "If an item was counted after the order was sent, you are asked when the delivery came in, so the count stays right.": "Sipariş gönderildikten sonra bir kalem sayıldıysa, sayım doğru kalsın diye teslimatın ne zaman geldiği sorulur.",
  "If an item was counted here after the transfer shipped, Receive asks when it came in, so it is never counted twice.": "Transfer gönderildikten sonra bir kalem burada sayıldıysa, Teslim al düğmesi malın ne zaman geldiğini sorar; böylece hiçbir şey iki kez sayılmaz.",
  "If an item was counted on the invoice's day, you are asked when the delivery came in, so the count stays right.": "Bir kalem fatura günü sayıldıysa, sayım doğru kalsın diye teslimatın ne zaman geldiği sorulur.",
  "If the item was counted after the goods came in, Add Stock asks when they came, so nothing is counted twice.": "Kalem, mal geldikten sonra sayıldıysa Stok ekle düğmesi malın ne zaman geldiğini sorar; böylece hiçbir şey iki kez sayılmaz.",
  "if the latest prices hold": "son fiyatlar böyle kalırsa",
  "If the vendor has an order waiting for these goods, you are asked whether the invoice is for it. For an order, the invoice prices what came and adds no stock twice; for none of them, its lines add their stock.": "Tedarikçinin bu mallar için bekleyen bir siparişi varsa, faturanın o sipariş için olup olmadığı sorulur. Bir sipariş içinse fatura gelen malları fiyatlandırır ve stoğu ikinci kez eklemez; hiçbiri için değilse satırları kendi stoklarını ekler.",
  "Import CSV updates prices and levels of items already on the list, matched by SKU, then by name. Export CSV saves the rows on screen.": "CSV içe aktar düğmesi, listede zaten bulunan kalemlerin fiyatlarını ve seviyelerini günceller; eşleştirme önce SKU'ya, sonra ada göre yapılır. CSV dışa aktar düğmesi, ekrandaki satırları dosya olarak indirir.",
  "Imported {0} of {1} row(s); {2} failed.": "{1} satırın {0} tanesi içe aktarıldı; {2} tanesi başarısız oldu.",
  "Imported {0} row(s).": "{0} satır içe aktarıldı.",
  "In progress": "Devam ediyor",
  "In the walk-in, start the voice counter: it reads each item out and fills in what you say, in English or Turkish. Nothing is saved by voice.": "Soğuk odada sesli sayımı başlatın: her kalemi sesli okur ve İngilizce ya da Türkçe söylediğiniz miktarı doldurur. Sesle hiçbir şey kaydedilmez.",
  "incl. PST": "PST dahil",
  "incl. PST, at this store's prices": "PST dahil, bu mağazanın fiyatlarıyla",
  "Ingredient added.": "Kalem eklendi.",
  "ingredient drains": "malzeme stoktan düşer",
  "ingredients": "kalem",
  "Ingredients are tracked per-store. Use the store picker at the top of the page to pick a single store; this page will refresh automatically.": "Kalemler mağaza bazında tutulur. Sayfanın üstündeki mağaza seçiciden tek bir mağaza seçin; bu sayfa otomatik olarak yenilenir.",
  "ingredients drain": "malzeme stoktan düşer",
  "Inventory error": "Envanter hatası",
  "Inventory value is what the stock on hand is worth. Health counts the items that are OK, low and out. Count freshness is how many days ago items were last counted, on average and at the oldest.": "Envanter değeri, mevcut stoğun ettiği tutardır. Sağlık göstergesi yeterli, düşük ve tükenmiş kalemleri sayar. Sayım güncelliği, kalemlerin en son kaç gün önce sayıldığını ortalama olarak ve en eskisi için gösterir.",
  "Invoice {0}": "Fatura {0}",
  "Invoices are tracked per-store.": "Faturalar mağaza bazında tutulur.",
  "It adds up: {0} = {1}": "Rakamlar tutuyor: {0} = {1}",
  "It comes filled with what Connect already has. Type only what is missing.": "Connect'te zaten olanlarla dolu gelir. Yalnızca eksik olanları yazın.",
  "It is written but the supplier has not seen it yet.": "Hazırlandı ama tedarikçi henüz görmedi.",
  "It uses {0} (its food, not the box). Lines saved here are added to that, such as the pop of a Pop Combo.": "Kullandığı: {0} (kutusu değil, yiyeceği). Burada kaydedilen satırlar buna eklenir; örneğin Pop Combo'daki içecek.",
  "It uses {0}, but that pizza's recipe is not complete yet: finish it on the pizza's own page. Lines saved here are only extras, such as the pop of a Pop Combo.": "Kullandığı: {0}; ancak o pizzanın tarifi henüz tamamlanmadı: tarifi pizzanın kendi sayfasında tamamlayın. Burada kaydedilen satırlar yalnızca ek satırlardır; örneğin Pop Combo'daki içecek.",
  "item {0}": "kalem {0}",
  "Item {0}": "Kalem {0}",
  "item has run out": "kalem tükendi",
  "item is running low": "kalem azalıyor",
  "item needs counting": "kalemin sayılması gerekiyor",
  "Item not saved": "Kalem kaydedilmedi",
  "Items are grouped as Food, Packaging, Cleaning and Other. Type the amount in the unit you count in, a case or the base unit; Enter jumps to the next item.": "Kalemler Yiyecek, Ambalaj, Temizlik ve Diğer olarak gruplanır. Miktarı saydığınız birimde (koli ya da temel birim) yazın; Enter sonraki kaleme geçer.",
  "items are running low": "kalem azalıyor",
  "Items below their reorder point with no vendor or pack size are listed at the bottom; set them on Inventory Items.": "Yeniden sipariş noktasının altında olup tedarikçisi ya da paket boyu olmayan kalemler en altta listelenir; bunları Stok listesinde ayarlayın.",
  "items have run out": "kalem tükendi",
  "items need counting": "kalemin sayılması gerekiyor",
  "Items without a par level are never suggested, unless Autopilot Mode is on.": "Autopilot modu açık değilse, par seviyesi olmayan kalemler asla önerilmez.",
  "Its own amounts": "Kendi miktarları",
  "Its pizza's recipe is not complete": "Pizzasının tarifi tamamlanmadı",
  "Jan": "Oca",
  "Jar": "Kavanoz",
  "Jul": "Tem",
  "Jun": "Haz",
  "just now": "az önce",
  "Keep": "Kalsın",
  "Keep a copy": "Bir kopya saklayın",
  "Keep buying inside the budget": "Alımları bütçe içinde tutun",
  "Keep PO": "PO kalsın",
  "Kilogram": "Kilogram",
  "Kubi's sections, one tap away": "Kubi'nin bölümleri bir dokunuş uzağınızda",
  "Labour": "İşçilik",
  "last {0}": "son görülme: {0}",
  "Last {0} days: {1} of {2} order lines took stock off by their recipes ({3}%).": "Son {0} gün: {2} sipariş satırının {1} tanesinde stok tarifine göre düşüldü (%{3}).",
  "last 30 days": "son 30 gün",
  "last 7 days": "son 7 gün",
  "Lead time: {0}d → expect to use {1} during transit": "Teslim süresi: {0} gün → yoldayken {1} kullanılması beklenir",
  "Leave the unit price empty when you do not know it: the estimate is never recorded as a price paid.": "Birim fiyatı bilmiyorsanız boş bırakın: tahmin asla ödenen fiyat olarak kaydedilmez.",
  "Less {0}": "{0} miktarını azalt",
  "Let Connect do the typing": "Yazma işini Connect'e bırakın",
  "Line {0}: fill in “{1}”.": "Satır {0}: “{1}” alanını doldurun.",
  "Line cancelled": "Satır iptal edildi",
  "line needs you": "satır sizi bekliyor",
  "Line saved ({0} {1} ordered)": "Satır kaydedildi ({0} {1} sipariş edildi)",
  "lines for every size": "her boy için satırlar",
  "lines need you": "satır sizi bekliyor",
  "Lines of transfer {0}": "{0} numaralı transferin satırları",
  "Link items to their vendor": "Kalemleri tedarikçilerine bağlayın",
  "Listening keeps failing (it needs the internet). You can use the quick-command box.": "Dinleme sürekli başarısız oluyor (internet bağlantısı gerekir). Hızlı komut kutusunu kullanabilirsiniz.",
  "Listening keeps failing. You can use the quick-command box.": "Dinleme sürekli başarısız oluyor. Hızlı komut kutusunu kullanabilirsiniz.",
  "Litre": "Litre",
  "Live COGS shows what food costs you as a share of sales, for today, this week or this month, and which items' food cost moved the most against the period before.": "Canlı COGS, yemeğin size maliyetini bugün, bu hafta ya da bu ay için satışların payı olarak gösterir; ayrıca yemek maliyeti önceki döneme göre en çok değişen kalemleri de gösterir.",
  "Load failed": "Yüklenemedi",
  "Loading {0} recipe…": "{0} mağazasının tarifi yükleniyor…",
  "Loading Dough Recipe…": "Hamur tarifi yükleniyor…",
  "Loading prep…": "Ara ürün yükleniyor…",
  "Loading recipe…": "Tarif yükleniyor…",
  "Loan and lease payments": "Kredi ve leasing ödemeleri",
  "Locked on {0}": "Sabitlenme: {0}",
  "Log a prep batch (a sauce, a sausage) on Log Production: its raw ingredients come off the stock by the recipe.": "Bir ara ürün partisini (bir sos, bir sucuk) Üretim kaydı bölümünde kaydedin: hammaddeleri tarife göre stoktan düşer.",
  "Log anyway": "Yine de kaydet",
  "Log delivery adds the goods to stock. Type the unit cost from the invoice when you have it; the order's estimate is never taken as the price paid.": "Teslimatı kaydet düğmesi malları stoğa ekler. Faturadaki birim maliyet elinizdeyse yazın; siparişteki tahmin asla ödenen fiyat olarak alınmaz.",
  "Log failed": "Kaydedilemedi",
  "Log it": "Kaydedin",
  "Log the delivery": "Teslimatı kaydedin",
  "Log waste saves the line. Waste after the latest count takes the stock off. Waste from before that count is kept as history only, because the count already saw it.": "Atığı kaydet düğmesi satırı kaydeder. Son sayımdan sonraki atık stoktan düşülür. O sayımdan önceki atık yalnızca geçmiş olarak tutulur, çünkü sayım onu zaten görmüştür.",
  "Logged {0} line(s)": "{0} satır kaydedildi",
  "Logged for {0}.": "{0} tarihine kaydedildi.",
  "Logging a dough mix or prep batch deducts raw ingredients from a specific store's inventory.": "Hamur karışımı ya da ara ürün partisi kaydetmek, hammaddeleri belirli bir mağazanın envanterinden düşer.",
  "Look after the menu": "Menüye göz kulak olun",
  "Looks right, save them": "Doğru görünüyor, kaydet",
  "Low ({0})": "Düşük ({0})",
  "low stock": "düşük stok",
  "Lowest price at your goal: {0}": "Hedefinizi tutturan en düşük fiyat: {0}",
  "Made to order: each sale takes the prep's ingredients. Made ahead: the prep is counted on the shelf and a sale takes the prep itself.": "Siparişte yapılır: her satış ara ürünün malzemelerini stoktan düşer. Önceden yapılır: ara ürün rafta sayılır ve satış ara ürünün kendisini düşer.",
  "Make the drafts": "Taslakları oluşturun",
  "Many at once from a file": "Dosyadan toplu güncelleme",
  "Mar": "Mar",
  "Margin % is green from 60%, amber from 40% and red below that.": "Marj yüzdesi %60 ve üzerinde yeşil, %40 ve üzerinde sarı, bunun altında kırmızıdır.",
  "Margin is the price minus what one costs in food: what its sales took off the stock, or else today's recipe. So it needs recipes in Products in Menu; items whose cost is not known yet are listed as Unpriced.": "Marj, fiyattan bir adedin yemek maliyeti çıkarılarak bulunur: bu maliyet, satışlarının stoktan düştüğü tutardır; o yoksa bugünkü tariftir. Bu yüzden Menüdeki ürünler sayfasında tarif gerekir; maliyeti henüz bilinmeyen ürünler Fiyatsız olarak listelenir.",
  "Mark memo #{0} ({1}) as credited? This can't be undone.": "Alacak #{0} ({1}) ödendi olarak işaretlensin mi? Bu işlem geri alınamaz.",
  "Matched: {0} — {1} Then tap Log waste.": "Eşleşti: {0} — {1} Sonra Atığı kaydet düğmesine dokunun.",
  "Matched: {0} — tap Log waste below to confirm": "Eşleşti: {0} — onaylamak için aşağıdaki Atığı kaydet düğmesine dokunun",
  "May": "May",
  "memos": "alacak",
  "menu change #{0}": "menü değişikliği #{0}",
  "Menu Engineering sorts what you sold by two things: how many sold, and what each one earns after its food cost (its margin). That shows what to keep, promote, re-price or take off the menu.": "Menü mühendisliği, sattıklarınızı iki şeye göre sıralar: kaç adet satıldığı ve her birinin yemek maliyetinden sonra ne kazandırdığı (marjı). Böylece neyi tutacağınızı, öne çıkaracağınızı, yeniden fiyatlandıracağınızı ya da menüden çıkaracağınızı görürsünüz.",
  "Mic permission denied. You can type into the voice box.": "Mikrofon izni verilmedi. Sesli giriş kutusuna yazabilirsiniz.",
  "Mic permission denied. You can use the quick-command box.": "Mikrofon izni verilmedi. Hızlı komut kutusunu kullanabilirsiniz.",
  "Millilitre": "Mililitre",
  "Mix today:": "Bugün karılacak:",
  "mixed": "karıldı",
  "Mixed at (Made at for a prep batch) logs it up to 48 hours late.": "Karılma zamanı (ara ürün partisinde Yapılış zamanı) ile kayıt 48 saate kadar geriye dönük girilebilir.",
  "Mixes, discards & prep batches": "Karışımlar, atılan toplar ve ara ürün partileri",
  "Money you took in is compared with the same number of days before. What food costs you is out of every $100 of sales, against your goal.": "Satıştan gelen para, önceki aynı sayıda günle karşılaştırılır. Yemeğin size maliyeti her $100'lık satış üzerinden gösterilir ve hedefinizle karşılaştırılır.",
  "More {0}": "{0} miktarını artır",
  "More than one food ingredient matches: {0}. Say more of the name, or search by name.": "Birden fazla yiyecek malzemesi eşleşiyor: {0}. Adın devamını da söyleyin ya da adına göre arayın.",
  "More than one item matches {0}: {1}. Say more of the name, or its SUPC.": "{0} ile birden fazla kalem eşleşiyor: {1}. Adın devamını ya da SUPC kodunu söyleyin.",
  "Move {0} (arrow keys)": "{0} satırını taşı (ok tuşları)",
  "MTD": "Bu ay",
  "Name, unit and a price of 0 or more are needed.": "Ad, birim ve 0 veya daha yüksek bir fiyat gerekli.",
  "Narrow it down": "Sonuçları daraltın",
  "Near budget limit: {0} remaining before hitting {1}% purchase cap.": "Bütçe sınırına yaklaşıldı: %{1} alım sınırına ulaşmadan önce {0} kaldı.",
  "need first count": "ilk sayım gerekiyor",
  "Network error — saved locally": "Ağ hatası — bu cihaza kaydedildi",
  "never": "hiçbir zaman",
  "new": "yeni",
  "new and changed orders": "yeni ve değişen siparişler",
  "new price": "yeni fiyat",
  "No {0} alerts": "“{0}” durumunda uyarı yok",
  "No {0} POs": "“{0}” durumunda PO yok",
  "No abnormal portion drift or consumption intensity detected across locations.": "Mağazalar genelinde olağan dışı porsiyon sapması ya da tüketim yoğunluğu saptanmadı.",
  "No accepted orders in the last {0} days.": "Son {0} günde kabul edilmiş sipariş yok.",
  "No access": "Erişim yok",
  "No amounts for every size yet.": "Henüz her boy için miktar yok.",
  "No amounts of its own: this size uses \"Every size\".": "Kendi miktarı yok: bu boy \"Her boy\" miktarlarını kullanır.",
  "No amounts yet": "Henüz miktar yok",
  "No baseline · all movements": "Başlangıç yok · tüm hareketler",
  "no change": "değişiklik yok",
  "No consumption in the last 14 days": "Son 14 günde tüketim yok",
  "no costs yet": "henüz maliyet yok",
  "No data rows found in the CSV.": "CSV'de veri satırı bulunamadı.",
  "No deliveries or open orders are recorded for these days yet.": "Bu günler için henüz kayıtlı teslimat ya da açık sipariş yok.",
  "No empty shelves, no waiting deliveries, no old counts. Keep it up.": "Boş raf yok, bekleyen teslimat yok, eski sayım yok. Böyle devam edin.",
  "No goal is set for food cost.": "Yemek maliyeti için bir hedef belirlenmemiş.",
  "No microphone was found. You can type into the voice box.": "Mikrofon bulunamadı. Sesli giriş kutusuna yazabilirsiniz.",
  "No microphone was found. You can use the quick-command box.": "Mikrofon bulunamadı. Hızlı komut kutusunu kullanabilirsiniz.",
  "No open line matches “{0}”": "“{0}” ile eşleşen açık satır yok",
  "No own amounts in this size: the product uses the topping's usual amounts.": "Bu boyda kendi miktarı yok: ürün, malzemenin olağan miktarlarını kullanır.",
  "No par": "Par yok",
  "No photo in this window": "Bu pencerede fotoğraf yok",
  "no price": "fiyat yok",
  "no price yet": "henüz fiyat yok",
  "No price yet": "Henüz fiyat yok",
  "No price yet — cost unknown.": "Henüz fiyat yok — maliyet bilinmiyor.",
  "no product uses it yet.": "henüz hiçbir ürün bunu kullanmıyor.",
  "No product's recipe uses the slice item yet: give \"Slice\" and the other slice products their recipes below.": "Henüz hiçbir ürünün tarifi dilim kalemini kullanmıyor: \"Slice\" ve diğer dilim ürünlerine tariflerini aşağıda verin.",
  "No recipe yet": "Henüz tarifi yok",
  "No recognised columns. Expected any of: {0}": "Tanınan sütun yok. Şunlardan biri bekleniyordu: {0}",
  "no sales history yet": "henüz satış geçmişi yok",
  "No sales in last 14 days — no consumption baseline.": "Son 14 günde satış yok — tüketim ortalaması hesaplanamıyor.",
  "No sales in the period before": "Önceki dönemde satış yok",
  "No sales to compare": "Karşılaştırılacak satış yok",
  "No sales with recipes yet, so we cannot work this out.": "Henüz tarifli satış yok, bu yüzden bunu hesaplayamıyoruz.",
  "No sales yet": "Henüz satış yok",
  "No signal in the walk-in? A submitted count waits on this device with the time you counted and sends itself when the connection is back.": "Soğuk odada sinyal yok mu? Gönderilen sayım, saydığınız saatle birlikte bu cihazda bekler ve bağlantı geri gelince kendiliğinden gönderilir.",
  "No single ingredient matches “{0}” — search by name instead.": "“{0}” ile eşleşen tek bir kalem yok — bunun yerine adına göre arayın.",
  "No suggested orders right now. Run a count sheet if you want to refresh the theoretical qty before the next reorder window.": "Şu anda önerilen sipariş yok. Bir sonraki sipariş döneminden önce teorik miktarı güncellemek isterseniz bir sayım yapın.",
  "no theoretical cost to compare": "karşılaştırılacak teorik maliyet yok",
  "Nobody has counted these in the last {0} days, so the numbers on screen may be wrong.": "Bunlar son {0} günde hiç sayılmadı, bu yüzden ekrandaki rakamlar yanlış olabilir.",
  "none yet": "henüz yok",
  "Normal pace": "Normal tempo",
  "Not delivered (-{0})": "Teslim edilmedi (-{0})",
  "Not every till yet": "Henüz tüm kasalarda değil",
  "Not for any of these POs": "Bu PO'ların hiçbiri için değil",
  "Not listed: {0} (they need no recipe of their own).": "Listelenmeyenler: {0} (bunların kendi tarifine gerek yok).",
  "not on a pizza size": "hiçbir pizza boyuna bağlı değil",
  "Not on Connect menu": "Connect menüsünde yok",
  "Not sent (off)": "Gönderilmedi (kapalı)",
  "Not sent by itself": "Kendiliğinden gönderilmedi",
  "not set": "ayarlanmadı",
  "Not set in Connect": "Connect'te ayarlanmadı",
  "Not set: {0} slice products on the menu use nothing yet.": "Ayarlanmadı: menüdeki {0} dilim ürünü henüz hiçbir şey kullanmıyor.",
  "Not set: 1 slice product on the menu use nothing yet.": "Ayarlanmadı: menüdeki 1 dilim ürünü henüz hiçbir şey kullanmıyor.",
  "Not set: shelf pizzas made in the last 30 days ({0}) take nothing off the stock yet.": "Ayarlanmadı: son 30 günde yapılan raf pizzaları ({0}) henüz stoktan hiçbir şey düşmüyor.",
  "Not set.": "Ayarlanmadı.",
  "not sold": "satılmadı",
  "Not working": "Tutmayanlar",
  "Note (optional), e.g. credited on the next invoice": "Not (isteğe bağlı), ör. bir sonraki faturada alacak olarak düşüldü",
  "Note for {0}": "{0} için not",
  "Nothing is saved by voice alone: check the form, then press Log waste.": "Yalnızca sesle hiçbir şey kaydedilmez: formu kontrol edin, sonra Atığı kaydet düğmesine basın.",
  "Nothing is waiting for you.": "Sizi bekleyen bir şey yok.",
  "Nothing is wrong with your stock — the screen just could not reach the server. Try again in a moment. If it keeps happening, tell support what time you tried.": "Stoğunuzda bir sorun yok — ekran yalnızca sunucuya ulaşamadı. Birazdan tekrar deneyin. Sorun sürerse destek ekibine hangi saatte denediğinizi söyleyin.",
  "Nothing needs you right now": "Şu an ilgilenmeniz gereken bir şey yok",
  "Nothing sold in these days, so the whole menu was checked ({0} sizes).": "Bu günlerde hiçbir şey satılmadı, bu yüzden tüm menü kontrol edildi ({0} boy).",
  "Nothing to apply: slip {0} has no open claim this check no longer finds, and no line to fill.": "Uygulanacak bir şey yok: {0} fişinde ne bu kontrolün artık bulmadığı açık bir talep ne de doldurulacak bir satır var.",
  "Nothing to compare yet": "Henüz karşılaştırılacak bir şey yok",
  "Nothing to mix today by the forecast — enter the balls you cut.": "Tahmine göre bugün karılacak hamur yok — kestiğiniz topları girin.",
  "Nothing to mix today by the forecast: one master batch is shown.": "Tahmine göre bugün karılacak hamur yok: bir ana parti gösteriliyor.",
  "Nothing to send: no size needs a new price.": "Gönderilecek bir şey yok: hiçbir boyun yeni fiyata ihtiyacı yok.",
  "Nothing urgent, but worth a look.": "Acil bir şey yok ama göz atmaya değer.",
  "Nothing was heard. Press Speak and say it again, or type it.": "Hiçbir şey duyulmadı. Konuş düğmesine basıp tekrar söyleyin ya da yazın.",
  "Nov": "Kas",
  "now: {0}": "şu an: {0}",
  "observed {0} vs baseline {1}": "gözlenen {0}, olağan seviye {1}",
  "Occurred on and At are the store's own time; Use current time fills in now. A time in the future is not allowed.": "Tarih ve Saat alanları mağazanın kendi saatine göredir; Şimdiki saat düğmesi şu anı doldurur. Gelecekteki bir saat girilemez.",
  "Oct": "Eki",
  "of every $100": "her $100'de",
  "OK ({0})": "Yeterli ({0})",
  "Oldest: {0}": "En eski: {0}",
  "On · Approvals": "Açık · Onaylar",
  "On · small raises by themselves": "Açık · küçük zamlar onaysız",
  "On hand covers {0} day(s)": "Mevcut stok {0} gün yeter",
  "On hand, its value, the last 14 days of use and Cover (how many days the stock lasts) sit on one line. Status turns Low, Critical or Out as it runs down.": "Mevcut miktar, değeri, son 14 günlük kullanım ve Yeterlilik (stoğun kaç gün yeteceği) tek satırda görünür. Stok azaldıkça Durum sütunu Düşük, Kritik ya da Tükendi olarak değişir.",
  "On Inventory Items, pick each item's vendor and pack size, so suggestions and orders know who to buy from.": "Stok listesinde her kalemin tedarikçisini ve paket boyunu seçin; böylece öneriler ve siparişler kimden alınacağını bilir.",
  "On their list your request is outgoing, with Approve and Ship. Shipping takes the goods off their stock and puts the transfer in transit.": "Onların listesinde talebiniz, Onayla ve Gönder düğmeleriyle birlikte giden olarak görünür. Gönderilince mallar onların stoğundan düşer ve transfer Yolda durumuna geçer.",
  "On this server approved prices are not sent to the tills by themselves.": "Bu sunucuda onaylanan fiyatlar kasalara kendiliğinden gönderilmez.",
  "On track": "Yolunda",
  "On your list it is incoming. Press Receive when the box is in; the goods are added to your stock.": "Sizin listenizde gelen olarak görünür. Koli geldiğinde Teslim al düğmesine basın; mallar stoğunuza eklenir.",
  "One line needs you": "Bir satır kontrolünüzü bekliyor",
  "One purchase order: its lines, what is still to come, and what to do with it next.": "Tek bir satın alma siparişi: satırları, hâlâ gelecek olanlar ve sırada onunla ne yapılacağı.",
  "one whole {0} {1}": "bütün bir {0} {1}",
  "Only a role with Head office changes the stock list, prices, recipes and vendors.": "Stok listesini, fiyatları, tarifleri ve tedarikçileri yalnızca Merkez ofis yetkisi olan bir rol değiştirebilir.",
  "Only dough and box set": "Yalnızca hamur ve kutu girildi",
  "Only food counts against the food cost goal; packaging and cleaning are shown beside it.": "Yemek maliyeti hedefine yalnızca yiyecek sayılır; ambalaj ve temizlik yanında ayrıca gösterilir.",
  "Only food ingredients are listed here. Packaging and supplies are left out.": "Burada yalnızca yiyecek malzemeleri listelenir. Ambalaj ve sarf malzemeleri dahil değildir.",
  "Only head office sees and changes the rules.": "Kuralları yalnızca merkez ofis görür ve değiştirir.",
  "only the size's dough and box": "yalnızca boyun hamuru ve kutusu",
  "Only the size's dough and box are set. Add this product's own lines, or amounts for its toppings in this size.": "Yalnızca boyun hamuru ve kutusu girildi. Bu ürünün kendi satırlarını ya da bu boydaki malzemelerinin miktarlarını ekleyin.",
  "Only what Connect cannot know waits for you: your staff with their hours and pay, bills like rent, electricity and gas, the delivery apps' fees, loans and leases.": "Yalnızca Connect'in bilemeyeceği şeyler sizi bekler: saatleri ve maaşlarıyla çalışanlarınız; kira, elektrik ve doğalgaz gibi faturalar; teslimat uygulamalarının ücretleri; kredi ve leasing ödemeleri.",
  "Open a store": "Bir mağaza açın",
  "Open an item by its name to set its par level (what you refill to), reorder point and safety stock. Tick several items to set them for all at once.": "Par seviyesini (stoğu tamamladığınız seviye), yeniden sipariş noktasını ve güvenlik stoğunu ayarlamak için kalemi adına tıklayarak açın. Birkaç kalemi işaretleyip hepsine birden ayarlayabilirsiniz.",
  "Open an order": "Bir sipariş açın",
  "Open Inventory Items": "Stok listesini aç",
  "Open it and pick a size": "Açın ve bir boy seçin",
  "Open POs lists the orders sent to vendors that still wait for goods. Pick the one the truck brought.": "Açık siparişler listesi, tedarikçilere gönderilip hâlâ mal bekleyen siparişleri gösterir. Kamyonun getirdiğini seçin.",
  "Open Prep recipes": "Ara ürün tariflerini aç",
  "Open Products in Menu": "Menüdeki ürünleri aç",
  "Open recipes": "Tarifleri aç",
  "Open shows what still needs attention. Acked, Resolved and All show the rest, and the type list narrows it to low stock, out of stock or price drift.": "Açık, hâlâ ilgilenilmesi gerekenleri gösterir. Görüldü, Çözüldü ve Tümü geri kalanları gösterir; tür listesi ise görünümü düşük stok, stok tükendi ya da fiyat kayması uyarılarıyla sınırlar.",
  "Open stock on hand at {0}": "{0} mağazasının eldeki stoğunu aç",
  "Open the history": "Geçmişi açın",
  "Opens {0} in COGS Variance": "{0} mağazasını COGS farkı sayfasında açar",
  "Opens {0} in Counting": "{0} mağazasını Sayım sayfasında açar",
  "Operating loss": "Faaliyet zararı",
  "Operating profit": "Faaliyet kârı",
  "Optimal": "İdeal",
  "Or count hands-free": "Ya da eller serbest sayım yapın",
  "Or let Autopilot do it": "Ya da işi Autopilot'a bırakın",
  "order is on the way": "sipariş yolda",
  "Order made wrong": "Sipariş yanlış yapıldı",
  "Order these now": "Bunları hemen sipariş et",
  "order was never sent": "sipariş henüz gönderilmedi",
  "Ordered again ({0} {1} ordered)": "Yeniden sipariş edildi (sipariş edilen: {0} {1})",
  "orders are on the way": "sipariş yolda",
  "orders were never sent": "sipariş henüz gönderilmedi",
  "Other costs": "Diğer maliyetler",
  "Other sales": "Diğer satışlar",
  "Out ({0})": "Tükendi ({0})",
  "Out means none left. Low means at or below the item's reorder point or safety stock, which you set on Inventory Items.": "Tükendi, hiç kalmadığı anlamına gelir. Düşük ise kalemin yeniden sipariş noktasında ya da güvenlik stoğunda veya bunların altında olduğunu gösterir; bunları Stok listesinde siz belirlersiniz.",
  "out of stock": "stok tükendi",
  "Outside the displayed period.": "Gösterilen dönemin dışında.",
  "Over purchase budget by {0} ({1}% of sales vs {2}% goal).": "Alım bütçesi {0} aşıldı (satışların %{1} kadarı; hedef %{2}).",
  "Override or take away": "Geçersiz kılın ya da çıkarın",
  "Overview, Inventory, Menu & Recipes, Purchasing, Cost and Administration. Each opens its pages in the row underneath.": "Genel bakış, Envanter, Menü ve tarifler, Satın alma, Maliyet ve Yönetim. Her biri kendi sayfalarını alttaki satırda açar.",
  "Pack count of line {0}": "{0}. satırın paket sayısı",
  "Packaging rules are defined per brand.": "Ambalaj kuralları marka bazında tanımlanır.",
  "Packaging rules say which boxes, bags and liners a sale uses, so they come off the stock with every order, the same way food does.": "Ambalaj kuralları, bir satışın hangi kutu, poşet ve altlıkları kullandığını belirtir; böylece bunlar da yiyecek gibi her siparişte stoktan düşer.",
  "Packs of {0}": "{0} için paket sayısı",
  "Paper": "Kâğıt",
  "Paper goods": "Kâğıt ürünleri",
  "Par for {0}": "{0} için par",
  "Par for {0} at {1}": "{1} mağazasında {0} için par",
  "Par levels tell Inventory when an item is running low and how much to order.": "Par seviyeleri sayesinde Envanter, bir kalemin ne zaman azaldığını ve ne kadar sipariş edilmesi gerektiğini bilir.",
  "Par saved: {0} {1}.": "Par kaydedildi: {0} için {1}.",
  "Par saved: {0} uses no par of its own.": "Par kaydedildi: {0} kendine ait bir par kullanmıyor.",
  "partial": "kısmi",
  "Partial": "Kısmi",
  "Pastas": "Makarnalar",
  "Paste or edit delivery slip lines, e.g.:\n1029381  Mozzarella Cheese 6x5lb   4   $54.20\n8492019  Pepperoni Sliced 25lb     2   $82.50": "Teslimat fişi satırlarını yapıştırın ya da düzenleyin, ör.:\n1029381  Mozzarella Cheese 6x5lb   4   $54.20\n8492019  Pepperoni Sliced 25lb     2   $82.50",
  "People, roles and store links are changed on Connect's Users and Roles pages. Open Users and Open Roles take you there when your role may change access.": "Kişiler, roller ve mağaza bağlantıları Connect'in Kullanıcılar ve Roller sayfalarında değiştirilir. Rolünüz erişimi değiştirebiliyorsa \"Kullanıcıları aç\" ve \"Rolleri aç\" düğmeleri sizi oraya götürür.",
  "per {0}": "{0} başına",
  "Per {0} before tax, {1}": "Vergi hariç {0} başına, {1}",
  "Per $1k sales": "$1k satış başına",
  "per kg": "kg başına",
  "photo": "fotoğraf",
  "Photos and PDFs are read once and never kept.": "Fotoğraflar ve PDF'ler bir kez okunur, hiçbir zaman saklanmaz.",
  "Photos or PDFs of receipts and invoices. I read the amount before tax, and you check it.": "Fiş ve faturaların fotoğrafları veya PDF'leri. Vergi öncesi tutarı ben okurum, siz kontrol edersiniz.",
  "Photos or PDFs of supplier invoices and receipts. I read every line, split food, paper and cleaning, and you check it.": "Tedarikçi faturalarının ve fişlerin fotoğrafları veya PDF'leri. Her satırı ben okurum; yiyecek, kâğıt ve temizliği ayırırım; siz kontrol edersiniz.",
  "Pick a category, then a product": "Önce bir kategori, sonra bir ürün seçin",
  "Pick a group (Food, Packaging, Cleaning…), search by name or SKU, or show only items that are low or critical.": "Bir grup seçin (Yiyecek, Ambalaj, Temizlik…), ada ya da SKU'ya göre arayın veya yalnızca düşük ya da kritik durumdaki kalemleri gösterin.",
  "Pick a group, search by name, or tick Needs amounts to see only the toppings that still need them. Best sellers come first.": "Bir grup seçin, ada göre arayın ya da yalnızca hâlâ miktar gereken malzemeleri görmek için Miktar gerekiyor kutusunu işaretleyin. En çok satanlar önce gelir.",
  "Pick a product": "Bir ürün seçin",
  "Pick a size": "Bir boy seçin",
  "Pick a status": "Bir durum seçin",
  "Pick a store, or All Stores, at the top.": "Üstten bir mağaza ya da Tüm mağazalar seçin.",
  "Pick All stores in the store picker at the top to see your stores side by side.": "Mağazalarınızı yan yana görmek için üstteki mağaza seçicide Tüm mağazalar seçeneğini seçin.",
  "Pick All stores in the store picker to see every store's food cost % against the target line.": "Her mağazanın yemek maliyeti yüzdesini hedef çizgisine göre görmek için mağaza seçicide Tüm mağazalar seçeneğini seçin.",
  "Pick All stores in the store picker to see every store's variance, the largest first.": "Her mağazanın farkını, en büyüğünden başlayarak görmek için mağaza seçicide Tüm mağazalar seçeneğini seçin.",
  "Pick one movement type, or one action, instead of all, and press Apply.": "Tümü yerine tek bir hareket türü ya da tek bir işlem seçin ve Uygula düğmesine basın.",
  "Pick packaging items": "Ambalaj kalemlerini seçin",
  "Pick the dates": "Tarihleri seçin",
  "Pick the order": "Siparişi seçin",
  "Pick the period": "Dönemi seçin",
  "Pick the stock item, the quantity and the unit price before tax. When the item has a pack size, type the pack count and the quantity follows.": "Stok kalemini seçin, miktarı ve vergi hariç birim fiyatı girin. Kalemin bir paket boyu varsa paket sayısını yazın; miktar kendiliğinden hesaplanır.",
  "Pick the window": "Dönemi seçin",
  "Pick what to see": "Ne göreceğinizi seçin",
  "Piece": "Adet",
  "Pizzas": "Pizzalar",
  "Plowhorses": "Plowhorses",
  "PO": "PO",
  "PO #{0}": "PO #{0}",
  "PO cancelled": "PO iptal edildi",
  "PO cancelled — vendor was notified, please call them": "PO iptal edildi — tedarikçiye bildirilmişti, lütfen tedarikçiyi arayın",
  "PO closed early": "PO erken kapatıldı",
  "PO sent to vendor": "PO tedarikçiye gönderildi",
  "Popular but cheap": "Sevilen ama az kazandıranlar",
  "PORTION": "PORSİYON",
  "Pound": "Libre",
  "Prefer one question at a time? Switch to Step by step at the top. You can also press Talk and answer out loud.": "Soruları tek tek yanıtlamayı mı tercih edersiniz? Üstteki Adım adım görünümüne geçin. Konuş düğmesine basıp sesli olarak da yanıtlayabilirsiniz.",
  "Prep batches": "Ara ürün partileri",
  "prep recipes": "ara ürün tarifi",
  "Prep recipes are defined per brand.": "Ara ürün tarifleri marka bazında tanımlanır.",
  "Prep recipes are what the kitchen makes from raw stock — sauces, sausages, dough balls — so a product's recipe can use them like any ingredient. Head office sets them; store managers do not see this page.": "Ara ürün tarifleri, mutfağın ham stoktan yaptıklarıdır — soslar, sosisler, hamur topları — böylece bir ürünün tarifi bunları herhangi bir malzeme gibi kullanabilir. Bunları merkez ofis belirler; mağaza müdürleri bu sayfayı görmez.",
  "Prep saved.": "Ara ürün kaydedildi.",
  "Prepped too much": "Fazla hazırlandı",
  "preps": "ara ürün",
  "Press {0} K anywhere in Inventory and type a few letters.": "Envanterin herhangi bir yerinde {0} K tuşlarına basın ve birkaç harf yazın.",
  "Press New invoice. Take a photo of the invoice or drop its PDF and Connect reads the lines for you, or type them in.": "Yeni fatura düğmesine basın. Faturanın fotoğrafını çekin ya da PDF'ini bırakın, Connect satırları sizin için okusun; ya da satırları kendiniz yazın.",
  "Press New prep, give it a name, choose Prep or Portion, and type what one batch yields.": "Yeni ara ürün düğmesine basın, bir ad verin, Ara ürün ya da Porsiyon seçin ve bir partinin verimini yazın.",
  "Press Scan bills and give it photos or PDFs of invoices and bills. Connect reads the amounts before tax and puts each one in its box for you to check.": "Faturaları tara düğmesine basın ve faturaların fotoğraflarını veya PDF'lerini yükleyin. Connect vergi öncesi tutarları okur ve kontrol etmeniz için her birini kendi kutusuna koyar.",
  "Press Speak and say one sentence, such as \"2.5 kg mozzarella spoiled\", or type it and press Auto-Fill: it fills the form for you. You can also pick the food ingredient, quantity, unit and reason yourself.": "Konuş düğmesine basıp \"2,5 kg mozzarella bozuldu\" gibi tek bir cümle söyleyin ya da cümleyi yazıp Otomatik doldur düğmesine basın: form sizin için doldurulur. Yiyecek malzemesini, miktarı, birimi ve nedeni kendiniz de seçebilirsiniz.",
  "Press Submit {0} counts to save — nothing is saved by voice.": "Kaydetmek için {0} sayımı gönderin — sesle hiçbir şey kaydedilmez.",
  "Press Submit 1 count to save — nothing is saved by voice.": "Kaydetmek için 1 sayımı gönderin — sesle hiçbir şey kaydedilmez.",
  "Prev and Latest are the last two prices paid. Change is the step between them; Window avg is the average price paid over the window.": "Önceki ve Son, ödenen son iki fiyattır. Değişim ikisi arasındaki farktır; Dönem ortalaması ise dönem boyunca ödenen ortalama fiyattır.",
  "Previous item": "Önceki kalem",
  "price drift": "fiyat kayması",
  "Price Drift shows how each ingredient's price moved across your deliveries, and what the change costs you over a year.": "Fiyat kayması, her malzemenin fiyatının teslimatlarınız boyunca nasıl değiştiğini ve bu değişikliğin size bir yılda neye mal olduğunu gösterir.",
  "price drift::Change": "Değişim",
  "Price not changed": "Fiyat değiştirilmedi",
  "Price trend of {0}": "{0} için fiyat eğilimi",
  "priced items contributing": "hesaba katılan fiyatlı kalemler",
  "Prices come from every delivery with a price (invoices, PO receipts and Add Stock), before PST.": "Fiyatlar, fiyatı olan her teslimattan (faturalar, PO teslim almaları ve Stok ekle) PST hariç olarak alınır.",
  "Primary flour is always 100% — edit its amount instead": "Esas un her zaman %100'dür — bunun yerine miktarını düzenleyin",
  "Prime cost": "Ana maliyet",
  "Product Engineering places each ingredient by how many products use it and the average margin of those products.": "Ürün mühendisliği her malzemeyi, onu kullanan ürün sayısına ve bu ürünlerin ortalama marjına göre yerleştirir.",
  "Products in Menu says what each product on the menu uses, size by size. When something sells, the sales job takes these ingredients off the stock by itself.": "Menüdeki ürünler, menüdeki her ürünün boy boy neler kullandığını gösterir. Bir şey satıldığında, satışları işleyen görev bu malzemeleri stoktan kendiliğinden düşer.",
  "PST {0}": "PST {0}",
  "PST of line {0}": "{0}. satırın PST oranı",
  "Puzzles": "Puzzles",
  "Qty has its sign: + came in, − went out. A count line shows the amount that was counted instead. Reference and Note say what the line belongs to; By says who made it.": "Miktar işaretlidir: + giren, − çıkan. Sayım satırında bunun yerine sayılan miktar görünür. Referans ve Not satırın neye ait olduğunu, Yapan ise satırı kimin oluşturduğunu gösterir.",
  "Quantity {0}": "Miktar {0}",
  "quantity missing": "miktar eksik",
  "Quantity of line {0}": "{0}. satırın miktarı",
  "Read a row": "Bir satırı okuyun",
  "Read Current": "Güncel sütununu okuyun",
  "Read each row": "Her satırı okuyun",
  "Read Food Cost %": "Yemek maliyeti yüzdesini okuyun",
  "Read from a scan: check it against the paper": "Taramadan okundu: kâğıttakiyle karşılaştırın",
  "Read from the bill": "Faturadan okundu",
  "read in {0} s": "{0} saniyede okundu",
  "Read only — prep recipes are set by head office.": "Salt okunur — ara ürün tariflerini merkez ofis belirler.",
  "Read only · {0}": "Salt okunur · {0}",
  "Read only · amounts are set by head office": "Salt okunur · miktarları merkez ofis belirler",
  "Read the alert": "Uyarıyı okuyun",
  "Read the four groups": "Dört grubu tanıyın",
  "Read the Inventory column": "Envanter sütununu okuyun",
  "Read the invoice": "Faturayı oku",
  "Read the numbers at the top": "Üstteki rakamları okuyun",
  "Read the warnings": "Uyarıları oku",
  "Read. Check it below.": "Okundu. Aşağıda kontrol edin.",
  "Reading it took too long. Try again, or enter the delivery by hand.": "Okuma çok uzun sürdü. Yeniden deneyin ya da teslimatı elle girin.",
  "Reading it took too long. Try again, or type the figures.": "Okuma çok uzun sürdü. Tekrar deneyin ya da rakamları yazın.",
  "Reading it took too long. Try again, or type the slip's lines.": "Okuma çok uzun sürdü. Yeniden deneyin ya da fişin satırlarını yazın.",
  "Reading it… a few seconds": "Okunuyor… birkaç saniye",
  "Reading the invoice…": "Fatura okunuyor…",
  "ready": "hazır",
  "reason missing": "neden eksik",
  "receipt": "fiş",
  "Receipt failed": "Teslim alma kaydedilemedi",
  "Receipt logged · {0} line(s)": "Teslim alma kaydedildi · {0} satır",
  "receipts": "teslim alma",
  "Receive {0}": "{0} için teslim alınan miktar",
  "Receive it when it arrives": "Geldiğinde teslim alın",
  "received": "teslim alındı",
  "Receiving now: {0}": "Şimdi teslim alınan: {0}",
  "Recent waste lists the lines of the period you pick at the top, with the cost recorded when each was logged and what it did to the stock.": "Son atıklar, üstte seçtiğiniz dönemin satırlarını, her biri kaydedilirken alınan maliyetle ve stoğa etkisiyle birlikte listeler.",
  "Recipe amounts saved!": "Tarif miktarları kaydedildi!",
  "Recipe complete": "Tarif eksiksiz",
  "Recipe cost {0}/kg": "Tarif maliyeti {0}/kg",
  "recipes": "tarif",
  "Recipes are head office's: a role without Inventory → Head office does not see this page.": "Tarifler merkez ofise aittir: Envanter → Merkez ofis yetkisi olmayan bir rol bu sayfayı görmez.",
  "Recipes, so sales take stock off by themselves (head office)": "Satışların stoğu kendiliğinden düşmesi için tarifler (merkez ofis)",
  "Record a vendor's invoice: what came in and what you paid. Saving adds the goods to stock at the invoice's prices.": "Bir tedarikçi faturasını kaydedin: ne geldiğini ve ne ödediğinizi. Kaydettiğinizde mallar, faturadaki fiyatlarla stoğa eklenir.",
  "Record Dough Batch ({0} kg)": "Hamur partisini kaydet ({0} kg)",
  "Record what came in": "Geleni kaydedin",
  "Record your deliveries (invoices or POs)": "Teslimatlarınızı kaydedin (faturalar ya da PO'lar)",
  "Recording batch…": "Parti kaydediliyor…",
  "Remove {0} from {1}?": "{0}, {1} için kaldırılsın mı?",
  "Remove {0}? Its items keep their prices; it no longer appears in lists.": "{0} kaldırılsın mı? Kalemleri fiyatlarını korur; tedarikçi artık listelerde görünmez.",
  "Remove line {0}": "{0}. satırı kaldır",
  "Remove them": "Bunları kaldır",
  "removed": "kaldırılan",
  "Removed {0} from {1}.": "{0}, {1} için kaldırıldı.",
  "Removing a vendor keeps its items' prices; it only leaves the lists.": "Bir tedarikçiyi kaldırmak kalemlerinin fiyatlarını değiştirmez; tedarikçi yalnızca listelerden çıkar.",
  "Rent": "Kira",
  "Rent and utilities": "Kira, elektrik, doğalgaz ve su",
  "Repeating item prompt": "Kalem yeniden okunuyor",
  "Replace with another ingredient": "Başka bir malzemeyle değiştir",
  "Replaced {0} with {1}. Review the retained quantity before saving.": "{0}, {1} ile değiştirildi. Kaydetmeden önce korunan miktarı gözden geçirin.",
  "Resolve failed": "Çözüldü olarak işaretlenemedi",
  "Resolve it when it is fixed": "Düzelince Çözüldü olarak işaretleyin",
  "Resolve once the item is ordered or the price is checked. An alert the check finds fixed by itself is marked auto.": "Kalem sipariş edildiğinde ya da fiyat kontrol edildiğinde Çözüldü düğmesine basın. Kontrolün kendiliğinden düzelmiş bulduğu bir uyarı otomatik etiketiyle işaretlenir.",
  "resolved": "çözüldü",
  "resolved {0}": "çözüldü: {0}",
  "Result": "Sonuç",
  "Revenue is net sales from the tills; Uber, DoorDash and Skip are shown beside it.": "Ciro, kasalardan gelen net satıştır; Uber, DoorDash ve Skip yanında ayrıca gösterilir.",
  "Roll": "Rulo",
  "Royalty and advertising fund": "Royalti ve reklam fonu",
  "rules": "kural",
  "Runout ~{0}": "Tükenme ~{0}",
  "runs": "üretim",
  "Safe all day": "Gün boyu yeterli",
  "Safety floor: {0}": "Güvenlik tabanı: {0}",
  "Salads": "Salatalar",
  "Sale": "Satış",
  "Sale {0}": "Satış fiyatı {0}",
  "Sales explain {0} a day; the counts show {1}": "Satışlar günde {0} kullanımı açıklıyor; sayımlar {1} gösteriyor",
  "Sales include Uber, DoorDash and Skip — their food is bought too. Rec = deliveries recorded in these days; Open = what sent orders still have to bring.": "Satışlara Uber, DoorDash ve Skip dahildir — onların yiyeceği de satın alınır. Gelen = bu günlerde kaydedilen teslimatlar; Açık = gönderilen siparişlerle henüz gelmesi gerekenler.",
  "Sales is what recipes took for orders, Purchases is what deliveries added, Other is everything else that changed the stock, such as waste.": "Satış, tariflerin siparişler için düştüğü miktardır; Alım, teslimatların eklediği miktardır; Diğer ise atık gibi stoğu değiştiren diğer her şeydir.",
  "Sales job ran: {0} lines taken, {1} set right, {2} given back.": "Satışları işleyen görev çalıştı: {0} satır düşüldü, {1} satır düzeltildi, {2} satır geri verildi.",
  "same as last month": "geçen ayla aynı",
  "Same as last month": "Geçen ayla aynı",
  "Sandwiches": "Sandviçler",
  "Sauces": "Soslar",
  "Save {0}": "{0} için kaydet",
  "Save failed": "Kaydedilemedi",
  "Save for {0}": "{0} için kaydet",
  "Save for every size": "Her boy için kaydet",
  "Save for every store, or for one": "Tüm mağazalar ya da tek bir mağaza için kaydedin",
  "Save ingredient": "Kalemi kaydet",
  "Save keeps the amounts of the size you are on. From then on, sales take them off the stock by themselves.": "Kaydet, açık olan boyun miktarlarını saklar. Bundan sonra satışlar bunları stoktan kendiliğinden düşer.",
  "save qty": "miktarı kaydet",
  "Save size": "Boyu kaydet",
  "Save the recipe first": "Önce tarifi kaydedin",
  "Save the size": "Boyu kaydedin",
  "Save, then use it": "Kaydedin, sonra kullanın",
  "saved · variance {0}": "kaydedildi · fark {0}",
  "Saved {0} for {1}.": "{0}, {1} için kaydedildi.",
  "Saved {0} on {1}.": "{0}, {1} ürünü için kaydedildi.",
  "Saved {0}.": "{0} kaydedildi.",
  "Saved invoice {0}.": "{0} numaralı fatura kaydedildi.",
  "Saved with Prep recipes — every stage uses it at once.": "Ara ürün tarifleriyle birlikte kaydedilir — her aşama onu anında kullanır.",
  "Saved: price suggestions are off, and their waiting cards were taken back.": "Kaydedildi: fiyat önerileri kapalı ve bekleyen kartları geri alındı.",
  "Saved. Press Check now to send today's suggestions; they are also checked every night.": "Kaydedildi. Bugünün önerilerini göndermek için \"Şimdi kontrol et\" düğmesine basın; öneriler her gece de kontrol edilir.",
  "Saved. The sales job looks at its last 21 days again on its next run.": "Kaydedildi. Satışları işleyen görev bir sonraki çalışmasında son 21 güne yeniden bakar.",
  "Say how much {0} there is.": "Ne kadar {0} olduğunu söyleyin.",
  "Say it, or fill it in": "Söyleyin ya da doldurun",
  "Say which item.": "Hangi kalem olduğunu söyleyin.",
  "Say yes or no so they know whether to expect it.": "Bekleyip beklemeyeceklerini bilmeleri için evet ya da hayır deyin.",
  "Scale to changes every amount and the yield together, so one batch still makes what its yield says.": "Hedef verim, tüm miktarları ve verimi birlikte değiştirir; böylece bir parti yine verimde yazan miktarı çıkarır.",
  "Scan invoices": "Faturaları tara",
  "Scan its barcode or type its SKU and press Enter to jump to it, or search by name. Show narrows the list to typed or not yet counted items.": "Kaleme gitmek için barkodunu okutun ya da SKU'sunu yazıp Enter'a basın; isterseniz ada göre arayın. Göster, listeyi miktar girilmiş ya da henüz sayılmamış kalemlerle sınırlar.",
  "Scan receipts": "Fişleri tara",
  "Scan the bill": "Faturayı tara",
  "Scan the statement": "Ekstreyi tara",
  "Scan your bills": "Faturalarınızı tarayın",
  "Scatter of the items by popularity and margin": "Kalemlerin popülerlik ve marja göre dağılım grafiği",
  "Search {0}": "{0} içinde ara",
  "Search finds a product, a size or a packaging item.": "Arama bir ürünü, bir boyu ya da bir ambalaj kalemini bulur.",
  "Search product, size, or packaging…": "Ürün, boy ya da ambalaj ara…",
  "Search size or packaging…": "Boy ya da ambalaj ara…",
  "Search your stocks or other preps and type each amount. Each line's cost, the batch total and the cost per unit follow by themselves.": "Stoklarınızda ya da diğer ara ürünlerde arayın ve her miktarı yazın. Her satırın maliyeti, parti toplamı ve birim maliyeti kendiliğinden hesaplanır.",
  "See how fast stock goes": "Stoğun ne kadar hızlı tükendiğini görün",
  "See how the store is doing": "Mağazanın gidişatını görün",
  "See what a change costs": "Bir değişikliğin maliyetini görün",
  "See what moved": "Nelerin değiştiğini görün",
  "See which ingredients drive the menu": "Menüyü hangi malzemelerin taşıdığını görün",
  "See who can use Inventory at your stores, with which role and in which stores. Inventory keeps no users of its own: it uses Connect's people, roles and store links.": "Mağazalarınızda Envanteri kimin, hangi rolle ve hangi mağazalarda kullanabileceğini görün. Envanterin kendine ait kullanıcıları yoktur: Connect'in kişilerini, rollerini ve mağaza bağlantılarını kullanır.",
  "Select {0}": "Seç: {0}",
  "Select all {0} matching": "Eşleşen {0} kalemin tümünü seç",
  "Send a draft PO first.": "Önce bir taslak PO gönderin.",
  "Send a PDF on its own: it already holds all its pages.": "PDF'i tek başına gönderin: tüm sayfaları zaten içinde.",
  "Send failed": "Gönderilemedi",
  "Send it": "Gönderin",
  "Send PO marks the order as sent. Connect does not e-mail the vendor: pass the order to your rep yourself.": "\"Siparişi gönder\" düğmesi siparişi gönderildi olarak işaretler. Connect tedarikçiye e-posta göndermez: siparişi temsilcinize kendiniz iletin.",
  "Send Recommended Mix to Log Production fills in today's mix; change the counts to the balls you really cut.": "\"Önerilen karışımı üretim kaydına aktar\" düğmesi bugünkü karışımı doldurur; adetleri gerçekten kestiğiniz toplara göre değiştirin.",
  "Send the goods": "Malları gönder",
  "Send the order": "Siparişi gönder",
  "Sending": "Gönderiliyor",
  "Sending an order does not e-mail the vendor: pass it to your rep yourself.": "Sipariş gönderildiğinde tedarikçiye e-posta gitmez: siparişi temsilcinize kendiniz iletin.",
  "Sent on the next check": "Bir sonraki kontrolde gönderilecek",
  "Sep": "Eyl",
  "set by hand": "elle girildi",
  "Set target levels": "Hedef seviyeleri belirle",
  "Set target levels (par) for what you order": "Sipariş ettikleriniz için hedef seviyeleri (par) belirleyin",
  "Set the dates": "Tarihleri belirleyin",
  "Set the levels": "Seviyeleri belirleyin",
  "Set the master dough's ingredients — flour is 100% and the rest follow as baker's percentages — what one batch yields, and the weight of each ball size. Then pick the ball each pizza size uses: every pizza sold in that size takes one ball off the stock.": "Ana hamurun malzemelerini — un %100'dür, diğerleri fırıncı yüzdesi olarak gelir — bir partinin verimini ve her top boyunun ağırlığını belirleyin. Ardından her pizza boyunun kullandığı topu seçin: o boyda satılan her pizza stoktan bir top düşer.",
  "Set the order cutoff": "Sipariş son saatini belirleyin",
  "Set up Inventory for this store": "Bu mağaza için Envanteri kurun",
  "Set when it happened": "Ne zaman olduğunu belirleyin",
  "Shelf pizzas are not counted any more.": "Raf pizzaları artık sayılmıyor.",
  "Shift + Enter goes back a row; Ctrl or ⌘ + Enter submits from any row.": "Shift + Enter bir satır geri gider; Ctrl ya da ⌘ + Enter herhangi bir satırdan gönderir.",
  "Show the photo larger": "Fotoğrafı büyüt",
  "shown when every line is in": "tüm satırlar girilince gösterilir",
  "Sides": "Yan ürünler",
  "Single store active — multi-store benchmark activates when multiple locations report sales.": "Tek mağaza aktif — birden fazla mağaza satış bildirdiğinde mağazalar arası karşılaştırma devreye girer.",
  "sizes": "boy",
  "skipped — {0} must be a number ≥ 0": "atlandı — {0} ≥ 0 olan bir sayı olmalı",
  "skipped — no changes": "atlandı — değişiklik yok",
  "skipped — no matching ingredient": "atlandı — eşleşen kalem yok",
  "Skipped item": "Kalem atlandı",
  "Sleeve": "Kılıf",
  "Slice products (their recipes use the slice item,": "Dilim ürünleri (tarifleri dilim kalemini kullananlar,",
  "Slices are not counted as a share of a pizza any more.": "Dilimler artık pizzanın payı olarak sayılmıyor.",
  "Slices: head office sets once which pizza a slice is cut from and how many slices it has (for example 1/8 of Pepperoni 18\"); slice products then take their share by themselves.": "Dilimler: merkez ofis, bir dilimin hangi pizzadan kesildiğini ve o pizzanın kaç dilim olduğunu bir kez belirler (örneğin Pepperoni 18\" pizzanın 1/8'i); ardından dilim ürünleri paylarını kendiliğinden alır.",
  "Slip / invoice #": "Fiş / fatura #",
  "Slip / invoice #{0}.": "Fiş / fatura #{0}.",
  "Slip photos are read once and never kept.": "Fiş fotoğrafları bir kez okunur ve asla saklanmaz.",
  "Smallwares": "Mutfak gereçleri",
  "so far": "şu ana kadar",
  "Some could not be sent: {0}": "Bazıları gönderilemedi: {0}",
  "Something else": "Başka bir neden",
  "Sort by Variance magnitude to see first where stock goes missing.": "Stoğun nerede eksildiğini önce görmek için Fark büyüklüğüne göre sıralayın.",
  "Speak waste line": "Atık satırını söyle",
  "Speech isn't available in this browser. You can use the quick-command box.": "Bu tarayıcıda konuşma tanıma kullanılamıyor. Hızlı komut kutusunu kullanabilirsiniz.",
  "Speech recognition is not supported in this browser. You can type into the voice box.": "Bu tarayıcı konuşma tanımayı desteklemiyor. Sesli giriş kutusuna yazabilirsiniz.",
  "Spoiled or out of date": "Bozuldu ya da tarihi geçti",
  "Spot the items to act on": "İlgilenmeniz gereken kalemleri bulun",
  "Staff meal": "Personel yemeği",
  "Stars": "Stars",
  "Stars sell a lot and earn well. Plowhorses sell a lot but earn little. Puzzles earn well but few people buy them. Dogs sell little and earn little. The dashed lines on the chart are the middle values (medians).": "Stars: çok satar ve iyi kazandırır. Plowhorses: çok satar ama az kazandırır. Puzzles: iyi kazandırır ama az kişi alır. Dogs: az satar ve az kazandırır. Grafikteki kesikli çizgiler orta değerlerdir (medyanlar).",
  "Start a new invoice": "Yeni bir fatura başlatın",
  "Start counting": "Sayıma başla",
  "Start from the last count": "Son sayımdan başlayın",
  "Start new orders from suggestions": "Yeni siparişleri önerilerden başlatın",
  "Start with sizes": "Boylarla başlayın",
  "Start with the cards at the top": "Üstteki kartlarla başlayın",
  "statement": "ekstre",
  "status::open": "Açık",
  "still open: {0}": "hâlâ açık: {0}",
  "Still some left, but not much. Put them on the next order.": "Biraz kaldı ama çok değil. Bir sonraki siparişe ekleyin.",
  "Still to come ({0})": "Henüz gelmeyen ({0})",
  "Stock at the end of the month": "Ay sonundaki stok",
  "Stock at the start of the month": "Ay başındaki stok",
  "Stock deducted when logged.": "Kaydedildiği anda stoktan düşüldü.",
  "Stock Health shows what your stock is worth, how fresh your counts are, and which items are running low or out: for this store, or for every store under All stores.": "Stok sağlığı; stoğunuzun değerini, sayımlarınızın ne kadar güncel olduğunu ve hangi kalemlerin azaldığını ya da tükendiğini gösterir: bu mağaza için ya da Tüm mağazalar altında her mağaza için.",
  "Stock ledger lists the stock movements at one store: counts, deliveries, waste, transfers and what sales took. Access & admin events lists the changes people made in Inventory, with the store they were for or brand-wide.": "Stok defteri, tek bir mağazadaki stok hareketlerini listeler: sayımlar, teslimatlar, atık, transferler ve satışların stoktan düştükleri. Erişim ve yönetim işlemleri ise kişilerin Envanterde yaptığı değişiklikleri, ilgili oldukları mağazayla ya da marka geneli olarak listeler.",
  "Stock of line {0}": "{0}. satırın stok kalemi",
  "Stock status: Out at 0; Critical at or below the safety stock; Low at or below the reorder point (the safety stock when there is none). An item with neither shows “No level set”. Days of cover use the same daily use as the suggested orders.": "Stok durumu: 0'da Tükendi; güvenlik stoğunda ya da altında Kritik; yeniden sipariş noktasında ya da altında Düşük (yeniden sipariş noktası yoksa güvenlik stoğu esas alınır). İkisi de girilmemiş bir kalemde “Seviye belirlenmemiş” görünür. Yeterlilik süresi, önerilen siparişlerdeki günlük kullanımın aynısıyla hesaplanır.",
  "Stock unchanged: already included in the latest physical count.": "Stok değişmedi: zaten son fiziksel sayıma dahil.",
  "Stockout risk": "Tükenme riski",
  "Stop counting shelf pizzas? Shelf tickets will take nothing off the stock again, and the shelf pizzas of the last 21 days give their ingredients back while the slices already sold stay sold, so the slice item goes below zero until it is counted.": "Raf pizzalarının sayılması durdurulsun mu? Raf fişleri eskisi gibi stoktan hiçbir şey düşmez; son 21 günün raf pizzaları malzemelerini stoğa geri verir ama satılmış dilimler satılmış kalır; bu yüzden dilim kalemi sayılana kadar sıfırın altına düşer.",
  "Stop counting slices as a share of a pizza? Slice products then use only what their own recipes say.": "Dilimlerin pizzanın payı olarak sayılması durdurulsun mu? Bundan sonra dilim ürünleri yalnızca kendi tariflerinde yazanı kullanır.",
  "Stop listening": "Dinlemeyi durdur",
  "Stopped trying": "Denemeler durduruldu",
  "store asked you for stock": "mağaza sizden stok istedi",
  "stores asked you for stock": "mağaza sizden stok istedi",
  "Stores need sales taken off by recipes, waste or counts in these days before they can be compared.": "Mağazaların karşılaştırılabilmesi için bu günlerde tariflerle satış düşümü, atık ya da sayım kaydı olması gerekir.",
  "Strict Budget Cap keeps the order inside the weekly budget, but never cuts what is about to run out, nor packaging and cleaning.": "Sıkı bütçe sınırı siparişi haftalık bütçe içinde tutar; ama bitmek üzere olanları, ambalajı ve temizliği asla kesmez.",
  "Stuck? Ask the page": "Takıldınız mı? Sayfaya sorun",
  "Submit {0} counts": "{0} sayımı gönder",
  "Submit 1 count": "1 sayımı gönder",
  "Submit failed": "Gönderilemedi",
  "Submit receipt ({0} lines)": "Teslim almayı gönder ({0} satır)",
  "Submit receipt (1 line)": "Teslim almayı gönder (1 satır)",
  "Submit sends every item you typed. Each row then shows the difference the count found; an item's first count just sets its starting number.": "Gönder, yazdığınız her kalemi gönderir. Ardından her satır, sayımın bulduğu farkı gösterir; bir kalemin ilk sayımı yalnızca başlangıç miktarını belirler.",
  "Submitting… {0}/{1}": "Gönderiliyor… {0}/{1}",
  "Suggested orders are per-store.": "Önerilen siparişler mağaza bazındadır.",
  "Suggested orders works out what to buy for this store from its stock, its par levels and how fast it uses each item, and turns it into draft purchase orders.": "Önerilen siparişler, bu mağaza için ne alınacağını stoğuna, par seviyelerine ve her kalemi ne kadar hızlı kullandığına göre hesaplar ve bunu taslak satın alma siparişlerine dönüştürür.",
  "Suggested orders works out what to buy from your stock and par levels, and makes the drafts for you.": "Önerilen siparişler, stoğunuza ve par seviyelerinize göre ne alınacağını hesaplar ve taslakları sizin için hazırlar.",
  "Sum of ingredients: {0} {1}": "Malzemelerin toplamı: {0} {1}",
  "SUPC": "SUPC",
  "SUPC/SKU: {0} ·": "SUPC/SKU: {0} ·",
  "Switch between By size and By product at the top; each keeps its own list.": "Üstte Boya göre ile Ürüne göre arasında geçiş yapın; her biri kendi listesini tutar.",
  "Sysco list price": "Sysco liste fiyatı",
  "Take {0} off": "{0} dosyasını kaldır",
  "Take a photo of the delivery slip or type its lines, then Verify. Connect compares the slip with the order and your count, and suggests driver credits for anything short or overpriced.": "Teslimat fişinin fotoğrafını çekin ya da satırlarını yazın, sonra Kontrol et düğmesine basın. Connect fişi siparişle ve sayımınızla karşılaştırır; eksik gelen ya da fazla fiyatlanan her şey için şoför alacağı önerir.",
  "Take a photo of the delivery’s invoice, or drop its PDF here. Connect reads every line and fills it in below; you check it and record.": "Teslimatın faturasının fotoğrafını çekin ya da PDF'ini buraya bırakın. Connect her satırı okuyup aşağıya doldurur; siz kontrol edip kaydedersiniz.",
  "target {0}": "hedef {0}",
  "Target {0}%": "Hedef %{0}",
  "That amount is too large. Check the number of digits.": "Bu tutar çok büyük. Basamak sayısını kontrol edin.",
  "That doesn’t look like an amount. Type it like 1633.04.": "Bu bir tutar gibi görünmüyor. 1633.04 gibi yazın.",
  "That file": "Bu dosya",
  "That is more than {0} pages. Send the pages with the totals on them.": "Bu, {0} sayfadan fazla. Toplamların yazılı olduğu sayfaları gönderin.",
  "The amount can’t be below zero.": "Tutar sıfırın altında olamaz.",
  "The Amounts cover pill at the top shows how much of what sold already has its amounts.": "Üstteki miktar kapsamı etiketi, satılanların ne kadarının miktarlarının girildiğini gösterir.",
  "The arrow on a row opens its lines: requested, shipped and received amounts, and what the sending store has on hand.": "Bir satırdaki ok, o transferin satırlarını açar: istenen, gönderilen ve teslim alınan miktarlar ile gönderen mağazada mevcut olan miktar.",
  "The assistant is speaking": "Asistan konuşuyor",
  "The audit trail is the record of what happened and who did it: the stock movements at a store, and the changes people made in Inventory. Nothing here can be edited.": "Denetim kaydı, ne olduğunun ve kimin yaptığının kaydıdır: bir mağazadaki stok hareketleri ve kişilerin Envanterde yaptığı değişiklikler. Buradaki hiçbir şey düzenlenemez.",
  "The buttons above the chart show one group at a time, on the chart and in the tables. Press it again to see them all.": "Grafiğin üstündeki düğmeler, grafikte ve tablolarda bir seferde tek bir grubu gösterir. Hepsini görmek için aynı düğmeye yeniden basın.",
  "The check failed.": "Kontrol başarısız oldu.",
  "The claims could not be logged; nothing was filled.": "Talepler kaydedilemedi; hiçbir satır doldurulmadı.",
  "The companies you buy from. Each item on Inventory Items is linked to its vendor, and orders are made one per vendor.": "Alım yaptığınız firmalar. Stok listesindeki her kalem kendi tedarikçisine bağlıdır ve her tedarikçi için ayrı sipariş oluşturulur.",
  "The count sheet is where you count the shelf. Type what you find next to each item and submit; Inventory compares it with what it expected and records the difference.": "Sayım listesi, rafı saydığınız yerdir. Her kalemin yanına bulduğunuz miktarı yazın ve gönderin; Envanter bunu beklediği miktarla karşılaştırır ve farkı kaydeder.",
  "The Dashboard is the store's daily check: what needs doing today, how sales and food cost are going, and where money is leaking.": "Pano, mağazanın günlük kontrolüdür: bugün yapılması gerekenler, satışların ve yemek maliyetinin nasıl gittiği ve paranın nereden kaçtığı.",
  "The Dashboard shows how many alerts are open under Things to look at.": "Pano, kaç uyarının açık olduğunu Bakılması gerekenler altında gösterir.",
  "The file could not be made just now.": "Dosya şu anda oluşturulamadı.",
  "The file is read and never kept. You see what is new, what changes and what goes, and every row to fix first.": "Dosya okunur ve asla saklanmaz. Neyin yeni olduğunu, neyin değişeceğini, neyin kaldırılacağını ve önce düzeltilmesi gereken her satırı görürsünüz.",
  "The first list is the one workbook head office fills in once: the stock list with its prices, the prep recipes, what every size uses, each topping's grams per size, and each product's own lines.": "İlk liste, merkez ofisin bir kez doldurduğu tek Excel dosyasıdır: fiyatlarıyla stok listesi, ara ürün tarifleri, her boyun kullandıkları, her malzemenin boy başına gramı ve her ürünün kendi satırları.",
  "The groups are worked out by margin, not by price.": "Gruplar fiyata göre değil, marja göre belirlenir.",
  "The guardrail sets this week's food allowance (7 days of sales × your food cost target) against what was delivered, what is on order and this order.": "Bütçe göstergesi, bu haftanın yiyecek bütçesini (7 günlük satış × yemek maliyeti hedefiniz) gelenlerle, siparişte olanlarla ve bu siparişle karşılaştırır.",
  "The invoice could not be read.": "Fatura okunamadı.",
  "the last {0} days again (recipes changed)": "son {0} gün, yeniden (tarifler değişti)",
  "The last time an order is taken for the next delivery. Purchasing shows it next to the weekly budget.": "Bir sonraki teslimat için siparişin verilebileceği son saat. Satın alma sayfası bunu haftalık bütçenin yanında gösterir.",
  "The list could not be applied; nothing was changed.": "Liste uygulanamadı; hiçbir şey değiştirilmedi.",
  "The list could not be made.": "Liste oluşturulamadı.",
  "The list could not be read.": "Liste okunamadı.",
  "the lowest price any of your stores charges.": "mağazalarınızın uyguladığı en düşük fiyat.",
  "The master dough lives on Dough Management, with its ball sizes and the 48-hour plan.": "Ana hamur, top boyları ve 48 saatlik planıyla birlikte Hamur yönetimi sayfasındadır.",
  "The master list of everything this store buys, stocks or uses: its price, how much is on hand, how fast it is used, and the levels that say when to reorder.": "Bu mağazanın satın aldığı, stokladığı ya da kullandığı her şeyin ana listesi: fiyatı, ne kadar mevcut olduğu, ne kadar hızlı kullanıldığı ve ne zaman yeniden sipariş verileceğini gösteren seviyeler.",
  "The matrix and Log Production work for one store: pick it in the store picker.": "Tablo ve Üretim kaydı tek bir mağaza için çalışır: mağazayı mağaza seçiciden seçin.",
  "The matrix needs the Dough recipe and its ball sizes.": "Tablo için Hamur tarifi ve top boyları gerekir.",
  "The matrix needs the dough recipe and the ball sizes head office sets up.": "Tablo için merkez ofisin hazırladığı hamur tarifi ve top boyları gerekir.",
  "The Monthly report is the store's month-end report for head office: one Excel file with the month's sales, costs and profit.": "Aylık rapor, mağazanın merkez ofis için hazırladığı ay sonu raporudur: ayın satışlarını, maliyetlerini ve kârını içeren tek bir Excel dosyası.",
  "The order closes by itself once everything has come. If the rest will not come, Close early keeps what was received and cancels the remaining lines.": "Her şey geldiğinde sipariş kendiliğinden kapanır. Kalanı gelmeyecekse Erken kapat, teslim alınanları korur ve kalan satırları iptal eder.",
  "The other store approves and ships": "Diğer mağaza onaylar ve gönderir",
  "The page opens on the last 30 days. Change From and To to look at another window.": "Sayfa son 30 günle açılır. Başka bir döneme bakmak için Başlangıç ve Bitiş tarihlerini değiştirin.",
  "The page you are on is highlighted. Everything works in this tab; Connect is one click away on the left.": "Bulunduğunuz sayfa vurgulanır. Her şey bu sekmede çalışır; Connect solda, bir tık uzağınızda.",
  "The pages of the section": "Bölümün sayfaları",
  "The par is the store's own: the matrix mixes enough to keep it on hand after the next 48 hours.": "Par mağazaya özeldir: tablo, önümüzdeki 48 saatten sonra da bu kadarını elde tutacak miktarda karışım planlar.",
  "The period always ends today: Today, 7 days or 30 days. Prior period is the same length of time just before it.": "Dönem her zaman bugün biter: Bugün, 7 gün ya da 30 gün. Önceki dönem, hemen öncesindeki aynı uzunluktaki süredir.",
  "The photo could not be prepared.": "Fotoğraf hazırlanamadı.",
  "the report": "rapor",
  "The sales job could not run.": "Satışları işleyen görev çalıştırılamadı.",
  "the server said no.": "sunucu reddetti.",
  "the size's own lines": "boyun kendi satırları",
  "the slice item": "dilim kalemi",
  "The slip could not be checked.": "Fiş kontrol edilemedi.",
  "The stock ledger works one store at a time: under All stores the page shows the access and admin events.": "Stok defteri her seferinde tek bir mağaza için çalışır: Tüm mağazalar seçiliyken sayfa erişim ve yönetim işlemlerini gösterir.",
  "The store's clock": "Mağazanın saati",
  "the store's menu price.": "mağazanın menü fiyatı.",
  "The store's pars": "Mağazanın par seviyeleri",
  "The system flagged something that should not wait.": "Sistem, bekletilmemesi gereken bir şey tespit etti.",
  "The tills still charge it until the undo is synced: {0}": "Geri alma eşitlenene kadar kasalar zamlı fiyattan satmaya devam eder: {0}",
  "The toppings a product comes with are set on Topping Recipes; here they are shown read only.": "Bir ürünle gelen malzemeler Malzeme tarifleri sayfasında belirlenir; burada salt okunur gösterilir.",
  "The undo ({0}) is at every till that took the raise: the old price is back.": "Geri alma ({0}), zammı alan tüm kasalara ulaştı: eski fiyat geri geldi.",
  "The undo ({0}) is being sent to the tills.": "Geri alma ({0}) kasalara gönderiliyor.",
  "The undo ({0}) is prepared and waits to be confirmed in the assistant; until then the tills still charge the raise.": "Geri alma ({0}) hazırlandı ve asistanda onaylanmayı bekliyor; o zamana kadar kasalar zamlı fiyattan satmaya devam eder.",
  "The undo reached {0} of the {1} tills that took the raise; {2} still charge it: {3}": "Geri alma, zammı alan {1} kasadan {0} tanesine ulaştı; {2} kasa hâlâ zamlı fiyattan satıyor: {3}",
  "The undo reached {0} of the {1} tills that took the raise; 1 still charges it: {2}": "Geri alma, zammı alan {1} kasadan {0} tanesine ulaştı; 1 kasa hâlâ zamlı fiyattan satıyor: {2}",
  "The variance report follows every item since its last count: what the count found, what moved after it, and where the stock should be now.": "Fark raporu, her kalemi son sayımından bu yana izler: sayımın ne bulduğu, sonrasında neyin hareket ettiği ve stoğun şu an ne kadar olması gerektiği.",
  "the vendor's last price": "tedarikçinin son fiyatı",
  "The Waste Log records what was thrown away, by the day and time it happened, so the stock and the food cost stay right.": "Atık kaydı, atılanları gerçekleştiği gün ve saate göre kaydeder; böylece stok ve yemek maliyeti doğru kalır.",
  "Theo Food Cost is what the recipes say the food cost, not a count of the shelf: COGS Variance compares the two.": "Teorik yemek maliyeti, raf sayımına değil tariflere göre hesaplanan yemek maliyetidir: COGS farkı ikisini karşılaştırır.",
  "There are no active inventory items in the selected store.": "Seçili mağazada aktif stok kalemi yok.",
  "There is none left on the shelf. Order today or you will run out during service.": "Rafta hiç kalmadı. Bugün sipariş verin, yoksa servis sırasında tükenir.",
  "These amounts apply on {0} only.": "Bu miktarlar yalnızca {0} ürününde geçerlidir.",
  "They are filled in below: check them against your paperwork, add any that are missing, then save them.": "Aşağıda dolduruldu: evraklarınızla karşılaştırın, eksik olanları ekleyin, ardından kaydedin.",
  "This browser can't listen in this language. You can use the quick-command box.": "Bu tarayıcı bu dilde dinleyemiyor. Hızlı komut kutusunu kullanabilirsiniz.",
  "This order's food: {0}": "Bu siparişteki yiyecek: {0}",
  "This PDF is too large to send ({0}). Take photos of its pages with the camera button instead.": "Bu PDF gönderilemeyecek kadar büyük ({0}). Bunun yerine sayfalarının fotoğraflarını kamera düğmesiyle çekin.",
  "This photo": "Bu fotoğraf",
  "This size uses the recipe for every size. Save lines here to give {0} its own.": "Bu boy, her boy için olan tarifi kullanıyor. {0} boyuna kendi tarifini vermek için satırları burada kaydedin.",
  "This size's own amounts replace \"Every size\" here.": "Bu boyun kendi miktarları burada \"Her boy\" miktarlarının yerine geçer.",
  "This size's own lines and its toppings' amounts cover it. Add lines here only to change them for this product.": "Boyun kendi satırları ve malzemelerinin miktarları bu ürünü karşılıyor. Buraya yalnızca bunları bu ürün için değiştirmek istediğinizde satır ekleyin.",
  "This store hasn't set up any ingredients yet. Create one to start tracking stock, prices, and recipes.": "Bu mağaza henüz hiç kalem eklemedi. Stoğu, fiyatları ve tarifleri izlemeye başlamak için bir kalem oluşturun.",
  "This store is set up": "Bu mağazanın kurulumu tamamlandı",
  "This store uses every store's recipe here. Lines saved here become {0}'s own.": "Bu mağaza burada tüm mağazaların tarifini kullanıyor. Burada kaydedilen satırlar {0} mağazasının kendi tarifi olur.",
  "this store's own": "bu mağazanın kendi tarifi",
  "this store's, for every size": "bu mağazanın, her boy için",
  "today": "bugün",
  "Today is compared with yesterday. WTD runs Monday to today, against the same days a week before. MTD runs from the 1st to today, against the same days of the month before.": "Bugün, dünle karşılaştırılır. Bu hafta pazartesiden bugüne kadardır ve bir hafta önceki aynı günlerle karşılaştırılır. Bu ay ayın 1'inden bugüne kadardır ve önceki ayın aynı günleriyle karşılaştırılır.",
  "Today, This week and This month at the top change the period of every number on the page.": "Üstteki Bugün, Bu hafta ve Bu ay seçenekleri sayfadaki tüm rakamların dönemini değiştirir.",
  "Too high to send": "Gönderilemeyecek kadar yüksek",
  "Top Cost Movers lists the items whose food cost changed the most against the period before, in dollars and in %.": "Maliyeti en çok değişenler, yemek maliyeti önceki döneme göre en çok değişen kalemleri dolar ve yüzde olarak listeler.",
  "Top movers are the items used most in the last 7 days. Slowest movers have not moved for 30 days or more and are money sitting on the shelf.": "En çok hareket edenler, son 7 günde en çok kullanılan kalemlerdir. En yavaş hareket edenler 30 gün ya da daha uzun süredir hareket etmemiştir; bunlar rafta bekleyen paradır.",
  "TOPPING RECIPE": "MALZEME TARİFİ",
  "TOPPING RECIPE · ON {0} ONLY": "MALZEME TARİFİ · YALNIZCA {0} ÜRÜNÜNDE",
  "Topping recipe: {0}": "Malzeme tarifi: {0}",
  "Topping Recipes says how much of each ingredient a topping uses on each size: a regular portion, and the light or extra amount when an order asks for it. Head office sets them; store managers do not see this page.": "Malzeme tarifleri, bir malzemenin her boyda her kalemden ne kadar kullandığını belirtir: normal bir porsiyon; sipariş istediğinde de az ya da ekstra miktar. Bunları merkez ofis belirler; mağaza müdürleri bu sayfayı görmez.",
  "toppings": "malzeme",
  "Tour, step {0} of {1}": "Tanıtım turu, adım {0}/{1}",
  "transfer direction::in": "Gelen",
  "transfer is waiting to leave": "transfer gönderilmeyi bekliyor",
  "transfers": "transfer",
  "Transfers are store-scoped. Select a store from the top bar to request or fulfil stock.": "Transferler mağazaya özeldir. Stok istemek ya da istenen stoğu karşılamak için üst çubuktan bir mağaza seçin.",
  "transfers are waiting to leave": "transfer gönderilmeyi bekliyor",
  "Transfers between stores and deliveries are not costs, so they are not counted here.": "Mağazalar arası transferler ve teslimatlar maliyet değildir; bu yüzden burada sayılmaz.",
  "Transfers move stock between your stores instead of buying it in a hurry. Every step is written to both stores' stock.": "Transferler, aceleyle satın almak yerine stoğu mağazalarınız arasında taşır. Her adım iki mağazanın stoğuna da işlenir.",
  "Tub": "Kap",
  "Type an amount, for example 1633.04.": "Bir tutar yazın, örneğin 1633.04.",
  "Type at least 2 chars (stock, prep or product)…": "En az 2 karakter yazın (stok, ara ürün ya da ürün)…",
  "Type each line's quantity in Receiving now, or scan or type an item's name to jump to its line. Enter moves down; lines left blank are not received.": "Her satırın miktarını Şimdi teslim alınan sütununa yazın ya da satırına gitmek için kalemi okutun veya adını yazın. Enter bir alt satıra geçer; boş bırakılan satırlar teslim alınmaz.",
  "Uber Eats, DoorDash and Skip": "Uber Eats, DoorDash ve Skip",
  "Uber Eats, DoorDash and Skip fees": "Uber Eats, DoorDash ve Skip ücretleri",
  "Uber Eats, DoorDash and Skip sales": "Uber Eats, DoorDash ve Skip satışları",
  "Unavailable": "Bilinmiyor",
  "unchanged": "değişmedi",
  "Under each ball size on Predictive Prep Matrix, type how many balls the store wants on hand. The plan mixes enough to keep that many after the next 48 hours.": "Tahmini hazırlık tablosunda her top boyunun altına, mağazanın elde bulundurmak istediği top sayısını yazın. Plan, önümüzdeki 48 saatten sonra da bu kadarını elde tutacak miktarda karışım hazırlar.",
  "Under Only on one product, pick a product and a size that uses more or less of this topping, like a meat lover's pizza with more pepperoni.": "Sadece bir üründe bölümünde, bu malzemeden daha çok ya da daha az kullanan bir ürün ve boy seçin; örneğin daha çok pepperoni konan etli bir pizza.",
  "Under Request stock, pick the store to ask, add the items and amounts, say why in the note, and send the request.": "Stok iste bölümünde istenecek mağazayı seçin, kalemleri ve miktarları ekleyin, nedenini nota yazın ve isteği gönderin.",
  "Undone after {0} tills took it": "{0} kasa aldıktan sonra geri alındı",
  "Undone after 1 till took it": "1 kasa aldıktan sonra geri alındı",
  "Undone at the tills": "Kasalarda geri alındı",
  "Undone, not sent": "Geri alındı, gönderilmedi",
  "Uniforms": "Üniformalar",
  "Unit changed to {0}. Enter the replacement quantity before saving.": "Birim {0} olarak değişti. Kaydetmeden önce yeni miktarı girin.",
  "Unit cost of {0}": "{0} birim maliyeti",
  "Unit for {0}": "{0} için birim",
  "Unit price of {0}": "{0} birim fiyatı",
  "Unit price of line {0}": "{0}. satırın birim fiyatı",
  "Unmatched": "Eşleşmedi",
  "Unpriced": "Fiyatsız",
  "unsaved changes": "kaydedilmemiş değişiklikler",
  "Up {0} out of every 100 — better than before.": "Yüzde {0} arttı — öncekinden daha iyi.",
  "up to {0} across stores": "mağazalar arasında en çok {0}",
  "Updated {0} ingredient(s).": "{0} kalem güncellendi.",
  "Updated {0} of {1} ingredient(s); {2} failed.": "{1} kalemden {0} tanesi güncellendi; {2} tanesi başarısız oldu.",
  "Upload it and check": "Yükleyin ve kontrol edin",
  "urgent warning": "acil uyarı",
  "urgent warnings": "acil uyarı",
  "Usage = what sales took by recipe, waste, count differences and hand changes, in dollars per $1,000 of the store's sales. Est. Loss = what it used over the median in these days.": "Kullanım = tariflere göre satışların düştüğü miktar, atık, sayım farkları ve elle yapılan değişiklikler; mağazanın her $1,000'lık satışı başına dolar olarak. Tahmini kayıp = mağazanın bu günlerde medyanın üzerinde kullandığı miktar.",
  "Use at most two decimals (cents).": "En fazla iki ondalık basamak kullanın (sent).",
  "Use the prep in a product's recipe (Products in Menu), a topping recipe or another prep. The list shows how many pizzas use each one.": "Ara ürünü bir ürünün tarifinde (Menüdeki ürünler), bir malzeme tarifinde ya da başka bir ara üründe kullanın. Liste, her birini kaç pizzanın kullandığını gösterir.",
  "Use the store picker at the top of the page.": "Sayfanın üstündeki mağaza seçiciyi kullanın.",
  "user {0}": "kullanıcı {0}",
  "uses nothing": "hiçbir şey kullanmaz",
  "Uses nothing is for gift cards and fees: nothing is taken off the stock when they sell.": "Hiçbir şey kullanmaz, hediye kartları ve ücretler içindir: bunlar satıldığında stoktan hiçbir şey düşülmez.",
  "Uses the amounts for every size": "Her boy miktarlarını kullanır",
  "Utilities": "Elektrik, doğalgaz ve su",
  "Value is the quantity at the item's cost. It shows \"—\" for a count line, which moves nothing by itself, and for an item that had no price.": "Değer, miktarın kalemin maliyetiyle çarpımıdır. Kendi başına hiçbir şeyi hareket ettirmeyen sayım satırlarında ve fiyatı olmayan kalemlerde \"—\" gösterir.",
  "Variance is per-store — pick the location to inspect.": "Fark mağaza bazındadır — incelemek için mağazayı seçin.",
  "Variance trend shows how far the last 5 counts were from what the book expected, in %.": "Fark eğilimi, son 5 sayımın kayıtlara göre beklenenden ne kadar saptığını yüzde olarak gösterir.",
  "vendor {0}": "tedarikçi {0}",
  "vendor changed means the last purchase came from a different vendor than the one before.": "tedarikçi değişti etiketi, son alımın bir öncekinden farklı bir tedarikçiden yapıldığını gösterir.",
  "Vendor Credit Memos lists every claim. Mark one credited when the vendor pays it back, or log a claim by hand.": "Tedarikçi alacakları her talebi listeler. Tedarikçi ödediğinde talebi Ödendi olarak işaretleyin ya da elle bir talep kaydedin.",
  "vendors": "tedarikçi",
  "View base ingredients for {0} and size. Default options are listed separately below.": "Bu boyun {0} için temel malzemelerini görüntüleyin. Varsayılan seçenekler aşağıda ayrıca listelenir.",
  "Wages (gross pay)": "Maaşlar (brüt ödeme)",
  "Waiting in Approvals": "Onaylarda bekliyor",
  "Waiting to send": "Gönderilmeyi bekliyor",
  "Waiting…": "Bekliyor…",
  "warn": "uyarı",
  "Waste lines are store-scoped. Select a store from the top bar to log or view entries.": "Atık satırları mağazaya özeldir. Kayıt girmek ya da kayıtları görmek için üst çubuktan bir mağaza seçin.",
  "Watch": "İzlenmeli",
  "Watch the weekly budget": "Haftalık bütçeyi izleyin",
  "Water and sewer": "Su ve kanalizasyon",
  "Well over your goal. Check waste, portions and supplier prices.": "Hedefinizin çok üstündesiniz. Atığı, porsiyonları ve tedarikçi fiyatlarını kontrol edin.",
  "What arrived at {0}": "{0} için gelen teslimatlar",
  "What comes in adds to the shelf. Take a photo of the invoice and Connect reads it for you.": "Gelen mallar rafa eklenir. Faturanın fotoğrafını çekin, Connect sizin için okusun.",
  "What is left at {0}": "{0} için kalan stok",
  "What is on the shelf right now": "Şu an rafta olanlar",
  "What is on the shelf right now at {0}": "{0} için şu an rafta olanlar",
  "What one batch makes, in {0}.": "Bir partiden çıkan miktar, {0} cinsinden.",
  "What the last count found against what the book expected. Red means less was on the shelf than expected, amber means more.": "Son sayımın bulduğu miktar ile kayıtlara göre beklenen miktarın karşılaştırması. Kırmızı, rafta beklenenden az olduğunu; sarı, fazla olduğunu gösterir.",
  "What the recipes of the products you sold took off the stock.": "Sattığınız ürünlerin tariflerine göre stoktan düşülen miktar.",
  "What the recipes of the sold products cost, out of the sales whose cost is known. At or under the target it shows green, up to 3 points over amber, more red.": "Satılan ürünlerin tarif maliyetinin, maliyeti bilinen satışlara oranı. Hedefte ya da altındaysa yeşil, hedefi 3 puana kadar aşarsa sarı, daha fazlasında kırmızı görünür.",
  "what the store kept": "mağazada kalan",
  "what the store last made it for": "mağazanın en son kaça mal ettiği",
  "What to order for {0}": "{0} için sipariş edilecekler",
  "What was bought: {0}": "Satın alınanlar: {0}",
  "What was thrown away at {0}": "{0} için kaydedilen atıklar",
  "What you type is kept as a draft on the server and on this device, so you can carry on from another device or after closing the page.": "Yazdıklarınız sunucuda ve bu cihazda taslak olarak saklanır; böylece başka bir cihazdan ya da sayfayı kapattıktan sonra kaldığınız yerden devam edebilirsiniz.",
  "When every box is green, the month is shown at the bottom. Press Finish: the Excel file is made and head office can see the report.": "Tüm kutular yeşil olduğunda ay en altta gösterilir. Bitir düğmesine basın: Excel dosyası oluşturulur ve merkez ofis raporu görebilir.",
  "When the delivery arrives, check it in so your stock stays right.": "Teslimat geldiğinde teslim alın ki stoğunuz doğru kalsın.",
  "When the dough is mixed, record the kilograms and the balls you cut of each size. The oldest balls are used first; dough left over is kept as dough stock. Discard balls from a batch with a reason.": "Hamur karıldığında kilogramı ve her boydan kestiğiniz top sayısını kaydedin. Önce en eski toplar kullanılır; artan hamur, hamur stoğu olarak tutulur. Bir partiden top atarken nedenini girin.",
  "When the goods arrive, type the quantity received on each line and the unit price on the supplier's paper, then Submit receipt. Lines left at 0 are not received.": "Mallar geldiğinde her satıra teslim alınan miktarı ve tedarikçinin belgesindeki birim fiyatı yazın, sonra Teslim almayı gönder düğmesine basın. 0'da bırakılan satırlar teslim alınmaz.",
  "Which store Inventory is looking at": "Envanterin baktığı mağaza",
  "Which store you are working on": "Üzerinde çalıştığınız mağaza",
  "With a recipe for each product, every sale takes its ingredients off the shelf by itself.": "Her ürünün bir tarifi olduğunda her satış, kendi malzemelerini raftan kendiliğinden düşer.",
  "With one store picked, type on Dough Recipe how many balls of each size the store wants on hand. The plan mixes enough to keep that many after the next 48 hours.": "Tek bir mağaza seçiliyken, Hamur tarifinde mağazanın her boydan elde bulundurmak istediği top sayısını yazın. Plan, önümüzdeki 48 saatten sonra da bu kadarını elde tutacak miktarda karışım hazırlar.",
  "Within Budget": "Bütçe içinde",
  "worked out once the three lines above are in": "yukarıdaki üç satır girilince hesaplanır",
  "WorkSafeBC": "WorkSafeBC",
  "WorkSafeBC estimate": "WorkSafeBC tahmini",
  "WTD": "Bu hafta",
  "yesterday": "dün",
  "Yield {0} kg · {1}/kg": "Verim {0} kg · {1}/kg",
  "You are inside your goal. Good.": "Hedefinizin içindesiniz. Güzel.",
  "You have {0} left to spend on orders this period.": "Bu dönem siparişlere harcayabileceğiniz {0} kaldı.",
  "You said yes already — send the goods and mark them as sent.": "Zaten evet dediniz — malları gönderin ve gönderildi olarak işaretleyin.",
  "your count on the last day": "son günkü sayımınız",
  "Your menu items sorts products by how much they sell and what each one earns, so you know what to promote, fix or drop.": "Menü ürünleriniz bölümü, ürünleri ne kadar sattıklarına ve her birinin ne kazandırdığına göre sıralar; böylece neyi öne çıkaracağınızı, düzelteceğinizi ya da menüden çıkaracağınızı bilirsiniz.",
  "Your store’s month on one page": "Mağazanızın ayı tek sayfada",
  "Your store’s month, one question at a time": "Mağazanızın ayı, her seferinde tek soru",
  "Your winners": "Kazananlarınız",
  "pack unit::Bucket": "Kova",
  "No level set": "Seviye belirlenmemiş",
  "dough::Discard": "At",
  "alert status::Open": "Açık",
  // The Inventory dashboard's two server warnings (Stock/Dashboard.php caveats), shown through $tr (11-04).
  "Sales are not taken off the stock at this brand yet, so there is no food cost.": "Bu markada satışlar henüz stoktan düşülmüyor, bu yüzden yemek maliyeti hesaplanamıyor.",
  "Some ingredients have no price yet, so the order lines that use them are left out of food cost % until a price is known.": "Bazı kalemlerin henüz fiyatı yok; onları kullanan sipariş satırları, fiyat belli olana kadar yemek maliyeti yüzdesinin dışında kalır.",
};
